{
  "de": {
    "ui": {
      "home": "Start",
      "homeTitle": "Startseite",
      "explore": "Entdecken",
      "gallery": "Galerie",
      "myImages": "Meine Bilder",
      "settings": "Einstellungen",
      "createImage": "Bild erstellen",
      "back": "Zurück",
      "search": "Suchen",
      "account": "Konto",
      "login": "Anmelden",
      "logout": "Abmelden",
      "profile": "Profil",
      "profileSettings": "Profil und Einstellungen",
      "plans": "Tarife und Nutzung",
      "plansSubtitle": "Bildguthaben und Abrechnung",
      "contact": "Kontakt",
      "contactSubtitle": "Hilfe und Feedback",
      "discoverVoxnela": "Voxnela entdecken",
      "discoverVoxnelaSubtitle": "Das Visual-Studio erneut ansehen",
      "privacy": "Datenschutz",
      "privacySubtitle": "So werden deine Daten geschützt",
      "terms": "Nutzungsbedingungen",
      "termsSubtitle": "Voxnela-Nutzungsbedingungen",
      "preferencesSubtitle": "Dein Konto und deine Voxnela-Einstellungen",
      "accountSubtitle": "Konto- und Mitgliedschaftsdaten",
      "voxAccount": "Voxnela-Konto",
      "accessEverywhere": "Greife auf jedem Gerät auf deine Bilder zu",
      "imageRights": "{{count}} Bildguthaben",
      "availableCredits": "Verfügbares Guthaben",
      "renewalDate": "Verlängerungsdatum",
      "membershipStart": "Mitglied seit",
      "registrationDate": "Registrierungsdatum",
      "monthly": "Monatlich",
      "renewalOff": "Verlängerung aus",
      "user": "Voxnela-Benutzer",
      "language": "Sprache",
      "languageSubtitle": "App-Sprache auswählen",
      "supportBody": "Schreib uns bei Problemen oder wenn du eine Idee teilen möchtest. Mit der Projekt-ID können wir schneller helfen.",
      "studioTitle": "Voxnela Bildstudio",
      "studioSubtitle": "Gestalte deinen Stil",
      "searchSubtitle": "Deine Bilder und Projekte",
      "searchPlaceholder": "Bild oder Projekt suchen",
      "noSearchResults": "Keine passenden Ergebnisse gefunden.",
      "project": "Projekt",
      "image": "Bild",
      "completed": "Abgeschlossen",
      "currentPlan": "Aktueller Tarif",
      "notSignedIn": "Nicht angemeldet",
      "signInIntro": "Melde dich an, um Voxnela zu verwenden.",
      "creditsAvailable": "{{count}} Studio-Bildguthaben verfügbar.",
      "noCredits": "Für diesen Zeitraum ist kein Bildguthaben mehr übrig.",
      "membershipInfo": "Bei Jahresabos wird das Guthaben monatlich erneuert und nicht übertragen. Wiederhergestellte Käufe bleiben über dein Konto geschützt.",
      "signedOutMembershipInfo": "Nach der Anmeldung erscheinen hier dein Bildguthaben und dein Tarif.",
      "reviewPlans": "Tarife ansehen",
      "versionUpdated": "Version {{version}} · Aktualisiert am {{date}}",
      "onboardingWelcome": "Willkommen bei Voxnela",
      "skipIntro": "Einführung überspringen",
      "continue": "Weiter",
      "startCreating": "Jetzt erstellen",
      "close": "Schließen",
      "dragToClose": "Zum Schließen nach unten wischen",
      "loading": "Wird geladen…",
      "sheetExpand": "Fenster erweitern",
      "sheetCollapse": "Fenster verkleinern",
      "cannotClose": "Während des Vorgangs nicht schließbar",
      "stylePreview": "Stilvorschau",
      "stylePreviewSubtitle": "Signaturstile und Trends",
      "categories": "Kategorien",
      "useThisStyle": "Diesen Stil verwenden",
      "videoControls": "Videosteuerung",
      "play": "Abspielen",
      "pause": "Pause",
      "mute": "Stummschalten",
      "unmute": "Ton einschalten",
      "minimize": "Verkleinern",
      "expandVideo": "In der App vergrößern",
      "videoProgress": "Videofortschritt",
      "toggleVideoControls": "Videosteuerung ein- oder ausblenden",
      "expandedVideo": "{{title}} – vergrößerte Videoansicht",
      "goToImage": "Gehen Sie zum {{title}}-Bild",
      "categoryVisualStyles": "{{category}} visuelle Stile",
      "onboarding1Eyebrow": "Bilder erstellen",
      "onboarding1Title": "Erstelle dein Bild.",
      "onboarding1Body": "Verwandle deine Idee mit 35-mm-Film, Editorial, Produkt, Poster und vielen weiteren Stilen in ein filmisches Bild.",
      "onboarding2Eyebrow": "Virtuelle Anprobe",
      "onboarding2Title": "Probiere neue Outfits an.",
      "onboarding2Body": "Bewahre die Identität über Produktionen hinweg und erstelle realistische Anproben für Mode, Accessoires und Produkte.",
      "onboarding3Eyebrow": "Bildbearbeitung",
      "onboarding3Title": "Bearbeite dein Bild.",
      "onboarding3Body": "Überarbeite Komposition, Licht, Farbe und Details im Dialog, ohne neu anzufangen.",
      "onboarding4Eyebrow": "3 kostenlose Bilder",
      "onboarding4Title": "Starte kostenlos.",
      "onboarding4Body": "Starte sofort mit 3 einmaligen kostenlosen KI-Bildern. Kein Konto nötig.",
      "onboardingFaceEyebrow": "Gesichts- und Stilanalyse",
      "onboardingFaceTitle": "Entdecke Gesicht und Stil.",
      "onboardingFaceBody": "Erkunde anhand deines Porträts passende Ideen für Haare, Brillen und Kleidung in einem visuellen Leitfaden.",
      "onboardingHouseEyebrow": "Zeitreise",
      "onboardingHouseTitle": "Reise durch die Zeit.",
      "onboardingHouseBody": "Verbinde deine Fotos und Daten und zeige, wie sich dein Zuhause mit der Zeit verändert hat.",
      "onboardingFestivalEyebrow": "Dein Festivaltag",
      "onboardingFestivalTitle": "Plane deinen Festivaltag auf einen Blick.",
      "onboardingFestivalBody": "Mach aus dem von dir angegebenen Programm, den Bühnen und Uhrzeiten eine persönliche visuelle Route.",
      "onboardingStylesEyebrow": "Voxnela-Stile",
      "onboardingStylesTitle": "Wähle deinen Stil.",
      "onboardingStylesBody": "Verwandle deine Idee mit 35-mm-Film, Editorial, Produkt, Poster und vielen weiteren Stilen in ein filmisches Bild."
    },
    "auth": {
      "enterCode": "Code eingeben",
      "membershipAndAccount": "Mitgliedschaft und Konto",
      "noPeriodInfo": "Zeitraum nicht verfügbar",
      "memberSince": "Mitglied seit",
      "planSince": "{{plan}} seit",
      "membershipRenewal": "Datum der Mitgliedschaftserneuerung",
      "accountActions": "Kontoaktionen",
      "manageSubscriptionTitle": "Abonnement beenden",
      "manageSubscriptionSubtitle": "Verwalten Sie Ihr Geschäftskundenabonnement und die automatische Verlängerung.",
      "deleteAccountTitle": "Mein Konto löschen",
      "deleteAccountSubtitle": "Umkehrbarer 15-Tage-Löschprozess.",
      "deleteDataTitle": "Meine Daten löschen",
      "deleteDataSubtitle": "Umkehrbarer 30-Tage-Datenlöschprozess.",
      "signingOut": "Abmeldung…",
      "signOut": "Abmelden",
      "signingIn": "Anmeldung…",
      "continueApple": "Mit Apple fortfahren",
      "continueGoogle": "Mit Google fortfahren",
      "or": "oder",
      "email": "E-Mail",
      "emailPlaceholder": "du@beispiel.de",
      "legalPrefix": "Durch die Fortsetzung mit Voxnela akzeptieren Sie die",
      "legalTerms": "Nutzungsbedingungen",
      "legalJoin": "und bestätigen Sie, dass Sie die gelesen und verstanden haben",
      "legalPrivacy": "Datenschutzerklärung",
      "legalSuffix": ".",
      "sendingCode": "Code wird gesendet…",
      "emailSignIn": "Mit E-Mail anmelden",
      "codeSent": "Wir haben einen Code an {{email}} gesendet.",
      "change": "Ändern",
      "sixDigitCode": "6-stelliger Code",
      "emailCode": "E-Mail-Anmeldecode",
      "verifyingCode": "Code wird geprüft…",
      "resendCode": "Code erneut senden",
      "requestReceived": "Anfrage erhalten",
      "accountDeletionStarted": "Ihr Konto-Löschprozess hat begonnen",
      "dataDeletionStarted": "Ihr Löschprozess für Daten hat begonnen",
      "accountAction": "Kontoeaktion",
      "accountDeletesAt": "Ihr Konto wird auf {{date}} dauerhaft gelöscht.",
      "dataDeletesAt": "Ihre persönlichen Voxnela-Daten werden auf {{date}} dauerhaft gelöscht.",
      "deletionUndo": "Wenn Sie sich vor diesem Datum mit demselben Konto anmelden, wird der Löschprozess automatisch storniert. Ihre aktuelle Sitzung wurde geschlossen, da die Anfrage erstellt wurde.",
      "done": "Fertig",
      "cancel": "Abbrechen",
      "preparing": "Vorbereiten...",
      "invalidEmail": "Geben Sie eine gültige E-Mail-Adresse ein.",
      "enterSixDigitCode": "Geben Sie den 6-stelligen Code ein, der an Ihre E-Mail-Adresse gesendet wurde.",
      "signInFailed": "Die Anmeldung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
      "codeSendFailed": "Der Anmeldecode konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
      "codeVerifyFailed": "Der Code konnte nicht verifiziert werden. Bitte versuchen Sie es erneut.",
      "operationFailed": "Die Operation konnte derzeit nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
      "popupClosed": "Das Anmeldefenster wurde geschlossen.",
      "unauthorizedDomain": "Diese Domain ist nicht für die Anmeldung autorisiert.",
      "methodUnavailable": "Diese Anmeldemethode ist noch nicht aktiviert.",
      "tooManyCodes": "Zu viele Codes wurden angefordert. Versuchen Sie es in ein paar Minuten erneut.",
      "invalidCode": "Der Code ist ungültig oder abgelaufen. Fordern Sie einen neuen Code an.",
      "emailUnavailable": "Die E-Mail-Versandoption ist derzeit nicht verfügbar.",
      "actions": {
        "subscription": {
          "eyebrow": "Aktionsbeziehung zum Abonnement",
          "title": "Beenden Sie Ihr Abonnement?",
          "confirm": "Abonnements verwalten",
          "paragraphs": [
            "Weiterführen öffnet die Apple App Store- oder Google Play-Abonnementverwaltungskarte, auf der Sie das Abonnement erworben haben. Sie müssen die automatische Verlängerung im Store deaktivieren.",
            "Nach der Stornierung bleiben Ihre bestehenden Mitgliedschaftsvorteile bis zum Ende des bezahlten Zeitraums verfügbar. Das Löschen Ihres Kontos oder Ihrer Daten storniert kein Store-Abonnement."
          ]
        },
        "account": {
          "eyebrow": "Aktion für das dauerhafte Konto",
          "title": "Sind Sie sich sicher, dass Sie Ihr Konto löschen möchten?",
          "confirm": "15-tägiger Löschprozess starten",
          "paragraphs": [
            "Wenn Sie weiterfahren, beginnt ein 15-tägiger Löschprozess und Sie werden aus Sicherheitsgründen abgemeldet. Wenn Sie sich in diesem Zeitraum nicht erneut anmelden, werden Ihr Konto, Ihr Profil, Ihre Kreationen, Ihre Bibliothek, Ihre Sammlungen und verwandte Voxnela-Daten dauerhaft gelöscht.",
            "Die Anmeldung mit demselben Konto vor 15 Tagen hebt die Löschung automatisch auf. Das Löschen des Kontos hebt kein aktives Store-Abo auf; stornieren Sie es separat im Store."
          ]
        },
        "data": {
          "eyebrow": "Permanente Datenaktion",
          "title": "Sind Sie sich sicher, dass Sie Ihre Daten löschen möchten?",
          "confirm": "30-Tage-Löschprozess starten",
          "paragraphs": [
            "Wenn Sie weiterfahren, beginnt ein 30-tägiger Löschprozess und Sie werden aus Sicherheitsgründen abgemeldet. Wenn Sie sich in diesem Zeitraum nicht erneut anmelden, werden Ihre Kreationen, Ihre Bibliothek, Ihre Sammlungen, Ihre Aufzeichnungen, Ihre Interaktionen und andere persönlichen Voxnela-Daten dauerhaft gelöscht; Ihr Anmeldekonto bleibt verfügbar.",
            "Die erneute Anmeldung vor 30 Tagen hebt die automatische Datenlöschung auf. Durch das Gesetz vorgeschriebene begrenzte Transaktions- und Sicherheitsaufzeichnungen können mit eingeschränktem Zugriff für die geltenden Rechtszeiträume aufbewahrt werden."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "Keine Bildnachweise mehr übrig",
      "quotaFreeMessage": "Sie haben die Bildnachweis-Guthaben in Ihrem kostenlosen Konto verwendet. Wählen Sie einen Plan, um weiter zu erstellen.",
      "later": "Später",
      "currentCredit": "Aktuelle Gutschriften: 0",
      "quotaProTitle": "Monatliches Pro-Kontingent erreicht",
      "quotaProMessage": "Sie haben die 100 Bildcredits dieses Monats verwendet. Upgrade auf Studio, um weiter zu erstellen.",
      "renewalDate": "Verlängerungsdatum: {{date}}",
      "quotaStudioTitle": "Monatliches Studio-Kontingent erreicht",
      "quotaStudioMessage": "Ihre Bildcredits werden automatisch auf {{date}} verlängert.",
      "done": "Fertig",
      "membership": "Voxnela-Mitgliedschaft",
      "options": "Mitgliedschaftsoptionen",
      "credits": "Guthaben",
      "currentMembership": "Aktuelle Mitgliedschaft",
      "yearlyDiscount": "17 % Rabatt",
      "loadingPrice": "Store-Preis wird geladen…",
      "loadingStorePrice": "Preisbeladung aus dem Geschäft",
      "year": "Jahr",
      "month": "Monat",
      "renewDisclosure": "Erneuert sich automatisch jedes {{period}}. Jedezeit kündigen.",
      "legal": "Rechtliches",
      "terms": "Bedingungen",
      "alreadyMember": "Sie haben bereits {{plan}} {{period}}",
      "startPlan": "Starten Sie den {{plan}}-Plan",
      "upgradeStudio": "Auf Studio upgraden",
      "yearlyAdvantage": "Wechseln Sie zu jährlichen Ersparnissen",
      "upgrade": "Mitgliedschaft upgraden",
      "signInRequired": "Melden Sie sich vor Beginn eines Abonnements bei Ihrem Voxnela-Konto an.",
      "catalogUnavailable": "Der Zahlungskatalog konnte für diesen Tarif nicht verifiziert werden. Bitte versuchen Sie es in Kürze erneut.",
      "paymentUnavailable": "Der Zahlungsbildschirm konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.",
      "benefits": [
        {
          "lead": "{{credits}} Credits",
          "label": "Jeden Monat hochauflösende Bildgenerierung"
        },
        {
          "lead": "50+ Studio-Stile",
          "label": "Neo-Minimalismus, Kinematisch und jeder Signature-Stil"
        },
        {
          "lead": "Gesichtsverriegelung",
          "label": "Virtuelle Modenschau ohne Veränderung der Gesichtszüge"
        },
        {
          "lead": "Prioritätswarteschlange",
          "label": "Ultra-schnelle GPU-Verarbeitung ohne Wartezeit"
        },
        {
          "lead": "Chat-Überarbeitungen",
          "label": "Unbegrenzte mehrstufige Detailbearbeitungen in natürlicher Sprache"
        },
        {
          "lead": "Volle kommerzielle Rechte",
          "label": "Hochauflösende, wasserzeichenfreie Nutzung"
        }
      ],
      "restorePurchases": "Käufe wiederherstellen",
      "restoringPurchases": "Wiederherstellung von Käufen...",
      "restoreSuccess": "Ihre Mitgliedschaft wurde wiederhergestellt.",
      "restoreEmpty": "Für dieses App Store-Konto wurde keine aktive Abonnement gefunden.",
      "membershipSyncPending": "Mitgliedschafts- und Bildnachweis überprüfen...",
      "membershipSyncFailed": "Bildguthaben konnte nicht synchronisiert werden. Versuche es erneut.",
      "membershipUnavailable": "Mitgliedschaft konnte nicht geladen werden.",
      "retry": "Erneut versuchen"
    },
    "video": {
      "revisionHook": "Machen Sie die ersten drei Sekunden ansprechender.",
      "revisionPace": "Ausgewogene das Tempo und verkürzen Sie die langsamen Abschnitte.",
      "revisionEnding": "Machen Sie das Ende einprägsamer.",
      "revisionTransition": "Machen Sie die Übergänge glatter und natürlicher.",
      "revisionFraming": "Verwenden Sie für die wichtigen Details eine ausgewogenere Rahmenung.",
      "revisionColor": "Machen Sie die Farben ausgewogener und filmischer.",
      "revisionText": "Machen Sie den Text kürzer und leichter zu lesen.",
      "revisionAudio": "Passen Sie die Musik besser zum Rhythmus der Bilder an.",
      "revisionEmotion": "Lass die Geschichte aufrichtiger und emotionaler wirken.",
      "revisionStructure": "Schaffen Sie einen klareren Anfang, Mitte und Ende.",
      "previewBack": "Zurück zur Vorschau",
      "revisionWelcome": "Was möchten Sie ändern?",
      "revisionFailed": "Ich konnte diese Änderung nicht anwenden. Könnten Sie sie noch einmal beschreiben?",
      "finalQueued": "Das endgültige Video ist in Warteschlange. Es wird nach der Fertigstellung unter Videos angezeigt.",
      "watermarkUpgrade": "Wählen Sie einen Plan, um ein neues endgültiges Ergebnis ohne das Voxnela-Wasserzeichen zu erstellen.",
      "finalFailed": "Das endgültige Video konnte nicht gestartet werden.",
      "projectDeleteFailed": "Das Projekt konnte nicht gelöscht werden.",
      "videoDescriptionWithBrief": "Dieses Video wurde aus „{{brief}}“ erstellt. Voxnela wählte die stärksten Momente aus und baute den Rhythmus und die Szenenreihenfolge um die gewählte kreative Richtung herum.",
      "videoDescriptionGeneric": "Voxnela bewertete die Materialien hinsichtlich Inhalt, Tempo und narrativer Kohärenz und hob die stärksten Momente für eine ausgewogene Bearbeitung hervor.",
      "play": "Spielen",
      "deletesOn": "Löscht auf {{date}}",
      "projectsBelong": "Ihre Projekte sind mit Ihrem Konto verknüpft.",
      "videosBelong": "Ihre Videos sind mit Ihrem Konto verknüpft.",
      "signInToSeeProjects": "Melden Sie sich an, um Ihre Projekte zu sehen und über Geräte hinweg fortzufahren.",
      "signInToSeeVideos": "Melden Sie sich an, um Ihre Videos anzusehen und sie auf mehreren Geräten weiterzusehen.",
      "delete": "Löschen",
      "deleting": "Wird gelöscht…",
      "secondsVersion": "{{seconds}} Sek · Version {{version}}",
      "deleteProject": "Projekt löschen",
      "projectCoverUnavailable": "Projektcover konnte nicht geladen werden",
      "videoCoverPreparing": "Video-Cover vorbereiten",
      "deleteVideo": "Video löschen",
      "signed": "Voxnela-markiert",
      "failed": "Konnte nicht abschließen",
      "tryAgain": "Sie können es erneut versuchen",
      "cancelled": "Storniert",
      "noCreditUsed": "Kein Guthaben verwendet",
      "featuredStyles": "Ausgewählte visuelle Stile",
      "previousImage": "Vorheriges Bild",
      "nextImage": "Nächstes Bild",
      "reviewStyle": "Entdecken Sie diesen Stil",
      "featuredNavigation": "Ausgewählte visuelle Navigation",
      "taskCategories": "Aufgabenkategorien",
      "projectOpening": "Öffentliches Projekt",
      "opening": "Öffnung...",
      "projectNotFound": "Projekt nicht gefunden",
      "projectUnavailable": "Dieses Projekt ist nicht mehr verfügbar.",
      "backToProjects": "Zurück zu meinen Projekten",
      "editVideo": "Video bearbeiten",
      "versionContext": "Version {{version}} · Voxnela kennt Ihr Projekt und Ihre Materialien",
      "livePreviewActions": "Live-Vorschau-Aktionen",
      "edit": "Bearbeiten",
      "preparing": "Wird vorbereitet",
      "save": "Speichern",
      "thinking": "Voxnela denkt",
      "revisionSuggestions": "Bearbeitungs-Vorschläge",
      "describeChange": "Beschreiben Sie die Änderung, die Sie wünschen",
      "sendEdit": "Bearbeitungsanfrage senden",
      "deleteProjectDescription": "Sind Sie sich sicher, dass Sie „{{title}}“ und alle zugehörigen Materialien löschen möchten? Dies kann nicht rückgängig gemacht werden.",
      "projects": "Projekte",
      "projectsPreparing": "Vorbereitung Ihrer Projekte",
      "noProjects": "Sie haben noch kein Projekt. Beginnen Sie damit, Ihre erste Idee zu beschreiben.",
      "createNew": "Neues Bild erstellen",
      "thisProject": "Dieses Projekt",
      "videos": "Videos",
      "videosPreparing": "Vorbereitung Ihrer Videos",
      "noVideos": "Sie haben noch kein abgeschlossenes Video. Es wird hier angezeigt, wenn Ihr erstes Video fertig ist.",
      "videoPlayFailed": "Das Video konnte nicht abgespielt werden.",
      "videoNotReady": "Die Videodatei ist noch nicht zum Herunterladen bereit.",
      "videoDownloadFailed": "Das Video konnte nicht heruntergeladen werden.",
      "videoDeleteFailed": "Das Video konnte nicht gelöscht werden.",
      "videoLoading": "Video wird geladen...",
      "videoActions": "Videoaktionen",
      "showVideoDescription": "Videobeschreibung anzeigen",
      "videoDownloading": "Video herunterladen",
      "downloadVideo": "Video herunterladen",
      "thisVideo": "Dieses Video",
      "deleteVideoDescription": "Sind Sie sich sicher, dass Sie das Video mit dem Titel „{{title}}“ löschen möchten? Dies kann nicht rückgängig gemacht werden."
    },
    "studio": {
      "useStyle": "Verwenden Sie diesen Stil",
      "galleryFilters": "Galeriefilter",
      "modeStyleTransfer": "Voxnela-Stile",
      "modeVirtualTryOn": "Virtuelle Anprobe",
      "modeMagazineCover": "Magazin & Titel",
      "modePosterStudio": "Poster Studio",
      "modeCommercial": "Produktvorstellung",
      "modeTimeWarp": "Zeitreise",
      "modeOutpaintRelight": "Erweitern & Wiederbeleuchten",
      "modeInfographic": "Infografik & Daten",
      "modePortraitRetouch": "Porträtretusche",
      "modeArtisticCollage": "Künstlerisches Collage",
      "defaultStyle": "Voxnela Stil",
      "signInToCreate": "Melden Sie sich an, um ein Bild zu erstellen.",
      "signInToEdit": "Melden Sie sich an, um ein Bild zu bearbeiten.",
      "creationSuccess": "Ihr Bild wurde erfolgreich erstellt. Teilen Sie mir direkt mit, wenn Sie die Beleuchtung, Farben, Objekte oder den Rahmen ändern möchten.",
      "imageReady": "Ihr Bild ist fertig. Sagen Sie mir, was Ihnen gefällt oder was Sie überarbeiten möchten.",
      "revisionSuccess": "Die Überarbeitung ist abgeschlossen. Sie können sie mit dem Vorher/Nachher-Schieberegler vergleichen oder eine weitere Änderung beantragen.",
      "versionReady": "Version {{version}} ist fertig.",
      "projectNotFound": "Projekt nicht gefunden.",
      "styleApplied": "{{style}} Stil angewendet",
      "imageCreation": "Bilderstellung",
      "defaultPrompt": "Studiobild",
      "aspectSquare": "Quadratisch",
      "aspectSquareDetail": "Instagram-Feed, Profil, Kunst",
      "aspectVertical": "Vertikal",
      "aspectVerticalDetail": "Instagram-Storys, Reels, TikTok",
      "aspectHorizontal": "Horizontal",
      "aspectHorizontalDetail": "YouTube, Banner, Kino",
      "aspectPortrait": "Porträt",
      "aspectPortraitDetail": "Instagram-Porträt, Poster, Ausstellungsfläche",
      "aspectPanoramic": "Panoramisch",
      "aspectPanoramicDetail": "Ultraweites, kinematisches Landschaftsbild",
      "styles": "Voxnela-Stile",
      "fullScreenStyle": "Stil im Vollbild anzeigen",
      "closeDescription": "Schließstilbeschreibung",
      "moreWithVoxnela": "Machen Sie mehr mit Voxnela",
      "quickStartBody": "Schreiben Sie unten, was Sie möchten, oder hängen Sie eine Datei an.",
      "createImage": "Bild erstellen",
      "createImageDetail": "Baue deine Idee von Grund auf neu auf",
      "editImage": "Bild bearbeiten",
      "editImageQuick": "Ein Bild bearbeiten",
      "editImageDetail": "Ein hochgeladenes Bild neu erfinden",
      "transformStyle": "Stil und Szene transformieren",
      "transformStyleDetail": "Verschieben Sie Ihr Bild in eine andere Welt",
      "visualizeDocument": "Ein Dokument oder eine Präsentation visualisieren",
      "visualizeDocumentDetail": "Verwandeln Sie den gesamten Inhalt in ein Design",
      "submittedImage": "Eingereichte Bild",
      "generating": "Voxnela erstellt dein Bild…",
      "viewImage": "Bild anzeigen",
      "removeStyle": "Ausgewählter Stil entfernen",
      "referenceImage": "Referenzbild",
      "referenceNotice": "Dieses Bild wird überarbeitet oder ein neuer Stil wird angewendet",
      "removeReference": "Referenzbild entfernen",
      "remove": "Entfernen",
      "uploading": "Hochladen",
      "addFile": "Eine Datei oder ein Bild hinzufügen",
      "addFileTitle": "Fügen Sie bis zu 4 Bilder oder ein Dokument hinzu (PDF, Word, PPT, max. 12 MB)",
      "aspectRatio": "Aspektverhältnis",
      "selectAspectRatio": "Aspektverhältnis auswählen",
      "aspectOptions": "Aspektverhältnisoptionen",
      "revisePlaceholder": "Was möchten Sie in diesem Bild ändern?",
      "styledPlaceholder": "Beschreiben Sie das Bild, das Sie in diesem Stil wünschen (optional)...",
      "promptPlaceholder": "Beschreiben Sie ein Bild oder schreiben Sie eine Aufforderung…",
      "reviseImage": "Bild überprüfen",
      "generateImage": "Bild generieren",
      "generatedImage": "Generiertes Bild",
      "done": "Fertig",
      "fileLimitTitle": "Datei zu groß",
      "fileLimitMessage": "\"{{name}}\" überschreitet das 12-MB-Limit ({{size}} MB). Wählen Sie eine kleinere Datei.",
      "imageLimitTitle": "Bildlimit",
      "imageLimitMessage": "Sie können bis zu 4 Bilder hochladen. {{count}}-Bilder sind derzeit ausgewählt.",
      "uploadFailedTitle": "Hochladen fehlgeschlagen",
      "uploadFailedMessage": "Beim Hochladen der Datei ist ein Problem aufgetreten.",
      "revisionFailed": "Bei der Überarbeitung ist ein Fehler aufgetreten oder das Limit wurde überschritten.",
      "generationFailed": "Es ist ein Fehler während der Bildgenerierung aufgetreten oder das Kontingent wurde überschritten.",
      "imageDetails": "Bilddetails",
      "close": "Schließen",
      "download": "Herunterladen",
      "downloadImage": "Bild herunterladen",
      "downloading": "Wird geladen",
      "versionImage": "Bild",
      "exploreTitle": "Welchen Stil suchst du?",
      "explorePlaceholder": "Zum Beispiel: ein filmisches Porträt mit dunklen Tönen und tiefer Perspektive",
      "searchStyles": "Bildstile suchen",
      "clearSearch": "Suchen Sie leer",
      "exploreCategories": "Kategorien erkunden",
      "all": "Alle",
      "styleCount": "{{count}} Stile",
      "noStyle": "Kein passender Stil gefunden",
      "noStyleBody": "Versuchen Sie es erneut mit einer kürzeren Beschreibung oder anderen Wörtern.",
      "libraryKicker": "Ihre persönliche Bildbibliothek",
      "myImages": "Meine Bilder",
      "imageWorks": "{{count}} Bild funktioniert",
      "newImage": "Neues Bild erstellen",
      "noImage": "Sie haben noch kein Bild erstellt",
      "noCategoryImage": "Keine Bilder in dieser Kategorie",
      "emptyGalleryBody": "Erstellen Sie Ihr erstes Bild mit Stilübertragung, virtuellem Anprobieren, Magazincover oder Produktpräsentation.",
      "firstImage": "Erstellen Sie Ihr erstes Bild",
      "imageWork": "Bildarbeit"
    },
    "create": {
      "briefTitle": "Beschreiben Sie Ihre Idee oder Ihr Thema",
      "briefPlaceholder": "Was ist das Thema? Zum Beispiel: die Zukunft der KI, eine Reise zum Mars oder ein Produktlaunch…",
      "briefLabel": "Erstellungsbrief",
      "contentType": "Inhaltstyp",
      "media": "Bilder & Medien",
      "added": "{{count}} hinzugefügt",
      "optional": "Optional",
      "addMedia": "Fügen Sie ein Foto oder Video hinzu, wenn Sie möchten",
      "addMediaBody": "Laden Sie Ihre eigenen Medien hoch oder lassen Sie sie leer und lassen Sie die KI sie finden",
      "attachedMedia": "Angehängte Medien",
      "add": "Hinzufügen",
      "mediaFallback": "Medien",
      "aiCompletes": "Lassen Sie die KI die visuellen Elemente vervollständigen",
      "noMedia": "Keine Bilder hochgeladen; die KI wird die Szenen vervollständigen.",
      "productionFormat": "Produktionsformat",
      "style": "Stil",
      "customVisualWorld": "Beschreiben Sie Ihre visuelle Welt",
      "colorsAtmosphere": "Farben, Atmosphäre, Kamera, Rhythmus",
      "customStyleShort": "Beschreiben Sie die visuelle Welt, die Sie sich vorstellen (zum Beispiel: Pastelltöne und eine ruhige Kamera, oder Cyberpunk-Neon…)",
      "customStyleLong": "Beschreiben Sie die visuelle Welt, Farben, Atmosphäre und den Rhythmus, die Sie im Sinn haben.",
      "voiceover": "Sprachausgabe",
      "ownVoiceover": "Ihr Sprachausgabe-Text",
      "voiceoverPlaceholder": "Schreiben Sie hier Ihren Text. Wenn er leer bleibt, bereitet Voxnela ihn vor.",
      "duration": "Dauer",
      "seconds": "{{count}} Sek.",
      "freeLimit": "Das längste Endvideo im kostenlosen Tarif dauert 60 Sekunden.",
      "addSound": "Sound oder Musik hinzufügen",
      "notAdded": "Nicht hinzugefügt",
      "files": "{{count}} Dateien",
      "readySounds": "Verwenden Sie vorgefertigte Klänge",
      "musicLibrary": "Musikbibliothek",
      "uploadOwn": "Laden Sie Ihre eigene hoch",
      "captions": "Untertitel",
      "back": "Zurück",
      "create": "Erstellen",
      "next": "Weiter",
      "researchingTopic": "Das Thema recherchieren...",
      "analyzingMaterials": "Materialanalysen...",
      "researchBody": "Überprüfung der Quellen und Vorbereitung des Skripts und des visuellen Plans.",
      "analyzeBody": "Starke Rahmen, Emotion, Rhythmus und das Kurze zusammen bewerten.",
      "creativeDirection": "Kreative Richtung {{count}}",
      "recommended": "Empfohlen",
      "generationFailed": "Die Erstellung konnte nicht abgeschlossen werden",
      "retry": "Nochmals vorbereiten",
      "backDirections": "Zur kreativen Richtung zurück",
      "preparingVideo": "Dein Video wird vorbereitet",
      "voiceoverText": "Sprachausgabe-Text",
      "describeStyle": "Beschreiben Sie Ihren eigenen Stil",
      "topicDirection": "Thema und Richtung",
      "styleEditorSubtitle": "Beschreiben Sie die visuelle Welt, Farben und Atmosphäre",
      "editorSubtitle": "Schreiben Sie den Text und fügen Sie ihn in das Erstellungsskript ein.",
      "voiceoverEditorPlaceholder": "Schreiben Sie den Text, der für die Sprachausgabe verwendet werden soll.",
      "topicEditorPlaceholder": "Schreiben Sie das Thema und wie Sie es erzählt haben möchten.",
      "insertText": "Text einfügen",
      "bestFor": "Am besten geeignet für:",
      "useStyle": "Verwenden Sie diesen Stil",
      "musicSubtitle": "Echte Spuren für die kommerzielle Nutzung freigegeben",
      "adding": "Hinzufügen...",
      "musicLicense": "Tracks werden unter CC0 1.0 bereitgestellt; kommerzielle Nutzung ist erlaubt und eine Zuordnung ist nicht erforderlich.",
      "yes": "Ja",
      "no": "Nein",
      "newCreation": "Neue Kreation",
      "reviewing": "Voxnela prüft",
      "chooseDirection": "Wählen Sie eine der drei Bearbeitungsansätze aus",
      "ideaSubtitle": "Beschreiben Sie Ihre Idee; laden Sie Bilder hoch oder lassen Sie Voxnela sie erstellen",
      "projectOpenFailed": "Das Projektpaket konnte nicht geöffnet werden.",
      "tooManyAssets": "Sie können bis zu 50 Assets zu einem Projekt hinzufügen.",
      "uploadSizeLimit": "Die Gesamtaufladung des Projekts überschreitet das 2 GB-Limit.",
      "filesAddFailed": "Die Dateien konnten nicht hinzugefügt werden.",
      "musicPreviewFailed": "Die Musikvorschau konnte nicht geöffnet werden.",
      "musicFetchFailed": "Die Musikdatei konnte nicht abgerufen werden.",
      "musicAddFailed": "Die Musik konnte nicht hinzugefügt werden.",
      "topicRequired": "Geben Sie ein Thema ein und beschreiben Sie, worüber Ihr Video gehen wird.",
      "briefTooShort": "Beschreiben Sie, was Sie sagen möchten, mit mindestens ein paar Wörtern.",
      "mediaRequired": "Laden Sie ein Bild hoch oder aktivieren Sie KI-generierte Bilder.",
      "proposalIntro": "Ich habe die Bilder und Videos überprüft und drei Bearbeitungsanweisungen vorbereitet, die zu Ihrem Stil, Format und Ihren Audioauswahlmöglichkeiten passen.",
      "removeMaterial": "{{name}} entfernen",
      "aiVisualNotice": "Offen lizenzierten echten Bildern und KI-Illustrationen werden automatisch gefunden.",
      "stepProgress": "Schritt {{current}} von {{total}}",
      "styleSampleAlt": "Beispiel, das den {{style}}-Video-Stil zeigt",
      "reviewStyle": "Überprüfen Sie den {{style}}-Stil",
      "selectedDirectionPrompt": "Ausgewählte Richtung: {{title}}. {{summary}} Visuelle Richtung: {{visual}}. Übergangsmethode: {{transitions}}. Musikmethode: {{music}}.",
      "letVoxnelaChoose": "Lass Voxnela wählen",
      "feminineVoice": "Feminin",
      "masculineVoice": "Männlich",
      "narrationStyle": "Erzählstil",
      "voiceEstimate": "Über {{seconds}} Sek · {{words}} Wörter.",
      "voiceShort": "Wenn es für {{duration}} Sekunden steht, wird Voxnela es abschließen, während es die Bedeutung beibehält.",
      "voiceNatural": "Voxnela passt nur Grammatik, Satzbildung und natürlichen Fluss an.",
      "removeFile": "Datei {{name}} entfernen",
      "musicStop": "Stopp {{title}}",
      "musicListen": "Hören Sie sich {{title}} an",
      "automatic": "Auto",
      "all": "Alles",
      "cinematic": "Kinematisch",
      "social": "Sozial & Dynamisch",
      "designTypography": "Design & Typografie",
      "retroExperimental": "Retro & Experimentell",
      "productionStage1": "Auswahl der stärksten Rahmen und Szenen.",
      "productionStage2": "Aufbau der Geschichte, Bewegung und Übergänge.",
      "productionStage3": "Musik, Stimme und Untertitel ausbalancieren.",
      "productionStage4": "Abschließende Prüfungen in der Live-Vorschau durchführen.",
      "genericCreationError": "Beim Erstellen des Videoplans ist ein Problem aufgetreten. Ihre Materialien und Ihre Auswahl werden gespeichert; Sie können es erneut versuchen.",
      "newVideo": "Neues Video",
      "topicNews": "Nachrichten",
      "topicDocumentary": "Dokumentation",
      "topicExplainer": "Erklärer",
      "topicStory": "Geschichte",
      "topicScience": "Wissenschaft",
      "topicPhilosophy": "Philosophie",
      "topicMagazine": "Magazin",
      "topicEntertainment": "Unterhaltung",
      "topicList": "Liste",
      "toneCalm": "Beruhigt",
      "toneEmotional": "Emotional",
      "toneEnergetic": "Energetisch",
      "toneStorytelling": "Geschichtenerzählen",
      "toneCheerful": "Fröhlich",
      "toneMysterious": "Mysteriös",
      "toneNews": "Nachrichten",
      "styleCinematic": "Kinematisch",
      "styleDarkCinematic": "Dunkles Kinematisches",
      "styleDocumentary": "Dokumentation",
      "styleModernDocumentary": "Moderne Dokumentation",
      "stylePovImmersive": "Immersive POV",
      "styleUgcAuthentic": "Authentisches UGC",
      "styleMiniVlog": "Mini-Vlog",
      "styleSocialViral": "Sozial viral",
      "styleHyperEdit": "Hyperedit",
      "styleSportsHype": "Sport-Hype",
      "styleVelocityEdit": "Geschwindigkeitsbearbeitung",
      "styleMusicBeatEdit": "Musik-Beat-Bearbeitung",
      "styleKineticTypography": "Kinetische Typografie",
      "styleMinimalClean": "Minimal & Sauber",
      "styleLuxuryMinimal": "Luxuriös Minimalistisch",
      "styleCommercialProduct": "Werbeprodukt",
      "styleEditorialFashion": "Redaktionelle Mode",
      "styleCollageZine": "Collage-Zine",
      "styleTechFuturistic": "Technisch futuristisch",
      "styleRetroFuturism": "Retrofuturismus",
      "styleY2kDigital": "Y2K Digital",
      "styleVhsCamcorder": "VHS-Camcorder",
      "styleAnalogFilm": "Analogfilm",
      "styleGlitchCyber": "Glitch Cyber",
      "musicUpbeatMood": "Energetisch · hell",
      "musicUpbeatDetail": "Echte Instrumentalaufnahmen für fröhliche soziale Inhalte, Reisemomente und lebendige Schnitte.",
      "musicElectronicMood": "Modern · rhythmisch",
      "musicElectronicDetail": "Echte elektronische Musik für Städte, Technologie, Produkte und schnelle Bearbeitungen.",
      "musicRomanceMood": "Emotional · warm",
      "musicRomanceDetail": "Instrumentale Musik mit einem sanften emotionalen Bogen für Familie, Porträts, besondere Tage und Erinnerungen.",
      "musicScoringMood": "Erzählend · filmisch",
      "musicScoringDetail": "Kinematische Hintergrundmusik, die unterstützende Geschichten, Werbeaktionen und dramatische Übergänge begleitet.",
      "musicEpicMood": "Stark · aufsteigend",
      "musicEpicDetail": "Schichtweise instrumentale Musik, die sich für große Eröffnungen, Reisen und starke Enden aufbaut.",
      "proposalBalancedTitle": "Ausgewogenes Narrativ",
      "proposalBalancedSummary": "Eine Bearbeitung, die den Fluss des Materials bewahrt und die stärksten Rahmen hervorhebt.",
      "proposalBalancedVisual": "Starke Hierarchie und ein kohärentes visuelles System",
      "proposalBalancedTransitions": "Glatte Schnitte und gemessene Einrückungen",
      "proposalBalancedMusic": "Musik, die sich von Emotion zu Rhythmus bewegt",
      "proposalQuietTitle": "Leise Geschichte",
      "proposalQuietSummary": "Ein ruhiger Ansatz, der den Rahmen mehr Zeit gibt und Details und natürliche Emotionen betont.",
      "proposalQuietVisual": "Sanfte Töne und längere Aufnahmen",
      "proposalQuietTransitions": "Kreuzauflösen und langsame Pfannen",
      "proposalQuietMusic": "Einfache und emotionale Musik",
      "proposalRhythmicTitle": "Rhythmisches Edit",
      "proposalRhythmicSummary": "Eine Bearbeitung mit einem starken Einstiegshaken, der in der Mitte beschleunigt und am Ende klar abklingt.",
      "proposalRhythmicVisual": "Stärkerer Kontrast und dynamisches Framing",
      "proposalRhythmicTransitions": "Beat-Schnitte und kontrollierte Peitschenwechsel",
      "proposalRhythmicMusic": "Energetische, aufstrebende Musik",
      "underVoiceover": "weich unter dem Sprachausgabe",
      "withShortVoiceover": "mit kurzem, prägnantem Sprachauszug"
    },
    "information": {
      "home": "Start",
      "documentInfo": "Dokumenteninformationen",
      "version": "Version",
      "effective": "Gültig ab",
      "updated": "Zuletzt aktualisiert",
      "contents": "Inhalt",
      "officialReferences": "Offizielle Referenzen",
      "referenceTitle": "Gesetze und Behördenressourcen",
      "referenceBody": "Diese Links dienen der allgemeinen Information. Es gelten die gesetzlichen Vorschriften und aktuellen Regeln der zuständigen Behörden.",
      "supportKicker": "Sponelabs-Support",
      "contactTitle": "Kontakt",
      "contactLead": "Kontaktieren Sie das Voxnela Supportteam bezüglich Ihres Kontos, Ihrer Mitgliedschaft, Ihrer Zahlung, Ihrer Erstellung, Ihrer Inhaltsberichte, Ihrer Privatsphäre oder technischer Probleme.",
      "supportEmail": "Support-E-Mail",
      "emailBody": "Die untenstehende Schaltfläche öffnet Ihre Standard-E-Mail-App mit einer sofort einsatzbereiten Supportvorlage, damit wir schneller ermitteln können.",
      "openEmail": "E-Mail-App öffnen",
      "includeTitle": "In die Nachricht aufnehmen",
      "includeItems": [
        "Egal, ob Sie Web, iOS oder Mac verwenden;",
        "Die Version Ihres Geräts und des Betriebssystems;",
        "Schritte zur Reproduktion des Problems;",
        "Der zugehörige Projektlink, Transaktionsdetails oder Screenshot, falls verfügbar."
      ],
      "sensitiveTitle": "Keine sensiblen Daten senden",
      "sensitiveBody": "Fügen Sie keine Verifizierungscodes, Passwörter, vollständige Zahlungskarteninformationen, Ausweisdokumente, Gesundheitsdaten oder andere sensible Informationen ein, die nicht erforderlich sind, um das Problem zu lösen.",
      "securityTitle": "Sicherheit und Inhaltsmeldungen",
      "securityBody": "Verwenden Sie „Sicherheit“ für eine Schwachstelle, „Datenschutzanfrage“ für eine Datenanfrage oder „Inhaltsbericht“ für schädlichen oder verstoßenden Inhalt. Kontaktieren Sie im Falle einer unmittelbaren physischen Gefahr die örtlichen Rettungsdienste.",
      "mailSubject": "Voxnela Supportanfrage",
      "mailGreeting": "Hallo Voxnela Supportteam,",
      "mailTopic": "Support-Thema:",
      "mailPlatform": "Plattform (Web / iOS / Mac):",
      "mailDevice": "Gerät und Betriebssystem:",
      "mailProject": "Projekt-ID (falls verfügbar):",
      "mailDescription": "Beschreibung des Problems oder der Anfrage:",
      "mailThanks": "Danke.",
      "termsEyebrow": "Voxnela Nutzungsbedingungen",
      "termsTitle": "Nutzungsbedingungen",
      "termsLead": "Diese Bedingungen regeln die Nutzung von KI-Bilderstellungs- und Bearbeitungsdiensten in der Voxnela-Webseite und den iOS-Apps.",
      "privacyEyebrow": "Voxnela Datenverbrauch",
      "privacyTitle": "Datenschutzrichtlinie",
      "privacyLead": "Diese Richtlinie erklärt, wie Konto, Bild, Projekt, Mitgliedschaft und technische Daten im Voxnela Bild-Erstellungsdienst verarbeitet werden.",
      "officialTurkishNotice": "Diese Übersetzung dient der Bequemlichkeit. Der türkische Rechtstext regelt, wenn die Bedeutungen unterschiedlich sind."
    }
  },
  "es": {
    "ui": {
      "home": "Inicio",
      "homeTitle": "Hogar",
      "explore": "Explorar",
      "gallery": "Galería",
      "myImages": "Mis imágenes",
      "settings": "Ajustes",
      "createImage": "Crear imagen",
      "back": "Volver",
      "search": "Buscar",
      "account": "Cuenta",
      "login": "Iniciar sesión",
      "logout": "Cerrar sesión",
      "profile": "Perfil",
      "profileSettings": "Perfil y Configuración",
      "plans": "Planes y uso",
      "plansSubtitle": "Créditos de imagen y facturación",
      "contact": "Contacto",
      "contactSubtitle": "Ayuda y comentarios",
      "discoverVoxnela": "Descubre Voxnela",
      "discoverVoxnelaSubtitle": "Revisa la experiencia del estudio visual",
      "privacy": "Privacidad",
      "privacySubtitle": "Cómo protegemos tus datos",
      "terms": "Condiciones de uso",
      "termsSubtitle": "Condiciones del servicio de Voxnela",
      "preferencesSubtitle": "Tu cuenta y preferencias de Voxnela",
      "accountSubtitle": "Datos de cuenta y suscripción",
      "voxAccount": "Cuenta de Voxnela",
      "accessEverywhere": "Accede a tus imágenes desde cualquier dispositivo",
      "imageRights": "{{count}} créditos de imagen",
      "availableCredits": "Créditos disponibles",
      "renewalDate": "Fecha de renovación",
      "membershipStart": "Inicio de la suscripción",
      "registrationDate": "Fecha de registro",
      "monthly": "Mensual",
      "renewalOff": "Renovación desactivada",
      "user": "Usuario de Voxnela",
      "language": "Idioma",
      "languageSubtitle": "Elige el idioma de la app",
      "supportBody": "Escríbenos si tienes un problema o quieres compartir una idea. Incluir el ID del proyecto nos ayuda a responder más rápido.",
      "studioTitle": "Estudio visual Voxnela",
      "studioSubtitle": "Crea tu estilo",
      "searchSubtitle": "Tus imágenes y proyectos",
      "searchPlaceholder": "Buscar una imagen o proyecto",
      "noSearchResults": "No hay resultados para esta búsqueda.",
      "project": "Proyecto",
      "image": "Imagen",
      "completed": "Completado",
      "currentPlan": "Plan actual",
      "notSignedIn": "Sesión no iniciada",
      "signInIntro": "Inicia sesión para empezar a usar Voxnela.",
      "creditsAvailable": "Tienes {{count}} créditos de imagen del estudio.",
      "noCredits": "No te quedan créditos de imagen en este período.",
      "membershipInfo": "En los planes anuales, los créditos se renuevan cada mes y no se acumulan. Las compras restauradas quedan protegidas en tu cuenta.",
      "signedOutMembershipInfo": "Cuando inicies sesión, aquí aparecerán tus créditos y los datos del plan.",
      "reviewPlans": "Ver planes",
      "versionUpdated": "Versión {{version}} · Actualizado el {{date}}",
      "onboardingWelcome": "Te damos la bienvenida a Voxnela",
      "skipIntro": "Omitir introducción",
      "continue": "Continuar",
      "startCreating": "Empezar a crear",
      "close": "Cerrar",
      "dragToClose": "Desliza hacia abajo para cerrar",
      "loading": "Cargando…",
      "sheetExpand": "Ampliar panel",
      "sheetCollapse": "Reducir panel",
      "cannotClose": "No se puede cerrar durante la operación",
      "stylePreview": "Vista previa del estilo",
      "stylePreviewSubtitle": "Estilos exclusivos y tendencias",
      "categories": "Categorías",
      "useThisStyle": "Usar este estilo",
      "videoControls": "Controles de vídeo",
      "play": "Reproducir",
      "pause": "Pausar",
      "mute": "Silenciar",
      "unmute": "Activar sonido",
      "minimize": "Minimizar",
      "expandVideo": "Ampliar en la app",
      "videoProgress": "Progreso del vídeo",
      "toggleVideoControls": "Mostrar u ocultar controles",
      "expandedVideo": "Vista ampliada de {{title}}",
      "goToImage": "Ir a la imagen {{title}}",
      "categoryVisualStyles": "Estilos visuales {{category}}",
      "onboarding1Eyebrow": "Creación de imágenes",
      "onboarding1Title": "Crea tu imagen.",
      "onboarding1Body": "Convierte tu idea en una imagen cinematográfica con película de 35 mm, editorial, producto, póster y muchos estilos más.",
      "onboarding2Eyebrow": "Prueba virtual de ropa",
      "onboarding2Title": "Pruébate nuevos conjuntos.",
      "onboarding2Body": "Conserva la identidad entre creaciones y genera pruebas realistas de moda, accesorios y productos.",
      "onboarding3Eyebrow": "Edición de imágenes",
      "onboarding3Title": "Edita tu imagen.",
      "onboarding3Body": "Ajusta composición, luz, color y detalles mediante una conversación, sin empezar de cero.",
      "onboarding4Eyebrow": "3 imágenes gratis",
      "onboarding4Title": "Empieza gratis.",
      "onboarding4Body": "Empieza ya con 3 generaciones de imágenes con IA gratis de una sola vez. No necesitas cuenta.",
      "onboardingFaceEyebrow": "Análisis de rostro y estilo",
      "onboardingFaceTitle": "Explora tu rostro y estilo.",
      "onboardingFaceBody": "Explora ideas de peinado, gafas y ropa a partir de tu retrato en una sola guía visual.",
      "onboardingHouseEyebrow": "Viaje en el tiempo",
      "onboardingHouseTitle": "Viaja en el tiempo.",
      "onboardingHouseBody": "Reúne tus fotos y fechas para visualizar cómo ha cambiado tu hogar con el tiempo.",
      "onboardingFestivalEyebrow": "Tu día de festival",
      "onboardingFestivalTitle": "Planifica tu día de festival de un vistazo.",
      "onboardingFestivalBody": "Convierte el programa, los escenarios y los horarios que compartas en una ruta visual personal.",
      "onboardingStylesEyebrow": "Estilos Voxnela",
      "onboardingStylesTitle": "Elige tu estilo.",
      "onboardingStylesBody": "Convierte tu idea en una imagen cinematográfica con película de 35 mm, editorial, producto, póster y muchos estilos más."
    },
    "auth": {
      "enterCode": "Introduce tu código",
      "membershipAndAccount": "Datos de suscripción y cuenta",
      "noPeriodInfo": "Período no disponible",
      "memberSince": "Miembro desde",
      "planSince": "{{plan}} desde",
      "membershipRenewal": "Fecha de renovación de la membresía",
      "accountActions": "Acciones de la cuenta",
      "manageSubscriptionTitle": "Finalizar suscripción",
      "manageSubscriptionSubtitle": "Gestiona tu suscripción a la tienda y la renovación automática.",
      "deleteAccountTitle": "Eliminar mi cuenta",
      "deleteAccountSubtitle": "Proceso de eliminación reversible de 15 días.",
      "deleteDataTitle": "Eliminar mis datos",
      "deleteDataSubtitle": "Proceso reversible de eliminación de datos de 30 días.",
      "signingOut": "Cerrando sesión…",
      "signOut": "Cerrar sesión",
      "signingIn": "Iniciando sesión…",
      "continueApple": "Continuar con Apple",
      "continueGoogle": "Continuar con Google",
      "or": "o",
      "email": "Correo electrónico",
      "emailPlaceholder": "tu@ejemplo.com",
      "legalPrefix": "Al continuar con Voxnela, aceptas el",
      "legalTerms": "Términos de uso",
      "legalJoin": "y confirme que ha leído y entendido el",
      "legalPrivacy": "Aviso de privacidad",
      "legalSuffix": ".",
      "sendingCode": "Enviando código…",
      "emailSignIn": "Iniciar sesión con correo",
      "codeSent": "Hemos enviado un código a {{email}}.",
      "change": "Cambiar",
      "sixDigitCode": "Código de 6 dígitos",
      "emailCode": "Código de inicio de sesión por correo electrónico",
      "verifyingCode": "Verificando código…",
      "resendCode": "Reenviar código",
      "requestReceived": "Solicitud recibida",
      "accountDeletionStarted": "El proceso de eliminación de tu cuenta ha comenzado",
      "dataDeletionStarted": "Su proceso de eliminación de datos ha comenzado",
      "accountAction": "Acción de la cuenta",
      "accountDeletesAt": "Tu cuenta será eliminada permanentemente en {{date}}.",
      "dataDeletesAt": "Sus datos personales de Voxnela serán eliminados permanentemente en {{date}}.",
      "deletionUndo": "Si inicia sesión con la misma cuenta antes de esta fecha, el proceso de eliminación se cancelará automáticamente. Su sesión actual se cerró porque se creó la solicitud.",
      "done": "Listo",
      "cancel": "Cancelar",
      "preparing": "Preparando...",
      "invalidEmail": "Introduzca una dirección de correo electrónico válida.",
      "enterSixDigitCode": "Introduzca el código de 6 dígitos enviado a su correo electrónico.",
      "signInFailed": "No se pudo completar el inicio de sesión. Por favor, inténtelo de nuevo.",
      "codeSendFailed": "El código de inicio de sesión no pudo enviarse. Por favor, inténtelo de nuevo.",
      "codeVerifyFailed": "El código no pudo ser verificado. Por favor, inténtelo de nuevo.",
      "operationFailed": "La operación no pudo completarse en este momento. Por favor, inténtelo de nuevo.",
      "popupClosed": "La ventana de inicio de sesión estaba cerrada.",
      "unauthorizedDomain": "Este dominio no está autorizado para iniciar sesión.",
      "methodUnavailable": "Este método de inicio de sesión aún no está habilitado.",
      "tooManyCodes": "Se solicitaron demasiados códigos. Inténtelo de nuevo en unos minutos.",
      "invalidCode": "El código es inválido o ha caducado. Solicite un nuevo código.",
      "emailUnavailable": "La entrega por correo electrónico no está disponible actualmente.",
      "actions": {
        "subscription": {
          "eyebrow": "Acción de suscripción",
          "title": "¿Terminar tu suscripción?",
          "confirm": "Gestionar suscripciones",
          "paragraphs": [
            "Continuar abre la página de gestión de suscripciones de la Apple App Store o de Google Play donde compraste la suscripción. Debes desactivar la renovación automática en la tienda.",
            "Después de la cancelación, los beneficios de tu membresía existentes siguen disponibles hasta el final del período de pago. Eliminar tu cuenta o tus datos no cancela una suscripción a la tienda."
          ]
        },
        "account": {
          "eyebrow": "Acción de cuenta permanente",
          "title": "¿Estás seguro de que quieres eliminar tu cuenta?",
          "confirm": "Iniciar el proceso de eliminación de 15 días",
          "paragraphs": [
            "Continuar inicia un proceso de eliminación de 15 días y te da de baja por seguridad. Si no inicias sesión de nuevo durante este periodo, tu cuenta, perfil, creaciones, biblioteca, colecciones y datos relacionados con Voxnela serán eliminados permanentemente.",
            "Iniciar sesión con la misma cuenta antes de 15 días cancela la eliminación automáticamente. Eliminar la cuenta no cancela una suscripción activa a la tienda; cancelela por separado en la tienda."
          ]
        },
        "data": {
          "eyebrow": "Acción de datos permanente",
          "title": "¿Estás seguro de que quieres eliminar tus datos?",
          "confirm": "Iniciar el proceso de eliminación de 30 días",
          "paragraphs": [
            "Continuar inicia un proceso de eliminación de 30 días y te da de baja por seguridad. Si no inicias sesión de nuevo durante este período, tus creaciones, biblioteca, colecciones, registros, interacciones y otros datos personales de Voxnela serán eliminados permanentemente; tu cuenta de inicio de sesión permanece disponible.",
            "Iniciar sesión de nuevo antes de 30 días cancela la eliminación de datos automáticamente. Los registros de transacciones y seguridad limitados requeridos por ley pueden conservarse con acceso restringido durante los períodos legales aplicables."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "No quedan créditos de imagen",
      "quotaFreeMessage": "Has utilizado el crédito de imagen en tu cuenta gratuita. Elige un plan para seguir creando.",
      "later": "Más tarde",
      "currentCredit": "Créditos actuales: 0",
      "quotaProTitle": "Se ha alcanzado la cuota mensual Pro",
      "quotaProMessage": "Has utilizado los 100 créditos de imágenes de este mes. Actualiza a Studio para seguir creando.",
      "renewalDate": "Fecha de renovación: {{date}}",
      "quotaStudioTitle": "Se ha alcanzado la cuota mensual de estudio",
      "quotaStudioMessage": "Los créditos de imagen se renovarán automáticamente en {{date}}.",
      "done": "Hecho",
      "membership": "Suscripción a Voxnela",
      "options": "Opciones de suscripción",
      "credits": "Créditos",
      "currentMembership": "Suscripción actual",
      "yearlyDiscount": "17 % de descuento",
      "loadingPrice": "Cargando precio de la tienda…",
      "loadingStorePrice": "Carga de precios de la tienda",
      "year": "año",
      "month": "mes",
      "renewDisclosure": "Se renueva automáticamente cada {{period}}. Cancelar en cualquier momento.",
      "legal": "Información legal",
      "terms": "Condiciones",
      "alreadyMember": "Ya tienes {{plan}} {{period}}",
      "startPlan": "Comienza el plan {{plan}}",
      "upgradeStudio": "Mejorar a Studio",
      "yearlyAdvantage": "Cambia a ahorros anuales",
      "upgrade": "Mejorar suscripción",
      "signInRequired": "Inicia sesión en tu cuenta de Voxnela antes de comenzar una suscripción.",
      "catalogUnavailable": "El catálogo de pagos no pudo ser verificado para este plan. Por favor, inténtelo de nuevo en breve.",
      "paymentUnavailable": "La pantalla de pago no pudo abrirse. Por favor, inténtelo de nuevo.",
      "benefits": [
        {
          "lead": "Créditos {{credits}}",
          "label": "Generación de imágenes de alta resolución cada mes"
        },
        {
          "lead": "Más de 50 estilos de estudio",
          "label": "Neomiminimalismo, cinematográfico y todos los estilos de firma"
        },
        {
          "lead": "Bloqueo facial",
          "label": "Prueba virtual de moda sin cambiar las características faciales"
        },
        {
          "lead": "Cola de prioridad",
          "label": "Procesamiento de GPU ultra rápido sin esperas"
        },
        {
          "lead": "Revisiones de chat",
          "label": "Ediciones de detalle ilimitadas en múltiples vueltas en lenguaje natural"
        },
        {
          "lead": "Derechos comerciales completos",
          "label": "Uso de alta resolución, sin marcas de agua"
        }
      ],
      "restorePurchases": "Restaurar compras",
      "restoringPurchases": "Restauración de compras...",
      "restoreSuccess": "Tu membresía ha sido restaurada.",
      "restoreEmpty": "No se encontró ninguna suscripción activa para esta cuenta de App Store.",
      "membershipSyncPending": "Verificando la membresía y los créditos de imagen...",
      "membershipSyncFailed": "No se pudieron sincronizar los créditos de imagen. Inténtalo de nuevo.",
      "membershipUnavailable": "No se pudo cargar la suscripción.",
      "retry": "Reintentar"
    },
    "video": {
      "revisionHook": "Haz que los primeros tres segundos sean más atractivos.",
      "revisionPace": "Equilibre el ritmo y acorte las secciones lentas.",
      "revisionEnding": "Haz que el final sea más memorable.",
      "revisionTransition": "Haz que las transiciones sean más suaves y naturales.",
      "revisionFraming": "Utilice un encuadre más equilibrado para los detalles importantes.",
      "revisionColor": "Haz que los colores sean más equilibrados y cinematográficos.",
      "revisionText": "Haz que el texto sea más corto y fácil de leer.",
      "revisionAudio": "Acompáñe la música más de cerca al ritmo de las imágenes.",
      "revisionEmotion": "Haz que la historia se sienta más sincera y emocional.",
      "revisionStructure": "Construye un comienzo, medio y final más claros.",
      "previewBack": "Volver a la vista previa",
      "revisionWelcome": "¿Qué te gustaría cambiar?",
      "revisionFailed": "No pude aplicar ese cambio. ¿Podrías describirlo de nuevo?",
      "finalQueued": "El video final está en cola. Aparecerá bajo Videos cuando esté listo.",
      "watermarkUpgrade": "Elige un plan para crear una nueva salida final sin la marca de agua de Voxnela.",
      "finalFailed": "El video final no pudo comenzar.",
      "projectDeleteFailed": "El proyecto no pudo ser eliminado.",
      "videoDescriptionWithBrief": "Este vídeo fue creado a partir de “{{brief}}”. Voxnela seleccionó los momentos más fuertes y construyó el ritmo y el orden de las escenas en torno a la dirección creativa elegida.",
      "videoDescriptionGeneric": "Voxnela evaluó los materiales en cuanto al contenido, el ritmo y la coherencia narrativa, destacando los momentos más fuertes para una edición equilibrada.",
      "play": "Jugar",
      "deletesOn": "elimina en {{date}}",
      "projectsBelong": "Tus proyectos están vinculados a tu cuenta.",
      "videosBelong": "Sus vídeos están vinculados a su cuenta.",
      "signInToSeeProjects": "Inicia sesión para ver tus proyectos y continuar en todos los dispositivos.",
      "signInToSeeVideos": "Inicia sesión para ver tus vídeos y continuar en todos los dispositivos.",
      "delete": "Eliminar",
      "deleting": "Eliminando…",
      "secondsVersion": "{{seconds}} sec · versión {{version}}",
      "deleteProject": "Eliminar proyecto",
      "projectCoverUnavailable": "La portada del proyecto no pudo cargarse",
      "videoCoverPreparing": "Preparando la portada del vídeo",
      "deleteVideo": "Eliminar vídeo",
      "signed": "Marcado Voxnela",
      "failed": "No pudo completar",
      "tryAgain": "Puedes volver a intentarlo",
      "cancelled": "Cancelado",
      "noCreditUsed": "No se utilizó crédito",
      "featuredStyles": "Estilos visuales destacados",
      "previousImage": "Imagen anterior",
      "nextImage": "Siguiente imagen",
      "reviewStyle": "Explora este estilo",
      "featuredNavigation": "Navegación visual destacada",
      "taskCategories": "Categorías de tareas",
      "projectOpening": "Proyecto de apertura",
      "opening": "Apertura...",
      "projectNotFound": "Proyecto no encontrado",
      "projectUnavailable": "Este proyecto ya no está disponible.",
      "backToProjects": "Volver a mis proyectos",
      "editVideo": "Editar vídeo",
      "versionContext": "Versión {{version}} · Voxnela conoce tu proyecto y materiales",
      "livePreviewActions": "Acciones de vista previa en vivo",
      "edit": "Editar",
      "preparing": "Preparando",
      "save": "Guardar",
      "thinking": "Voxnela está pensando",
      "revisionSuggestions": "Sugerencias de edición",
      "describeChange": "Describe el cambio que quieres",
      "sendEdit": "Enviar solicitud de edición",
      "deleteProjectDescription": "¿Estás seguro de que quieres eliminar “{{title}}” y todos los materiales relacionados? Esto no se puede deshacer.",
      "projects": "Proyectos",
      "projectsPreparing": "Preparando tus proyectos",
      "noProjects": "Aún no tienes un proyecto. Empieza describiendo tu primera idea.",
      "createNew": "Crear imagen nueva",
      "thisProject": "Este proyecto",
      "videos": "Vídeos",
      "videosPreparing": "Preparando tus vídeos",
      "noVideos": "Aún no tienes un video completado. Aparecerá aquí cuando tu primer video esté listo.",
      "videoPlayFailed": "El video no pudo reproducirse.",
      "videoNotReady": "El archivo de video aún no está listo para descargar.",
      "videoDownloadFailed": "El video no pudo descargarse.",
      "videoDeleteFailed": "El vídeo no pudo ser eliminado.",
      "videoLoading": "Cargando el vídeo...",
      "videoActions": "Acciones de vídeo",
      "showVideoDescription": "Mostrar descripción del vídeo",
      "videoDownloading": "Descarga de vídeo",
      "downloadVideo": "Descargar video",
      "thisVideo": "Este video",
      "deleteVideoDescription": "¿Estás seguro de que quieres eliminar el vídeo titulado “{{title}}”? Esto no se puede deshacer."
    },
    "studio": {
      "useStyle": "Usa este estilo",
      "galleryFilters": "Filtros de galería",
      "modeStyleTransfer": "Estilos Voxnela",
      "modeVirtualTryOn": "Prueba virtual",
      "modeMagazineCover": "Revista y portada",
      "modePosterStudio": "Estudio de cartelería",
      "modeCommercial": "Muestra de productos",
      "modeTimeWarp": "Viaje en el tiempo",
      "modeOutpaintRelight": "Ampliar y reencender",
      "modeInfographic": "Infografías y datos",
      "modePortraitRetouch": "Retoque de retrato",
      "modeArtisticCollage": "Collage artístico",
      "defaultStyle": "Estilo Voxnela",
      "signInToCreate": "Inicia sesión para crear una imagen.",
      "signInToEdit": "Inicia sesión para editar una imagen.",
      "creationSuccess": "Tu imagen se ha creado correctamente. Avísame directamente si deseas cambiar la iluminación, los colores, los objetos o el encuadre.",
      "imageReady": "Tu imagen está lista. Dime qué te gusta o qué quieres revisar.",
      "revisionSuccess": "La revisión está completa. Puedes compararla con el deslizador antes/después o solicitar otro cambio.",
      "versionReady": "La versión {{version}} está lista.",
      "projectNotFound": "Proyecto no encontrado.",
      "styleApplied": "Estilo {{style}} aplicado",
      "imageCreation": "Creación de imágenes",
      "defaultPrompt": "Imagen de estudio",
      "aspectSquare": "Cuadrado",
      "aspectSquareDetail": "Bucle de Instagram, Perfil, Arte",
      "aspectVertical": "Vertical",
      "aspectVerticalDetail": "Historias de Instagram, Reels, TikTok",
      "aspectHorizontal": "Horizontal",
      "aspectHorizontalDetail": "YouTube, Banner, Cine",
      "aspectPortrait": "Retrato",
      "aspectPortraitDetail": "Retrato de Instagram, póster, muestra",
      "aspectPanoramic": "Panorámico",
      "aspectPanoramicDetail": "Paisaje cinematográfico ultra ancho",
      "styles": "Estilos Voxnela",
      "fullScreenStyle": "Ver estilo a pantalla completa",
      "closeDescription": "Descripción del estilo de cierre",
      "moreWithVoxnela": "Haz más con Voxnela",
      "quickStartBody": "Escribe lo que quieras a continuación o adjunta un archivo.",
      "createImage": "Crear imagen",
      "createImageDetail": "Construye tu idea desde cero",
      "editImage": "Editar imagen",
      "editImageQuick": "Editar una imagen",
      "editImageDetail": "Reimagina una imagen subida",
      "transformStyle": "Transformar el estilo y la escena",
      "transformStyleDetail": "Mueve tu imagen a otro mundo",
      "visualizeDocument": "Visualizar un documento o presentación",
      "visualizeDocumentDetail": "Convierte el contenido completo en un diseño",
      "submittedImage": "Imagen enviada",
      "generating": "Voxnela está creando tu imagen…",
      "viewImage": "Ver imagen",
      "removeStyle": "Eliminar estilo seleccionado",
      "referenceImage": "Imagen de referencia",
      "referenceNotice": "Esta imagen será revisada o se aplicará un nuevo estilo",
      "removeReference": "Eliminar imagen de referencia",
      "remove": "Eliminar",
      "uploading": "Subiendo",
      "addFile": "Añadir un archivo o imagen",
      "addFileTitle": "Sumar hasta 4 imágenes o un documento (PDF, Word, PPT, máximo 12 MB)",
      "aspectRatio": "Relación de aspecto",
      "selectAspectRatio": "Seleccionar relación de aspecto",
      "aspectOptions": "Opciones de relación de aspecto",
      "revisePlaceholder": "¿Qué te gustaría cambiar en esta imagen?",
      "styledPlaceholder": "Describe la imagen que quieres en este estilo (opcional)...",
      "promptPlaceholder": "Describe una imagen o escribe una instrucción...",
      "reviseImage": "Revisar imagen",
      "generateImage": "Generar imagen",
      "generatedImage": "Imagen generada",
      "done": "Listo",
      "fileLimitTitle": "Archivo demasiado grande",
      "fileLimitMessage": "“{{name}}” supera el límite de 12 MB ({{size}} MB). Elija un archivo más pequeño.",
      "imageLimitTitle": "Límite de imagen",
      "imageLimitMessage": "Puedes subir hasta 4 imágenes. Las imágenes {{count}} están seleccionadas actualmente.",
      "uploadFailedTitle": "Subida fallida",
      "uploadFailedMessage": "Se ha producido un problema al cargar el archivo.",
      "revisionFailed": "Se ha producido un error durante la revisión o se ha excedido la cuota.",
      "generationFailed": "Se ha producido un error durante la generación de imágenes o se ha excedido la cuota.",
      "imageDetails": "Detalles de la imagen",
      "close": "Cerrar",
      "download": "Descargar",
      "downloadImage": "Descargar imagen",
      "downloading": "Descargando",
      "versionImage": "Imagen",
      "exploreTitle": "¿Qué estilo buscas?",
      "explorePlaceholder": "Por ejemplo: un retrato cinematográfico con tonos oscuros y perspectiva profunda",
      "searchStyles": "Buscar estilos visuales",
      "clearSearch": "Búsqueda clara",
      "exploreCategories": "Explora categorías",
      "all": "Todos",
      "styleCount": "Estilos {{count}}",
      "noStyle": "No se encontró un estilo que coincida",
      "noStyleBody": "Inténtalo de nuevo con una descripción más corta o con palabras diferentes.",
      "libraryKicker": "Tu biblioteca de imágenes personales",
      "myImages": "Mis imágenes",
      "imageWorks": "La imagen {{count}} funciona",
      "newImage": "Crear imagen nueva",
      "noImage": "Aún no has creado una imagen",
      "noCategoryImage": "No hay imágenes en esta categoría",
      "emptyGalleryBody": "Crea tu primera imagen con transferencia de estilo, prueba virtual, portada de revista o muestra de producto.",
      "firstImage": "Crea tu primera imagen",
      "imageWork": "Trabajo de imagen"
    },
    "create": {
      "briefTitle": "Describe tu idea o tema",
      "briefPlaceholder": "¿Cuál es el tema? Por ejemplo: el futuro de la IA, un viaje a Marte o el lanzamiento de un producto…",
      "briefLabel": "Resumen de creación",
      "contentType": "Tipo de contenido",
      "media": "Imágenes y medios",
      "added": "{{count}} añadido",
      "optional": "Opcional",
      "addMedia": "Añade una foto o video si quieres",
      "addMediaBody": "Sube tus propios medios o déjalos vacíos y deja que la IA los encuentre",
      "attachedMedia": "Medios adjuntos",
      "add": "Añadir",
      "mediaFallback": "Medios",
      "aiCompletes": "Deja que la IA complete las imágenes",
      "noMedia": "No se han subido imágenes; la IA completará las escenas.",
      "productionFormat": "Formato de producción",
      "style": "Estilo",
      "customVisualWorld": "Describe tu mundo visual",
      "colorsAtmosphere": "Colores, atmósfera, cámara, ritmo",
      "customStyleShort": "Describe el mundo visual que tienes en mente (por ejemplo: tonos pastel y una cámara tranquila, o neón cyberpunk...)",
      "customStyleLong": "Describe el mundo visual, los colores, la atmósfera y el ritmo que tienes en mente.",
      "voiceover": "Voz en off",
      "ownVoiceover": "Tu texto de voz en off",
      "voiceoverPlaceholder": "Escribe tu texto aquí. Si está vacío, Voxnela lo preparará.",
      "duration": "Duración",
      "seconds": "{{count}} seg",
      "freeLimit": "El video final más largo del plan gratuito es de 60 segundos.",
      "addSound": "Añadir sonido o música",
      "notAdded": "No añadido",
      "files": "Archivos {{count}}",
      "readySounds": "Utilice sonidos prefabricados",
      "musicLibrary": "Biblioteca de música",
      "uploadOwn": "Sube el tuyo propio",
      "captions": "Subtítulos",
      "back": "Volver",
      "create": "Crear",
      "next": "Siguiente",
      "researchingTopic": "Investigando el tema...",
      "analyzingMaterials": "Analizando materiales...",
      "researchBody": "Verificando las fuentes y preparando el guion y el plan visual.",
      "analyzeBody": "Evaluando los marcos fuertes, la emoción, el ritmo y lo breve juntos.",
      "creativeDirection": "Dirección creativa {{count}}",
      "recommended": "Recomendado",
      "generationFailed": "La creación no pudo completarse",
      "retry": "Prepárate de nuevo",
      "backDirections": "Volver a las direcciones creativas",
      "preparingVideo": "Preparando tu vídeo",
      "voiceoverText": "Texto de voz en off",
      "describeStyle": "Describe tu propio estilo",
      "topicDirection": "Tema y dirección",
      "styleEditorSubtitle": "Describe el mundo visual, los colores y la atmósfera",
      "editorSubtitle": "Escribe el texto e insertalo en la hoja de creación",
      "voiceoverEditorPlaceholder": "Escribe el texto para usar para el locución en off.",
      "topicEditorPlaceholder": "Escribe el tema y cómo quieres que te lo cuenten.",
      "insertText": "Insertar texto",
      "bestFor": "Mejor para:",
      "useStyle": "Usa este estilo",
      "musicSubtitle": "Las pistas reales están autorizadas para uso comercial",
      "adding": "Añadiendo...",
      "musicLicense": "Las pistas están proporcionadas bajo CC0 1.0; se permite el uso comercial y no se requiere atribución.",
      "yes": "Sí",
      "no": "No",
      "newCreation": "Nueva creación",
      "reviewing": "Voxnela está revisando",
      "chooseDirection": "Elija uno de los tres enfoques de edición",
      "ideaSubtitle": "Describe tu idea; sube imágenes o permite que Voxnela las cree",
      "projectOpenFailed": "El paquete del proyecto no se pudo abrir.",
      "tooManyAssets": "Puedes añadir hasta 50 activos a un proyecto.",
      "uploadSizeLimit": "La carga total del proyecto supera el límite de 2 GB.",
      "filesAddFailed": "Los archivos no pudieron añadirse.",
      "musicPreviewFailed": "La vista previa de la música no pudo abrirse.",
      "musicFetchFailed": "No se pudo recuperar el archivo de música.",
      "musicAddFailed": "La música no pudo añadirse.",
      "topicRequired": "Introduce un tema y describe de qué tratará tu vídeo.",
      "briefTooShort": "Describe lo que quieres decir en al menos unas pocas palabras.",
      "mediaRequired": "Suba una imagen o habilite las visuales generadas por IA.",
      "proposalIntro": "Revisé las imágenes y los videos y preparé tres instrucciones de edición que se ajustan a tu estilo, formato y opciones de audio.",
      "removeMaterial": "Eliminar {{name}}",
      "aiVisualNotice": "Las imágenes reales y las ilustraciones de IA de licencia abierta se encuentran automáticamente.",
      "stepProgress": "Paso {{current}} de {{total}}",
      "styleSampleAlt": "Ejemplo que muestra el estilo de vídeo {{style}}",
      "reviewStyle": "Revise el estilo {{style}}",
      "selectedDirectionPrompt": "Dirección seleccionada: {{title}}. {{summary}} Dirección visual: {{visual}}. Enfoque de transición: {{transitions}}. Enfoque musical: {{music}}.",
      "letVoxnelaChoose": "Deja que Voxnela elija",
      "feminineVoice": "Femenino",
      "masculineVoice": "Masculino",
      "narrationStyle": "Estilo de narración",
      "voiceEstimate": "Acerca de {{seconds}} sec · Palabras {{words}}.",
      "voiceShort": "Si es una abreviatura de {{duration}} segundos, Voxnela lo completará manteniendo el significado.",
      "voiceNatural": "Voxnela solo ajusta la gramática, la redacción y el flujo natural.",
      "removeFile": "Eliminar el archivo {{name}}",
      "musicStop": "Detener {{title}}",
      "musicListen": "Escuche {{title}}",
      "automatic": "Automóvil",
      "all": "Todo",
      "cinematic": "Cinemático",
      "social": "Social y dinámico",
      "designTypography": "Diseño y tipografía",
      "retroExperimental": "Retro y experimental",
      "productionStage1": "Seleccionando los mejores encuadros y escenas.",
      "productionStage2": "Construyendo la historia, el movimiento y las transiciones.",
      "productionStage3": "Equilibrando música, voz y subtítulos.",
      "productionStage4": "Realizando las comprobaciones finales en la vista previa en vivo.",
      "genericCreationError": "Se ha producido un problema al preparar el plan de vídeo. Sus materiales y opciones se han conservado; puede volver a intentarlo.",
      "newVideo": "Nuevo video",
      "topicNews": "Noticias",
      "topicDocumentary": "Documental",
      "topicExplainer": "Explicador",
      "topicStory": "Historia",
      "topicScience": "Ciencia",
      "topicPhilosophy": "Filosofía",
      "topicMagazine": "Revista",
      "topicEntertainment": "Entretenimiento",
      "topicList": "Lista",
      "toneCalm": "Calmo",
      "toneEmotional": "Emocional",
      "toneEnergetic": "Enérgico",
      "toneStorytelling": "Narración de historias",
      "toneCheerful": "Animado",
      "toneMysterious": "Misterioso",
      "toneNews": "Noticias",
      "styleCinematic": "Cinemático",
      "styleDarkCinematic": "Cinematográfico oscuro",
      "styleDocumentary": "Documental",
      "styleModernDocumentary": "Documental moderno",
      "stylePovImmersive": "Punto de vista inmersivo",
      "styleUgcAuthentic": "UGC auténtico",
      "styleMiniVlog": "Mini vlog",
      "styleSocialViral": "Viral social",
      "styleHyperEdit": "Edición hiperactiva",
      "styleSportsHype": "Hype deportivo",
      "styleVelocityEdit": "Edición de velocidad",
      "styleMusicBeatEdit": "Edición de ritmos musicales",
      "styleKineticTypography": "Tipografía cinética",
      "styleMinimalClean": "Mínimo y limpio",
      "styleLuxuryMinimal": "Minimalismo de lujo",
      "styleCommercialProduct": "Producto comercial",
      "styleEditorialFashion": "Moda editorial",
      "styleCollageZine": "Colchado de revistas",
      "styleTechFuturistic": "Tecnología futurista",
      "styleRetroFuturism": "Retrofuturismo",
      "styleY2kDigital": "Digital Y2K",
      "styleVhsCamcorder": "Cámara VHS",
      "styleAnalogFilm": "Cinta analógica",
      "styleGlitchCyber": "Fallo cibernético",
      "musicUpbeatMood": "Enérgica · brillante",
      "musicUpbeatDetail": "Grabaciones instrumentales reales para contenido social animado, momentos de viaje y ediciones animadas.",
      "musicElectronicMood": "Moderno · rítmico",
      "musicElectronicDetail": "Música electrónica real para ciudades, tecnología, productos y ediciones de ritmo rápido.",
      "musicRomanceMood": "Emocional · cálido",
      "musicRomanceDetail": "Música instrumental con un suave arco emocional para la familia, retratos, días especiales y recuerdos.",
      "musicScoringMood": "Narrativo · cinematográfico",
      "musicScoringDetail": "Música de fondo cinematográfica que apoya historias, promociones y transiciones dramáticas.",
      "musicEpicMood": "Potente · en aumento",
      "musicEpicDetail": "Música instrumental estratificada que se construye para grandes aperturas, viajes y finales fuertes.",
      "proposalBalancedTitle": "Narrativa equilibrada",
      "proposalBalancedSummary": "Una edición que conserva el flujo del material y resalta los cuadros más fuertes.",
      "proposalBalancedVisual": "Fuerte jerarquía y un sistema visual coherente",
      "proposalBalancedTransitions": "Cortes lisos y empujones medidos",
      "proposalBalancedMusic": "Música que pasa de la emoción al ritmo",
      "proposalQuietTitle": "Historia tranquila",
      "proposalQuietSummary": "Un enfoque tranquilo que da a los marcos más tiempo y enfatiza los detalles y la emoción natural.",
      "proposalQuietVisual": "Tonos suaves y tomas más largas",
      "proposalQuietTransitions": "Disolución cruzada y bandejas lentas",
      "proposalQuietMusic": "Música sencilla y emocional",
      "proposalRhythmicTitle": "Edición rítmica",
      "proposalRhythmicSummary": "Una edición con un fuerte gancho de apertura que se acelera en el medio y se asienta claramente al final.",
      "proposalRhythmicVisual": "Mayor contraste y encuadre dinámico",
      "proposalRhythmicTransitions": "Cortes de ritmo y transiciones de látigo controladas",
      "proposalRhythmicMusic": "Música energética y en ascenso",
      "underVoiceover": "suave debajo de la voz en off",
      "withShortVoiceover": "con un breve y contundente locución en off"
    },
    "information": {
      "home": "Inicio",
      "documentInfo": "Información del documento",
      "version": "Versión",
      "effective": "Vigente desde",
      "updated": "Última actualización",
      "contents": "Contenido",
      "officialReferences": "Referencias oficiales",
      "referenceTitle": "Recursos legales y de autoridad",
      "referenceBody": "Estos enlaces se proporcionan para información general. La ley obligatoria y las normas vigentes de las autoridades competentes tienen prioridad.",
      "supportKicker": "Soporte de Sponelabs",
      "contactTitle": "Contáctanos",
      "contactLead": "Contacta con el equipo de soporte de Voxnela sobre tu cuenta, membresía, pago, creación, informes de contenido, privacidad o problemas técnicos.",
      "supportEmail": "Correo de soporte",
      "emailBody": "El botón de abajo abre tu aplicación de correo electrónico predeterminada con una plantilla de soporte lista para usar para que podamos investigar más rápido.",
      "openEmail": "Abrir app de correo",
      "includeTitle": "Incluye en tu mensaje",
      "includeItems": [
        "Tanto si utilizas Web, iOS o Mac;",
        "Versión de tu dispositivo y del sistema operativo;",
        "Pasos para reproducir el problema;",
        "El enlace del proyecto relacionado, los detalles de la transacción o la captura de pantalla, si están disponibles."
      ],
      "sensitiveTitle": "No envíes información sensible",
      "sensitiveBody": "No incluya códigos de verificación, contraseñas, detalles completos de la tarjeta de pago, documentos de identidad, datos de salud u otra información sensible que no sea necesaria para resolver el problema.",
      "securityTitle": "Seguridad y denuncias de contenido",
      "securityBody": "Utilice “Seguridad” para una vulnerabilidad, “Solicitud de privacidad” para una solicitud de datos o “Informe de contenido” para contenido dañino o infringido. Contacte con los servicios de emergencia locales en caso de peligro físico inmediato.",
      "mailSubject": "Solicitud de soporte de Voxnela",
      "mailGreeting": "Hola Equipo de Soporte Voxnela,",
      "mailTopic": "Tema de soporte:",
      "mailPlatform": "Plataforma (Web / iOS / Mac):",
      "mailDevice": "Dispositivo y sistema operativo:",
      "mailProject": "ID del proyecto (si está disponible):",
      "mailDescription": "Descripción del problema o solicitud:",
      "mailThanks": "Gracias.",
      "termsEyebrow": "Términos de servicio de Voxnela",
      "termsTitle": "Términos de uso",
      "termsLead": "Estos términos regulan el uso de los servicios de creación y edición de imágenes con IA en la web de Voxnela y las aplicaciones iOS.",
      "privacyEyebrow": "Uso de datos Voxnela",
      "privacyTitle": "Política de privacidad",
      "privacyLead": "Esta política explica cómo se procesan las cuentas, imágenes, proyectos, membresías y datos técnicos en el servicio de creación de imágenes Voxnela.",
      "officialTurkishNotice": "Esta traducción se proporciona para comodidad. El texto legal turco rige si los significados difieren."
    }
  },
  "fr": {
    "ui": {
      "home": "Accueil",
      "homeTitle": "maison",
      "explore": "Explorer",
      "gallery": "Galerie",
      "myImages": "Mes images",
      "settings": "Réglages",
      "createImage": "Créer une image",
      "back": "Retour",
      "search": "Rechercher",
      "account": "Compte",
      "login": "Se connecter",
      "logout": "Se déconnecter",
      "profile": "Profil",
      "profileSettings": "Profil et paramètres",
      "plans": "Offres et utilisation",
      "plansSubtitle": "Crédits image et facturation",
      "contact": "contact",
      "contactSubtitle": "Aide et commentaires",
      "discoverVoxnela": "Découvrir Voxnela",
      "discoverVoxnelaSubtitle": "Revoir le parcours du studio visuel",
      "privacy": "Confidentialité",
      "privacySubtitle": "Comment vos données sont protégées",
      "terms": "Conditions d’utilisation",
      "termsSubtitle": "Conditions de service de Voxnela",
      "preferencesSubtitle": "Votre compte et vos préférences Voxnela",
      "accountSubtitle": "Informations du compte et de l’abonnement",
      "voxAccount": "Compte Voxnela",
      "accessEverywhere": "Accédez à vos images sur tous vos appareils",
      "imageRights": "{{count}} crédits image",
      "availableCredits": "Crédits disponibles",
      "renewalDate": "Date de renouvellement",
      "membershipStart": "Début de l’abonnement",
      "registrationDate": "Date d’inscription",
      "monthly": "Mensuel",
      "renewalOff": "Renouvellement désactivé",
      "user": "Utilisateur Voxnela",
      "language": "Langue",
      "languageSubtitle": "Choisir la langue de l’app",
      "supportBody": "Écrivez-nous si vous rencontrez un problème ou souhaitez partager une idée. Ajouter l’identifiant du projet nous aide à répondre plus vite.",
      "studioTitle": "Studio visuel Voxnela",
      "studioSubtitle": "Créez votre style",
      "searchSubtitle": "Vos images et projets",
      "searchPlaceholder": "Rechercher une image ou un projet",
      "noSearchResults": "Aucun résultat ne correspond à cette recherche.",
      "project": "Projet",
      "image": "image",
      "completed": "Terminé",
      "currentPlan": "Offre actuelle",
      "notSignedIn": "Non connecté",
      "signInIntro": "Connectez-vous pour commencer à utiliser Voxnela.",
      "creditsAvailable": "{{count}} crédits image Studio disponibles.",
      "noCredits": "Vous n’avez plus de crédits image pour cette période.",
      "membershipInfo": "Avec les offres annuelles, les crédits sont renouvelés chaque mois et ne sont pas reportés. Les achats restaurés restent protégés par votre compte.",
      "signedOutMembershipInfo": "Après connexion, vos crédits image et les informations de votre offre apparaîtront ici.",
      "reviewPlans": "Voir les offres",
      "versionUpdated": "Version {{version}} · Mise à jour le {{date}}",
      "onboardingWelcome": "Bienvenue sur Voxnela",
      "skipIntro": "Ignorer la présentation",
      "continue": "Continuer",
      "startCreating": "Commencer à créer",
      "close": "Fermer",
      "dragToClose": "Balayez vers le bas pour fermer",
      "loading": "Chargement…",
      "sheetExpand": "Agrandir la feuille",
      "sheetCollapse": "Réduire la feuille",
      "cannotClose": "Impossible de fermer pendant l’opération",
      "stylePreview": "Aperçu du style",
      "stylePreviewSubtitle": "Styles signature et tendances",
      "categories": "Catégories",
      "useThisStyle": "Utiliser ce style",
      "videoControls": "Commandes vidéo",
      "play": "Lire",
      "pause": "pause",
      "mute": "Couper le son",
      "unmute": "Activer le son",
      "minimize": "Réduire",
      "expandVideo": "Agrandir dans l’app",
      "videoProgress": "Progression vidéo",
      "toggleVideoControls": "Afficher ou masquer les commandes",
      "expandedVideo": "Vue vidéo agrandie de {{title}}",
      "goToImage": "Aller à l'image {{title}}",
      "categoryVisualStyles": "Styles visuels {{category}}",
      "onboarding1Eyebrow": "Création d’images",
      "onboarding1Title": "Créez votre image.",
      "onboarding1Body": "Transformez votre idée en image cinématographique avec le film 35 mm, l’éditorial, le produit, l’affiche et bien d’autres styles.",
      "onboarding2Eyebrow": "Essayage virtuel",
      "onboarding2Title": "Essayez de nouvelles tenues.",
      "onboarding2Body": "Préservez l’identité entre les créations et réalisez des essayages réalistes de mode, accessoires et produits.",
      "onboarding3Eyebrow": "Retouche d’image",
      "onboarding3Title": "Modifiez votre image.",
      "onboarding3Body": "Révisez la composition, la lumière, la couleur et les détails par conversation, sans recommencer.",
      "onboarding4Eyebrow": "3 images gratuites",
      "onboarding4Title": "Commencez gratuitement.",
      "onboarding4Body": "Commencez tout de suite avec 3 créations d’images IA gratuites et uniques. Aucun compte requis.",
      "onboardingFaceEyebrow": "Analyse du visage et du style",
      "onboardingFaceTitle": "Explorez votre visage et votre style.",
      "onboardingFaceBody": "Explorez des idées de coiffure, de lunettes et de tenue à partir de votre portrait dans un guide visuel.",
      "onboardingHouseEyebrow": "Voyage dans le temps",
      "onboardingHouseTitle": "Voyagez dans le temps.",
      "onboardingHouseBody": "Réunissez vos photos et vos dates pour visualiser l’évolution de votre maison.",
      "onboardingFestivalEyebrow": "Votre journée de festival",
      "onboardingFestivalTitle": "Planifiez votre journée de festival d’un coup d’œil.",
      "onboardingFestivalBody": "Transformez le programme, les scènes et les horaires fournis en un parcours visuel personnel.",
      "onboardingStylesEyebrow": "Styles Voxnela",
      "onboardingStylesTitle": "Choisissez votre style.",
      "onboardingStylesBody": "Transformez votre idée en image cinématographique avec le film 35 mm, l’éditorial, le produit, l’affiche et bien d’autres styles."
    },
    "auth": {
      "enterCode": "Saisissez votre code",
      "membershipAndAccount": "Abonnement et compte",
      "noPeriodInfo": "Période indisponible",
      "memberSince": "Membre depuis",
      "planSince": "{{plan}} depuis",
      "membershipRenewal": "Date de renouvellement de l'adhésion",
      "accountActions": "Actions du compte",
      "manageSubscriptionTitle": "Fin de l'abonnement",
      "manageSubscriptionSubtitle": "Gérez votre abonnement au magasin et le renouvellement automatique.",
      "deleteAccountTitle": "Supprimer mon compte",
      "deleteAccountSubtitle": "Processus de suppression réversible de 15 jours.",
      "deleteDataTitle": "Supprimer mes données",
      "deleteDataSubtitle": "Processus de suppression des données réversible sur 30 jours.",
      "signingOut": "Déconnexion…",
      "signOut": "Se déconnecter",
      "signingIn": "Connexion…",
      "continueApple": "Continuer avec Apple",
      "continueGoogle": "Continuer avec Google",
      "or": "ou",
      "email": "E-mail",
      "emailPlaceholder": "vous@exemple.fr",
      "legalPrefix": "En continuant avec Voxnela, vous acceptez le",
      "legalTerms": "Conditions d'utilisation",
      "legalJoin": "et confirmez que vous avez lu et compris le",
      "legalPrivacy": "Avis de confidentialité",
      "legalSuffix": ".",
      "sendingCode": "Envoi du code…",
      "emailSignIn": "Se connecter par e-mail",
      "codeSent": "Nous avons envoyé un code à {{email}}.",
      "change": "Modifier",
      "sixDigitCode": "Code à 6 chiffres",
      "emailCode": "Code de connexion par e-mail",
      "verifyingCode": "Vérification du code…",
      "resendCode": "Renvoyer le code",
      "requestReceived": "Demande reçue",
      "accountDeletionStarted": "Le processus de suppression de votre compte a commencé",
      "dataDeletionStarted": "Votre processus de suppression de données a commencé",
      "accountAction": "Action du compte",
      "accountDeletesAt": "Votre compte sera supprimé définitivement sur {{date}}.",
      "dataDeletesAt": "Vos données personnelles Voxnela seront supprimées définitivement sur {{date}}.",
      "deletionUndo": "Si vous vous connectez avec le même compte avant cette date, le processus de suppression est automatiquement annulé. Votre session actuelle a été fermée car la demande a été créée.",
      "done": "Terminé",
      "cancel": "Annuler",
      "preparing": "En train de préparer...",
      "invalidEmail": "Entrez une adresse e-mail valide.",
      "enterSixDigitCode": "Entrez le code à 6 chiffres envoyé à votre e-mail.",
      "signInFailed": "La connexion n'a pas pu être terminée. Veuillez réessayer.",
      "codeSendFailed": "Le code de connexion n'a pas pu être envoyé. Veuillez réessayer.",
      "codeVerifyFailed": "Le code n'a pas pu être vérifié. Veuillez réessayer.",
      "operationFailed": "L'opération n'a pas pu être terminée pour le moment. Veuillez réessayer.",
      "popupClosed": "La fenêtre de connexion a été fermée.",
      "unauthorizedDomain": "Ce domaine n'est pas autorisé pour la connexion.",
      "methodUnavailable": "Cette méthode de connexion n'est pas encore activée.",
      "tooManyCodes": "Trop de codes ont été demandés. Réessayez dans quelques minutes.",
      "invalidCode": "Le code est invalide ou expiré. Demandez un nouveau code.",
      "emailUnavailable": "La livraison par e-mail n'est actuellement pas disponible.",
      "actions": {
        "subscription": {
          "eyebrow": "Action d'abonnement",
          "title": "Terminez votre abonnement ?",
          "confirm": "Gérer les abonnements",
          "paragraphs": [
            "Continuer ouvre la page de gestion de l'abonnement de l'Apple App Store ou de Google Play où vous avez acheté l'abonnement. Vous devez désactiver le renouvellement automatique dans le magasin.",
            "Après l'annulation, les avantages de votre adhésion existante restent disponibles jusqu'à la fin de la période payée. La suppression de votre compte ou de vos données n'annule pas l'abonnement au magasin."
          ]
        },
        "account": {
          "eyebrow": "Action du compte permanent",
          "title": "Êtes-vous sûr de vouloir supprimer votre compte ?",
          "confirm": "Démarrez le processus de suppression de 15 jours",
          "paragraphs": [
            "La poursuite déclenche un processus de suppression de 15 jours et vous déconnecte pour des raisons de sécurité. Si vous ne vous reconnectez pas pendant cette période, votre compte, votre profil, vos créations, votre bibliothèque, vos collections et les données Voxnela connexes seront supprimés définitivement.",
            "Se connecter avec le même compte avant 15 jours annule la suppression automatiquement. La suppression du compte n’annule pas l’abonnement actif au magasin ; annulez‑le séparément dans le magasin."
          ]
        },
        "data": {
          "eyebrow": "Action de données permanente",
          "title": "Êtes-vous sûr de vouloir supprimer vos données ?",
          "confirm": "Démarrez le processus de suppression de 30 jours",
          "paragraphs": [
            "La poursuite déclenche un processus de suppression de 30 jours et vous déconnecte pour des raisons de sécurité. Si vous ne vous reconnectez pas pendant cette période, vos créations, votre bibliothèque, vos collections, vos enregistrements, vos interactions et d'autres données personnelles Voxnela seront supprimées définitivement ; votre compte de connexion reste disponible.",
            "Se connecter à nouveau avant 30 jours annule automatiquement la suppression des données. Les transactions limitées et les dossiers de sécurité requis par la loi peuvent être conservés avec un accès restreint pendant les périodes juridiques applicables."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "Plus de crédits d'image restants",
      "quotaFreeMessage": "Vous avez utilisé le crédit d'image dans votre compte gratuit. Choisissez un forfait pour continuer à créer.",
      "later": "à tout à l'heure",
      "currentCredit": "Crédits actuels : 0",
      "quotaProTitle": "Quota Pro mensuel atteint",
      "quotaProMessage": "Vous avez utilisé les 100 crédits d'image de ce mois-ci. Passez à Studio pour continuer à créer.",
      "renewalDate": "Date de renouvellement : {{date}}",
      "quotaStudioTitle": "Quota mensuel de studio atteint",
      "quotaStudioMessage": "Vos crédits d'image seront renouvelés automatiquement sur {{date}}.",
      "done": "marché conclu!",
      "membership": "Abonnement Voxnela",
      "options": "Options d’abonnement",
      "credits": "Crédits",
      "currentMembership": "Abonnement actuel",
      "yearlyDiscount": "17 % de réduction",
      "loadingPrice": "Chargement du prix…",
      "loadingStorePrice": "Chargement du prix depuis le magasin",
      "year": "an",
      "month": "mois",
      "renewDisclosure": "Renouvelle automatiquement chaque {{period}}. Annulez à tout moment.",
      "legal": "Mentions légales",
      "terms": "Conditions",
      "alreadyMember": "Vous avez déjà {{plan}} {{period}}",
      "startPlan": "Commencer le plan {{plan}}",
      "upgradeStudio": "Passer à Studio",
      "yearlyAdvantage": "Passer à des économies annuelles",
      "upgrade": "Améliorer l’abonnement",
      "signInRequired": "Connectez-vous à votre compte Voxnela avant de commencer un abonnement.",
      "catalogUnavailable": "Le catalogue de paiement n'a pas pu être vérifié pour ce forfait. Veuillez réessayer dans un instant.",
      "paymentUnavailable": "L'écran de paiement n'a pas pu être ouvert. Veuillez réessayer.",
      "benefits": [
        {
          "lead": "{{credits}} Crédits",
          "label": "Génération d'images haute résolution chaque mois"
        },
        {
          "lead": "Plus de 50 styles de studio",
          "label": "Néo-minimalisme, cinématographique et tous les styles signatures"
        },
        {
          "lead": "Verrouillage du visage",
          "label": "Essais de mode virtuels sans modifier les traits du visage"
        },
        {
          "lead": "File d'attente prioritaire",
          "label": "Traitement GPU ultra-rapide sans attente"
        },
        {
          "lead": "Révisions de la discussion",
          "label": "Modifications détaillées illimitées en plusieurs tours en langage naturel"
        },
        {
          "lead": "Droits commerciaux complets",
          "label": "Utilisation haute résolution, sans filigranes"
        }
      ],
      "restorePurchases": "Rétablir les achats",
      "restoringPurchases": "Restauration des achats...",
      "restoreSuccess": "Votre adhésion a été rétablie.",
      "restoreEmpty": "Aucune abonnement actif n'a été trouvé pour ce compte App Store.",
      "membershipSyncPending": "Vérification de l'adhésion et des crédits d'image...",
      "membershipSyncFailed": "Impossible de synchroniser les crédits d’image. Réessayez.",
      "membershipUnavailable": "Impossible de charger l’abonnement.",
      "retry": "Réessayer"
    },
    "video": {
      "revisionHook": "Rendez les trois premières secondes plus engageantes.",
      "revisionPace": "Équilibrez le rythme et raccourcissez les sections lentes.",
      "revisionEnding": "Rendez la fin plus mémorable.",
      "revisionTransition": "Rendez les transitions plus fluides et plus naturelles.",
      "revisionFraming": "Utilisez un encadrement plus équilibré pour les détails importants.",
      "revisionColor": "Assurez-vous que les couleurs soient plus équilibrées et cinématographiques.",
      "revisionText": "Rendre le texte plus court et plus facile à lire.",
      "revisionAudio": "Associez la musique plus étroitement au rythme des images.",
      "revisionEmotion": "Rendez l'histoire plus sincère et émotionnelle.",
      "revisionStructure": "Construisez un début, un milieu et une fin plus clairs.",
      "previewBack": "Retour à la prévisualisation",
      "revisionWelcome": "Qu'aimeriez-vous changer ?",
      "revisionFailed": "Je ne pouvais pas appliquer ce changement. Pourriez-vous le décrire à nouveau ?",
      "finalQueued": "La dernière vidéo est en attente. Elle apparaîtra sous Vidéos lorsqu'elle sera prête.",
      "watermarkUpgrade": "Choisissez un plan pour créer une nouvelle sortie finale sans le filigrane Voxnela.",
      "finalFailed": "La vidéo finale n'a pas pu être lancée.",
      "projectDeleteFailed": "Le projet n'a pas pu être supprimé.",
      "videoDescriptionWithBrief": "Cette vidéo a été créée à partir de « {{brief}} ». Voxnela a sélectionné les moments les plus forts et a construit le rythme et l'ordre des scènes autour de la direction créative choisie.",
      "videoDescriptionGeneric": "Voxnela a évalué les matériaux pour le contenu, le rythme et la cohérence narrative, mettant en évidence les moments les plus forts pour une édition équilibrée.",
      "play": "jouer",
      "deletesOn": "supprime sur {{date}}",
      "projectsBelong": "Vos projets sont liés à votre compte.",
      "videosBelong": "Vos vidéos sont liées à votre compte.",
      "signInToSeeProjects": "Connectez-vous pour voir vos projets et continuer sur tous les appareils.",
      "signInToSeeVideos": "Connectez-vous pour voir vos vidéos et continuer sur tous les appareils.",
      "delete": "Supprimer",
      "deleting": "Suppression…",
      "secondsVersion": "{{seconds}} sec · version {{version}}",
      "deleteProject": "Supprimer le projet",
      "projectCoverUnavailable": "La couverture du projet n'a pas pu être chargée",
      "videoCoverPreparing": "Préparation de la couverture vidéo",
      "deleteVideo": "Supprimer la vidéo",
      "signed": "Marqué Voxnela",
      "failed": "Impossible de terminer",
      "tryAgain": "Vous pouvez réessayer",
      "cancelled": "Annulé",
      "noCreditUsed": "Aucun crédit utilisé",
      "featuredStyles": "Styles visuels en vedette",
      "previousImage": "Image précédente",
      "nextImage": "Prochaine image",
      "reviewStyle": "Explorez ce style",
      "featuredNavigation": "Navigation visuelle mise en avant",
      "taskCategories": "Catégories de tâches",
      "projectOpening": "Projet d'ouverture",
      "opening": "Ouverture...",
      "projectNotFound": "Projet introuvable",
      "projectUnavailable": "Ce projet n'est plus disponible.",
      "backToProjects": "Retour à mes projets",
      "editVideo": "Modifier la vidéo",
      "versionContext": "Version {{version}} · Voxnela connaît votre projet et vos matériaux",
      "livePreviewActions": "Actions de prévisualisation en direct",
      "edit": "Modifier",
      "preparing": "Préparation",
      "save": "Enregistrer",
      "thinking": "Voxnela pense",
      "revisionSuggestions": "Suggestions d'édition",
      "describeChange": "Décrivez le changement que vous souhaitez",
      "sendEdit": "Envoyer une demande de modification",
      "deleteProjectDescription": "Êtes-vous sûr de vouloir supprimer « {{title}} » et tous les documents associés ? Ceci ne peut pas être annulé.",
      "projects": "Projets",
      "projectsPreparing": "Préparer vos projets",
      "noProjects": "Vous n'avez pas encore de projet. Commencez par décrire votre première idée.",
      "createNew": "Créer une image",
      "thisProject": "Ce projet",
      "videos": "Vidéos",
      "videosPreparing": "Préparer vos vidéos",
      "noVideos": "Vous n'avez pas encore de vidéo terminée. Elle apparaîtra ici lorsque votre première vidéo sera prête.",
      "videoPlayFailed": "La vidéo n'a pas pu être jouée.",
      "videoNotReady": "Le fichier vidéo n'est pas encore prêt à être téléchargé.",
      "videoDownloadFailed": "La vidéo n'a pas pu être téléchargée.",
      "videoDeleteFailed": "La vidéo n'a pas pu être supprimée.",
      "videoLoading": "Chargement de la vidéo...",
      "videoActions": "Actions vidéo",
      "showVideoDescription": "Afficher la description de la vidéo",
      "videoDownloading": "Téléchargement de vidéo",
      "downloadVideo": "Télécharger la vidéo",
      "thisVideo": "Cette vidéo",
      "deleteVideoDescription": "Êtes-vous sûr de vouloir supprimer la vidéo intitulée « {{title}} » ? Cela ne peut pas être annulé."
    },
    "studio": {
      "useStyle": "Utilisez ce style",
      "galleryFilters": "Filtres de galerie",
      "modeStyleTransfer": "Styles Voxnela",
      "modeVirtualTryOn": "Essai virtuel",
      "modeMagazineCover": "Magazine et couverture",
      "modePosterStudio": "Studio de posters",
      "modeCommercial": "Exposition des produits",
      "modeTimeWarp": "voyage dans le temps",
      "modeOutpaintRelight": "Élargir et réallumer",
      "modeInfographic": "Infographie et données",
      "modePortraitRetouch": "Retouche de portrait",
      "modeArtisticCollage": "Collage artistique",
      "defaultStyle": "Style Voxnela",
      "signInToCreate": "Connectez-vous pour créer une image.",
      "signInToEdit": "Connectez-vous pour modifier une image.",
      "creationSuccess": "Votre image a été créée avec succès. Dites-moi directement si vous souhaitez modifier l'éclairage, les couleurs, les objets ou le cadrage.",
      "imageReady": "Votre image est prête. Dites-moi ce que vous aimez ou ce que vous voulez réviser.",
      "revisionSuccess": "La révision est terminée. Vous pouvez la comparer avec le curseur avant/après ou demander un autre changement.",
      "versionReady": "La version {{version}} est prête.",
      "projectNotFound": "Projet non trouvé.",
      "styleApplied": "Style {{style}} appliqué",
      "imageCreation": "Création d'image",
      "defaultPrompt": "Image de studio",
      "aspectSquare": "carré",
      "aspectSquareDetail": "Flux Instagram, Profil, Art",
      "aspectVertical": "vertical",
      "aspectVerticalDetail": "Histoire Instagram, Reels, TikTok",
      "aspectHorizontal": "horizontal",
      "aspectHorizontalDetail": "YouTube, Bannière, Cinéma",
      "aspectPortrait": "portrait",
      "aspectPortraitDetail": "Portrait Instagram, affiche, vitrine",
      "aspectPanoramic": "panoramique",
      "aspectPanoramicDetail": "Paysage cinématographique ultra large",
      "styles": "Styles Voxnela",
      "fullScreenStyle": "Afficher le style en plein écran",
      "closeDescription": "Description du style de fermeture",
      "moreWithVoxnela": "Faites plus avec Voxnela",
      "quickStartBody": "Écrivez ce que vous voulez ci-dessous ou joignez un fichier.",
      "createImage": "Créer une image",
      "createImageDetail": "Construisez votre idée à partir de zéro",
      "editImage": "Modifier l’image",
      "editImageQuick": "Modifier une image",
      "editImageDetail": "Réimaginer une image téléchargée",
      "transformStyle": "Transformer le style et la scène",
      "transformStyleDetail": "Déplacez votre image dans un autre monde",
      "visualizeDocument": "Visualiser un document ou une présentation",
      "visualizeDocumentDetail": "Transformer le contenu complet en un design",
      "submittedImage": "Image soumise",
      "generating": "Voxnela crée votre image…",
      "viewImage": "Voir l'image",
      "removeStyle": "Supprimer le style sélectionné",
      "referenceImage": "Image de référence",
      "referenceNotice": "Cette image sera révisée ou un nouveau style sera appliqué",
      "removeReference": "Supprimer l'image de référence",
      "remove": "enlever",
      "uploading": "Téléchargement",
      "addFile": "Ajouter un fichier ou une image",
      "addFileTitle": "Ajoutez jusqu'à 4 images ou un document (PDF, Word, PPT, max 12 Mo)",
      "aspectRatio": "Rapport d'aspect",
      "selectAspectRatio": "Sélectionner le rapport d'aspect",
      "aspectOptions": "Options de rapport d'aspect",
      "revisePlaceholder": "Qu'aimeriez-vous changer dans cette image ?",
      "styledPlaceholder": "Décrivez l'image que vous souhaitez dans ce style (facultatif)...",
      "promptPlaceholder": "Décrivez une image ou écrivez une consigne...",
      "reviseImage": "Réviser l'image",
      "generateImage": "Générer une image",
      "generatedImage": "Image générée",
      "done": "Terminé",
      "fileLimitTitle": "Fichier trop grand",
      "fileLimitMessage": "« {{name}} » dépasse la limite de 12 Mo ({{size}} Mo). Choisissez un fichier plus petit.",
      "imageLimitTitle": "Limite d'image",
      "imageLimitMessage": "Vous pouvez télécharger jusqu'à 4 images. Les images {{count}} sont actuellement sélectionnées.",
      "uploadFailedTitle": "Téléchargement échoué",
      "uploadFailedMessage": "Un problème s'est produit lors du téléchargement du fichier.",
      "revisionFailed": "Une erreur s'est produite lors de la révision ou le quota a été dépassé.",
      "generationFailed": "Une erreur s'est produite lors de la génération de l'image ou le quota a été dépassé.",
      "imageDetails": "Détails de l'image",
      "close": "fermer",
      "download": "Télécharger",
      "downloadImage": "Télécharger l'image",
      "downloading": "Téléchargement",
      "versionImage": "image",
      "exploreTitle": "Quel style recherchez-vous ?",
      "explorePlaceholder": "Par exemple : un portrait cinématographique aux tons sombres et à la perspective profonde",
      "searchStyles": "Rechercher des styles visuels",
      "clearSearch": "Recherche claire",
      "exploreCategories": "Explorer les catégories",
      "all": "Tous",
      "styleCount": "Styles {{count}}",
      "noStyle": "Aucun style correspondant trouvé",
      "noStyleBody": "Réessayez avec une description plus courte ou des mots différents.",
      "libraryKicker": "Votre bibliothèque d'images personnelles",
      "myImages": "Mes images",
      "imageWorks": "L'image {{count}} fonctionne",
      "newImage": "Créer une image",
      "noImage": "Vous n'avez pas encore créé d'image",
      "noCategoryImage": "Aucune image dans cette catégorie",
      "emptyGalleryBody": "Créez votre première image avec transfert de style, essai virtuel, couverture de magazine ou présentation de produit.",
      "firstImage": "Créez votre première image",
      "imageWork": "Travail d'image"
    },
    "create": {
      "briefTitle": "Décrivez votre idée ou votre sujet",
      "briefPlaceholder": "Quel est le sujet ? Par exemple : l'avenir de l'IA, un voyage vers Mars ou le lancement d'un produit…",
      "briefLabel": "Bilan de création",
      "contentType": "Type de contenu",
      "media": "Images et médias",
      "added": "{{count}} ajouté",
      "optional": "Facultatif",
      "addMedia": "Ajoutez une photo ou une vidéo si vous le souhaitez",
      "addMediaBody": "Téléchargez votre propre média ou laissez-le vide et laissez l'IA le trouver",
      "attachedMedia": "Médias joints",
      "add": "ajouter",
      "mediaFallback": "des médias",
      "aiCompletes": "Laissez l'IA compléter les visuels",
      "noMedia": "Aucune image téléchargée ; l'IA complétera les scènes.",
      "productionFormat": "Format de production",
      "style": "style",
      "customVisualWorld": "Décrivez votre monde visuel",
      "colorsAtmosphere": "Couleurs, atmosphère, caméra, rythme",
      "customStyleShort": "Décrivez le monde visuel auquel vous pensez (par exemple : des tons pastel et une caméra calme, ou du néon cyberpunk…)",
      "customStyleLong": "Décrivez le monde visuel, les couleurs, l'atmosphère et le rythme que vous avez en tête.",
      "voiceover": "Voix off",
      "ownVoiceover": "Votre texte de sous-titre vocal",
      "voiceoverPlaceholder": "Écrivez votre texte ici. S'il est laissé vide, Voxnela le préparera.",
      "duration": "Durée",
      "seconds": "{{count}} sec",
      "freeLimit": "La vidéo finale la plus longue du forfait gratuit est de 60 secondes.",
      "addSound": "Ajouter du son ou de la musique",
      "notAdded": "Pas ajouté",
      "files": "Fichiers {{count}}",
      "readySounds": "Utilisez des sons prêts à l'emploi",
      "musicLibrary": "Bibliothèque musicale",
      "uploadOwn": "Téléchargez le vôtre",
      "captions": "Sous-titres",
      "back": "Retour",
      "create": "Créer",
      "next": "Suivant",
      "researchingTopic": "Recherche sur le sujet...",
      "analyzingMaterials": "Analyse des matériaux...",
      "researchBody": "Vérification des sources et préparation du script et du plan visuel.",
      "analyzeBody": "Évaluer les cadres forts, l'émotion, le rythme et le bref ensemble.",
      "creativeDirection": "Direction créative {{count}}",
      "recommended": "Recommandé",
      "generationFailed": "La création n'a pas pu être terminée",
      "retry": "Préparer à nouveau",
      "backDirections": "Retour aux orientations créatives",
      "preparingVideo": "Préparation de votre vidéo",
      "voiceoverText": "Texte de la voix off",
      "describeStyle": "Décrivez votre propre style",
      "topicDirection": "Sujet et direction",
      "styleEditorSubtitle": "Décrivez le monde visuel, les couleurs et l'atmosphère",
      "editorSubtitle": "Écrivez le texte et insérez-le dans la feuille de création",
      "voiceoverEditorPlaceholder": "Écrivez le texte à utiliser pour la voix off.",
      "topicEditorPlaceholder": "Écrivez le sujet et comment vous voulez qu'il soit raconté.",
      "insertText": "Insérer du texte",
      "bestFor": "Meilleur pour :",
      "useStyle": "Utilisez ce style",
      "musicSubtitle": "Des pistes réelles autorisées pour un usage commercial",
      "adding": "Ajout...",
      "musicLicense": "Les pistes sont fournies sous CC0 1.0 ; l'utilisation commerciale est autorisée et l'attribution n'est pas requise.",
      "yes": "Oui",
      "no": "Non",
      "newCreation": "Nouvelle création",
      "reviewing": "Voxnela est en cours de révision",
      "chooseDirection": "Choisissez l'une des trois approches de montage",
      "ideaSubtitle": "Décrivez votre idée ; téléchargez des visuels ou laissez Voxnela les créer",
      "projectOpenFailed": "Le forfait de projet n'a pas pu être ouvert.",
      "tooManyAssets": "Vous pouvez ajouter jusqu'à 50 actifs à un projet.",
      "uploadSizeLimit": "Le téléchargement total du projet dépasse la limite de 2 Go.",
      "filesAddFailed": "Les fichiers n'ont pas pu être ajoutés.",
      "musicPreviewFailed": "La prévisualisation de la musique n'a pas pu être ouverte.",
      "musicFetchFailed": "Le fichier de musique n'a pas pu être récupéré.",
      "musicAddFailed": "La musique n'a pas pu être ajoutée.",
      "topicRequired": "Entrez un sujet et décrivez de quoi votre vidéo parlera.",
      "briefTooShort": "Décrivez ce que vous voulez dire en au moins quelques mots.",
      "mediaRequired": "Téléchargez une image ou activez les visuels générés par l'IA.",
      "proposalIntro": "J'ai examiné les images et les vidéos et préparé trois directions de montage qui correspondent à votre style, format et choix audio.",
      "removeMaterial": "Supprimer {{name}}",
      "aiVisualNotice": "Des images réelles et des illustrations par IA librement licencées sont trouvées automatiquement.",
      "stepProgress": "Étape {{current}} de {{total}}",
      "styleSampleAlt": "Exemple montrant le style vidéo {{style}}",
      "reviewStyle": "Revoir le style {{style}}",
      "selectedDirectionPrompt": "Direction sélectionnée : {{title}}. {{summary}} Direction visuelle : {{visual}}. Approche de transition : {{transitions}}. Approche musicale : {{music}}.",
      "letVoxnelaChoose": "Laissez Voxnela choisir",
      "feminineVoice": "féminin",
      "masculineVoice": "masculin",
      "narrationStyle": "Style de narration",
      "voiceEstimate": "À propos de {{seconds}} sec · mots {{words}}.",
      "voiceShort": "Si cela signifie {{duration}} seconds, Voxnela le complétera tout en préservant le sens.",
      "voiceNatural": "Voxnela ne modifie que la grammaire, la formulation et le flux naturel.",
      "removeFile": "Supprimer le fichier {{name}}",
      "musicStop": "Arrêter {{title}}",
      "musicListen": "Écoutez {{title}}",
      "automatic": "auto",
      "all": "tous",
      "cinematic": "cinématographique",
      "social": "Social et dynamique",
      "designTypography": "Conception et typographie",
      "retroExperimental": "Rétro et Expérimental",
      "productionStage1": "Sélectionner les cadres et les scènes les plus forts.",
      "productionStage2": "Construire l'histoire, le mouvement et les transitions.",
      "productionStage3": "Équilibrer la musique, la voix et les sous-titres.",
      "productionStage4": "Effectuer les vérifications finales sur la prévisualisation en direct.",
      "genericCreationError": "Un problème est survenu lors de la préparation du plan vidéo. Vos matériaux et vos choix sont préservés ; vous pouvez réessayer.",
      "newVideo": "Nouvelle vidéo",
      "topicNews": "nouvelles",
      "topicDocumentary": "documentaire",
      "topicExplainer": "Explicateur",
      "topicStory": "histoire",
      "topicScience": "science",
      "topicPhilosophy": "philosophie",
      "topicMagazine": "magazine",
      "topicEntertainment": "divertissement",
      "topicList": "liste",
      "toneCalm": "calme",
      "toneEmotional": "émotionnel",
      "toneEnergetic": "énergique",
      "toneStorytelling": "narration",
      "toneCheerful": "joyeux",
      "toneMysterious": "mystérieux",
      "toneNews": "nouvelles",
      "styleCinematic": "cinématographique",
      "styleDarkCinematic": "Cinématique sombre",
      "styleDocumentary": "documentaire",
      "styleModernDocumentary": "Documentaire moderne",
      "stylePovImmersive": "Point de vue immersif",
      "styleUgcAuthentic": "UGC authentique",
      "styleMiniVlog": "Mini vlog",
      "styleSocialViral": "Virale sociale",
      "styleHyperEdit": "Hyperédition",
      "styleSportsHype": "Hype sportif",
      "styleVelocityEdit": "Édition de vitesse",
      "styleMusicBeatEdit": "Édition de rythme musical",
      "styleKineticTypography": "Typographie cinétique",
      "styleMinimalClean": "Minimaliste et propre",
      "styleLuxuryMinimal": "Minimalisme de luxe",
      "styleCommercialProduct": "Produit commercial",
      "styleEditorialFashion": "Mode éditoriale",
      "styleCollageZine": "Collage Zine",
      "styleTechFuturistic": "Technologie futuriste",
      "styleRetroFuturism": "Futurisme rétro",
      "styleY2kDigital": "Numérique Y2K",
      "styleVhsCamcorder": "Caméra vidéo VHS",
      "styleAnalogFilm": "Film analogique",
      "styleGlitchCyber": "Goulot d'étranglement cyber",
      "musicUpbeatMood": "Énergique · lumineux",
      "musicUpbeatDetail": "De vraies enregistrements instrumentaux pour du contenu social énergisant, des moments de voyage et des montages animés.",
      "musicElectronicMood": "Moderne · rythmique",
      "musicElectronicDetail": "De la musique électronique réelle pour les villes, la technologie, les produits et les montages rapides.",
      "musicRomanceMood": "Émotionnel · chaleureux",
      "musicRomanceDetail": "Musique instrumentale avec une douce arc émotionnelle pour la famille, les portraits, les jours spéciaux et les souvenirs.",
      "musicScoringMood": "Narration · cinématographique",
      "musicScoringDetail": "Musique de fond cinématographique soutenant les histoires, les promotions et les transitions dramatiques.",
      "musicEpicMood": "Puissant · croissant",
      "musicEpicDetail": "Musique instrumentale stratifiée qui s'élève pour les grands ouvertures, les voyages et les finales fortes.",
      "proposalBalancedTitle": "Narration équilibrée",
      "proposalBalancedSummary": "Une modification qui préserve le flux du matériel et met en évidence les cadres les plus forts.",
      "proposalBalancedVisual": "Une hiérarchie forte et un système visuel cohérent",
      "proposalBalancedTransitions": "Coupes lisses et insertions mesurées",
      "proposalBalancedMusic": "Musique qui passe de l'émotion au rythme",
      "proposalQuietTitle": "Histoire tranquille",
      "proposalQuietSummary": "Une approche calme qui donne aux cadres plus de temps et met l'accent sur les détails et l'émotion naturelle.",
      "proposalQuietVisual": "Teintes douces et plans plus longs",
      "proposalQuietTransitions": "Dissolution croisée et poêles lentes",
      "proposalQuietMusic": "Musique simple et émotionnelle",
      "proposalRhythmicTitle": "Édition rythmique",
      "proposalRhythmicSummary": "Une modification avec un fort accroche d'ouverture qui s'accélère au milieu et se stabilise clairement à la fin.",
      "proposalRhythmicVisual": "Contraste plus fort et cadrage dynamique",
      "proposalRhythmicTransitions": "Coupes de rythme et transitions de balayage contrôlées",
      "proposalRhythmicMusic": "Musique énergique et montante",
      "underVoiceover": "doux sous la voix off",
      "withShortVoiceover": "avec une voix off courte et percutante"
    },
    "information": {
      "home": "Accueil",
      "documentInfo": "Informations sur le document",
      "version": "version",
      "effective": "En vigueur",
      "updated": "Dernière mise à jour",
      "contents": "Sommaire",
      "officialReferences": "Références officielles",
      "referenceTitle": "Ressources juridiques et d'autorité",
      "referenceBody": "Ces liens sont fournis à titre d'information générale. La loi obligatoire et les règles en vigueur des autorités compétentes prévalent.",
      "supportKicker": "Soutien Sponelabs",
      "contactTitle": "Nous contacter",
      "contactLead": "Contactez l'équipe d'assistance Voxnela concernant votre compte, votre adhésion, votre paiement, votre création, vos rapports de contenu, votre vie privée ou vos problèmes techniques.",
      "supportEmail": "E-mail du support",
      "emailBody": "Le bouton ci-dessous ouvre votre application de messagerie électronique par défaut avec un modèle de support prêt à l'emploi afin que nous puissions enquêter plus rapidement.",
      "openEmail": "Ouvrir l’app de messagerie",
      "includeTitle": "À inclure dans votre message",
      "includeItems": [
        "Que vous utilisiez Web, iOS ou Mac ;",
        "La version de votre appareil et de votre système d'exploitation ;",
        "Étapes pour reproduire le problème ;",
        "Le lien du projet associé, les détails de la transaction ou une capture d'écran, si disponibles."
      ],
      "sensitiveTitle": "N’envoyez pas de données sensibles",
      "sensitiveBody": "Ne pas inclure de codes de vérification, de mots de passe, de détails complets de la carte de paiement, de documents d'identité, de données de santé ou d'autres informations sensibles qui ne sont pas nécessaires pour résoudre le problème.",
      "securityTitle": "Sécurité et signalement de contenu",
      "securityBody": "Utilisez « Sécurité » pour une vulnérabilité, « Demande de confidentialité » pour une demande de données, ou « Rapport de contenu » pour du contenu nuisible ou contraire aux lois. Contactez les services d'urgence locaux en cas de danger physique immédiat.",
      "mailSubject": "Demande de soutien Voxnela",
      "mailGreeting": "Bonjour l'équipe d'assistance Voxnela,",
      "mailTopic": "Sujet de l'assistance :",
      "mailPlatform": "Plateforme (Web / iOS / Mac) :",
      "mailDevice": "Appareil et système d'exploitation :",
      "mailProject": "ID de projet (si disponible) :",
      "mailDescription": "Description du problème ou de la demande :",
      "mailThanks": "Merci.",
      "termsEyebrow": "Conditions d'utilisation de Voxnela",
      "termsTitle": "Conditions d'utilisation",
      "termsLead": "Ces conditions régissent l'utilisation des services de création et de montage d'images par l'IA dans le site web Voxnela et les applications iOS.",
      "privacyEyebrow": "Utilisation des données Voxnela",
      "privacyTitle": "Politique de confidentialité",
      "privacyLead": "Cette politique explique comment les comptes, les images, les projets, l'adhésion et les données techniques sont traités dans le service de création d'images Voxnela.",
      "officialTurkishNotice": "Cette traduction est fournie à titre de commodité. Le texte juridique turc régit les cas où les significations diffèrent."
    }
  },
  "ru": {
    "ui": {
      "home": "Главная",
      "homeTitle": "Дома",
      "explore": "Обзор",
      "gallery": "Галерея",
      "myImages": "Мои изображения",
      "settings": "Настройки",
      "createImage": "Создать изображение",
      "back": "Назад",
      "search": "Поиск",
      "account": "Аккаунт",
      "login": "Войти",
      "logout": "Выйти",
      "profile": "Профиль",
      "profileSettings": "Профиль и настройки",
      "plans": "Тарифы и использование",
      "plansSubtitle": "Авторские права на изображения и оплата",
      "contact": "Связаться",
      "contactSubtitle": "Помощь и обратная связь",
      "discoverVoxnela": "Откройте для себя Voxnela",
      "discoverVoxnelaSubtitle": "Оцените опыт работы визуального студии",
      "privacy": "Конфиденциальность",
      "privacySubtitle": "Как ваши данные защищаются",
      "terms": "Условия использования",
      "termsSubtitle": "Условия использования Voxnela",
      "preferencesSubtitle": "Ваш аккаунт и предпочтения Voxnela",
      "accountSubtitle": "Детали аккаунта и членства",
      "voxAccount": "Аккаунт Voxnela",
      "accessEverywhere": "Доступ к вашим изображениям на любом устройстве",
      "imageRights": "Кредиты на изображение {{count}}",
      "availableCredits": "Доступные кредиты",
      "renewalDate": "Дата продления",
      "membershipStart": "Запуск членства",
      "registrationDate": "Дата регистрации",
      "monthly": "Месячно",
      "renewalOff": "Отключение продления",
      "user": "Пользователь Voxnela",
      "language": "Язык",
      "languageSubtitle": "Выберите язык приложения",
      "supportBody": "Напишите нам, если у вас возникнут проблемы или вы хотите поделиться идеей. Указание идентификатора проекта помогает нам быстрее ответить.",
      "studioTitle": "Визуальная студия Voxnela",
      "studioSubtitle": "Создайте свой стиль",
      "searchSubtitle": "Ваши изображения и проекты",
      "searchPlaceholder": "Ищите изображение или проект",
      "noSearchResults": "Ничего не совпало с этим поиском.",
      "project": "Проект",
      "image": "Изображение",
      "completed": "Завершено",
      "currentPlan": "Текущий план",
      "notSignedIn": "Не войти",
      "signInIntro": "Войдите, чтобы начать использовать Voxnela.",
      "creditsAvailable": "Кредиты на изображение студии {{count}} доступны.",
      "noCredits": "В этом периоде у вас нет оставшихся кредитов на изображения.",
      "membershipInfo": "Кредиты в ежегодном плане продлеваются каждый месяц и не переносят. Восстановленные покупки остаются защищены через ваш аккаунт.",
      "signedOutMembershipInfo": "После входа здесь появятся доступные кредиты на изображения и информация о тарифе.",
      "reviewPlans": "Просмотреть планы",
      "versionUpdated": "Версия {{version}} · Последнее обновление {{date}}",
      "onboardingWelcome": "Добро пожаловать в Voxnela",
      "skipIntro": "Пропустить знакомство",
      "continue": "Продолжить",
      "startCreating": "Начать создавать",
      "close": "Закрыть",
      "dragToClose": "Проведите вниз, чтобы закрыть",
      "loading": "Загрузка...",
      "sheetExpand": "Расширить лист",
      "sheetCollapse": "Возвратная лист на нормальную высоту",
      "cannotClose": "Невозможно закрыть, пока операция выполняется",
      "stylePreview": "Предварительный просмотр стиля",
      "stylePreviewSubtitle": "Стили и тренды с подпиской",
      "categories": "Категории",
      "useThisStyle": "Используйте этот стиль",
      "videoControls": "Контроли видео",
      "play": "Играть",
      "pause": "Пауза",
      "mute": "Мучить",
      "unmute": "Отключить моё голосовое отключение",
      "minimize": "Минимизировать",
      "expandVideo": "Расширить в приложении",
      "videoProgress": "Прогресс видео",
      "toggleVideoControls": "Показать или скрывать видеоконтролиры",
      "expandedVideo": "{{title}} расширенный просмотр видео",
      "goToImage": "Перейдите к изображению {{title}}",
      "categoryVisualStyles": "{{category}} визуальные стили",
      "onboarding1Eyebrow": "Создание изображений",
      "onboarding1Title": "Создайте своё изображение.",
      "onboarding1Body": "Превратите вашу идею в кинематографический кадр с использованием 35-мм пленки, редакционных, продуктовых, плакатурных и многих других визуальных стилей.",
      "onboarding2Eyebrow": "Виртуальная примерка",
      "onboarding2Title": "Примерьте новые образы.",
      "onboarding2Body": "Сохраняйте идентичность во всех выпусках и создавайте реалистичные визуальные изображения для демонстрации моды, аксессуаров и продуктов.",
      "onboarding3Eyebrow": "Редактирование изображений",
      "onboarding3Title": "Редактируйте своё изображение.",
      "onboarding3Body": "Обновите композицию, свет, цвет и детали разговорно, не начиная с нуля.",
      "onboarding4Eyebrow": "3 бесплатных изображений",
      "onboarding4Title": "Начните бесплатно.",
      "onboarding4Body": "Начните сразу с 3 бесплатных разовых генераций изображений с ИИ. Аккаунт не нужен.",
      "onboardingFaceEyebrow": "Анализ лица и стиля",
      "onboardingFaceTitle": "Изучите лицо и стиль.",
      "onboardingFaceBody": "Изучите идеи причёски, очков и одежды по своему портрету в одном наглядном руководстве.",
      "onboardingHouseEyebrow": "Путешествие во времени",
      "onboardingHouseTitle": "Путешествуйте во времени.",
      "onboardingHouseBody": "Объедините свои фотографии и даты, чтобы показать, как менялся дом со временем.",
      "onboardingFestivalEyebrow": "День фестиваля",
      "onboardingFestivalTitle": "Спланируйте день фестиваля с первого взгляда.",
      "onboardingFestivalBody": "Превратите предоставленные программу, сцены и время в персональный визуальный маршрут.",
      "onboardingStylesEyebrow": "Стили Voxnela",
      "onboardingStylesTitle": "Выберите свой стиль.",
      "onboardingStylesBody": "Превратите вашу идею в кинематографический кадр с использованием 35-мм пленки, редакционных, продуктовых, плакатурных и многих других визуальных стилей."
    },
    "auth": {
      "enterCode": "Введите код",
      "membershipAndAccount": "Подписка и детали аккаунта",
      "noPeriodInfo": "Период недоступен",
      "memberSince": "Член с",
      "planSince": "{{plan}} с",
      "membershipRenewal": "Дата продления членства",
      "accountActions": "Действия с аккаунтом",
      "manageSubscriptionTitle": "Завершение подписки",
      "manageSubscriptionSubtitle": "Управляйте подпиской на магазин и автоматическим продлением.",
      "deleteAccountTitle": "Удалить мой аккаунт",
      "deleteAccountSubtitle": "Возвратный процесс удаления на 15 дней.",
      "deleteDataTitle": "Удалить мои данные",
      "deleteDataSubtitle": "Возвратный процесс удаления данных на 30 дней.",
      "signingOut": "Выход…",
      "signOut": "Выйти",
      "signingIn": "Вход…",
      "continueApple": "Продолжить с Apple",
      "continueGoogle": "Продолжить с Google",
      "or": "или",
      "email": "Эл. почта",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "Продолжая работу с Voxnela, вы соглашаетесь с",
      "legalTerms": "Условия использования",
      "legalJoin": "и подтвердите, что вы прочитали и поняли",
      "legalPrivacy": "Уведомление о конфиденциальности",
      "legalSuffix": ".",
      "sendingCode": "Отправка кода…",
      "emailSignIn": "Войти по эл. почте",
      "codeSent": "Мы отправили код на {{email}}.",
      "change": "Изменить",
      "sixDigitCode": "6-значный код",
      "emailCode": "Код входа по электронной почте",
      "verifyingCode": "Проверка кода…",
      "resendCode": "Отправить код снова",
      "requestReceived": "Запрос получен",
      "accountDeletionStarted": "Процесс удаления вашего аккаунта начался",
      "dataDeletionStarted": "Процесс удаления ваших данных начался",
      "accountAction": "Действия с аккаунтом",
      "accountDeletesAt": "Ваш аккаунт будет навсегда удален на {{date}}.",
      "dataDeletesAt": "Ваши персональные данные Voxnela будут навсегда удалены на {{date}}.",
      "deletionUndo": "Если вы войдете в систему с тем же аккаунтом до этой даты, процесс удаления будет автоматически отменён. Ваша текущая сессия была закрыта, поскольку запрос был создан.",
      "done": "Готово",
      "cancel": "Отмена",
      "preparing": "Подготовка...",
      "invalidEmail": "Введите действительный адрес электронной почты.",
      "enterSixDigitCode": "Введите 6-значный код, отправленный на ваш адрес электронной почты.",
      "signInFailed": "Запись в систему не удалась. Пожалуйста, попробуйте снова.",
      "codeSendFailed": "Код входа не мог быть отправлен. Пожалуйста, попробуйте снова.",
      "codeVerifyFailed": "Код не мог быть проверен. Пожалуйста, попробуйте еще раз.",
      "operationFailed": "Операция не могла быть завершена в настоящее время. Пожалуйста, попробуйте снова.",
      "popupClosed": "Окно входа закрыто.",
      "unauthorizedDomain": "Этот домен не авторизован для входа.",
      "methodUnavailable": "Этот метод входа еще не активирован.",
      "tooManyCodes": "Запрошены слишком много кодов. Попробуйте снова через несколько минут.",
      "invalidCode": "Код недействителен или истек срок действия. Запросите новый код.",
      "emailUnavailable": "Текущая доставка электронной почты недоступна.",
      "actions": {
        "subscription": {
          "eyebrow": "Действие подписки",
          "title": "Завершите подписку?",
          "confirm": "Управление подписками",
          "paragraphs": [
            "Продолжение открывает страницу управления подпиской в Apple App Store или Google Play, где вы приобрели подписку. Вам необходимо отключить автоматическое продление в магазине.",
            "После отмены ваши существующие преимущества членства остаются доступны до окончания платной периода. Удаление вашего аккаунта или данных не отменяет подписку на магазин."
          ]
        },
        "account": {
          "eyebrow": "Действие постоянного счета",
          "title": "Вы уверены, что хотите удалить свой аккаунт?",
          "confirm": "Начало 15-дневного процесса удаления",
          "paragraphs": [
            "Продолжение запускает 15-дневный процесс удаления и отключает вас для обеспечения безопасности. Если вы не войдете в систему снова в течение этого периода, ваш аккаунт, профиль, созданные материалы, библиотека, коллекции и связанные с ними данные Voxnela будут навсегда удалены.",
            "Вход с тем же аккаунтом до 15 дней автоматически отменяет удаление. Удаление аккаунта не отменяет активную подписку на магазин; отмените её отдельно в магазине."
          ]
        },
        "data": {
          "eyebrow": "Постоянные действия с данными",
          "title": "Вы уверены, что хотите удалить свои данные?",
          "confirm": "Начало 30-дневного процесса удаления",
          "paragraphs": [
            "Продолжение запускает 30-дневный процесс удаления и выводит вас из системы для обеспечения безопасности. Если вы не войдете в систему снова в течение этого периода, ваши созданные работы, библиотека, коллекции, записи, взаимодействия и другие персональные данные Voxnela будут навсегда удалены; ваш аккаунт для входа останется доступным.",
            "Переход в систему снова до 30 дней автоматически отменяет удаление данных. Требуемые законом ограниченные записи о транзакциях и безопасности могут быть сохранены с ограниченным доступом в течение соответствующих юридических периодов."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "Залишилось не каких кредитов на изображение",
      "quotaFreeMessage": "Вы использовали кредит на изображение в своем бесплатном аккаунте. Выберите план, чтобы продолжить создавать.",
      "later": "Позже",
      "currentCredit": "Текущие кредиты: 0",
      "quotaProTitle": "Месячный пропускный лимит достигнут",
      "quotaProMessage": "Вы использовали 100 кредитов на изображения этого месяца. Обновите до Studio, чтобы продолжить создавать.",
      "renewalDate": "Дата продления: {{date}}",
      "quotaStudioTitle": "Месячная квота на студию достигнута",
      "quotaStudioMessage": "Ваши кредиты на изображение будут автоматически продлены на {{date}}.",
      "done": "Готово",
      "membership": "Подписка Voxnela",
      "options": "Варианты подписки",
      "credits": "Кредиты",
      "currentMembership": "Текущая подписка",
      "yearlyDiscount": "Скидка 17 %",
      "loadingPrice": "Загрузка цены…",
      "loadingStorePrice": "Загрузка цены из магазина",
      "year": "год",
      "month": "месяц",
      "renewDisclosure": "Автоматически продлевается каждый {{period}}. Отменить в любое время.",
      "legal": "Правовая информация",
      "terms": "Условия",
      "alreadyMember": "У вас уже есть {{plan}} {{period}}",
      "startPlan": "Начать план {{plan}}",
      "upgradeStudio": "Перейти на Studio",
      "yearlyAdvantage": "Переключитесь на ежегодные сбережения",
      "upgrade": "Улучшить подписку",
      "signInRequired": "Войдите в свой аккаунт Voxnela, прежде чем начать подписку.",
      "catalogUnavailable": "Каталог оплаты для этого плана не был проверен. Пожалуйста, попробуйте снова в ближайшее время.",
      "paymentUnavailable": "Скриншоп оплаты не удался открыть. Пожалуйста, попробуйте еще раз.",
      "benefits": [
        {
          "lead": "{{credits}} Кредиты",
          "label": "Генерация высококачественного изображения каждый месяц"
        },
        {
          "lead": "50+ стилей студийного дизайна",
          "label": "Нео-мининализм, кинематографизм и каждый характерный стиль"
        },
        {
          "lead": "Защита лица",
          "label": "Виртуальное пробное тестирование моды без изменения черт лица"
        },
        {
          "lead": "Прямой очередь приоритетов",
          "label": "Ультрабыстрый обработка графического процессора без ожиданий"
        },
        {
          "lead": "Обновления чата",
          "label": "Неограниченные многократные детализированные правки в естественном языке"
        },
        {
          "lead": "Полные коммерческие права",
          "label": "Высокое разрешение, без во水印ного использования"
        }
      ],
      "restorePurchases": "Восстановить покупки",
      "restoringPurchases": "Восстановление покупок...",
      "restoreSuccess": "Ваша подписка восстановлена.",
      "restoreEmpty": "Для этого аккаунта App Store не найдено активного подписки.",
      "membershipSyncPending": "Проверка членства и кредитов по изображению...",
      "membershipSyncFailed": "Не удалось синхронизировать кредиты изображений. Повторите попытку.",
      "membershipUnavailable": "Не удалось загрузить подписку.",
      "retry": "Повторить"
    },
    "video": {
      "revisionHook": "Сделайте первые три секунды более увлекательными.",
      "revisionPace": "Сбалансируйте темп и сократите медленные части.",
      "revisionEnding": "Сделайте концовку более запоминающейся.",
      "revisionTransition": "Сделайте переход более плавным и естественным.",
      "revisionFraming": "Используйте более сбалансированное оформление для важных деталей.",
      "revisionColor": "Сделайте цвета более сбалансированными и кинематографичными.",
      "revisionText": "Сделайте текст короче и легче читать.",
      "revisionAudio": "Подбирайте музыку более близко к ритму изображений.",
      "revisionEmotion": "Сделайте историю более искренней и эмоциональной.",
      "revisionStructure": "Создайте более четкое начало, середину и конец.",
      "previewBack": "Возвращение к предварительному просмотру",
      "revisionWelcome": "Что вы хотите изменить?",
      "revisionFailed": "Я не мог внести эту変更у. Можете описать её ещё раз?",
      "finalQueued": "Последнее видео находится в очереди. Оно появится под разделами «Видео», когда будет готово.",
      "watermarkUpgrade": "Выберите план, чтобы создать новый окончательный результат без во水印 Voxnela.",
      "finalFailed": "Окончательное видео не удалось начать.",
      "projectDeleteFailed": "Проект не мог быть удален.",
      "videoDescriptionWithBrief": "Это видео было создано из «{{brief}}». Voxnela выбрала самые сильные моменты и построила ритм и порядок сцен вокруг выбранного творческого направления.",
      "videoDescriptionGeneric": "Voxnela оценила материалы по содержанию, скорости и целостности нарратива, выделяя самые сильные моменты для сбалансированного редактирования.",
      "play": "Играть",
      "deletesOn": "удаляет на {{date}}",
      "projectsBelong": "Ваши проекты связаны с вашим аккаунтом.",
      "videosBelong": "Ваши видео связаны с вашим аккаунтом.",
      "signInToSeeProjects": "Войдите, чтобы увидеть свои проекты и продолжить работу на всех устройствах.",
      "signInToSeeVideos": "Войдите, чтобы посмотреть свои видео и продолжить просмотр на всех устройствах.",
      "delete": "Удалить",
      "deleting": "Удаление…",
      "secondsVersion": "{{seconds}} сек · версия {{version}}",
      "deleteProject": "Удалить проект",
      "projectCoverUnavailable": "Заложка проекта не могла быть загружена",
      "videoCoverPreparing": "Подготовка видеозаставки",
      "deleteVideo": "Удалить видео",
      "signed": "Бренд Voxnela",
      "failed": "Не удалось завершить",
      "tryAgain": "Вы можете попробовать снова",
      "cancelled": "Отменён",
      "noCreditUsed": "Нет использованного кредита",
      "featuredStyles": "Представленные визуальные стили",
      "previousImage": "Предыдущее изображение",
      "nextImage": "Следующее изображение",
      "reviewStyle": "Откройте для себя этот стиль",
      "featuredNavigation": "Представленная визуальная навигация",
      "taskCategories": "Категории задач",
      "projectOpening": "Открытие проекта",
      "opening": "Открытие...",
      "projectNotFound": "Проект не найден",
      "projectUnavailable": "Этот проект больше не доступен.",
      "backToProjects": "К моим проектам",
      "editVideo": "Изменить видео",
      "versionContext": "Версия {{version}} · Voxnela знает ваш проект и материалы",
      "livePreviewActions": "Живое предварительное представление действий",
      "edit": "Изменить",
      "preparing": "Подготовка",
      "save": "Сохранить",
      "thinking": "Вокснела думает",
      "revisionSuggestions": "Предложения по редактированию",
      "describeChange": "Опишите изменение, которое вы хотите",
      "sendEdit": "Отправить запрос на редактирование",
      "deleteProjectDescription": "Вы уверены, что хотите удалить «{{title}}» и все связанные материалы? Это нельзя отменить.",
      "projects": "Проекты",
      "projectsPreparing": "Подготовка ваших проектов",
      "noProjects": "У вас еще нет проекта. Начните с описания вашей первой идеи.",
      "createNew": "Создать изображение",
      "thisProject": "Этот проект",
      "videos": "Видео",
      "videosPreparing": "Подготовка ваших видео",
      "noVideos": "У вас еще нет завершенного видео. Оно появится здесь, когда ваше первое видео будет готово.",
      "videoPlayFailed": "Видео не смогло быть воспроизведено.",
      "videoNotReady": "Видеофайл еще не готов к загрузке.",
      "videoDownloadFailed": "Видео не удалось скачать.",
      "videoDeleteFailed": "Видео не удалось удалить.",
      "videoLoading": "Загрузка видео...",
      "videoActions": "Видеоакции",
      "showVideoDescription": "Показать описание видео",
      "videoDownloading": "Загрузка видео",
      "downloadVideo": "Скачать видео",
      "thisVideo": "Этот видео",
      "deleteVideoDescription": "Вы уверены, что хотите удалить видео с названием «{{title}}»? Это нельзя отменить."
    },
    "studio": {
      "useStyle": "Используйте этот стиль",
      "galleryFilters": "Фильтры галереи",
      "modeStyleTransfer": "Стили Voxnela",
      "modeVirtualTryOn": "Виртуальное примеривание",
      "modeMagazineCover": "Магазин и обложка",
      "modePosterStudio": "Студия постеров",
      "modeCommercial": "Выставка продуктов",
      "modeTimeWarp": "Передвижение во времени",
      "modeOutpaintRelight": "Расширить и осветить",
      "modeInfographic": "Инфографика и данные",
      "modePortraitRetouch": "Ретауш портрета",
      "modeArtisticCollage": "Арт-коллектаж",
      "defaultStyle": "Стиль Voxnela",
      "signInToCreate": "Войдите, чтобы создать изображение.",
      "signInToEdit": "Войдите, чтобы отредактировать изображение.",
      "creationSuccess": "Ваше изображение успешно создано. Скажите мне напрямую, если вы хотите изменить освещение, цвета, объекты или рамку.",
      "imageReady": "Ваше изображение готово. Скажите мне, что вам нравится или что вы хотите отредактировать.",
      "revisionSuccess": "Отредактировка завершена. Вы можете сравнить ее с слайдером до/после или запросить другую изменение.",
      "versionReady": "Версия {{version}} готова.",
      "projectNotFound": "Проект не найден.",
      "styleApplied": "Применен стиль {{style}}",
      "imageCreation": "Создание изображения",
      "defaultPrompt": "Студийное изображение",
      "aspectSquare": "Квадратный",
      "aspectSquareDetail": "Инстаграм-рефейд, профиль, искусство",
      "aspectVertical": "Вертикальный",
      "aspectVerticalDetail": "История в Instagram, реэли, TikTok",
      "aspectHorizontal": "Горизонтальный",
      "aspectHorizontalDetail": "YouTube, баннер, кино",
      "aspectPortrait": "Портрет",
      "aspectPortraitDetail": "Портрет в Instagram, плакат, показ",
      "aspectPanoramic": "Панoramный",
      "aspectPanoramicDetail": "Ультраширокий кинематографический пейзаж",
      "styles": "Стили Voxnela",
      "fullScreenStyle": "Просмотреть стиль в полный экран",
      "closeDescription": "Описание стиля закрытия",
      "moreWithVoxnela": "Делайте больше с Voxnela",
      "quickStartBody": "Напишите ниже, что вы хотите, или прикрепите файл.",
      "createImage": "Создать изображение",
      "createImageDetail": "Создайте свою идею с нуля",
      "editImage": "Изменить изображение",
      "editImageQuick": "Изменить изображение",
      "editImageDetail": "Переосмыслить загруженное изображение",
      "transformStyle": "Измените стиль и сцену",
      "transformStyleDetail": "Переместите свое изображение в другой мир",
      "visualizeDocument": "Визуализуйте документ или презентацию",
      "visualizeDocumentDetail": "Преобразуйте полный контент в дизайн",
      "submittedImage": "Отправленное изображение",
      "generating": "Voxnela создаёт изображение…",
      "viewImage": "Просмотреть изображение",
      "removeStyle": "Убрать выбранный стиль",
      "referenceImage": "Референсная изображение",
      "referenceNotice": "Это изображение будет отредактировано или будет применён новый стиль",
      "removeReference": "Убрать изображение-ссылка",
      "remove": "Убрать",
      "uploading": "Загрузка",
      "addFile": "Добавить файл или изображение",
      "addFileTitle": "Добавьте до 4 изображений или документ (PDF, Word, PPT, максимум 12 МБ)",
      "aspectRatio": "Отношение сторон",
      "selectAspectRatio": "Выберите соотношение сторон",
      "aspectOptions": "Возможные варианты соотношения сторон",
      "revisePlaceholder": "Что вы хотите изменить в этом изображении?",
      "styledPlaceholder": "Опишите изображение, которое вы хотите в этом стиле (опционально)...",
      "promptPlaceholder": "Опишите изображение или напишите запрос…",
      "reviseImage": "Переоценить изображение",
      "generateImage": "Создать изображение",
      "generatedImage": "Сгенерированное изображение",
      "done": "Готово",
      "fileLimitTitle": "Файл слишком большой",
      "fileLimitMessage": "«{{name}}» превышает ограничение в 12 МБ ({{size}} МБ). Выберите меньший файл.",
      "imageLimitTitle": "Лимит изображения",
      "imageLimitMessage": "Вы можете загрузить до 4 изображений. В настоящее время выбраны изображения {{count}}.",
      "uploadFailedTitle": "Загрузка не удалась",
      "uploadFailedMessage": "Произошла проблема при загрузке файла.",
      "revisionFailed": "Появилась ошибка во время переработки или был превышен лимит.",
      "generationFailed": "Появилась ошибка во время генерации изображения или был превышен лимит.",
      "imageDetails": "Детали изображения",
      "close": "Закрыть",
      "download": "Скачать",
      "downloadImage": "Загрузить изображение",
      "downloading": "Загрузка",
      "versionImage": "Изображение",
      "exploreTitle": "Какой стиль вы ищете?",
      "explorePlaceholder": "Например: кинематографический портрет с темными тонами и глубокой перспективой",
      "searchStyles": "Поиск стилей",
      "clearSearch": "Очищенный поиск",
      "exploreCategories": "Откройте категории",
      "all": "Все",
      "styleCount": "Стили {{count}}",
      "noStyle": "Не найдено подходящего стиля",
      "noStyleBody": "Попробуйте снова с более коротким описанием или другими словами.",
      "libraryKicker": "Ваша личная библиотека изображений",
      "myImages": "Мои изображения",
      "imageWorks": "Изображение {{count}} работает",
      "newImage": "Создать изображение",
      "noImage": "Вы еще не создали изображение",
      "noCategoryImage": "Нет изображений в этой категории",
      "emptyGalleryBody": "Создайте свое первое изображение с помощью перевода стиля, виртуального примеривания, обложки журнала или демонстрации продукта.",
      "firstImage": "Создайте свое первое изображение",
      "imageWork": "Работа с изображением"
    },
    "create": {
      "briefTitle": "Опишите свою идею или тему",
      "briefPlaceholder": "Какое это направление? Например: будущее ИИ, путешествие на Марс или запуск продукта…",
      "briefLabel": "Краткое описание создания",
      "contentType": "Тип контента",
      "media": "Изображения и СМИ",
      "added": "{{count}} добавлен",
      "optional": "Необязательно",
      "addMedia": "Добавьте фото или видео, если хотите",
      "addMediaBody": "Загрузите свои собственные медиафайлы или оставьте их пустыми и позвольте ИИ их найти",
      "attachedMedia": "Вложенные медиафайлы",
      "add": "Добавить",
      "mediaFallback": "Спецмедиа",
      "aiCompletes": "Дайте ИИ завершить визуальные элементы",
      "noMedia": "Не загружено никаких изображений; ИИ завершит сцены.",
      "productionFormat": "Формат производства",
      "style": "Стиль",
      "customVisualWorld": "Опишите свой визуальный мир",
      "colorsAtmosphere": "Цвета, атмосфера, камера, ритм",
      "customStyleShort": "Опишите визуальный мир, который вы имеете в виду (например: пастельные тона и спокойная камера, или киберпанк-неоно…)",
      "customStyleLong": "Опишите визуальный мир, цвета, атмосферу и ритм, которые вы имеете в виду.",
      "voiceover": "Озвучка",
      "ownVoiceover": "Текст вашего озвучивания",
      "voiceoverPlaceholder": "Напишите свой текст здесь. Если оставить пустым, Voxnela подготовит его.",
      "duration": "Длительность",
      "seconds": "{{count}} сек",
      "freeLimit": "Самое длинное финальное видео в бесплатной программе составляет 60 секунд.",
      "addSound": "Добавить звук или музыку",
      "notAdded": "Не добавлено",
      "files": "Файлы {{count}}",
      "readySounds": "Используйте готовые звуки",
      "musicLibrary": "Музыкальная библиотека",
      "uploadOwn": "Загрузите свой собственный",
      "captions": "Субтитры",
      "back": "Назад",
      "create": "Создать",
      "next": "Далее",
      "researchingTopic": "Исследование темы...",
      "analyzingMaterials": "Анализ материалов...",
      "researchBody": "Проверка источников и подготовка сценария и визуального плана.",
      "analyzeBody": "Оценка сильных кадров, эмоций, ритма и краткого вместе.",
      "creativeDirection": "Креативное направление {{count}}",
      "recommended": "Рекомендуется",
      "generationFailed": "Создание не удалось завершить",
      "retry": "Подготовь снова",
      "backDirections": "Возвращение в творческие направления",
      "preparingVideo": "Подготовка видео",
      "voiceoverText": "Текст с озвучкой",
      "describeStyle": "Опишите свой собственный стиль",
      "topicDirection": "Тема и направление",
      "styleEditorSubtitle": "Опишите визуальный мир, цвета и атмосферу",
      "editorSubtitle": "Напишите текст и вставьте его в лист создания",
      "voiceoverEditorPlaceholder": "Напишите текст, который будет использоваться для озвучки.",
      "topicEditorPlaceholder": "Напишите тему и как вы хотите, чтобы её рассказали.",
      "insertText": "Вставить текст",
      "bestFor": "Лучше подходит для:",
      "useStyle": "Используйте этот стиль",
      "musicSubtitle": "Реальные треки разрешены для коммерческого использования",
      "adding": "Добавлять...",
      "musicLicense": "Треки предоставляются в соответствии с CC0 1.0; коммерческое использование разрешено, атрибуция не требуется.",
      "yes": "Да",
      "no": "Нет",
      "newCreation": "Новое создание",
      "reviewing": "Voxnela пересматривает",
      "chooseDirection": "Выберите один из трех подходов к редактированию",
      "ideaSubtitle": "Опишите свою идею; загрузите визуальные материалы или позволите Voxnela их создать",
      "projectOpenFailed": "Проектный пакет не мог быть открыт.",
      "tooManyAssets": "Вы можете добавить до 50 активов в проект.",
      "uploadSizeLimit": "Общий загрузчик проекта превышает ограничение в 2 ГБ.",
      "filesAddFailed": "Файлы не могли быть добавлены.",
      "musicPreviewFailed": "Предварительный просмотр музыки не удался открыть.",
      "musicFetchFailed": "Музыкальный файл не удалось получить.",
      "musicAddFailed": "Музыка не могла быть добавлена.",
      "topicRequired": "Введите тему и опишите, о чем будет ваше видео.",
      "briefTooShort": "Опишите, что вы хотите сказать, используя как минимум несколько слов.",
      "mediaRequired": "Загрузите изображение или включите визуальные изображения, созданные ИИ.",
      "proposalIntro": "Я проверил изображения и видео и подготовил три направления редактирования, соответствующие вашему стилю, формату и выбору аудио.",
      "removeMaterial": "Удалить {{name}}",
      "aiVisualNotice": "Открыто лицензированные реальные изображения и ИИ-иллюстрации автоматически найдены.",
      "stepProgress": "Шаг {{current}} из {{total}}",
      "styleSampleAlt": "Пример, показывающий стиль видео {{style}}",
      "reviewStyle": "Проверьте стиль {{style}}",
      "selectedDirectionPrompt": "Выбранный направление: {{title}}. {{summary}} Визуальное направление: {{visual}}. Подход к переходу: {{transitions}}. Музыкальный подход: {{music}}.",
      "letVoxnelaChoose": "Дайте Voxnela выбрать",
      "feminineVoice": "Фемининное",
      "masculineVoice": "Мускулинный",
      "narrationStyle": "Стиль повествования",
      "voiceEstimate": "О {{seconds}} сек · {{words}} словах.",
      "voiceShort": "Если это сокращение от {{duration}} секунд, Voxnela завершит его, сохраняя смысл.",
      "voiceNatural": "Voxnela корректирует только грамматику, формулировки и естественный поток.",
      "removeFile": "Удалить файл {{name}}",
      "musicStop": "Стоп {{title}}",
      "musicListen": "Слушайте {{title}}",
      "automatic": "Автомобиль",
      "all": "Все",
      "cinematic": "Кинематографический",
      "social": "Социальный и динамичный",
      "designTypography": "Дизайн и типографика",
      "retroExperimental": "Ретро и экспериментальный",
      "productionStage1": "Выбор самых сильных кадров и сцен.",
      "productionStage2": "Создание истории, движения и переходов.",
      "productionStage3": "Поддержание баланса между музыкой, голосом и субтитрами.",
      "productionStage4": "Проводится окончательные проверки на живом предварительном просмотре.",
      "genericCreationError": "Произошла проблема при подготовке видеоплана. Ваши материалы и выбор сохранены; вы можете попробовать снова.",
      "newVideo": "Новое видео",
      "topicNews": "Новости",
      "topicDocumentary": "Документальный",
      "topicExplainer": "Объяснитель",
      "topicStory": "История",
      "topicScience": "Наука",
      "topicPhilosophy": "Философия",
      "topicMagazine": "Магазин",
      "topicEntertainment": "Развлечения",
      "topicList": "Список",
      "toneCalm": "Спокойный",
      "toneEmotional": "Эмоциональный",
      "toneEnergetic": "Энергичный",
      "toneStorytelling": "Рассказы",
      "toneCheerful": "Радостный",
      "toneMysterious": "Таинственный",
      "toneNews": "Новости",
      "styleCinematic": "Кинематографический",
      "styleDarkCinematic": "Темный кинематографический",
      "styleDocumentary": "Документальный",
      "styleModernDocumentary": "Современное документальное кино",
      "stylePovImmersive": "Иммерсивный POV",
      "styleUgcAuthentic": "Античный UGC",
      "styleMiniVlog": "Мини-вилог",
      "styleSocialViral": "Социальный вирус",
      "styleHyperEdit": "Гиперредактировать",
      "styleSportsHype": "Спортивная хайп",
      "styleVelocityEdit": "Изменение скорости",
      "styleMusicBeatEdit": "Изменение бита музыки",
      "styleKineticTypography": "Кинетическая типографика",
      "styleMinimalClean": "Минималистичный и чистый",
      "styleLuxuryMinimal": "Лаконичный роскошь",
      "styleCommercialProduct": "Коммерческий продукт",
      "styleEditorialFashion": "Редакцияльная мода",
      "styleCollageZine": "Коллаж-циклет",
      "styleTechFuturistic": "Технологии футуристичные",
      "styleRetroFuturism": "Ретрофутуризм",
      "styleY2kDigital": "Цифровой Y2K",
      "styleVhsCamcorder": "VHS-камерка",
      "styleAnalogFilm": "Аналоговый пленки",
      "styleGlitchCyber": "Блокс-блок Cyber",
      "musicUpbeatMood": "Энергичный · яркий",
      "musicUpbeatDetail": "Реальные инструментальные записи для энергичного социального контента, моментов путешествий и ярких монтажей.",
      "musicElectronicMood": "Модерн · ритмичный",
      "musicElectronicDetail": "Реальная электронная музыка для городов, технологий, продуктов и быстрых монтажей.",
      "musicRomanceMood": "Эмоциональный · тёплый",
      "musicRomanceDetail": "Инструментальная музыка с нежным эмоциональным лассом для семьи, портретов, особых дней и воспоминаний.",
      "musicScoringMood": "Историческая повествование · кинематографическая",
      "musicScoringDetail": "Кинематографическая музыка в качестве фонового сопровождения для историй, промоций и драматических переходов.",
      "musicEpicMood": "Сильный · растущий",
      "musicEpicDetail": "Слойная инструментальная музыка, которая строится для грандиозных открытий, путешествий и сильных финалов.",
      "proposalBalancedTitle": "Сбалансированная повествование",
      "proposalBalancedSummary": "Изменение, которое сохраняет поток материала и подчеркивает самые сильные кадры.",
      "proposalBalancedVisual": "Сильная иерархия и согласованная визуальная система",
      "proposalBalancedTransitions": "Гладкие разрезы и измерченные вставки",
      "proposalBalancedMusic": "Музыка, которая переходит от эмоций к ритуалу",
      "proposalQuietTitle": "Тихая история",
      "proposalQuietSummary": "Спокойный подход, который даёт рамкам больше времени и подчеркивает детали и естественную эмоцию.",
      "proposalQuietVisual": "Мягкие тональности и более длинные кадры",
      "proposalQuietTransitions": "Перекрестные растворения и медленные сковорки",
      "proposalQuietMusic": "Простая и эмоциональная музыка",
      "proposalRhythmicTitle": "ритмическое редактирование",
      "proposalRhythmicSummary": "Изменение с сильным открывающим крюком, который ускоряется в середине и четко завершается в конце.",
      "proposalRhythmicVisual": "Более сильный контраст и динамическое оформление",
      "proposalRhythmicTransitions": "Резьёжные удары и контролируемые переходы с битой",
      "proposalRhythmicMusic": "Энергичная, растущая музыка",
      "underVoiceover": "мягкий под озвучкой",
      "withShortVoiceover": "с коротким, резким озвучкой"
    },
    "information": {
      "home": "Главная",
      "documentInfo": "Информация о документах",
      "version": "Версия",
      "effective": "Действует с",
      "updated": "Обновлено",
      "contents": "Содержание",
      "officialReferences": "Официальные ссылки",
      "referenceTitle": "Законодательные и ресурсы власти",
      "referenceBody": "Эти ссылки предоставлены для общего ознакомления. Преобладают обязательные законы и действующие правила со стороны компетентных органов.",
      "supportKicker": "Поддержка Sponelabs",
      "contactTitle": "Связаться с нами",
      "contactLead": "Обратитесь в службу поддержки Voxnela по вопросам вашего аккаунта, членства, оплаты, создания, отчетов о контенте, конфиденциальности или технических проблем.",
      "supportEmail": "Почта поддержки",
      "emailBody": "Кнопка ниже открывает вашу стандартную программу электронной почты с готовым шаблоном поддержки, чтобы мы могли быстрее разобраться в проблеме.",
      "openEmail": "Открыть почту",
      "includeTitle": "Укажите в сообщении",
      "includeItems": [
        "Независимо от того, используете ли вы веб-сайт, iOS или Mac;",
        "Версия вашего устройства и операционной системы;",
        "Шаги для воспроизведения проблемы;",
        "Связанный ссылка на проект, детали транзакции или скриншот, если они доступны."
      ],
      "sensitiveTitle": "Не отправляйте конфиденциальные данные",
      "sensitiveBody": "Не включайте коды подтверждения, пароли, полную информацию о деталях банковской карты, документы для подтверждения личности, медицинские данные или другую конфиденциальную информацию, которая не требуется для решения проблемы.",
      "securityTitle": "Безопасность и жалобы",
      "securityBody": "Используйте «Безопасность» для обнаружения уязвимости, «Запрос конфиденциальности» для запроса данных или «Отчет о контенте» для обнаружения вредоносного или нарушающего закон контента. Свяжитесь с местными экстренными службами в случае немедленной физической опасности.",
      "mailSubject": "Запрос на поддержку Voxnela",
      "mailGreeting": "Здравствуйте, команда поддержки Voxnela,",
      "mailTopic": "Тема поддержки:",
      "mailPlatform": "Платформа (Веб / iOS / Mac):",
      "mailDevice": "Устройство и операционная система:",
      "mailProject": "Идентификатор проекта (если доступен):",
      "mailDescription": "Описание проблемы или запроса:",
      "mailThanks": "Спасибо.",
      "termsEyebrow": "Условия использования Voxnela",
      "termsTitle": "Условия использования",
      "termsLead": "Эти условия регулируют использование сервисов создания и редактирования изображений ИИ в веб-приложениях Voxnela и iOS.",
      "privacyEyebrow": "Использование данных Voxnela",
      "privacyTitle": "Политика конфиденциальности",
      "privacyLead": "Эта политика объясняет, как обрабатываются учетные записи, изображения, проекты, членство и технические данные в сервисе создания изображений Voxnela.",
      "officialTurkishNotice": "Этот перевод предоставлен для удобства. Турецкий юридический текст определяет, если значения отличаются."
    }
  },
  "it": {
    "ui": {
      "home": "casa",
      "homeTitle": "casa",
      "explore": "Esplora",
      "gallery": "Galleria",
      "myImages": "Le mie immagini",
      "settings": "Impostazioni",
      "createImage": "Crea immagine",
      "back": "Indietro",
      "search": "Cerca",
      "account": "conto",
      "login": "Accedi",
      "logout": "Esci",
      "profile": "Profilo",
      "profileSettings": "Profilo e impostazioni",
      "plans": "Piani e utilizzo",
      "plansSubtitle": "Crediti immagine e fatturazione",
      "contact": "Contatti",
      "contactSubtitle": "Aiuto e feedback",
      "discoverVoxnela": "Scopri Voxnela",
      "discoverVoxnelaSubtitle": "Rivedi l'esperienza dello studio visivo",
      "privacy": "privacy",
      "privacySubtitle": "Come i tuoi dati sono protetti",
      "terms": "Condizioni d’uso",
      "termsSubtitle": "Termini di servizio Voxnela",
      "preferencesSubtitle": "Il tuo account e le preferenze di Voxnela",
      "accountSubtitle": "Dettagli dell'account e dell'iscrizione",
      "voxAccount": "Account Voxnela",
      "accessEverywhere": "Accedi alle tue immagini su ogni dispositivo",
      "imageRights": "Crediti immagine {{count}}",
      "availableCredits": "Crediti disponibili",
      "renewalDate": "Data di rinnovo",
      "membershipStart": "L'iscrizione è iniziata",
      "registrationDate": "Data di registrazione",
      "monthly": "mensile",
      "renewalOff": "Rinnovo disattivato",
      "user": "Utente Voxnela",
      "language": "Lingua",
      "languageSubtitle": "Scegli la lingua dell’app",
      "supportBody": "Scrivici se hai un problema o vuoi condividere un'idea. Includere l'ID del progetto ci aiuta a rispondere più velocemente.",
      "studioTitle": "Studio visivo Voxnela",
      "studioSubtitle": "Crea il tuo stile",
      "searchSubtitle": "Le tue immagini e progetti",
      "searchPlaceholder": "Cerca un'immagine o un progetto",
      "noSearchResults": "Nessuna cosa corrisponde a questa ricerca.",
      "project": "progetto",
      "image": "immagine",
      "completed": "portato a termine",
      "currentPlan": "Piano attuale",
      "notSignedIn": "Non effettuato l'accesso",
      "signInIntro": "Accedi per iniziare a utilizzare Voxnela.",
      "creditsAvailable": "I crediti immagine dello studio {{count}} sono disponibili.",
      "noCredits": "Non hai più crediti immagine in questo periodo.",
      "membershipInfo": "I crediti del piano annuale si rinnovano ogni mese e non vengono trasferiti. Gli acquisti ripristinati rimangono protetti attraverso il tuo account.",
      "signedOutMembershipInfo": "Dopo aver effettuato l'accesso, i crediti immagine disponibili e le informazioni sul piano appariranno qui.",
      "reviewPlans": "Visualizza i piani",
      "versionUpdated": "Versione {{version}} · Ultimo aggiornamento {{date}}",
      "onboardingWelcome": "Benvenuto su Voxnela",
      "skipIntro": "Salta introduzione",
      "continue": "Continua",
      "startCreating": "Inizia a creare",
      "close": "Chiudi",
      "dragToClose": "Scorri verso il basso per chiudere",
      "loading": "Caricamento...",
      "sheetExpand": "Foglio di espansione",
      "sheetCollapse": "Foglio di reso alla normale altezza",
      "cannotClose": "Impossibile chiudere mentre l'operazione è in corso",
      "stylePreview": "Anteprima dello stile",
      "stylePreviewSubtitle": "Stili e tendenze distintivi",
      "categories": "Categorie",
      "useThisStyle": "Usa questo stile",
      "videoControls": "Controlli video",
      "play": "giocare",
      "pause": "pausa",
      "mute": "muto",
      "unmute": "Spegni la muta",
      "minimize": "minimizzare",
      "expandVideo": "Espandi nell'app",
      "videoProgress": "Progresso del video",
      "toggleVideoControls": "Mostra o nascondi i comandi video",
      "expandedVideo": "{{title}} vista video estesa",
      "goToImage": "Vai all'immagine {{title}}",
      "categoryVisualStyles": "{{category}} stili visivi",
      "onboarding1Eyebrow": "Creazione di immagini",
      "onboarding1Title": "Crea la tua immagine.",
      "onboarding1Body": "Trasforma la tua idea in un fotogramma cinematografico con pellicola da 35 mm, editorial, prodotto, poster e molti altri stili visivi.",
      "onboarding2Eyebrow": "Prova virtuale degli abiti",
      "onboarding2Title": "Prova nuovi outfit.",
      "onboarding2Body": "Preserva l'identità tra le produzioni e crea immagini realistiche di moda, accessori e visuali di prova di prodotti.",
      "onboarding3Eyebrow": "Modifica delle immagini",
      "onboarding3Title": "Modifica la tua immagine.",
      "onboarding3Body": "Rivedi composizione, luce, colore e dettagli in modo conversazionale senza ricominciare da capo.",
      "onboarding4Eyebrow": "3 immagini gratuite",
      "onboarding4Title": "Inizia gratis.",
      "onboarding4Body": "Inizia subito con 3 generazioni di immagini IA gratuite una tantum. Nessun account richiesto.",
      "onboardingFaceEyebrow": "Analisi del viso e dello stile",
      "onboardingFaceTitle": "Scopri viso e stile.",
      "onboardingFaceBody": "Esplora idee per capelli, occhiali e abbigliamento a partire dal tuo ritratto in una guida visiva.",
      "onboardingHouseEyebrow": "Viaggio nel tempo",
      "onboardingHouseTitle": "Viaggia nel tempo.",
      "onboardingHouseBody": "Unisci foto e date per visualizzare come la tua casa è cambiata nel tempo.",
      "onboardingFestivalEyebrow": "La tua giornata al festival",
      "onboardingFestivalTitle": "Organizza la giornata al festival a colpo d’occhio.",
      "onboardingFestivalBody": "Trasforma programma, palchi e orari che fornisci in un percorso visivo personale.",
      "onboardingStylesEyebrow": "Stili Voxnela",
      "onboardingStylesTitle": "Scegli il tuo stile.",
      "onboardingStylesBody": "Trasforma la tua idea in un fotogramma cinematografico con pellicola da 35 mm, editorial, prodotto, poster e molti altri stili visivi."
    },
    "auth": {
      "enterCode": "Inserisci il codice",
      "membershipAndAccount": "Dettagli dell'iscrizione e dell'account",
      "noPeriodInfo": "Periodo non disponibile",
      "memberSince": "Membro dal",
      "planSince": "{{plan}} da",
      "membershipRenewal": "Data di rinnovo dell'iscrizione",
      "accountActions": "Azioni account",
      "manageSubscriptionTitle": "Fine abbonamento",
      "manageSubscriptionSubtitle": "Gestisci l'abbonamento al tuo negozio e il rinnovo automatico.",
      "deleteAccountTitle": "Elimina il mio account",
      "deleteAccountSubtitle": "Processo di cancellazione reversibile di 15 giorni.",
      "deleteDataTitle": "Elimina i miei dati",
      "deleteDataSubtitle": "Processo di cancellazione dei dati reversibile di 30 giorni.",
      "signingOut": "Disconnessione…",
      "signOut": "Esci",
      "signingIn": "Accesso…",
      "continueApple": "Continua con Apple",
      "continueGoogle": "Continua con Google",
      "or": "oppure",
      "email": "E-mail",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "Continuando con Voxnela, accetti il",
      "legalTerms": "Termini di utilizzo",
      "legalJoin": "e confermare che hai letto e compreso il",
      "legalPrivacy": "Avviso sulla privacy",
      "legalSuffix": ".",
      "sendingCode": "Invio del codice…",
      "emailSignIn": "Accedi con e-mail",
      "codeSent": "Abbiamo inviato un codice a {{email}}.",
      "change": "Modifica",
      "sixDigitCode": "Codice a 6 cifre",
      "emailCode": "Codice di accesso via email",
      "verifyingCode": "Verifica del codice…",
      "resendCode": "Invia di nuovo il codice",
      "requestReceived": "Richiesta ricevuta",
      "accountDeletionStarted": "Il processo di cancellazione del tuo account è iniziato",
      "dataDeletionStarted": "Il processo di cancellazione dei tuoi dati è iniziato",
      "accountAction": "Azione dell'account",
      "accountDeletesAt": "Il tuo account verrà cancellato definitivamente su {{date}}.",
      "dataDeletesAt": "I tuoi dati personali Voxnela saranno cancellati definitivamente su {{date}}.",
      "deletionUndo": "Se ti registri con lo stesso account prima di questa data, il processo di cancellazione viene annullato automaticamente. La tua sessione corrente è stata chiusa perché la richiesta è stata creata.",
      "done": "Fine",
      "cancel": "Annulla",
      "preparing": "Preparando...",
      "invalidEmail": "Inserisci un indirizzo email valido.",
      "enterSixDigitCode": "Inserisci il codice a 6 cifre inviato alla tua email.",
      "signInFailed": "L'accesso non è stato completato. Per favore riprova.",
      "codeSendFailed": "Il codice di accesso non è stato inviato. Per favore riprova.",
      "codeVerifyFailed": "Il codice non è stato verificato. Per favore riprova.",
      "operationFailed": "L'operazione non è stata completata al momento. Per favore riprova.",
      "popupClosed": "La finestra di accesso è stata chiusa.",
      "unauthorizedDomain": "Questo dominio non è autorizzato per l'accesso.",
      "methodUnavailable": "Questo metodo di accesso non è ancora abilitato.",
      "tooManyCodes": "Sono stati richiesti troppi codici. Riprova tra qualche minuto.",
      "invalidCode": "Il codice è invalido o scaduto. Richiedi un nuovo codice.",
      "emailUnavailable": "La consegna via e-mail non è attualmente disponibile.",
      "actions": {
        "subscription": {
          "eyebrow": "Azione di abbonamento",
          "title": "Termina il tuo abbonamento?",
          "confirm": "Gestisci gli abbonamenti",
          "paragraphs": [
            "Continuando apre la pagina di gestione dell'abbonamento dell'Apple App Store o di Google Play in cui hai acquistato l'abbonamento. Devi disattivare il rinnovo automatico nel negozio.",
            "Dopo la cancellazione, i vantaggi della tua iscrizione esistente rimangono disponibili fino alla fine del periodo di pagamento. L'eliminazione del tuo account o dei tuoi dati non annulla l'abbonamento al negozio."
          ]
        },
        "account": {
          "eyebrow": "Azione dell'account permanente",
          "title": "Sei sicuro di voler eliminare il tuo account?",
          "confirm": "Inizia il processo di cancellazione di 15 giorni",
          "paragraphs": [
            "La continuazione avvia un processo di cancellazione di 15 giorni e ti disconnette per motivi di sicurezza. Se non ti accedi nuovamente durante questo periodo, il tuo account, profilo, creazioni, libreria, raccolte e i dati Voxnela correlati verranno cancellati definitivamente.",
            "Accedere con lo stesso account entro 15 giorni annulla automaticamente la cancellazione. La cancellazione dell'account non annulla un abbonamento attivo al negozio; annullalo separatamente nel negozio."
          ]
        },
        "data": {
          "eyebrow": "Azione dati permanente",
          "title": "Sei sicuro di voler eliminare i tuoi dati?",
          "confirm": "Inizia il processo di cancellazione di 30 giorni",
          "paragraphs": [
            "Continuando avvia un processo di cancellazione di 30 giorni e ti disconnette per motivi di sicurezza. Se non ti connetti nuovamente durante questo periodo, le tue creazioni, la libreria, le raccolte, i record, le interazioni e altri dati personali Voxnela saranno cancellati definitivamente; il tuo account di accesso rimane disponibile.",
            "L'accesso nuovamente entro 30 giorni annulla automaticamente la cancellazione dei dati. I registri delle transazioni e della sicurezza limitati richiesti dalla legge possono essere conservati con accesso limitato per i periodi legali applicabili."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "Non ci sono più crediti immagine",
      "quotaFreeMessage": "Hai utilizzato il credito immagine nel tuo account gratuito. Scegli un piano per continuare a creare.",
      "later": "Più tardi",
      "currentCredit": "Crediti attuali: 0",
      "quotaProTitle": "Quota mensile Pro raggiunta",
      "quotaProMessage": "Hai utilizzato i 100 crediti immagine di questo mese. Passa a Studio per continuare a creare.",
      "renewalDate": "Data di rinnovo: {{date}}",
      "quotaStudioTitle": "Quota mensile dello studio raggiunta",
      "quotaStudioMessage": "I crediti per le tue immagini si rinnoveranno automaticamente su {{date}}.",
      "done": "Fatto",
      "membership": "Abbonamento Voxnela",
      "options": "Opzioni di abbonamento",
      "credits": "Crediti",
      "currentMembership": "Abbonamento attuale",
      "yearlyDiscount": "17% di sconto",
      "loadingPrice": "Caricamento prezzo…",
      "loadingStorePrice": "Caricamento del prezzo dal negozio",
      "year": "anno",
      "month": "mese",
      "renewDisclosure": "Si rinnova automaticamente ogni {{period}}. Annulla in qualsiasi momento.",
      "legal": "Note legali",
      "terms": "Termini",
      "alreadyMember": "Hai già {{plan}} {{period}}",
      "startPlan": "Inizia il piano {{plan}}",
      "upgradeStudio": "Passa a Studio",
      "yearlyAdvantage": "Passa ai risparmi annuali",
      "upgrade": "Aggiorna abbonamento",
      "signInRequired": "Accedi al tuo account Voxnela prima di iniziare un abbonamento.",
      "catalogUnavailable": "Il catalogo dei pagamenti non è stato verificato per questo piano. Riprova a breve.",
      "paymentUnavailable": "La schermata di pagamento non è riuscita ad aprirsi. Per favore riprova.",
      "benefits": [
        {
          "lead": "Crediti {{credits}}",
          "label": "Generazione di immagini ad alta risoluzione ogni mese"
        },
        {
          "lead": "Oltre 50 stili da studio",
          "label": "Neo-Minimalismo, cinematografico e ogni stile distintivo"
        },
        {
          "lead": "Blocco facciale",
          "label": "Prova di moda virtuale senza cambiare le caratteristiche del viso"
        },
        {
          "lead": "Coda di priorità",
          "label": "Elaborazione GPU ultra-veloce senza attese"
        },
        {
          "lead": "Revisioni della chat",
          "label": "Modifiche dettagliate illimitate in più giri in linguaggio naturale"
        },
        {
          "lead": "Diritti commerciali completi",
          "label": "Uso ad alta risoluzione, senza watermark"
        }
      ],
      "restorePurchases": "Restituisci gli acquisti",
      "restoringPurchases": "Acquisti di restauro...",
      "restoreSuccess": "La tua iscrizione è stata ripristinata.",
      "restoreEmpty": "Non è stata trovata alcuna abbonamento attivo per questo account App Store.",
      "membershipSyncPending": "Verifica dell'iscrizione e dei crediti immagine...",
      "membershipSyncFailed": "Impossibile sincronizzare i crediti immagine. Riprova.",
      "membershipUnavailable": "Impossibile caricare l’abbonamento.",
      "retry": "Riprova"
    },
    "video": {
      "revisionHook": "Rendi i primi tre secondi più coinvolgenti.",
      "revisionPace": "Bilancia il ritmo e accorcia le sezioni lente.",
      "revisionEnding": "Rendi la fine più memorabile.",
      "revisionTransition": "Rendi le transizioni più fluide e naturali.",
      "revisionFraming": "Usa inquadrature più bilanciate per i dettagli importanti.",
      "revisionColor": "Rendi i colori più equilibrati e cinematografici.",
      "revisionText": "Rendi il testo più breve e più facile da leggere.",
      "revisionAudio": "Abbina la musica più strettamente al ritmo delle immagini.",
      "revisionEmotion": "Rendi la storia più sincera ed emotiva.",
      "revisionStructure": "Costruisci un inizio, una metà e una fine più chiari.",
      "previewBack": "Torna alla anteprima",
      "revisionWelcome": "Cosa vorresti cambiare?",
      "revisionFailed": "Non potevo applicare quel cambiamento. Potresti descriverlo di nuovo?",
      "finalQueued": "Il video finale è in coda. Apparirà sotto Video quando sarà pronto.",
      "watermarkUpgrade": "Scegli un piano per creare un nuovo output finale senza il watermark Voxnela.",
      "finalFailed": "Il video finale non è stato possibile iniziare.",
      "projectDeleteFailed": "Il progetto non è stato possibile eliminare.",
      "videoDescriptionWithBrief": "Questo video è stato creato da “{{brief}}”. Voxnela ha selezionato i momenti più forti e ha costruito il ritmo e l'ordine delle scene attorno alla direzione creativa scelta.",
      "videoDescriptionGeneric": "Voxnela ha valutato i materiali per contenuto, ritmo e coerenza narrativa, evidenziando i momenti più forti per un montaggio equilibrato.",
      "play": "giocare",
      "deletesOn": "elimina su {{date}}",
      "projectsBelong": "I tuoi progetti sono collegati al tuo account.",
      "videosBelong": "I tuoi video sono collegati al tuo account.",
      "signInToSeeProjects": "Accedi per vedere i tuoi progetti e continuare su tutti i dispositivi.",
      "signInToSeeVideos": "Accedi per vedere i tuoi video e continuare su tutti i dispositivi.",
      "delete": "Elimina",
      "deleting": "Eliminazione…",
      "secondsVersion": "{{seconds}} sec · versione {{version}}",
      "deleteProject": "Elimina progetto",
      "projectCoverUnavailable": "La copertina del progetto non è stata caricata",
      "videoCoverPreparing": "Preparazione della copertina del video",
      "deleteVideo": "Elimina video",
      "signed": "Marchiato Voxnela",
      "failed": "Non è riuscito a completare",
      "tryAgain": "Puoi riprovare",
      "cancelled": "Cancellato",
      "noCreditUsed": "Nessun credito utilizzato",
      "featuredStyles": "Stili visivi in primo piano",
      "previousImage": "Immagine precedente",
      "nextImage": "Prossima immagine",
      "reviewStyle": "Esplora questo stile",
      "featuredNavigation": "Navigazione visiva in primo piano",
      "taskCategories": "Categorie di compiti",
      "projectOpening": "Progetto di apertura",
      "opening": "Apertura...",
      "projectNotFound": "Progetto non trovato",
      "projectUnavailable": "Questo progetto non è più disponibile.",
      "backToProjects": "Torna ai miei progetti",
      "editVideo": "Modifica video",
      "versionContext": "Versione {{version}} · Voxnela conosce il tuo progetto e i tuoi materiali",
      "livePreviewActions": "Azioni di anteprima in tempo reale",
      "edit": "Modifica",
      "preparing": "Preparazione",
      "save": "Salva",
      "thinking": "Voxnela sta pensando",
      "revisionSuggestions": "Suggerimenti di modifica",
      "describeChange": "Descrivi il cambiamento che desideri",
      "sendEdit": "Invia richiesta di modifica",
      "deleteProjectDescription": "Sei sicuro di voler eliminare “{{title}}” e tutti i materiali correlati? Questo non può essere annullato.",
      "projects": "Progetti",
      "projectsPreparing": "Preparare i tuoi progetti",
      "noProjects": "Non hai ancora un progetto. Inizia descrivendo la tua prima idea.",
      "createNew": "Crea nuova immagine",
      "thisProject": "Questo progetto",
      "videos": "Video",
      "videosPreparing": "Preparare i tuoi video",
      "noVideos": "Non hai ancora un video completato. Apparirà qui quando il tuo primo video sarà pronto.",
      "videoPlayFailed": "Il video non è stato riprodotto.",
      "videoNotReady": "Il file video non è ancora pronto per il download.",
      "videoDownloadFailed": "Il video non è stato possibile scaricare.",
      "videoDeleteFailed": "Il video non è stato possibile eliminare.",
      "videoLoading": "Caricamento del video...",
      "videoActions": "Azioni video",
      "showVideoDescription": "Mostra descrizione del video",
      "videoDownloading": "Scaricamento video",
      "downloadVideo": "Scarica video",
      "thisVideo": "Questo video",
      "deleteVideoDescription": "Sei sicuro di voler eliminare il video intitolato “{{title}}”? Questo non può essere annullato."
    },
    "studio": {
      "useStyle": "Usa questo stile",
      "galleryFilters": "Filtri della galleria",
      "modeStyleTransfer": "Stili Voxnela",
      "modeVirtualTryOn": "Prova virtuale",
      "modeMagazineCover": "Rivista e copertina",
      "modePosterStudio": "Studio di poster",
      "modeCommercial": "Spettacolo di prodotti",
      "modeTimeWarp": "viaggio nel tempo",
      "modeOutpaintRelight": "Espandi e riaccendi",
      "modeInfographic": "Infografica e dati",
      "modePortraitRetouch": "Ritocco del ritratto",
      "modeArtisticCollage": "Collage artistico",
      "defaultStyle": "Stile Voxnela",
      "signInToCreate": "Accedi per creare un'immagine.",
      "signInToEdit": "Accedi per modificare un'immagine.",
      "creationSuccess": "La tua immagine è stata creata con successo. Dimmi direttamente se desideri modificare l'illuminazione, i colori, gli oggetti o la cornice.",
      "imageReady": "La tua immagine è pronta. Dimmi cosa ti piace o cosa vuoi rivedere.",
      "revisionSuccess": "La revisione è completa. Puoi confrontarla con il cursore prima/dopo o richiedere un altro cambiamento.",
      "versionReady": "La versione {{version}} è pronta.",
      "projectNotFound": "Progetto non trovato.",
      "styleApplied": "Stile {{style}} applicato",
      "imageCreation": "Creazione di immagini",
      "defaultPrompt": "Immagine da studio",
      "aspectSquare": "quadrato",
      "aspectSquareDetail": "Feed di Instagram, Profilo, Arte",
      "aspectVertical": "verticale",
      "aspectVerticalDetail": "Storie di Instagram, Reel, TikTok",
      "aspectHorizontal": "orizzontale",
      "aspectHorizontalDetail": "YouTube, Banner, Cinema",
      "aspectPortrait": "ritratto",
      "aspectPortraitDetail": "Ritratto Instagram, Poster, Spettacolo",
      "aspectPanoramic": "panoramico",
      "aspectPanoramicDetail": "Paesaggio cinematografico ultra ampio",
      "styles": "Stili Voxnela",
      "fullScreenStyle": "Visualizza lo stile a schermo intero",
      "closeDescription": "Descrizione dello stile di chiusura",
      "moreWithVoxnela": "Fai di più con Voxnela",
      "quickStartBody": "Scrivi quello che vuoi qui sotto o allegare un file.",
      "createImage": "Crea immagine",
      "createImageDetail": "Costruisci la tua idea da zero",
      "editImage": "Modifica immagine",
      "editImageQuick": "Modifica un'immagine",
      "editImageDetail": "Rimagina un'immagine caricata",
      "transformStyle": "Trasforma lo stile e la scena",
      "transformStyleDetail": "Trasferisci la tua immagine in un altro mondo",
      "visualizeDocument": "Visualizza un documento o una presentazione",
      "visualizeDocumentDetail": "Trasforma il contenuto completo in un design",
      "submittedImage": "Immagine inviata",
      "generating": "Voxnela sta creando la tua immagine…",
      "viewImage": "Visualizza immagine",
      "removeStyle": "Rimuovi lo stile selezionato",
      "referenceImage": "Immagine di riferimento",
      "referenceNotice": "Questa immagine verrà rivista o verrà applicato un nuovo stile",
      "removeReference": "Rimuovi l'immagine di riferimento",
      "remove": "rimuovere",
      "uploading": "Caricamento",
      "addFile": "Aggiungi un file o un'immagine",
      "addFileTitle": "Somma fino a 4 immagini o un documento (PDF, Word, PPT, max 12 MB)",
      "aspectRatio": "Rapporto di aspetto",
      "selectAspectRatio": "Seleziona il rapporto di aspetto",
      "aspectOptions": "Opzioni di rapporto di aspetto",
      "revisePlaceholder": "Cosa vorresti cambiare in questa immagine?",
      "styledPlaceholder": "Descrivi l'immagine che desideri in questo stile (opzionale)...",
      "promptPlaceholder": "Descrivi un'immagine o scrivi un prompt...",
      "reviseImage": "Rivedi immagine",
      "generateImage": "Genera immagine",
      "generatedImage": "Immagine generata",
      "done": "Fine",
      "fileLimitTitle": "File troppo grande",
      "fileLimitMessage": "\"{{name}}\" supera il limite di 12 MB ({{size}} MB). Scegli un file più piccolo.",
      "imageLimitTitle": "Limite di immagine",
      "imageLimitMessage": "Puoi caricare fino a 4 immagini. Le immagini {{count}} sono attualmente selezionate.",
      "uploadFailedTitle": "Caricamento fallito",
      "uploadFailedMessage": "Si è verificato un problema durante l'upload del file.",
      "revisionFailed": "Si è verificato un errore durante la revisione o la quota è stata superata.",
      "generationFailed": "Si è verificato un errore durante la generazione dell'immagine o la quota è stata superata.",
      "imageDetails": "Dettagli dell'immagine",
      "close": "chiudere",
      "download": "Scarica",
      "downloadImage": "Scarica immagine",
      "downloading": "Download",
      "versionImage": "immagine",
      "exploreTitle": "Quale stile stai cercando?",
      "explorePlaceholder": "Ad esempio: un ritratto cinematografico con toni scuri e prospettiva profonda",
      "searchStyles": "Cerca stili visivi",
      "clearSearch": "Ricerca chiara",
      "exploreCategories": "Esplora le categorie",
      "all": "Tutti",
      "styleCount": "Stili {{count}}",
      "noStyle": "Nessuno stile corrispondente trovato",
      "noStyleBody": "Riprova con una descrizione più breve o parole diverse.",
      "libraryKicker": "La tua libreria di immagini personali",
      "myImages": "Le mie immagini",
      "imageWorks": "L'immagine {{count}} funziona",
      "newImage": "Crea nuova immagine",
      "noImage": "Non hai ancora creato un'immagine",
      "noCategoryImage": "Nessun'immagine in questa categoria",
      "emptyGalleryBody": "Crea la tua prima immagine con trasferimento di stile, provetta virtuale, copertina di rivista o presentazione del prodotto.",
      "firstImage": "Crea la tua prima immagine",
      "imageWork": "Lavoro di immagine"
    },
    "create": {
      "briefTitle": "Descrivi la tua idea o argomento",
      "briefPlaceholder": "Qual è l'argomento? Ad esempio: il futuro dell'IA, un viaggio su Marte o il lancio di un prodotto…",
      "briefLabel": "Breve di creazione",
      "contentType": "Tipo di contenuto",
      "media": "Immagini e media",
      "added": "{{count}} aggiunto",
      "optional": "Facoltativo",
      "addMedia": "Aggiungi una foto o un video se vuoi",
      "addMediaBody": "Carica i tuoi media o lasciali vuoti e lascia che l'IA li trovi",
      "attachedMedia": "Media allegati",
      "add": "Aggiungi",
      "mediaFallback": "nei media",
      "aiCompletes": "Lascia che l'IA completi le immagini",
      "noMedia": "Nessuna immagine caricata; l'IA completerà le scene.",
      "productionFormat": "Formato di produzione",
      "style": "Stile",
      "customVisualWorld": "Descrivi il tuo mondo visivo",
      "colorsAtmosphere": "Colori, atmosfera, fotocamera, ritmo",
      "customStyleShort": "Descrivi il mondo visivo che hai in mente (ad esempio: tonalità pastello e una fotocamera calma, o neon cyberpunk…)",
      "customStyleLong": "Descrivi il mondo visivo, i colori, l'atmosfera e il ritmo che hai in mente.",
      "voiceover": "Voce fuori campo",
      "ownVoiceover": "Il testo della tua voce fuori campo",
      "voiceoverPlaceholder": "Scrivi il tuo testo qui. Se lasciato vuoto, Voxnela lo preparerà.",
      "duration": "Durata",
      "seconds": "{{count}} sec",
      "freeLimit": "Il video finale più lungo sul piano gratuito è di 60 secondi.",
      "addSound": "Aggiungi suono o musica",
      "notAdded": "Non aggiunto",
      "files": "File {{count}}",
      "readySounds": "Usa suoni pronti",
      "musicLibrary": "Libreria musicale",
      "uploadOwn": "Carica il tuo",
      "captions": "Sottotitoli",
      "back": "Indietro",
      "create": "Crea",
      "next": "Avanti",
      "researchingTopic": "Studiando l'argomento...",
      "analyzingMaterials": "Analisi dei materiali...",
      "researchBody": "Verificare le fonti e preparare lo script e il piano visivo.",
      "analyzeBody": "Valutare i forti inquadraggi, l'emozione, il ritmo e il breve insieme.",
      "creativeDirection": "Direzione creativa {{count}}",
      "recommended": "Consigliato",
      "generationFailed": "La creazione non è stata completata",
      "retry": "Preparare di nuovo",
      "backDirections": "Ritorno alle direzioni creative",
      "preparingVideo": "Preparazione del video",
      "voiceoverText": "Testo in voce fuori campo",
      "describeStyle": "Descrivi il tuo stile personale",
      "topicDirection": "Argomento e direzione",
      "styleEditorSubtitle": "Descrivi il mondo visivo, i colori e l'atmosfera",
      "editorSubtitle": "Scrivi il testo e inseriscilo nella scheda di creazione",
      "voiceoverEditorPlaceholder": "Scrivi il testo da utilizzare per la voce fuori campo.",
      "topicEditorPlaceholder": "Scrivi l'argomento e come vuoi che venga raccontato.",
      "insertText": "Inserisci testo",
      "bestFor": "Il migliore per:",
      "useStyle": "Usa questo stile",
      "musicSubtitle": "Brani reali autorizzati all'uso commerciale",
      "adding": "Aggiungendo...",
      "musicLicense": "Le tracce sono fornite ai sensi del CC0 1.0; l'uso commerciale è consentito e non è richiesta l'attribuzione.",
      "yes": "Sì",
      "no": "no.",
      "newCreation": "Nuova creazione",
      "reviewing": "Voxnela sta revisionando",
      "chooseDirection": "Scegli uno dei tre approcci di editing",
      "ideaSubtitle": "Descrivi la tua idea; carica immagini o permetti a Voxnela di crearle",
      "projectOpenFailed": "Il pacchetto progetto non è stato possibile aprire.",
      "tooManyAssets": "Puoi aggiungere fino a 50 asset a un progetto.",
      "uploadSizeLimit": "L'upload totale del progetto supera il limite di 2 GB.",
      "filesAddFailed": "I file non sono stati aggiunti.",
      "musicPreviewFailed": "La anteprima della musica non è stata aperta.",
      "musicFetchFailed": "Il file musicale non è stato recuperato.",
      "musicAddFailed": "La musica non poteva essere aggiunta.",
      "topicRequired": "Inserisci un argomento e descrivi di cosa parlerà il tuo video.",
      "briefTooShort": "Descrivi cosa vuoi dire in almeno alcune parole.",
      "mediaRequired": "Carica un'immagine o abilita le visualizzazioni generate dall'IA.",
      "proposalIntro": "Ho esaminato le immagini e i video e preparato tre direzioni di editing che si adattano al tuo stile, formato e alle tue scelte audio.",
      "removeMaterial": "Rimuovi {{name}}",
      "aiVisualNotice": "Le immagini reali e le illustrazioni dell'IA con licenza aperta vengono trovate automaticamente.",
      "stepProgress": "Passo {{current}} di {{total}}",
      "styleSampleAlt": "Esempio che mostra lo stile video {{style}}",
      "reviewStyle": "Rivedi lo stile {{style}}",
      "selectedDirectionPrompt": "Direzione selezionata: {{title}}. {{summary}} Direzione visiva: {{visual}}. Approccio di transizione: {{transitions}}. Approccio musicale: {{music}}.",
      "letVoxnelaChoose": "Lascia che Voxnela scelga",
      "feminineVoice": "femminile",
      "masculineVoice": "maschile",
      "narrationStyle": "Stile di narrazione",
      "voiceEstimate": "Informazioni su {{seconds}} sec · parole {{words}}.",
      "voiceShort": "Se è abbreviato in {{duration}} secondi, Voxnela lo completerà preservando il significato.",
      "voiceNatural": "Voxnela si adatta solo alla grammatica, alla formulazione e al flusso naturale.",
      "removeFile": "Rimuovi il file {{name}}",
      "musicStop": "Stop {{title}}",
      "musicListen": "Ascolta {{title}}",
      "automatic": "auto",
      "all": "tutti",
      "cinematic": "cinematografico",
      "social": "Sociale e dinamico",
      "designTypography": "Design e tipografia",
      "retroExperimental": "Retro e Sperimentale",
      "productionStage1": "Selezionare le cornici e le scene più forti.",
      "productionStage2": "Costruire la storia, il movimento e le transizioni.",
      "productionStage3": "Bilanciamento di musica, voce e sottotitoli.",
      "productionStage4": "Eseguono controlli finali sulla anteprima in tempo reale.",
      "genericCreationError": "Si è verificato un problema durante la preparazione del piano video. I tuoi materiali e le tue scelte sono stati preservati; puoi riprovare.",
      "newVideo": "Nuovo video",
      "topicNews": "notizie",
      "topicDocumentary": "documentario",
      "topicExplainer": "chi spiega",
      "topicStory": "storia",
      "topicScience": "scienza",
      "topicPhilosophy": "filosofia",
      "topicMagazine": "rivista",
      "topicEntertainment": "divertimento",
      "topicList": "elenco",
      "toneCalm": "calma",
      "toneEmotional": "emotivo",
      "toneEnergetic": "energico",
      "toneStorytelling": "narrazione",
      "toneCheerful": "allegro",
      "toneMysterious": "misterioso",
      "toneNews": "notizie",
      "styleCinematic": "cinematografico",
      "styleDarkCinematic": "Cinematico oscuro",
      "styleDocumentary": "documentario",
      "styleModernDocumentary": "Documentario moderno",
      "stylePovImmersive": "POV immersivo",
      "styleUgcAuthentic": "UGC autentico",
      "styleMiniVlog": "Mini vlog",
      "styleSocialViral": "Virale sociale",
      "styleHyperEdit": "Modifica iperattiva",
      "styleSportsHype": "Hype sportivo",
      "styleVelocityEdit": "Modifica della velocità",
      "styleMusicBeatEdit": "Modifica del battito musicale",
      "styleKineticTypography": "Tipografia cinetica",
      "styleMinimalClean": "Minimo e pulito",
      "styleLuxuryMinimal": "Minimalismo di lusso",
      "styleCommercialProduct": "Prodotto commerciale",
      "styleEditorialFashion": "Moda editoriale",
      "styleCollageZine": "Zine collage",
      "styleTechFuturistic": "Tecnologico Futuristico",
      "styleRetroFuturism": "Retrofuturismo",
      "styleY2kDigital": "Digitale Y2K",
      "styleVhsCamcorder": "Videocamera VHS",
      "styleAnalogFilm": "Film analogico",
      "styleGlitchCyber": "Guasto Cyber",
      "musicUpbeatMood": "Energico · luminoso",
      "musicUpbeatDetail": "Registrazioni strumentali reali per contenuti sociali allegri, momenti di viaggio e montaggi vivaci.",
      "musicElectronicMood": "Moderno · ritmico",
      "musicElectronicDetail": "Musica elettronica reale per città, tecnologia, prodotti e montaggi veloci.",
      "musicRomanceMood": "Emozionale · caldo",
      "musicRomanceDetail": "Musica strumentale con un delicato arco emotivo per la famiglia, i ritratti, i giorni speciali e i ricordi.",
      "musicScoringMood": "Narrativo · cinematografico",
      "musicScoringDetail": "Musica di sottofondo cinematografica a supporto di storie, promozioni e transizioni drammatiche.",
      "musicEpicMood": "Potente · in crescita",
      "musicEpicDetail": "Musica strumentale stratificata che si costruisce per i grandi opening, i viaggi e i forti finali.",
      "proposalBalancedTitle": "Narrazione bilanciata",
      "proposalBalancedSummary": "Una modifica che preserva il flusso del materiale e mette in risalto i fotogrammi più forti.",
      "proposalBalancedVisual": "Strong hierarchy e un sistema visivo coerente",
      "proposalBalancedTransitions": "Tagli lisci e inserimenti misurati",
      "proposalBalancedMusic": "Musica che passa dall'emozione al ritmo",
      "proposalQuietTitle": "Storia silenziosa",
      "proposalQuietSummary": "Un approccio calmo che dà ai cornici più tempo e sottolinea i dettagli e l'emozione naturale.",
      "proposalQuietVisual": "Toni morbidi e inquadrature più lunghe",
      "proposalQuietTransitions": "Dissoluzione crociata e padelle lente",
      "proposalQuietMusic": "Musica semplice ed emozionante",
      "proposalRhythmicTitle": "Modifica ritmica",
      "proposalRhythmicSummary": "Un montaggio con un forte gancio di apertura che accelera al centro e si stabilizza chiaramente alla fine.",
      "proposalRhythmicVisual": "Contrasto più forte e inquadratura dinamica",
      "proposalRhythmicTransitions": "Tagli di battito e transizioni di frusta controllate",
      "proposalRhythmicMusic": "Musica energica e in crescita",
      "underVoiceover": "dolce sotto la voce fuori campo",
      "withShortVoiceover": "con voce fuori campo breve e incisiva"
    },
    "information": {
      "home": "casa",
      "documentInfo": "Informazioni sui documenti",
      "version": "Versione",
      "effective": "In vigore",
      "updated": "Ultimo aggiornamento",
      "contents": "Indice",
      "officialReferences": "Riferimenti ufficiali",
      "referenceTitle": "Risorse legali e di autorità",
      "referenceBody": "Questi link sono forniti per informazioni generali. Prevale la normativa obbligatoria e le norme vigenti delle autorità competenti.",
      "supportKicker": "Supporto Sponelabs",
      "contactTitle": "Contattaci",
      "contactLead": "Contatta il team di supporto Voxnela per informazioni sul tuo account, iscrizione, pagamento, creazione, segnalazioni di contenuti, privacy o problemi tecnici.",
      "supportEmail": "Email di assistenza",
      "emailBody": "Il pulsante qui sotto apre la tua applicazione di posta elettronica predefinita con un modello di supporto pronto all'uso in modo che possiamo indagare più velocemente.",
      "openEmail": "Apri l’app email",
      "includeTitle": "Includi nel messaggio",
      "includeItems": [
        "Che tu utilizzi Web, iOS o Mac;",
        "La versione del tuo dispositivo e del sistema operativo;",
        "Passaggi per riprodurre il problema;",
        "Il link del progetto correlato, i dettagli della transazione o uno screenshot, se disponibili."
      ],
      "sensitiveTitle": "Non inviare dati sensibili",
      "sensitiveBody": "Non includere codici di verifica, password, dettagli completi della carta di pagamento, documenti di identità, dati sanitari o altre informazioni sensibili che non sono necessarie per risolvere il problema.",
      "securityTitle": "Sicurezza e segnalazioni",
      "securityBody": "Utilizza “Sicurezza” per una vulnerabilità, “Richiesta di privacy” per una richiesta di dati o “Segnalazione contenuti” per contenuti dannosi o che violano le leggi. Contatta i servizi di emergenza locali in caso di pericolo fisico immediato.",
      "mailSubject": "Richiesta di supporto Voxnela",
      "mailGreeting": "Ciao Team di supporto Voxnela,",
      "mailTopic": "Argomento di supporto:",
      "mailPlatform": "Piattaforma (Web / iOS / Mac):",
      "mailDevice": "Dispositivo e sistema operativo:",
      "mailProject": "ID del progetto (se disponibile):",
      "mailDescription": "Descrizione del problema o della richiesta:",
      "mailThanks": "Grazie.",
      "termsEyebrow": "Termini di servizio Voxnela",
      "termsTitle": "Termini di utilizzo",
      "termsLead": "Questi termini regolano l'utilizzo dei servizi di creazione e modifica di immagini con intelligenza artificiale nel web e nelle app iOS di Voxnela.",
      "privacyEyebrow": "Uso dei dati Voxnela",
      "privacyTitle": "Informativa sulla privacy",
      "privacyLead": "Questa politica spiega come account, immagine, progetto, iscrizione e dati tecnici vengono elaborati nel servizio di creazione immagini Voxnela.",
      "officialTurkishNotice": "Questa traduzione è fornita a scopo pratico. Il testo legale turco regola se i significati differiscono."
    }
  },
  "pt": {
    "ui": {
      "home": "Início",
      "homeTitle": "casa",
      "explore": "Explorar",
      "gallery": "Galeria",
      "myImages": "Minhas Imagens",
      "settings": "Definições",
      "createImage": "Criar imagem",
      "back": "Voltar",
      "search": "Pesquisar",
      "account": "Conta",
      "login": "Iniciar sessão",
      "logout": "Terminar sessão",
      "profile": "Perfil",
      "profileSettings": "Perfil e Configurações",
      "plans": "Planos e utilização",
      "plansSubtitle": "Créditos de imagem e cobrança",
      "contact": "Contacto",
      "contactSubtitle": "Ajuda e feedback",
      "discoverVoxnela": "Descubra a Voxnela",
      "discoverVoxnelaSubtitle": "Revisar a experiência do estúdio visual",
      "privacy": "Privacidade",
      "privacySubtitle": "Como seus dados são protegidos",
      "terms": "Termos de utilização",
      "termsSubtitle": "Termos de serviço Voxnela",
      "preferencesSubtitle": "Sua conta e preferências Voxnela",
      "accountSubtitle": "Detalhes da conta e da associação",
      "voxAccount": "Conta Voxnela",
      "accessEverywhere": "Acesse suas imagens em todos os dispositivos",
      "imageRights": "Créditos de imagem {{count}}",
      "availableCredits": "Créditos disponíveis",
      "renewalDate": "Data de renovação",
      "membershipStart": "Assinatura iniciada",
      "registrationDate": "Data de registro",
      "monthly": "mensalmente",
      "renewalOff": "Renovação desativada",
      "user": "Usuário Voxnela",
      "language": "Idioma",
      "languageSubtitle": "Escolha o idioma da aplicação",
      "supportBody": "Escreva-nos se tiver algum problema ou quiser compartilhar uma ideia. Incluir o ID do projeto nos ajuda a responder mais rapidamente.",
      "studioTitle": "Estúdio visual Voxnela",
      "studioSubtitle": "Crie seu estilo",
      "searchSubtitle": "Suas imagens e projetos",
      "searchPlaceholder": "Procure uma imagem ou projeto",
      "noSearchResults": "Nada correspondeu a esta busca.",
      "project": "projeto",
      "image": "imagem",
      "completed": "Concluído",
      "currentPlan": "Plano atual",
      "notSignedIn": "Não conectado",
      "signInIntro": "Faça login para começar a usar o Voxnela.",
      "creditsAvailable": "Os créditos de imagem do estúdio {{count}} estão disponíveis.",
      "noCredits": "Você não tem créditos de imagem restantes neste período.",
      "membershipInfo": "Os créditos do plano anual renovam a cada mês e não são transferidos. As compras restauradas permanecem protegidas através da sua conta.",
      "signedOutMembershipInfo": "Depois de fazer login, seus créditos de imagem disponíveis e informações do plano aparecerão aqui.",
      "reviewPlans": "Ver planos",
      "versionUpdated": "Versão {{version}} · Última atualização {{date}}",
      "onboardingWelcome": "Boas-vindas ao Voxnela",
      "skipIntro": "Ignorar introdução",
      "continue": "Continuar",
      "startCreating": "Começar a criar",
      "close": "fechar",
      "dragToClose": "Deslize para baixo para fechar a planilha",
      "loading": "Carregando...",
      "sheetExpand": "Expandir folha",
      "sheetCollapse": "Folha de retorno para altura normal",
      "cannotClose": "Não pode fechar enquanto a operação está em andamento",
      "stylePreview": "Prévia de Estilo",
      "stylePreviewSubtitle": "Estilos e tendências de assinatura",
      "categories": "Categorias",
      "useThisStyle": "Use este estilo",
      "videoControls": "Controles de vídeo",
      "play": "jogar",
      "pause": "pausa",
      "mute": "mudo",
      "unmute": "Desativar o silêncio",
      "minimize": "minimizar",
      "expandVideo": "Expandir no aplicativo",
      "videoProgress": "Progresso do vídeo",
      "toggleVideoControls": "Mostrar ou ocultar os controles de vídeo",
      "expandedVideo": "{{title}} visualização de vídeo expandida",
      "goToImage": "Vá para a imagem {{title}}",
      "categoryVisualStyles": "{{category}} estilos visuais",
      "onboarding1Eyebrow": "Criação de imagens",
      "onboarding1Title": "Cria a tua imagem.",
      "onboarding1Body": "Transforme sua ideia em uma moldura cinematográfica com filme de 35mm, editorial, produto, pôster e muitos outros estilos visuais.",
      "onboarding2Eyebrow": "Prova virtual de roupa",
      "onboarding2Title": "Experimenta novos looks.",
      "onboarding2Body": "Preserve a identidade em todas as produções e crie imagens realistas de moda, acessórios e visualizações de provação de produtos.",
      "onboarding3Eyebrow": "Edição de imagens",
      "onboarding3Title": "Edita a tua imagem.",
      "onboarding3Body": "Revise a composição, a luz, a cor e os detalhes conversacionalmente sem começar do zero.",
      "onboarding4Eyebrow": "3 imagens grátis",
      "onboarding4Title": "Começa grátis.",
      "onboarding4Body": "Comece agora com 3 gerações de imagens com IA grátis, válidas uma única vez. Não é preciso conta.",
      "onboardingFaceEyebrow": "Análise de rosto e estilo",
      "onboardingFaceTitle": "Descobre rosto e estilo.",
      "onboardingFaceBody": "Explora ideias para cabelo, óculos e roupa a partir do teu retrato num único guia visual.",
      "onboardingHouseEyebrow": "Viagem no tempo",
      "onboardingHouseTitle": "Viaja no tempo.",
      "onboardingHouseBody": "Reúne as tuas fotografias e datas para visualizar como a casa mudou com o tempo.",
      "onboardingFestivalEyebrow": "O teu dia de festival",
      "onboardingFestivalTitle": "Planeia o teu dia de festival num relance.",
      "onboardingFestivalBody": "Transforma o programa, os palcos e os horários que indicas num percurso visual pessoal.",
      "onboardingStylesEyebrow": "Estilos Voxnela",
      "onboardingStylesTitle": "Escolhe o teu estilo.",
      "onboardingStylesBody": "Transforme sua ideia em uma moldura cinematográfica com filme de 35mm, editorial, produto, pôster e muitos outros estilos visuais."
    },
    "auth": {
      "enterCode": "Introduza o código",
      "membershipAndAccount": "Detalhes da associação e da conta",
      "noPeriodInfo": "Período indisponível",
      "memberSince": "Membro desde",
      "planSince": "{{plan}} desde",
      "membershipRenewal": "Data de renovação da associação",
      "accountActions": "Ações da conta",
      "manageSubscriptionTitle": "Terminar assinatura",
      "manageSubscriptionSubtitle": "Gerencie sua assinatura de loja e renovação automática.",
      "deleteAccountTitle": "Excluir minha conta",
      "deleteAccountSubtitle": "Processo de exclusão reversível de 15 dias.",
      "deleteDataTitle": "Exclua meus dados",
      "deleteDataSubtitle": "Processo reversível de exclusão de dados de 30 dias.",
      "signingOut": "A terminar sessão…",
      "signOut": "Terminar sessão",
      "signingIn": "A iniciar sessão…",
      "continueApple": "Continuar com Apple",
      "continueGoogle": "Continuar com Google",
      "or": "ou",
      "email": "E-mail",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "Ao continuar com a Voxnela, você aceita o",
      "legalTerms": "Termos de Uso",
      "legalJoin": "e confirme que você leu e entendeu o",
      "legalPrivacy": "Aviso de Privacidade",
      "legalSuffix": ".",
      "sendingCode": "A enviar código…",
      "emailSignIn": "Iniciar sessão por e-mail",
      "codeSent": "Enviamos um código para {{email}}.",
      "change": "Alterar",
      "sixDigitCode": "Código de 6 dígitos",
      "emailCode": "Código de login por e-mail",
      "verifyingCode": "A verificar código…",
      "resendCode": "Reenviar código",
      "requestReceived": "Solicitação recebida",
      "accountDeletionStarted": "O processo de exclusão da sua conta começou",
      "dataDeletionStarted": "Seu processo de exclusão de dados começou",
      "accountAction": "Ação da conta",
      "accountDeletesAt": "Sua conta será excluída permanentemente em {{date}}.",
      "dataDeletesAt": "Seus dados pessoais Voxnela serão excluídos permanentemente em {{date}}.",
      "deletionUndo": "Se você fizer login com a mesma conta antes desta data, o processo de exclusão será cancelado automaticamente. Sua sessão atual foi fechada porque a solicitação foi criada.",
      "done": "Concluído",
      "cancel": "Cancelar",
      "preparing": "Preparando...",
      "invalidEmail": "Digite um endereço de e-mail válido.",
      "enterSixDigitCode": "Digite o código de 6 dígitos enviado para o seu e-mail.",
      "signInFailed": "O login não pôde ser concluído. Por favor, tente novamente.",
      "codeSendFailed": "O código de login não pôde ser enviado. Por favor, tente novamente.",
      "codeVerifyFailed": "O código não pôde ser verificado. Por favor, tente novamente.",
      "operationFailed": "A operação não pôde ser concluída no momento. Por favor, tente novamente.",
      "popupClosed": "A janela de login foi fechada.",
      "unauthorizedDomain": "Este domínio não está autorizado para login.",
      "methodUnavailable": "Este método de login ainda não está ativado.",
      "tooManyCodes": "Muitos códigos foram solicitados. Tente novamente em alguns minutos.",
      "invalidCode": "O código está inválido ou expirado. Solicite um novo código.",
      "emailUnavailable": "A entrega por e-mail está atualmente indisponível.",
      "actions": {
        "subscription": {
          "eyebrow": "Ação de assinatura",
          "title": "Termine sua assinatura?",
          "confirm": "Gerenciar assinaturas",
          "paragraphs": [
            "Continuar abre a página de gerenciamento de assinatura da Apple App Store ou do Google Play onde você comprou a assinatura. Você deve desativar a renovação automática na loja.",
            "Após a cancelamento, os benefícios da sua assinatura existente permanecem disponíveis até o final do período pago. Excluir sua conta ou dados não cancela uma assinatura de loja."
          ]
        },
        "account": {
          "eyebrow": "Ação de conta permanente",
          "title": "Você tem certeza de que quer excluir sua conta?",
          "confirm": "Inicie o processo de exclusão de 15 dias",
          "paragraphs": [
            "Continuar inicia um processo de exclusão de 15 dias e te desconecta por segurança. Se você não fizer login novamente durante este período, sua conta, perfil, criações, biblioteca, coleções e dados relacionados à Voxnela serão excluídos permanentemente.",
            "Fazer login com a mesma conta antes de 15 dias cancela a exclusão automaticamente. Excluir a conta não cancela uma assinatura ativa da loja; cancele-a separadamente na loja."
          ]
        },
        "data": {
          "eyebrow": "Ação de dados permanente",
          "title": "Tem certeza de que quer excluir seus dados?",
          "confirm": "Inicie o processo de exclusão de 30 dias",
          "paragraphs": [
            "Continuar inicia um processo de exclusão de 30 dias e você será desconectado por segurança. Se você não fizer login novamente durante este período, suas criações, biblioteca, coleções, registros, interações e outros dados pessoais Voxnela serão excluídos permanentemente; sua conta de login permanece disponível.",
            "Faça login novamente antes de 30 dias para cancelar a exclusão de dados automaticamente. Registros de transações e de segurança limitados exigidos por lei podem ser mantidos com acesso restrito pelos períodos legais aplicáveis."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "Nenhum crédito de imagem restante",
      "quotaFreeMessage": "Você usou o crédito de imagem na sua conta gratuita. Escolha um plano para continuar criando.",
      "later": "Mais tarde",
      "currentCredit": "Créditos atuais: 0",
      "quotaProTitle": "Quota mensal Pro atingida",
      "quotaProMessage": "Você usou os 100 créditos de imagem deste mês. Faça o upgrade para o Studio para continuar criando.",
      "renewalDate": "Data de renovação: {{date}}",
      "quotaStudioTitle": "Quota mensal de estúdio atingida",
      "quotaStudioMessage": "Os créditos de imagem do seu serão renovados automaticamente em {{date}}.",
      "done": "pronto",
      "membership": "Adesão Voxnela",
      "options": "Opções de adesão",
      "credits": "Créditos",
      "currentMembership": "Adesão atual",
      "yearlyDiscount": "17% de desconto",
      "loadingPrice": "A carregar preço…",
      "loadingStorePrice": "Carregamento de preço da loja",
      "year": "ano",
      "month": "mês",
      "renewDisclosure": "Renova automaticamente a cada {{period}}. Cancelar a qualquer momento.",
      "legal": "Informação legal",
      "terms": "Termos",
      "alreadyMember": "Você já tem {{plan}} {{period}}",
      "startPlan": "Inicie o plano {{plan}}",
      "upgradeStudio": "Atualizar para Studio",
      "yearlyAdvantage": "Mude para economias anuais",
      "upgrade": "Atualizar adesão",
      "signInRequired": "Faça login na sua conta Voxnela antes de iniciar uma subscrição.",
      "catalogUnavailable": "O catálogo de pagamentos não pôde ser verificado para este plano. Por favor, tente novamente em breve.",
      "paymentUnavailable": "A tela de pagamento não pôde ser aberta. Por favor, tente novamente.",
      "benefits": [
        {
          "lead": "{{credits}} Créditos",
          "label": "Geração de imagem de alta resolução todos os meses"
        },
        {
          "lead": "Mais de 50 Estilos de Estúdio",
          "label": "Neo-Minimalismo, Cinematográfico e todos os estilos de assinatura"
        },
        {
          "lead": "Bloqueio facial",
          "label": "Experimentação de moda virtual sem alterar as características faciais"
        },
        {
          "lead": "Filial Prioritária",
          "label": "Processamento de GPU ultra-rápido sem espera"
        },
        {
          "lead": "Revisões de bate-papo",
          "label": "Edições detalhadas ilimitadas em várias voltas em linguagem natural"
        },
        {
          "lead": "Direitos Comerciais Totais",
          "label": "Uso de alta resolução, sem marca d'água"
        }
      ],
      "restorePurchases": "Restaurar compras",
      "restoringPurchases": "Compras de restauração...",
      "restoreSuccess": "Sua associação foi restaurada.",
      "restoreEmpty": "Nenhuma assinatura ativa foi encontrada para esta conta da App Store.",
      "membershipSyncPending": "Verificando a assinatura e créditos de imagem...",
      "membershipSyncFailed": "Não foi possível sincronizar os créditos de imagem. Tente novamente.",
      "membershipUnavailable": "Não foi possível carregar a assinatura.",
      "retry": "Tentar novamente"
    },
    "video": {
      "revisionHook": "Torne os primeiros três segundos mais envolventes.",
      "revisionPace": "Equilibre o ritmo e encurte as seções lentas.",
      "revisionEnding": "Torne o final mais memorável.",
      "revisionTransition": "Torne as transições mais suaves e naturais.",
      "revisionFraming": "Use uma moldura mais equilibrada para os detalhes importantes.",
      "revisionColor": "Torne as cores mais equilibradas e cinematográficas.",
      "revisionText": "Torne o texto mais curto e fácil de ler.",
      "revisionAudio": "Combine a música mais de perto com o ritmo das imagens.",
      "revisionEmotion": "Faça a história parecer mais sincera e emocional.",
      "revisionStructure": "Construa um começo, meio e fim mais claros.",
      "previewBack": "Voltar à prévia",
      "revisionWelcome": "O que você gostaria de mudar?",
      "revisionFailed": "Não consegui aplicar essa mudança. Você poderia descrevê-la novamente?",
      "finalQueued": "O vídeo final está em fila. Ele aparecerá em Vídeos quando estiver pronto.",
      "watermarkUpgrade": "Escolha um plano para criar uma nova saída final sem a marca d'água Voxnela.",
      "finalFailed": "O vídeo final não pôde ser iniciado.",
      "projectDeleteFailed": "O projeto não pôde ser excluído.",
      "videoDescriptionWithBrief": "Este vídeo foi criado a partir de “{{brief}}”. A Voxnela selecionou os momentos mais fortes e construiu o ritmo e a ordem das cenas em torno da direção criativa escolhida.",
      "videoDescriptionGeneric": "A Voxnela avaliou os materiais quanto ao conteúdo, ritmo e coerência narrativa, destacando os momentos mais fortes para uma edição equilibrada.",
      "play": "jogar",
      "deletesOn": "exclui em {{date}}",
      "projectsBelong": "Seus projetos estão vinculados à sua conta.",
      "videosBelong": "Seus vídeos estão vinculados à sua conta.",
      "signInToSeeProjects": "Faça login para ver seus projetos e continuar em diferentes dispositivos.",
      "signInToSeeVideos": "Faça login para ver seus vídeos e continuar em diferentes dispositivos.",
      "delete": "Eliminar",
      "deleting": "A eliminar…",
      "secondsVersion": "{{seconds}} sec · versão {{version}}",
      "deleteProject": "Eliminar projeto",
      "projectCoverUnavailable": "A capa do projeto não pôde ser carregada",
      "videoCoverPreparing": "Preparando capa de vídeo",
      "deleteVideo": "Eliminar vídeo",
      "signed": "Marcado Voxnela",
      "failed": "Não foi possível completar",
      "tryAgain": "Você pode tentar novamente",
      "cancelled": "Cancelado",
      "noCreditUsed": "Nenhum crédito usado",
      "featuredStyles": "Estilos visuais em destaque",
      "previousImage": "Imagem anterior",
      "nextImage": "Próxima imagem",
      "reviewStyle": "Explorar este estilo",
      "featuredNavigation": "Navegação visual em destaque",
      "taskCategories": "Categorias de tarefas",
      "projectOpening": "Projeto de abertura",
      "opening": "Abertura...",
      "projectNotFound": "Projeto não encontrado",
      "projectUnavailable": "Este projeto não está mais disponível.",
      "backToProjects": "Voltar aos meus projetos",
      "editVideo": "Editar vídeo",
      "versionContext": "Versão {{version}} · A Voxnela conhece seu projeto e materiais",
      "livePreviewActions": "Ações de prévia ao vivo",
      "edit": "Editar",
      "preparing": "A preparar",
      "save": "Guardar",
      "thinking": "Voxnela está pensando",
      "revisionSuggestions": "Sugestões de edição",
      "describeChange": "Descreva a mudança que você quer",
      "sendEdit": "Enviar solicitação de edição",
      "deleteProjectDescription": "Você tem certeza de que deseja excluir “{{title}}” e todos os materiais relacionados? Isso não pode ser desfeito.",
      "projects": "Projetos",
      "projectsPreparing": "Preparando seus projetos",
      "noProjects": "Você ainda não tem um projeto. Comece descrevendo sua primeira ideia.",
      "createNew": "Criar nova imagem",
      "thisProject": "Este projeto",
      "videos": "Vídeos",
      "videosPreparing": "Preparando seus vídeos",
      "noVideos": "Você ainda não tem um vídeo concluído. Ele aparecerá aqui quando seu primeiro vídeo estiver pronto.",
      "videoPlayFailed": "O vídeo não pôde ser reproduzido.",
      "videoNotReady": "O arquivo de vídeo ainda não está pronto para ser baixado.",
      "videoDownloadFailed": "O vídeo não pôde ser baixado.",
      "videoDeleteFailed": "O vídeo não pôde ser excluído.",
      "videoLoading": "Carregando vídeo...",
      "videoActions": "Ações de vídeo",
      "showVideoDescription": "Mostrar descrição do vídeo",
      "videoDownloading": "Baixando vídeo",
      "downloadVideo": "Baixar vídeo",
      "thisVideo": "Este vídeo",
      "deleteVideoDescription": "Você tem certeza de que deseja excluir o vídeo intitulado “{{title}}”? Isso não pode ser desfeito."
    },
    "studio": {
      "useStyle": "Use este estilo",
      "galleryFilters": "Filtros de galeria",
      "modeStyleTransfer": "Estilos Voxnela",
      "modeVirtualTryOn": "Experimentação Virtual",
      "modeMagazineCover": "Revista e Capa",
      "modePosterStudio": "Estúdio de cartazes",
      "modeCommercial": "Exposição de produtos",
      "modeTimeWarp": "viagem no tempo",
      "modeOutpaintRelight": "Expandir e reiluminar",
      "modeInfographic": "Infográfico e Dados",
      "modePortraitRetouch": "Remontagem de retrato",
      "modeArtisticCollage": "Colagem Artística",
      "defaultStyle": "Estilo Voxnela",
      "signInToCreate": "Faça login para criar uma imagem.",
      "signInToEdit": "Faça login para editar uma imagem.",
      "creationSuccess": "Sua imagem foi criada com sucesso. Avise-me diretamente se quiser alterar a iluminação, as cores, os objetos ou a enquadramento.",
      "imageReady": "Sua imagem está pronta. Diga-me o que você gosta ou o que deseja revisar.",
      "revisionSuccess": "A revisão está completa. Você pode compará-la com o controle deslizante antes/depois ou solicitar outra alteração.",
      "versionReady": "A versão {{version}} está pronta.",
      "projectNotFound": "Projeto não encontrado.",
      "styleApplied": "Estilo {{style}} aplicado",
      "imageCreation": "Criação de imagem",
      "defaultPrompt": "Imagem de estúdio",
      "aspectSquare": "quadrado",
      "aspectSquareDetail": "Feed do Instagram, Perfil, Arte",
      "aspectVertical": "vertical",
      "aspectVerticalDetail": "Histórias do Instagram, Reels, TikTok",
      "aspectHorizontal": "horizontal",
      "aspectHorizontalDetail": "YouTube, Banner, Cinema",
      "aspectPortrait": "retrato",
      "aspectPortraitDetail": "Retrato do Instagram, Cartaz, Exposição",
      "aspectPanoramic": "panorâmico",
      "aspectPanoramicDetail": "Paisagem Cinematográfica Ultra Ampla",
      "styles": "Estilos Voxnela",
      "fullScreenStyle": "Ver estilo em tela cheia",
      "closeDescription": "Descrição do estilo de fechamento",
      "moreWithVoxnela": "Faça mais com a Voxnela",
      "quickStartBody": "Escreva o que você quer abaixo ou anexe um arquivo.",
      "createImage": "Criar imagem",
      "createImageDetail": "Construa sua ideia do zero",
      "editImage": "Editar imagem",
      "editImageQuick": "Editar uma imagem",
      "editImageDetail": "Reimagine uma imagem enviada",
      "transformStyle": "Transforme o estilo e a cena",
      "transformStyleDetail": "Mova sua imagem para outro mundo",
      "visualizeDocument": "Visualize um documento ou apresentação",
      "visualizeDocumentDetail": "Transforme o conteúdo completo em um design",
      "submittedImage": "Imagem enviada",
      "generating": "O Voxnela está a criar a imagem…",
      "viewImage": "Ver imagem",
      "removeStyle": "Remover estilo selecionado",
      "referenceImage": "Imagem de referência",
      "referenceNotice": "Esta imagem será revisada ou um novo estilo será aplicado",
      "removeReference": "Remover imagem de referência",
      "remove": "remover",
      "uploading": "Carregando",
      "addFile": "Adicionar um arquivo ou imagem",
      "addFileTitle": "Adicione até 4 imagens ou um documento (PDF, Word, PPT, máximo 12 MB)",
      "aspectRatio": "Razão de aspecto",
      "selectAspectRatio": "Selecione a proporção de aspecto",
      "aspectOptions": "Opções de proporção de aspecto",
      "revisePlaceholder": "O que você gostaria de mudar nesta imagem?",
      "styledPlaceholder": "Descreva a imagem que você quer neste estilo (opcional)...",
      "promptPlaceholder": "Descreva uma imagem ou escreva uma solicitação...",
      "reviseImage": "Revise a imagem",
      "generateImage": "Gerar imagem",
      "generatedImage": "Imagem gerada",
      "done": "Concluído",
      "fileLimitTitle": "Arquivo muito grande",
      "fileLimitMessage": "“{{name}}” excede o limite de 12 MB ({{size}} MB). Escolha um arquivo menor.",
      "imageLimitTitle": "Limite de imagem",
      "imageLimitMessage": "Você pode enviar até 4 imagens. As imagens {{count}} estão selecionadas atualmente.",
      "uploadFailedTitle": "Envio falhou",
      "uploadFailedMessage": "Ocorreu um problema ao carregar o arquivo.",
      "revisionFailed": "Ocorreu um erro durante a revisão ou a cota foi excedida.",
      "generationFailed": "Ocorreu um erro durante a geração de imagem ou a cota foi excedida.",
      "imageDetails": "Detalhes da imagem",
      "close": "fechar",
      "download": "Transferir",
      "downloadImage": "Baixar imagem",
      "downloading": "A transferir",
      "versionImage": "imagem",
      "exploreTitle": "Que estilo procura?",
      "explorePlaceholder": "Por exemplo: um retrato cinematográfico com tons escuros e perspectiva profunda",
      "searchStyles": "Pesquisar estilos visuais",
      "clearSearch": "Pesquisa limpa",
      "exploreCategories": "Explorar categorias",
      "all": "Todos",
      "styleCount": "Estilos {{count}}",
      "noStyle": "Nenhum estilo correspondente encontrado",
      "noStyleBody": "Tente novamente com uma descrição mais curta ou palavras diferentes.",
      "libraryKicker": "Sua biblioteca de imagens pessoais",
      "myImages": "As minhas imagens",
      "imageWorks": "A imagem {{count}} funciona",
      "newImage": "Criar nova imagem",
      "noImage": "Você ainda não criou uma imagem",
      "noCategoryImage": "Sem imagens nesta categoria",
      "emptyGalleryBody": "Crie sua primeira imagem com transferência de estilo, provação virtual, capa de revista ou showcase de produto.",
      "firstImage": "Crie sua primeira imagem",
      "imageWork": "Trabalho de imagem"
    },
    "create": {
      "briefTitle": "Descreva sua ideia ou tópico",
      "briefPlaceholder": "Qual é o assunto? Por exemplo: o futuro da IA, uma jornada para Marte ou o lançamento de um produto…",
      "briefLabel": "Breve de criação",
      "contentType": "Tipo de conteúdo",
      "media": "Imagens e Mídia",
      "added": "{{count}} adicionado",
      "optional": "Opcional",
      "addMedia": "Adicione uma foto ou vídeo se quiser",
      "addMediaBody": "Carregue seus próprios meios de comunicação ou deixe-os vazios e deixe a IA encontrá-los",
      "attachedMedia": "Mídia em anexo",
      "add": "adicionar",
      "mediaFallback": "mídia",
      "aiCompletes": "Deixe a IA completar as imagens",
      "noMedia": "Nenhuma imagem enviada; a IA completará as cenas.",
      "productionFormat": "Formato de produção",
      "style": "Estilo",
      "customVisualWorld": "Descreva seu mundo visual",
      "colorsAtmosphere": "Cores, atmosfera, câmera, ritmo",
      "customStyleShort": "Descreva o mundo visual que você tem em mente (por exemplo: tons pastel e uma câmera calma, ou neon cyberpunk…)",
      "customStyleLong": "Descreva o mundo visual, as cores, a atmosfera e o ritmo que você tem em mente.",
      "voiceover": "Narração",
      "ownVoiceover": "Seu texto de narração",
      "voiceoverPlaceholder": "Escreva seu texto aqui. Se estiver em branco, a Voxnela preparará.",
      "duration": "Duração",
      "seconds": "{{count}} seg",
      "freeLimit": "O vídeo final mais longo no plano gratuito tem 60 segundos.",
      "addSound": "Adicionar som ou música",
      "notAdded": "Não adicionado",
      "files": "Arquivos {{count}}",
      "readySounds": "Use sons prontos",
      "musicLibrary": "Biblioteca de música",
      "uploadOwn": "Carregue o seu próprio",
      "captions": "Legendas",
      "back": "Voltar",
      "create": "Criar",
      "next": "Seguinte",
      "researchingTopic": "Pesquisando o tópico...",
      "analyzingMaterials": "Analisando materiais...",
      "researchBody": "Verificando fontes e preparando o roteiro e o plano visual.",
      "analyzeBody": "Avaliando quadros fortes, emoção, ritmo e o breve juntos.",
      "creativeDirection": "Direção criativa {{count}}",
      "recommended": "Recomendado",
      "generationFailed": "A criação não pôde ser concluída",
      "retry": "Prepare novamente",
      "backDirections": "De volta às direções criativas",
      "preparingVideo": "A preparar o vídeo",
      "voiceoverText": "Texto de voz gravado",
      "describeStyle": "Descreva seu próprio estilo",
      "topicDirection": "Tópico e direção",
      "styleEditorSubtitle": "Descreva o mundo visual, cores e atmosfera",
      "editorSubtitle": "Escreva o texto e insira-o na folha de criação",
      "voiceoverEditorPlaceholder": "Escreva o texto a ser usado para a narração.",
      "topicEditorPlaceholder": "Escreva o tópico e como você quer que seja contado.",
      "insertText": "Insira texto",
      "bestFor": "Melhor para:",
      "useStyle": "Use este estilo",
      "musicSubtitle": "Faixas reais liberadas para uso comercial",
      "adding": "Adicionando...",
      "musicLicense": "As faixas são fornecidas sob CC0 1.0; o uso comercial é permitido e a atribuição não é necessária.",
      "yes": "Sim",
      "no": "Não",
      "newCreation": "Nova criação",
      "reviewing": "Voxnela está revisando",
      "chooseDirection": "Escolha uma das três abordagens de edição",
      "ideaSubtitle": "Descreva sua ideia; carregue imagens ou permita que a Voxnela as crie",
      "projectOpenFailed": "O pacote do projeto não pôde ser aberto.",
      "tooManyAssets": "Você pode adicionar até 50 ativos a um projeto.",
      "uploadSizeLimit": "O upload total do projeto excede o limite de 2 GB.",
      "filesAddFailed": "Os arquivos não puderam ser adicionados.",
      "musicPreviewFailed": "A prévia da música não pôde ser aberta.",
      "musicFetchFailed": "O arquivo de música não pôde ser recuperado.",
      "musicAddFailed": "A música não pôde ser adicionada.",
      "topicRequired": "Digite um tópico e descreva sobre o que seu vídeo será.",
      "briefTooShort": "Descreva o que você quer dizer em pelo menos algumas palavras.",
      "mediaRequired": "Carregue uma imagem ou ative os visuais gerados por IA.",
      "proposalIntro": "Revisei as imagens e os vídeos e preparei três orientações de edição que se encaixam no seu estilo, formato e escolhas de áudio.",
      "removeMaterial": "Remover {{name}}",
      "aiVisualNotice": "Imagens reais e ilustrações de IA de código aberto são encontradas automaticamente.",
      "stepProgress": "Passo {{current}} de {{total}}",
      "styleSampleAlt": "Exemplo mostrando o estilo de vídeo {{style}}",
      "reviewStyle": "Revise o estilo {{style}}",
      "selectedDirectionPrompt": "Direção selecionada: {{title}}. {{summary}} Direção visual: {{visual}}. Abordagem de transição: {{transitions}}. Abordagem musical: {{music}}.",
      "letVoxnelaChoose": "Deixe a Voxnela escolher",
      "feminineVoice": "feminino",
      "masculineVoice": "masculino",
      "narrationStyle": "Estilo de narração",
      "voiceEstimate": "Sobre {{seconds}} sec · palavras {{words}}.",
      "voiceShort": "Se for uma abreviação para {{duration}} segundos, a Voxnela o completará preservando o significado.",
      "voiceNatural": "A Voxnela apenas ajusta a gramática, a fraseado e o fluxo natural.",
      "removeFile": "Remova o arquivo {{name}}",
      "musicStop": "Pare {{title}}",
      "musicListen": "Ouça {{title}}",
      "automatic": "automóvel",
      "all": "tudo",
      "cinematic": "cinematográfico",
      "social": "Social e Dinâmico",
      "designTypography": "Design e Tipografia",
      "retroExperimental": "Retro e Experimental",
      "productionStage1": "Selecionando os quadros e cenas mais fortes.",
      "productionStage2": "Construindo a história, o movimento e as transições.",
      "productionStage3": "Equilibrando música, voz e legendas.",
      "productionStage4": "Executando verificações finais na prévia ao vivo.",
      "genericCreationError": "Ocorreu um problema ao preparar o plano de vídeo. Seus materiais e escolhas foram preservados; você pode tentar novamente.",
      "newVideo": "Novo vídeo",
      "topicNews": "notícias",
      "topicDocumentary": "documentário",
      "topicExplainer": "Explorador",
      "topicStory": "história",
      "topicScience": "ciência",
      "topicPhilosophy": "filosofia",
      "topicMagazine": "revista",
      "topicEntertainment": "entretenimento",
      "topicList": "lista",
      "toneCalm": "calma",
      "toneEmotional": "emocional",
      "toneEnergetic": "enérgico",
      "toneStorytelling": "narração de histórias",
      "toneCheerful": "alegre",
      "toneMysterious": "misterioso",
      "toneNews": "notícias",
      "styleCinematic": "cinematográfico",
      "styleDarkCinematic": "Cinematográfico escuro",
      "styleDocumentary": "documentário",
      "styleModernDocumentary": "Documentário moderno",
      "stylePovImmersive": "Ponto de vista imersivo",
      "styleUgcAuthentic": "UGC autêntico",
      "styleMiniVlog": "Mini Vlog",
      "styleSocialViral": "Viral Social",
      "styleHyperEdit": "Hiper Edição",
      "styleSportsHype": "Hype Esportivo",
      "styleVelocityEdit": "Edição de Velocidade",
      "styleMusicBeatEdit": "Edição de batida de música",
      "styleKineticTypography": "Tipografia cinética",
      "styleMinimalClean": "Mínimo e limpo",
      "styleLuxuryMinimal": "Luxo Minimalista",
      "styleCommercialProduct": "Produto Comercial",
      "styleEditorialFashion": "Moda Editorial",
      "styleCollageZine": "Zine de Colagem",
      "styleTechFuturistic": "Tecnologia Futurista",
      "styleRetroFuturism": "Futurismo retrô",
      "styleY2kDigital": "Digital Y2K",
      "styleVhsCamcorder": "Câmera VHS",
      "styleAnalogFilm": "Filme analógico",
      "styleGlitchCyber": "Falha Cibernética",
      "musicUpbeatMood": "Energético · brilhante",
      "musicUpbeatDetail": "Gravações instrumentais reais para conteúdo social animado, momentos de viagem e edições animadas.",
      "musicElectronicMood": "Moderno · rítmico",
      "musicElectronicDetail": "Música eletrônica real para cidades, tecnologia, produtos e edições rápidas.",
      "musicRomanceMood": "Emocional · quente",
      "musicRomanceDetail": "Música instrumental com um suave arco emocional para a família, retratos, dias especiais e memórias.",
      "musicScoringMood": "Narrativa · cinematográfica",
      "musicScoringDetail": "Música de fundo cinematográfica que apoia histórias, promoções e transições dramáticas.",
      "musicEpicMood": "Poderoso · crescendo",
      "musicEpicDetail": "Música instrumental em camadas que se constrói para grandes aberturas, jornadas e finais fortes.",
      "proposalBalancedTitle": "Narrativa equilibrada",
      "proposalBalancedSummary": "Uma edição que preserva o fluxo do material e destaca os quadros mais fortes.",
      "proposalBalancedVisual": "Hierarquia forte e um sistema visual coerente",
      "proposalBalancedTransitions": "Cortes suaves e empurrões medidos",
      "proposalBalancedMusic": "Música que passa da emoção para o ritmo",
      "proposalQuietTitle": "História tranquila",
      "proposalQuietSummary": "Uma abordagem calma que dá mais tempo às molduras e enfatiza detalhes e emoção natural.",
      "proposalQuietVisual": "Tons suaves e fotos mais longas",
      "proposalQuietTransitions": "Dissolução cruzada e panelas lentas",
      "proposalQuietMusic": "Música simples e emocional",
      "proposalRhythmicTitle": "Edição rítmica",
      "proposalRhythmicSummary": "Uma edição com um forte gancho de abertura que acelera no meio e se estabelece claramente no final.",
      "proposalRhythmicVisual": "Contraste mais forte e enquadramento dinâmico",
      "proposalRhythmicTransitions": "Cortes de batida e transições de chicote controladas",
      "proposalRhythmicMusic": "Música energética e em alta",
      "underVoiceover": "suave sob a narração",
      "withShortVoiceover": "com voz de narração curta e marcante"
    },
    "information": {
      "home": "Início",
      "documentInfo": "Informações do documento",
      "version": "Versão",
      "effective": "Em vigor",
      "updated": "Última atualização",
      "contents": "Conteúdo",
      "officialReferences": "Referências oficiais",
      "referenceTitle": "Recursos de leis e autoridade",
      "referenceBody": "Esses links são fornecidos para informações gerais. As leis obrigatórias e as regras atuais das autoridades competentes têm precedência.",
      "supportKicker": "Suporte Sponelabs",
      "contactTitle": "Contacte-nos",
      "contactLead": "Entre em contacto com a equipa de apoio da Voxnela sobre a sua conta, associação, pagamento, criação, relatórios de conteúdo, privacidade ou problemas técnicos.",
      "supportEmail": "E-mail de suporte",
      "emailBody": "O botão abaixo abre seu aplicativo de e-mail padrão com um modelo de suporte pronto para uso para que possamos investigar mais rapidamente.",
      "openEmail": "Abrir aplicação de e-mail",
      "includeTitle": "Inclua na mensagem",
      "includeItems": [
        "Seja você usar Web, iOS ou Mac;",
        "Versão do seu dispositivo e do sistema operacional;",
        "Passos para reproduzir o problema;",
        "O link do projeto relacionado, os detalhes da transação ou captura de tela, se disponível."
      ],
      "sensitiveTitle": "Não envie dados sensíveis",
      "sensitiveBody": "Não inclua códigos de verificação, senhas, detalhes completos do cartão de pagamento, documentos de identidade, dados de saúde ou outras informações sensíveis que não sejam necessárias para resolver o problema.",
      "securityTitle": "Segurança e denúncias de conteúdo",
      "securityBody": "Use “Segurança” para uma vulnerabilidade, “Solicitação de Privacidade” para uma solicitação de dados ou “Relatório de Conteúdo” para conteúdo prejudicial ou infrator da lei. Entre em contato com os serviços de emergência locais em caso de perigo físico imediato.",
      "mailSubject": "Solicitação de suporte Voxnela",
      "mailGreeting": "Olá Equipe de Suporte Voxnela,",
      "mailTopic": "Tópico de suporte:",
      "mailPlatform": "Plataforma (Web / iOS / Mac):",
      "mailDevice": "Dispositivo e sistema operacional:",
      "mailProject": "ID do projeto (se disponível):",
      "mailDescription": "Descrição do problema ou solicitação:",
      "mailThanks": "Obrigado.",
      "termsEyebrow": "Termos de serviço Voxnela",
      "termsTitle": "Termos de Uso",
      "termsLead": "Estes termos regulam o uso dos serviços de criação e edição de imagens com IA na web da Voxnela e nos apps iOS.",
      "privacyEyebrow": "Uso de dados Voxnela",
      "privacyTitle": "política de privacidade",
      "privacyLead": "Esta política explica como as contas, imagens, projetos, associações e dados técnicos são processados no serviço de criação de imagens Voxnela.",
      "officialTurkishNotice": "Esta tradução é fornecida para conveniência. O texto legal turco determina se os significados diferem."
    }
  },
  "sv": {
    "ui": {
      "home": "Hem",
      "homeTitle": "hem",
      "explore": "Utforska",
      "gallery": "Galleri",
      "myImages": "Mina bilder",
      "settings": "Inställningar",
      "createImage": "Skapa bild",
      "back": "Tillbaka",
      "search": "Sök",
      "account": "Konto",
      "login": "Logga in",
      "logout": "Logga ut",
      "profile": "Profil",
      "profileSettings": "Profil och inställningar",
      "plans": "Planer och användning",
      "plansSubtitle": "Bildkrediter och fakturering",
      "contact": "Kontakt",
      "contactSubtitle": "Hjälp och feedback",
      "discoverVoxnela": "Upptäck Voxnela",
      "discoverVoxnelaSubtitle": "Granska den visuella studioupplevelsen",
      "privacy": "Integritet",
      "privacySubtitle": "Hur din data skyddas",
      "terms": "Användarvillkor",
      "termsSubtitle": "Voxnela användarvillkor",
      "preferencesSubtitle": "Ditt konto och Voxnela-preferenser",
      "accountSubtitle": "Kontoinformation och medlemsuppgifter",
      "voxAccount": "Voxnela-konto",
      "accessEverywhere": "Kom åt dina bilder på alla enheter",
      "imageRights": "{{count}} bildkrediter",
      "availableCredits": "Tillgängliga krediter",
      "renewalDate": "Förnyelsesdatum",
      "membershipStart": "Medlemskap startade",
      "registrationDate": "Registreringsdatum",
      "monthly": "månatlig",
      "renewalOff": "Förnyelse avstängd",
      "user": "Voxnela-användare",
      "language": "Språk",
      "languageSubtitle": "Välj appspråk",
      "supportBody": "Skriv till oss om du har ett problem eller vill dela en idé. Att inkludera projekt-ID:t hjälper oss att svara snabbare.",
      "studioTitle": "Voxnela bildstudio",
      "studioSubtitle": "Skapa din stil",
      "searchSubtitle": "Dina bilder och projekt",
      "searchPlaceholder": "Sök efter en bild eller ett projekt",
      "noSearchResults": "Ingenting matchade denna sökning.",
      "project": "projektera",
      "image": "bild",
      "completed": "avslutad",
      "currentPlan": "Nuvarande plan",
      "notSignedIn": "Inte inloggad",
      "signInIntro": "Logga in för att börja använda Voxnela.",
      "creditsAvailable": "{{count}} studiobildkrediter är tillgängliga.",
      "noCredits": "Du har inga bildkrediter kvar under denna period.",
      "membershipInfo": "Årliga plankrediter förnyas varje månad och överförs inte. Återställda köp förblir skyddade genom ditt konto.",
      "signedOutMembershipInfo": "Efter att du har loggat in kommer dina tillgängliga bildkrediter och planinformation att visas här.",
      "reviewPlans": "Visa planer",
      "versionUpdated": "Version {{version}} · Senast uppdaterad {{date}}",
      "onboardingWelcome": "Välkommen till Voxnela",
      "skipIntro": "Hoppa över introduktionen",
      "continue": "Fortsätt",
      "startCreating": "Börja skapa",
      "close": "stänga",
      "dragToClose": "Skjut ner för att stänga arket",
      "loading": "Laddar…",
      "sheetExpand": "Utöka blad",
      "sheetCollapse": "Återställ returbladet till normal höjd",
      "cannotClose": "Kan inte stängas av medan operationen pågår",
      "stylePreview": "Stilförhandsvisning",
      "stylePreviewSubtitle": "Signaturstilar och trender",
      "categories": "Kategorier",
      "useThisStyle": "Använd den här stilen",
      "videoControls": "Videokontroller",
      "play": "leka",
      "pause": "paus",
      "mute": "träcka",
      "unmute": "Avstäng tystnad",
      "minimize": "minimera",
      "expandVideo": "Utöka i appen",
      "videoProgress": "Videoströmning",
      "toggleVideoControls": "Visa eller dölj videokontroller",
      "expandedVideo": "{{title}} utökad videovisning",
      "goToImage": "Gå till {{title}}-bilden",
      "categoryVisualStyles": "{{category}} visuella stilar",
      "onboarding1Eyebrow": "Skapa bilder",
      "onboarding1Title": "Skapa din bild.",
      "onboarding1Body": "Förvandla din idé till en filmisk ram med 35 mm-film, redaktionell, produkt, affisch och många fler visuella stilar.",
      "onboarding2Eyebrow": "Virtuell klädprovning",
      "onboarding2Title": "Prova nya kläder.",
      "onboarding2Body": "Behåll identiteten över produktioner och skapa realistiska bilder på mode, accessoarer och produktprovningar.",
      "onboarding3Eyebrow": "Bildredigering",
      "onboarding3Title": "Redigera din bild.",
      "onboarding3Body": "Revidera komposition, ljus, färg och detaljer konversationellt utan att börja om.",
      "onboarding4Eyebrow": "3 gratisbilder",
      "onboarding4Title": "Kom igång gratis.",
      "onboarding4Body": "Börja direkt med 3 gratis AI-bildgenereringar en gång. Inget konto behövs.",
      "onboardingFaceEyebrow": "Ansikts- och stilanalys",
      "onboardingFaceTitle": "Upptäck ansikte och stil.",
      "onboardingFaceBody": "Utforska idéer för hår, glasögon och kläder utifrån ditt porträtt i en visuell guide.",
      "onboardingHouseEyebrow": "Tidsresa",
      "onboardingHouseTitle": "Res genom tiden.",
      "onboardingHouseBody": "Samla dina foton och datum och visa hur hemmet har förändrats över tid.",
      "onboardingFestivalEyebrow": "Din festivaldag",
      "onboardingFestivalTitle": "Planera festivaldagen med en snabb blick.",
      "onboardingFestivalBody": "Gör programmet, scenerna och tiderna du anger till en personlig visuell rutt.",
      "onboardingStylesEyebrow": "Voxnela-stilar",
      "onboardingStylesTitle": "Välj din stil.",
      "onboardingStylesBody": "Förvandla din idé till en filmisk ram med 35 mm-film, redaktionell, produkt, affisch och många fler visuella stilar."
    },
    "auth": {
      "enterCode": "Ange din kod",
      "membershipAndAccount": "Medlemskap och kontoinformation",
      "noPeriodInfo": "Perioden är otillgänglig",
      "memberSince": "Medlem sedan",
      "planSince": "{{plan}} sedan",
      "membershipRenewal": "Medlemsförnyelsesdatum",
      "accountActions": "Kontoåtgärder",
      "manageSubscriptionTitle": "Avsluta prenumerationen",
      "manageSubscriptionSubtitle": "Hantera ditt butiksabonnemang och automatiska förnyelse.",
      "deleteAccountTitle": "Radera mitt konto",
      "deleteAccountSubtitle": "Återställningsbar 15-dagars raderingsprocess.",
      "deleteDataTitle": "Radera mina data",
      "deleteDataSubtitle": "Återkopplingsbar 30-dagars datadelningsprocess.",
      "signingOut": "Loggar ut…",
      "signOut": "Logga ut",
      "signingIn": "Loggar in…",
      "continueApple": "Fortsätt med Apple",
      "continueGoogle": "Fortsätt med Google",
      "or": "eller",
      "email": "E-post",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "Genom att fortsätta med Voxnela accepterar du",
      "legalTerms": "Användarvillkor",
      "legalJoin": "och bekräfta att du har läst och förstått den",
      "legalPrivacy": "Integritetspolicy",
      "legalSuffix": ".",
      "sendingCode": "Skickar kod…",
      "emailSignIn": "Logga in med e-post",
      "codeSent": "Vi skickade en kod till {{email}}.",
      "change": "Ändra",
      "sixDigitCode": "6-siffrig kod",
      "emailCode": "E-postinloggningskod",
      "verifyingCode": "Verifierar kod…",
      "resendCode": "Skicka koden igen",
      "requestReceived": "Begäran mottagen",
      "accountDeletionStarted": "Din kontoutraderingsprocess har startat",
      "dataDeletionStarted": "Din datadelningsprocess har startat",
      "accountAction": "Kontoinaction",
      "accountDeletesAt": "Ditt konto kommer att raderas permanent på {{date}}.",
      "dataDeletesAt": "Dina personliga Voxnela-data kommer att raderas permanent på {{date}}.",
      "deletionUndo": "Om du loggar in med samma konto före detta datum avbryts raderingsprocessen automatiskt. Din nuvarande session stängdes eftersom begäran skapades.",
      "done": "Klar",
      "cancel": "Avbryt",
      "preparing": "Förbereder…",
      "invalidEmail": "Ange en giltig e-postadress.",
      "enterSixDigitCode": "Ange den 6-siffriga koden som skickades till din e-postadress.",
      "signInFailed": "Inloggningen kunde inte slutföras. Vänligen försök igen.",
      "codeSendFailed": "Inloggningskoden kunde inte skickas. Vänligen försök igen.",
      "codeVerifyFailed": "Koden kunde inte verifieras. Vänligen försök igen.",
      "operationFailed": "Operationen kunde inte slutföras just nu. Vänligen försök igen.",
      "popupClosed": "Inloggningsfönstret var stängt.",
      "unauthorizedDomain": "Denna domän är inte auktoriserad för inloggning.",
      "methodUnavailable": "Denna inloggningsmetod är ännu inte aktiverad.",
      "tooManyCodes": "För många koder har begärts. Försök igen om några minuter.",
      "invalidCode": "Koden är ogiltig eller utgången. Begär en ny kod.",
      "emailUnavailable": "E-postleverans är för närvarande otillgänglig.",
      "actions": {
        "subscription": {
          "eyebrow": "Prenumerationsåtgärd",
          "title": "Avsluta din prenumeration?",
          "confirm": "Hantera prenumerationer",
          "paragraphs": [
            "Att fortsätta öppnar Apple App Store eller Google Play-prenumerationshanteringssidan där du köpte prenumerationen. Du måste stänga av automatisk förnyelse i butiken.",
            "Efter avbokning förblir dina befintliga medlemsförmåner tillgängliga fram till slutet av den betalda perioden. Att radera ditt konto eller din data avbokar inte ett butiksabonnemang."
          ]
        },
        "account": {
          "eyebrow": "Åtgärd för permanent konto",
          "title": "Är du säker på att du vill radera ditt konto?",
          "confirm": "Starta 15-dagars raderingsprocess",
          "paragraphs": [
            "Att fortsätta startar en 15-dagars raderingsprocess och loggar ut dig för säkerhetens skull. Om du inte loggar in igen under denna period kommer ditt konto, din profil, dina skapelser, ditt bibliotek, dina samlingar och relaterad Voxnela-data att raderas permanent.",
            "Att logga in med samma konto innan 15 dagar avbryter raderingen automatiskt. Att radera kontot avbryter inte ett aktivt butiksabonnemang; avbryt det separat i butiken."
          ]
        },
        "data": {
          "eyebrow": "Permanent datahantering",
          "title": "Är du säker på att du vill radera dina data?",
          "confirm": "Starta 30-dagars raderingsprocess",
          "paragraphs": [
            "Att fortsätta startar en 30-dagars raderingsprocess och låser dig ut av säkerhetsskäl. Om du inte loggar in igen under denna period kommer dina skapelser, bibliotek, samlingar, register, interaktioner och annan personlig Voxnela-data att raderas permanent; ditt inloggningskonto förblir tillgängligt.",
            "Att logga in igen innan 30 dagar avbryter automatiskt datadelning. Begränsade transaktioner och säkerhetsregister som krävs enligt lag kan behållas med begränsad åtkomst under de tillämpliga rättsliga perioderna."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "Inga bildkrediter kvar",
      "quotaFreeMessage": "Du har använt bildkrediterna i ditt gratiskonto. Välj ett plan för att fortsätta skapa.",
      "later": "senare",
      "currentCredit": "Nuvarande krediter: 0",
      "quotaProTitle": "Månadlig Pro-kvot nådd",
      "quotaProMessage": "Du har använt månadens 100 bildkrediter. Uppgradera till Studio för att fortsätta skapa.",
      "renewalDate": "Förnyelsesdatum: {{date}}",
      "quotaStudioTitle": "Månadlig studiotillåtelse har nåtts",
      "quotaStudioMessage": "Dina bildkrediter förnyas automatiskt på {{date}}.",
      "done": "gjort",
      "membership": "Voxnela-medlemskap",
      "options": "Medlemsalternativ",
      "credits": "Krediter",
      "currentMembership": "Nuvarande medlemskap",
      "yearlyDiscount": "17 % rabatt",
      "loadingPrice": "Laddar butikspris…",
      "loadingStorePrice": "Prisladdning från butiken",
      "year": "år",
      "month": "månad",
      "renewDisclosure": "Förnyas automatiskt varje {{period}}. Avbryt när som helst.",
      "legal": "Juridik",
      "terms": "Villkor",
      "alreadyMember": "Du har redan {{plan}} {{period}}",
      "startPlan": "Starta {{plan}}-planen",
      "upgradeStudio": "Uppgradera till Studio",
      "yearlyAdvantage": "Byt till årliga besparingar",
      "upgrade": "Uppgradera medlemskap",
      "signInRequired": "Logga in på ditt Voxnela-konto innan du börjar prenumerera.",
      "catalogUnavailable": "Betalningskatalogen kunde inte verifieras för detta abonnemang. Vänligen försök igen snart.",
      "paymentUnavailable": "Betalningsskärmen kunde inte öppnas. Vänligen försök igen.",
      "benefits": [
        {
          "lead": "{{credits}} krediter",
          "label": "Bildgenerering med hög upplösning varje månad"
        },
        {
          "lead": "50+ studioplayouter",
          "label": "Neo-minimalism, filmisk och varje signaturstil"
        },
        {
          "lead": "Ansiktslåsning",
          "label": "Virtuell modeprovning utan att ändra ansiktsdrag"
        },
        {
          "lead": "Prioritetskö",
          "label": "Ultra-snabb GPU-bearbetning utan väntetider"
        },
        {
          "lead": "Chattrevisioner",
          "label": "Obegränsade detaljredigeringar i flera varv på naturligt språk"
        },
        {
          "lead": "Fulla kommersiella rättigheter",
          "label": "Hög upplösning, vattenmärkningsfri användning"
        }
      ],
      "restorePurchases": "Återställ köp",
      "restoringPurchases": "Återställande av köp…",
      "restoreSuccess": "Ditt medlemskap har återställds.",
      "restoreEmpty": "Ingen aktiv prenumeration hittades för det här App Store-kontot.",
      "membershipSyncPending": "Verifierar medlemskap och bildkrediter…",
      "membershipSyncFailed": "Bildkrediterna kunde inte synkroniseras. Försök igen.",
      "membershipUnavailable": "Medlemskapet kunde inte laddas.",
      "retry": "Försök igen"
    },
    "video": {
      "revisionHook": "Gör de första tre sekunderna mer engagerande.",
      "revisionPace": "Balansera tempot och korta ner de långsamma avsnitten.",
      "revisionEnding": "Gör slutet mer minnesvärt.",
      "revisionTransition": "Gör övergångarna smidigare och mer naturliga.",
      "revisionFraming": "Använd mer balanserad inramning för de viktiga detaljerna.",
      "revisionColor": "Gör färgerna mer balanserade och filmiska.",
      "revisionText": "Gör texten kortare och lättare att läsa.",
      "revisionAudio": "Matcha musiken mer noggrant med bildernas rytm.",
      "revisionEmotion": "Gör berättelsen mer uppriktig och känslomässig.",
      "revisionStructure": "Bygg ett tydligare början, mitten och slut.",
      "previewBack": "Tillbaka till förhandsvisning",
      "revisionWelcome": "Vad skulle du vilja ändra?",
      "revisionFailed": "Jag kunde inte tillämpa den ändringen. Kan du beskriva den igen?",
      "finalQueued": "Den sista videon är i kö. Den kommer att dyka upp under Videor när den är klar.",
      "watermarkUpgrade": "Välj en plan för att skapa en ny slutlig utdata utan Voxnela-vatarmärket.",
      "finalFailed": "Den sista videon kunde inte startas.",
      "projectDeleteFailed": "Projektet kunde inte raderas.",
      "videoDescriptionWithBrief": "Denna video skapades från “{{brief}}”. Voxnela valde de starkaste ögonblicken och byggde rytmen och scenordningen kring den valda kreativa riktningen.",
      "videoDescriptionGeneric": "Voxnela utvärderade materialet för innehåll, tempo och narrativ sammanhang, och lyfte fram de starkaste ögonblicken för en balanserad redigering.",
      "play": "leka",
      "deletesOn": "raderar på {{date}}",
      "projectsBelong": "Dina projekt är kopplade till ditt konto.",
      "videosBelong": "Dina videor är kopplade till ditt konto.",
      "signInToSeeProjects": "Logga in för att se dina projekt och fortsätta över enheter.",
      "signInToSeeVideos": "Logga in för att se dina videor och fortsätta över enheter.",
      "delete": "Radera",
      "deleting": "Raderar…",
      "secondsVersion": "{{seconds}} sek · version {{version}}",
      "deleteProject": "Radera projekt",
      "projectCoverUnavailable": "Projektomslaget kunde inte laddas",
      "videoCoverPreparing": "Förbereda videoförpackning",
      "deleteVideo": "Radera video",
      "signed": "Voxnela-märkt",
      "failed": "Kunde inte slutföra",
      "tryAgain": "Du kan försöka igen",
      "cancelled": "Avbruten",
      "noCreditUsed": "Ingen kredit användes",
      "featuredStyles": "Framhävda visuella stilar",
      "previousImage": "Föregående bild",
      "nextImage": "Nästa bild",
      "reviewStyle": "Utforska den här stilen",
      "featuredNavigation": "Framhävd visuell navigering",
      "taskCategories": "Uppgiftskategorier",
      "projectOpening": "Öppningsprojekt",
      "opening": "Öppning…",
      "projectNotFound": "Projektet hittades inte",
      "projectUnavailable": "Detta projekt är inte längre tillgängligt.",
      "backToProjects": "Tillbaka till mina projekt",
      "editVideo": "Redigera video",
      "versionContext": "Version {{version}} · Voxnela känner till ditt projekt och dina material",
      "livePreviewActions": "Liveförhandsvisningsåtgärder",
      "edit": "Redigera",
      "preparing": "Förbereder",
      "save": "Spara",
      "thinking": "Voxnela tänker",
      "revisionSuggestions": "Redigeringsförslag",
      "describeChange": "Beskriv förändringen du vill ha",
      "sendEdit": "Skicka redigeringsförfrågan",
      "deleteProjectDescription": "Är du säker på att du vill radera “{{title}}” och alla relaterade material? Detta kan inte ångras.",
      "projects": "Projekt",
      "projectsPreparing": "Förbereda dina projekt",
      "noProjects": "Du har inget projekt ännu. Börja med att beskriva din första idé.",
      "createNew": "Skapa ny bild",
      "thisProject": "Detta projekt",
      "videos": "Videor",
      "videosPreparing": "Förbereda dina videor",
      "noVideos": "Du har ännu inte en färdig video. Den kommer att visas här när din första video är klar.",
      "videoPlayFailed": "Videon kunde inte spelas upp.",
      "videoNotReady": "Videofilen är ännu inte redo att laddas ner.",
      "videoDownloadFailed": "Videon kunde inte laddas ner.",
      "videoDeleteFailed": "Videon kunde inte raderas.",
      "videoLoading": "Laddar upp video…",
      "videoActions": "Videofactionsåtgärder",
      "showVideoDescription": "Visa videobeskrivning",
      "videoDownloading": "Ladda ner video",
      "downloadVideo": "Ladda ner video",
      "thisVideo": "Den här videon",
      "deleteVideoDescription": "Är du säker på att du vill ta bort videon med titeln “{{title}}”? Detta kan inte ångras."
    },
    "studio": {
      "useStyle": "Använd denna stil",
      "galleryFilters": "Gallerifiltreringar",
      "modeStyleTransfer": "Voxnela-stilar",
      "modeVirtualTryOn": "Virtuell provning",
      "modeMagazineCover": "Magasin & omslag",
      "modePosterStudio": "Affischstudio",
      "modeCommercial": "Produktdemonstration",
      "modeTimeWarp": "Tidsresor",
      "modeOutpaintRelight": "Utöka & Återupplysa",
      "modeInfographic": "Infografik och data",
      "modePortraitRetouch": "Porträttretusch",
      "modeArtisticCollage": "Konstnärlig collage",
      "defaultStyle": "Voxnela-stil",
      "signInToCreate": "Logga in för att skapa en bild.",
      "signInToEdit": "Logga in för att redigera en bild.",
      "creationSuccess": "Din bild skapades framgångsrikt. Berätta direkt om du vill ändra belysningen, färgerna, objekten eller ramningen.",
      "imageReady": "Din bild är klar. Berätta vad du gillar eller vad du vill revidera.",
      "revisionSuccess": "Revisionen är komplett. Du kan jämföra den med för-/efter-skjutaren eller begära en annan ändring.",
      "versionReady": "Version {{version}} är redo.",
      "projectNotFound": "Projekt hittades inte.",
      "styleApplied": "{{style}}-stil tillämpad",
      "imageCreation": "Bildskapande",
      "defaultPrompt": "Studiobild",
      "aspectSquare": "kvadrat",
      "aspectSquareDetail": "Instagram-flöde, Profil, Konst",
      "aspectVertical": "vertikal",
      "aspectVerticalDetail": "Instagram Story, Reels, TikTok",
      "aspectHorizontal": "horisontal",
      "aspectHorizontalDetail": "YouTube, Bannerskärm, Biografer",
      "aspectPortrait": "porträtt",
      "aspectPortraitDetail": "Instagram-porträtt, affisch, showcase",
      "aspectPanoramic": "panorama-",
      "aspectPanoramicDetail": "Extremt vidsträckt, kinematisk landskap",
      "styles": "Voxnela-stilar",
      "fullScreenStyle": "Visa stil i helskärm",
      "closeDescription": "Stilbeskrivning stäng",
      "moreWithVoxnela": "Gör mer med Voxnela",
      "quickStartBody": "Skriv vad du vill nedan eller bifoga en fil.",
      "createImage": "Skapa bild",
      "createImageDetail": "Bygg din idé från grunden",
      "editImage": "Redigera bild",
      "editImageQuick": "Redigera en bild",
      "editImageDetail": "Återuppfinna en uppladdad bild",
      "transformStyle": "Förvandla stil och scen",
      "transformStyleDetail": "Flytta din bild till en annan värld",
      "visualizeDocument": "Visualisera ett dokument eller en presentation",
      "visualizeDocumentDetail": "Omvandla hela innehållet till en design",
      "submittedImage": "Skickad bild",
      "generating": "Voxnela skapar din bild…",
      "viewImage": "Visa bild",
      "removeStyle": "Ta bort valt stil",
      "referenceImage": "Referensbild",
      "referenceNotice": "Denna bild kommer att revideras eller en ny stil kommer att tillämpas.",
      "removeReference": "Ta bort referensbild",
      "remove": "flytta",
      "uploading": "Laddning",
      "addFile": "Lägg till en fil eller bild",
      "addFileTitle": "Lägg till upp till 4 bilder eller ett dokument (PDF, Word, PPT, max 12 MB)",
      "aspectRatio": "Aspektförhållande",
      "selectAspectRatio": "Välj förhållandeförhållande",
      "aspectOptions": "Aspektförhållandesalternativ",
      "revisePlaceholder": "Vad skulle du vilja ändra i den här bilden?",
      "styledPlaceholder": "Beskriv bilden du vill ha i den här stilen (valfritt)…",
      "promptPlaceholder": "Beskriv en bild eller skriv en prompt…",
      "reviseImage": "Granska bild",
      "generateImage": "Generera bild",
      "generatedImage": "Genererad bild",
      "done": "Klar",
      "fileLimitTitle": "Filen för stor",
      "fileLimitMessage": "“{{name}}” överskrider gränsen på 12 MB ({{size}} MB). Välj en mindre fil.",
      "imageLimitTitle": "Bildgräns",
      "imageLimitMessage": "Du kan ladda upp upp till 4 bilder. {{count}}-bilderna är för närvarande valda.",
      "uploadFailedTitle": "Uppladdning misslyckades",
      "uploadFailedMessage": "Ett problem uppstod när filen laddades upp.",
      "revisionFailed": "Ett fel inträffade under revisionen eller kvoten överskreds.",
      "generationFailed": "Ett fel uppstod under bildgenereringen eller kvoten har överskridits.",
      "imageDetails": "Bilddetaljer",
      "close": "stänga",
      "download": "Hämta",
      "downloadImage": "Ladda ner bild",
      "downloading": "Hämtar",
      "versionImage": "bild",
      "exploreTitle": "Vilken stil letar du efter?",
      "explorePlaceholder": "Till exempel: ett filmiskt porträtt med mörka toner och djupt perspektiv",
      "searchStyles": "Sök bildstilar",
      "clearSearch": "Rensa sökning",
      "exploreCategories": "Utforska kategorier",
      "all": "Alla",
      "styleCount": "{{count}} stilar",
      "noStyle": "Ingen matchande stil hittades",
      "noStyleBody": "Försök igen med en kortare beskrivning eller olika ord.",
      "libraryKicker": "Ditt personliga bildbibliotek",
      "myImages": "Mina bilder",
      "imageWorks": "{{count}}-bilden fungerar",
      "newImage": "Skapa ny bild",
      "noImage": "Du har inte skapat en bild ännu",
      "noCategoryImage": "Inga bilder i den här kategorin",
      "emptyGalleryBody": "Skapa din första bild med stilöverföring, virtuell provning, tidningsomslag eller produktvisning.",
      "firstImage": "Skapa din första bild",
      "imageWork": "Bildarbete"
    },
    "create": {
      "briefTitle": "Beskriv din idé eller ditt ämne",
      "briefPlaceholder": "Vad är ämnet? Till exempel: framtiden för AI, en resa till Mars eller en produktlansering…",
      "briefLabel": "Skapandebeskrivning",
      "contentType": "Innehållstyp",
      "media": "Bilder & Media",
      "added": "{{count}} tillagd",
      "optional": "Valfritt",
      "addMedia": "Lägg till ett foto eller en video om du vill",
      "addMediaBody": "Ladda upp ditt eget media eller lämna det tomt och låt AI hitta det",
      "attachedMedia": "Bilagor",
      "add": "tillägga",
      "mediaFallback": "media",
      "aiCompletes": "Låt AI slutföra bilderna",
      "noMedia": "Inga bilder uppladdade; AI kommer att slutföra scenerna.",
      "productionFormat": "Produktionsformat",
      "style": "Stil",
      "customVisualWorld": "Beskriv din visuella värld",
      "colorsAtmosphere": "Färger, atmosfär, kamera, rytm",
      "customStyleShort": "Beskriv den visuella världen du har i åtanke (till exempel: pastelltoner och en lugn kamera, eller cyberpunk-neon…)",
      "customStyleLong": "Beskriv den visuella världen, färgerna, atmosfären och rytmen du har i åtanke.",
      "voiceover": "Berättarröst",
      "ownVoiceover": "Din röstöverföringstext",
      "voiceoverPlaceholder": "Skriv din text här. Om den lämnas tom kommer Voxnela att förbereda den.",
      "duration": "Längd",
      "seconds": "{{count}} sek",
      "freeLimit": "Den längsta slutvideon på det kostnadsfria abonnemanget är 60 sekunder.",
      "addSound": "Lägg till ljud eller musik",
      "notAdded": "Inte tillagd",
      "files": "{{count}}-filer",
      "readySounds": "Använd färdiggjorda ljud",
      "musicLibrary": "Musikbibliotek",
      "uploadOwn": "Ladda upp din egen",
      "captions": "Undertexter",
      "back": "Tillbaka",
      "create": "Skapa",
      "next": "Nästa",
      "researchingTopic": "Undersöker ämnet…",
      "analyzingMaterials": "Analysera material…",
      "researchBody": "Verifiera källor och förbereda manus och visuellt plan.",
      "analyzeBody": "Utvärderar starka ramar, emotion, rytm och det korta tillsammans.",
      "creativeDirection": "Kreativ riktning {{count}}",
      "recommended": "Rekommenderas",
      "generationFailed": "Skapandet kunde inte slutföras",
      "retry": "Förbered igen",
      "backDirections": "Tillbaka till kreativa riktningar",
      "preparingVideo": "Förbereder din video",
      "voiceoverText": "Röstöverföringstext",
      "describeStyle": "Beskriv din egen stil",
      "topicDirection": "Ämne och riktning",
      "styleEditorSubtitle": "Beskriv den visuella världen, färgerna och atmosfären",
      "editorSubtitle": "Skriv texten och infoga den i skapandebladet",
      "voiceoverEditorPlaceholder": "Skriv texten som ska användas för röstöverföring.",
      "topicEditorPlaceholder": "Skriv ämnet och hur du vill att det ska berättas.",
      "insertText": "Infoga text",
      "bestFor": "Bäst för:",
      "useStyle": "Använd den här stilen",
      "musicSubtitle": "Riktiga spår godkända för kommersiellt bruk",
      "adding": "Lägger till…",
      "musicLicense": "Spåren tillhandahålls enligt CC0 1.0; kommersiell användning är tillåten och attribution krävs inte.",
      "yes": "Ja",
      "no": "Nej",
      "newCreation": "Ny skapelse",
      "reviewing": "Voxnela granskar",
      "chooseDirection": "Välj en av tre redigeringsmetoder",
      "ideaSubtitle": "Beskriv din idé; ladda upp visuella bilder eller låt Voxnela skapa dem",
      "projectOpenFailed": "Projektpaketet kunde inte öppnas.",
      "tooManyAssets": "Du kan lägga till upp till 50 tillgångar till ett projekt.",
      "uploadSizeLimit": "Den totala projektuppladdningen överskrider 2 GB-gränsen.",
      "filesAddFailed": "Filerna kunde inte läggas till.",
      "musicPreviewFailed": "Musikförhandsvisningen kunde inte öppnas.",
      "musicFetchFailed": "Musikfilen kunde inte hämtas.",
      "musicAddFailed": "Musiken kunde inte läggas till.",
      "topicRequired": "Ange ett ämne och beskriv vad din video kommer att handla om.",
      "briefTooShort": "Beskriv vad du vill berätta med minst några ord.",
      "mediaRequired": "Ladda upp en bild eller aktivera AI-genererade visuella element.",
      "proposalIntro": "Jag granskade bilderna och videorna och förberedde tre redigeringsriktningar som passar din stil, format och ljudval.",
      "removeMaterial": "Ta bort {{name}}",
      "aiVisualNotice": "Öppet licensierade verkliga bilder och AI-illustrationer hittas automatiskt.",
      "stepProgress": "Steg {{current}} av {{total}}",
      "styleSampleAlt": "Exempel som visar {{style}}-videostilen",
      "reviewStyle": "Granska {{style}}-stilen",
      "selectedDirectionPrompt": "Vald riktning: {{title}}. {{summary}} Visuell riktning: {{visual}}. Övergångsmetod: {{transitions}}. Musikmetod: {{music}}.",
      "letVoxnelaChoose": "Låt Voxnela välja",
      "feminineVoice": "kvinnlig",
      "masculineVoice": "manlig",
      "narrationStyle": "Berättarstil",
      "voiceEstimate": "Om {{seconds}} sek · {{words}} ord.",
      "voiceShort": "Om det är en förkortning för {{duration}} sekunder, kommer Voxnela att slutföra det samtidigt som det bevarar betydelsen.",
      "voiceNatural": "Voxnela justerar endast grammatik, formulering och naturligt flöde.",
      "removeFile": "Ta bort {{name}}-filen",
      "musicStop": "Stoppa {{title}}",
      "musicListen": "Lyssna på {{title}}",
      "automatic": "bil-",
      "all": "all",
      "cinematic": "film-",
      "social": "Socialt och dynamiskt",
      "designTypography": "Design & Typografi",
      "retroExperimental": "Retro & Experimentell",
      "productionStage1": "Att välja de starkaste ramarna och scenerna.",
      "productionStage2": "Bygga upp berättelsen, rörelsen och övergångarna.",
      "productionStage3": "Balansera musik, röst och undertexter.",
      "productionStage4": "Kör slutliga kontroller på den direkta förhandsvisningen.",
      "genericCreationError": "Ett problem uppstod när du förberedde videoplanen. Dina material och val sparas; du kan försöka igen.",
      "newVideo": "Ny video",
      "topicNews": "nyheter",
      "topicDocumentary": "dokumentarisk",
      "topicExplainer": "Förklaring",
      "topicStory": "historia",
      "topicScience": "vetenskap",
      "topicPhilosophy": "filosofi",
      "topicMagazine": "tidning",
      "topicEntertainment": "förplägnad",
      "topicList": "stad",
      "toneCalm": "lugn",
      "toneEmotional": "känslo-",
      "toneEnergetic": "energisk",
      "toneStorytelling": "Berättande",
      "toneCheerful": "glad",
      "toneMysterious": "mystisk",
      "toneNews": "nyheter",
      "styleCinematic": "film-",
      "styleDarkCinematic": "Mörk kinematisk",
      "styleDocumentary": "dokumentarisk",
      "styleModernDocumentary": "Modern dokumentär",
      "stylePovImmersive": "Immersivt POV",
      "styleUgcAuthentic": "Autentiskt UGC",
      "styleMiniVlog": "Mini-vlogg",
      "styleSocialViral": "Social viral",
      "styleHyperEdit": "Hyperredigera",
      "styleSportsHype": "Sporthype",
      "styleVelocityEdit": "Hastighetsredigera",
      "styleMusicBeatEdit": "Redigera musikklick",
      "styleKineticTypography": "Kinetisk typografi",
      "styleMinimalClean": "Minimalt & Rent",
      "styleLuxuryMinimal": "Lyx Minimalistisk",
      "styleCommercialProduct": "Kommersiell produkt",
      "styleEditorialFashion": "Redaktionell mode",
      "styleCollageZine": "Collagezine",
      "styleTechFuturistic": "Teknisk futuristisk",
      "styleRetroFuturism": "Retrofuturism",
      "styleY2kDigital": "Y2K Digital",
      "styleVhsCamcorder": "VHS-kamerakamera",
      "styleAnalogFilm": "Analogfilm",
      "styleGlitchCyber": "Glitch Cyber",
      "musicUpbeatMood": "Energisk · ljus",
      "musicUpbeatDetail": "Riktiga instrumentala inspelningar för upplyftande socialt innehåll, reseögonblick och livliga redigeringar.",
      "musicElectronicMood": "Modern · rytmisk",
      "musicElectronicDetail": "Riktig elektronisk musik för städer, teknik, produkter och snabba redigeringar.",
      "musicRomanceMood": "Emotionell · varm",
      "musicRomanceDetail": "Instrumentalmusik med en mjuk emotionell båge för familjer, porträtt, speciella dagar och minnen.",
      "musicScoringMood": "Berättande · filmiskt",
      "musicScoringDetail": "Kinematisk bakgrundsmusik som stöder berättelser, kampanjer och dramatiska övergångar.",
      "musicEpicMood": "Kraftfull · stigande",
      "musicEpicDetail": "Lagerad instrumentalmusik som bygger upp inför stora öppningar, resor och starka finaler.",
      "proposalBalancedTitle": "Balanserad berättelse",
      "proposalBalancedSummary": "En redigering som bevarar materialets flöde och lyfter fram de starkaste ramarna.",
      "proposalBalancedVisual": "Stark hierarki och ett sammanhängande visuellt system",
      "proposalBalancedTransitions": "Jämna snitt och mätta tryckinsättningar",
      "proposalBalancedMusic": "Musik som rör sig från känsla till rytm",
      "proposalQuietTitle": "Tyst berättelse",
      "proposalQuietSummary": "En lugn approach som ger ramarna mer tid och betonar detaljer och naturlig känsla.",
      "proposalQuietVisual": "Mjuka toner och längre bilder",
      "proposalQuietTransitions": "Korslösning och långsamma pannor",
      "proposalQuietMusic": "Enkel och känslosam musik",
      "proposalRhythmicTitle": "Rytmisk redigering",
      "proposalRhythmicSummary": "En redigering med en stark inledande hook som accelererar i mitten och lägger sig tydligt i slutet.",
      "proposalRhythmicVisual": "Starkare kontrast och dynamisk inramning",
      "proposalRhythmicTransitions": "Beatklipp och kontrollerade piskovergångar",
      "proposalRhythmicMusic": "Energisk, uppåtgående musik",
      "underVoiceover": "mjuk under röstöverföringen",
      "withShortVoiceover": "med kort, slagkraftig röstöverföring"
    },
    "information": {
      "home": "Start",
      "documentInfo": "Dokumentinformation",
      "version": "version",
      "effective": "Gäller från",
      "updated": "Senast uppdaterad",
      "contents": "Innehåll",
      "officialReferences": "Officiella referenser",
      "referenceTitle": "Lagar och myndighetsresurser",
      "referenceBody": "Dessa länkar tillhandahålls för allmän information. Tvingande lagar och nuvarande regler från behöriga myndigheter har företräde.",
      "supportKicker": "Sponelabs support",
      "contactTitle": "Kontakta oss",
      "contactLead": "Kontakta Voxnela supportteamet angående ditt konto, medlemskap, betalning, skapande, innehållsrapporter, integritet eller tekniska problem.",
      "supportEmail": "Supportmejl",
      "emailBody": "Knappen nedan öppnar din standard-e-postapp med en färdiganpassad supportmall så att vi kan undersöka snabbare.",
      "openEmail": "Öppna e-postappen",
      "includeTitle": "Ta med i meddelandet",
      "includeItems": [
        "Oavsett om du använder webben, iOS eller Mac;",
        "Din enhets och operativsystemversion;",
        "Steg för att reproducera problemet;",
        "Den relaterade projektlänken, transaktionsdetaljer eller skärmdump, om tillgänglig."
      ],
      "sensitiveTitle": "Skicka inte känsliga uppgifter",
      "sensitiveBody": "Inkludera inte verifieringskoder, lösenord, fullständiga betalkortsuppgifter, identitetsdokument, hälsodata eller annan känslig information som inte krävs för att lösa problemet.",
      "securityTitle": "Säkerhet och innehållsrapportering",
      "securityBody": "Använd “Säkerhet” för en sårbarhet, “Integritetsbegäran” för en databegäran eller “Innehållsrapport” för skadligt eller upphovsrättsstridigt innehåll. Kontakta lokala räddningstjänster vid omedelbar fysisk fara.",
      "mailSubject": "Voxnela supportförfrågan",
      "mailGreeting": "Hej Voxnela Supportteam,",
      "mailTopic": "Supportämne:",
      "mailPlatform": "Plattform (Webb / iOS / Mac):",
      "mailDevice": "Enhet och operativsystem:",
      "mailProject": "Projekt-ID (om tillgängligt):",
      "mailDescription": "Beskrivning av problemet eller förfrågan:",
      "mailThanks": "Tack.",
      "termsEyebrow": "Voxnela användarvillkor",
      "termsTitle": "Användarvillkor",
      "termsLead": "Dessa villkor styr användningen av AI-bildskapande- och redigeringstjänster i Voxnela-webbplatsen och iOS-apparna.",
      "privacyEyebrow": "Voxnela datanvändning",
      "privacyTitle": "Integritetspolicy",
      "privacyLead": "Denna policy förklarar hur konto, bild, projekt, medlemskap och tekniska data bearbetas i Voxnela bildskapande-tjänsten.",
      "officialTurkishNotice": "Denna översättning tillhandahålls för bekvämlighetens skull. Den turkiska juridiska texten styr om betydelserna skiljer sig åt."
    }
  },
  "nl": {
    "ui": {
      "home": "thuis",
      "homeTitle": "thuis",
      "explore": "Ontdekken",
      "gallery": "Galerij",
      "myImages": "Mijn afbeeldingen",
      "settings": "Instellingen",
      "createImage": "Afbeelding maken",
      "back": "Terug",
      "search": "Zoeken",
      "account": "rekening",
      "login": "Inloggen",
      "logout": "Uitloggen",
      "profile": "Profiel",
      "profileSettings": "Profiel en instellingen",
      "plans": "Abonnementen en gebruik",
      "plansSubtitle": "Afbeeldingscredits en facturering",
      "contact": "contact",
      "contactSubtitle": "Hulp en feedback",
      "discoverVoxnela": "Ontdek Voxnela",
      "discoverVoxnelaSubtitle": "Bekijk de visuele studio-ervaring",
      "privacy": "privacy",
      "privacySubtitle": "Hoe uw gegevens worden beschermd",
      "terms": "Gebruiksvoorwaarden",
      "termsSubtitle": "Voxnela gebruiksvoorwaarden",
      "preferencesSubtitle": "Uw account en Voxnela voorkeuren",
      "accountSubtitle": "Account- en lidmaatschapsgegevens",
      "voxAccount": "Voxnela-account",
      "accessEverywhere": "Toegang krijgen tot uw afbeeldingen op elk apparaat",
      "imageRights": "{{count}} afbeeldingscredits",
      "availableCredits": "Beschikbare credits",
      "renewalDate": "Vernieuwingsdatum",
      "membershipStart": "Lidmaatschap gestart",
      "registrationDate": "Registratiedatum",
      "monthly": "maandelijks",
      "renewalOff": "Vernieuwing uitgeschakeld",
      "user": "Voxnela-gebruiker",
      "language": "Taal",
      "languageSubtitle": "Kies de app-taal",
      "supportBody": "Schrijf ons als je een probleem hebt of een idee wilt delen. Het project-ID helpt ons sneller te reageren.",
      "studioTitle": "Voxnela beeldstudio",
      "studioSubtitle": "Creëer je stijl",
      "searchSubtitle": "Uw afbeeldingen en projecten",
      "searchPlaceholder": "Zoek naar een afbeelding of project",
      "noSearchResults": "Niets kwam overeen met deze zoekopdracht.",
      "project": "project",
      "image": "beeld",
      "completed": "Voltooid",
      "currentPlan": "Huidig plan",
      "notSignedIn": "Niet ingelogd",
      "signInIntro": "Meld u aan om Voxnela te gaan gebruiken.",
      "creditsAvailable": "{{count}} studioafbeeldingscredits zijn beschikbaar.",
      "noCredits": "Je hebt in deze periode geen afbeeldingenkrediet meer.",
      "membershipInfo": "Jaarlijkse plancredits worden elke maand verlengd en worden niet overgedragen. Herstelde aankopen blijven beschermd via uw account.",
      "signedOutMembershipInfo": "Na het inloggen verschijnen hier uw beschikbare afbeeldingenkredieten en planinformatie.",
      "reviewPlans": "Bekijk plannen",
      "versionUpdated": "Versie {{version}} · Laatst bijgewerkt {{date}}",
      "onboardingWelcome": "Welkom bij Voxnela",
      "skipIntro": "Introductie overslaan",
      "continue": "Doorgaan",
      "startCreating": "Begin met maken",
      "close": "sluiten",
      "dragToClose": "Veeg naar beneden om het blad te sluiten",
      "loading": "Laden...",
      "sheetExpand": "Uitbreidingsblad",
      "sheetCollapse": "Retourblad terug naar normale hoogte",
      "cannotClose": "Kan niet sluiten terwijl de operatie bezig is",
      "stylePreview": "Stijlvoorbeeld",
      "stylePreviewSubtitle": "Signatuurstijlen en trends",
      "categories": "Categorieën",
      "useThisStyle": "Gebruik deze stijl",
      "videoControls": "Videoknoppen",
      "play": "spelen",
      "pause": "pauze",
      "mute": "dempen",
      "unmute": "Demuten",
      "minimize": "minimaliseren",
      "expandVideo": "Uitbreiden in de app",
      "videoProgress": "Video voortgang",
      "toggleVideoControls": "Videoknoppen weergeven of verbergen",
      "expandedVideo": "{{title}} uitgebreide videovergazing",
      "goToImage": "Ga naar {{title}} afbeelding",
      "categoryVisualStyles": "{{category}} visuele stijlen",
      "onboarding1Eyebrow": "Afbeeldingen maken",
      "onboarding1Title": "Maak jouw afbeelding.",
      "onboarding1Body": "Maak je idee om tot een cinematografisch frame met 35mm-film, redactioneel, product, poster en nog veel meer visuele stijlen.",
      "onboarding2Eyebrow": "Virtueel kleding passen",
      "onboarding2Title": "Pas nieuwe outfits.",
      "onboarding2Body": "Behoud de identiteit tussen producties en creëer realistische mode-, accessoires- en productproefvisualisaties.",
      "onboarding3Eyebrow": "Afbeeldingen bewerken",
      "onboarding3Title": "Bewerk jouw afbeelding.",
      "onboarding3Body": "Herzie de compositie, het licht, de kleur en de details in een gesprek zonder opnieuw te beginnen.",
      "onboarding4Eyebrow": "3 gratis afbeeldingen",
      "onboarding4Title": "Begin gratis.",
      "onboarding4Body": "Begin direct met 3 eenmalige gratis AI-afbeeldingen. Geen account nodig.",
      "onboardingFaceEyebrow": "Gezichts- en stijlanalyse",
      "onboardingFaceTitle": "Ontdek je gezicht en stijl.",
      "onboardingFaceBody": "Verken ideeën voor haar, brillen en kleding op basis van je portret in één visuele gids.",
      "onboardingHouseEyebrow": "Tijdreizen",
      "onboardingHouseTitle": "Reis door de tijd.",
      "onboardingHouseBody": "Breng je foto’s en datums samen en zie hoe je huis met de tijd veranderde.",
      "onboardingFestivalEyebrow": "Jouw festivaldag",
      "onboardingFestivalTitle": "Plan je festivaldag in één oogopslag.",
      "onboardingFestivalBody": "Maak van het programma, de podia en tijden die je opgeeft een persoonlijke visuele route.",
      "onboardingStylesEyebrow": "Voxnela-stijlen",
      "onboardingStylesTitle": "Kies jouw stijl.",
      "onboardingStylesBody": "Maak je idee om tot een cinematografisch frame met 35mm-film, redactioneel, product, poster en nog veel meer visuele stijlen."
    },
    "auth": {
      "enterCode": "Voer je code in",
      "membershipAndAccount": "Lidmaatschap en accountgegevens",
      "noPeriodInfo": "Periode niet beschikbaar",
      "memberSince": "Lid sinds",
      "planSince": "{{plan}} sinds",
      "membershipRenewal": "Datum van vernieuwing lidmaatschap",
      "accountActions": "Accountacties",
      "manageSubscriptionTitle": "Abonnement beëindigen",
      "manageSubscriptionSubtitle": "Beheer uw winkelabonnement en automatische verlenging.",
      "deleteAccountTitle": "Verwijder mijn account",
      "deleteAccountSubtitle": "Omkeerbaar verwijderingsproces van 15 dagen.",
      "deleteDataTitle": "Verwijder mijn gegevens",
      "deleteDataSubtitle": "Omkeerbaar 30-daags proces voor gegevensverwijdering.",
      "signingOut": "Uitloggen…",
      "signOut": "Uitloggen",
      "signingIn": "Inloggen…",
      "continueApple": "Doorgaan met Apple",
      "continueGoogle": "Doorgaan met Google",
      "or": "of",
      "email": "E-mail",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "Door verder te gaan met Voxnela, accepteert u de",
      "legalTerms": "Gebruiksvoorwaarden",
      "legalJoin": "en bevestig dat u de",
      "legalPrivacy": "Privacyverklaring",
      "legalSuffix": ".",
      "sendingCode": "Code verzenden…",
      "emailSignIn": "Inloggen met e-mail",
      "codeSent": "We hebben een code gestuurd naar {{email}}.",
      "change": "Wijzigen",
      "sixDigitCode": "6-cijferige code",
      "emailCode": "E-mailinlogcode",
      "verifyingCode": "Code controleren…",
      "resendCode": "Code opnieuw verzenden",
      "requestReceived": "Verzoek ontvangen",
      "accountDeletionStarted": "Het verwijderingsproces van uw account is gestart",
      "dataDeletionStarted": "Uw proces voor gegevensverwijdering is gestart",
      "accountAction": "Accountactie",
      "accountDeletesAt": "Uw account wordt permanent verwijderd op {{date}}.",
      "dataDeletesAt": "Uw persoonlijke Voxnela-gegevens worden permanent verwijderd op {{date}}.",
      "deletionUndo": "Als u zich vóór deze datum inmeldt met hetzelfde account, wordt het verwijderingsproces automatisch geannuleerd. Uw huidige sessie is gesloten omdat het verzoek is aangemaakt.",
      "done": "Gereed",
      "cancel": "Annuleren",
      "preparing": "Voorbereiden...",
      "invalidEmail": "Voer een geldig e-mailadres in.",
      "enterSixDigitCode": "Voer de 6-cijferige code in die naar uw e-mail is gestuurd.",
      "signInFailed": "Inloggen kon niet worden voltooid. Probeer het opnieuw.",
      "codeSendFailed": "De aanmeldcode kon niet worden verzonden. Probeer het opnieuw.",
      "codeVerifyFailed": "De code kon niet worden geverifieerd. Probeer het opnieuw.",
      "operationFailed": "De operatie kon op dit moment niet worden voltooid. Probeer het opnieuw.",
      "popupClosed": "Het inlogvenster was gesloten.",
      "unauthorizedDomain": "Dit domein is niet geautoriseerd voor aanmelden.",
      "methodUnavailable": "Deze inlogmethode is nog niet ingeschakeld.",
      "tooManyCodes": "Er zijn te veel codes aangevraagd. Probeer het over enkele minuten opnieuw.",
      "invalidCode": "De code is ongeldig of verlopen. Vraag een nieuwe code aan.",
      "emailUnavailable": "E-mailbezorging is momenteel niet beschikbaar.",
      "actions": {
        "subscription": {
          "eyebrow": "Abonnementactie",
          "title": "Eindig uw abonnement?",
          "confirm": "Abonnementen beheren",
          "paragraphs": [
            "Door 'Doorgaan' te selecteren, opent u de pagina voor het beheer van het Apple App Store- of Google Play-abonnement waar u het abonnement heeft gekocht. U moet automatische verlenging in de winkel uitschakelen.",
            "Na opzegging blijven uw bestaande lidmaatschapsvoordelen beschikbaar tot het einde van de betaalde periode. Het verwijderen van uw account of gegevens annuleert geen winkelabonnement."
          ]
        },
        "account": {
          "eyebrow": "Actie op permanente rekening",
          "title": "Weet je zeker dat je je account wilt verwijderen?",
          "confirm": "Start 15-daags verwijderingsproces",
          "paragraphs": [
            "Doorgaan start een verwijderingsproces van 15 dagen en logt je uit voor de veiligheid. Als je gedurende deze periode niet opnieuw inlogt, worden je account, profiel, creaties, bibliotheek, collecties en gerelateerde Voxnela-gegevens permanent verwijderd.",
            "Inloggen met hetzelfde account vóór 15 dagen annuleert de verwijdering automatisch. Het verwijderen van het account annuleert geen actief winkelabonnement; annuleer het apart in de winkel."
          ]
        },
        "data": {
          "eyebrow": "Permanente gegevensactie",
          "title": "Weet je zeker dat je je gegevens wilt verwijderen?",
          "confirm": "Start 30-daags verwijderingsproces",
          "paragraphs": [
            "Doorgaan start een verwijderingsproces van 30 dagen en logt u uit voor de veiligheid. Als u gedurende deze periode niet opnieuw inlogt, worden uw creaties, bibliotheek, collecties, records, interacties en andere persoonlijke Voxnela-gegevens permanent verwijderd; uw inlogaccount blijft beschikbaar.",
            "Het opnieuw inloggen vóór 30 dagen annuleert automatisch het verwijderen van gegevens. Beperkte transactie- en beveiligingsrecords die wettelijk vereist zijn, kunnen gedurende de toepasselijke wettelijke periodes met beperkte toegang worden bewaard."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "Geen afbeeldingscredits meer",
      "quotaFreeMessage": "Je hebt de afbeeldingscredits in je gratis account gebruikt. Kies een abonnement om verder te blijven creëren.",
      "later": "later",
      "currentCredit": "Huidige tegoeden: 0",
      "quotaProTitle": "Maandelijks Pro-quotum bereikt",
      "quotaProMessage": "Je hebt de 100 afbeeldingscredits van deze maand gebruikt. Upgrade naar Studio om verder te kunnen creëren.",
      "renewalDate": "Vernieuwingsdatum: {{date}}",
      "quotaStudioTitle": "Maandelijks studioquotum bereikt",
      "quotaStudioMessage": "Uw afbeeldingscredits worden automatisch verlengd op {{date}}.",
      "done": "klaar",
      "membership": "Voxnela-lidmaatschap",
      "options": "Lidmaatschapsopties",
      "credits": "aftiteling",
      "currentMembership": "Huidig lidmaatschap",
      "yearlyDiscount": "17% korting",
      "loadingPrice": "Winkelprijs laden…",
      "loadingStorePrice": "Prijs laden uit de winkel",
      "year": "jaar",
      "month": "maand",
      "renewDisclosure": "Wordt automatisch verlengd elke {{period}}. Annuleer op elk moment.",
      "legal": "Juridisch",
      "terms": "Voorwaarden",
      "alreadyMember": "Je hebt al {{plan}} {{period}}",
      "startPlan": "Start {{plan}}-plan",
      "upgradeStudio": "Upgraden naar Studio",
      "yearlyAdvantage": "Schakel over naar jaarlijkse besparingen",
      "upgrade": "Lidmaatschap upgraden",
      "signInRequired": "Meld je aan bij je Voxnela-account voordat je een abonnement begint.",
      "catalogUnavailable": "De betaalcatalogus kon niet worden geverifieerd voor dit abonnement. Probeer het binnenkort opnieuw.",
      "paymentUnavailable": "Het betaalscherm kon niet worden geopend. Probeer het opnieuw.",
      "benefits": [
        {
          "lead": "{{credits}} Kredieten",
          "label": "Maandelijkse generatie van afbeeldingen op hoge resolutie"
        },
        {
          "lead": "50+ Studio-stijlen",
          "label": "Neo-minimalisme, cinematisch en elke kenmerkende stijl"
        },
        {
          "lead": "Gelaatslokker",
          "label": "Virtuele modetest zonder gezichtsfuncties te veranderen"
        },
        {
          "lead": "Prioriteitswachtrij",
          "label": "Ultra-snel GPU-verwerking zonder wachten"
        },
        {
          "lead": "Chatherzieningen",
          "label": "Onbeperkte multi-turn detailbewerkingen in natuurlijke taal"
        },
        {
          "lead": "Volledige commerciële rechten",
          "label": "Hoge resolutie, watermerkvrij gebruik"
        }
      ],
      "restorePurchases": "Aankopen herstellen",
      "restoringPurchases": "Herstel aankopen...",
      "restoreSuccess": "Uw lidmaatschap is hersteld.",
      "restoreEmpty": "Er is geen actieve abonnement gevonden voor dit App Store-account.",
      "membershipSyncPending": "Lidmaatschap en afbeeldingscredits verifiëren...",
      "membershipSyncFailed": "Afbeeldingstegoed kon niet worden gesynchroniseerd. Probeer opnieuw.",
      "membershipUnavailable": "Lidmaatschap kon niet worden geladen.",
      "retry": "Opnieuw proberen"
    },
    "video": {
      "revisionHook": "Maak de eerste drie seconden boeiender.",
      "revisionPace": "Breng het tempo in evenwicht en verkort de langzame secties.",
      "revisionEnding": "Maak het einde memorabeler.",
      "revisionTransition": "Maak de overgangen soepeler en natuurlijker.",
      "revisionFraming": "Gebruik een evenwichtigere kadering voor de belangrijke details.",
      "revisionColor": "Maak de kleuren evenwichtiger en cinematischer.",
      "revisionText": "Maak de tekst korter en gemakkelijker te lezen.",
      "revisionAudio": "Stem de muziek nauwer af op het ritme van de afbeeldingen.",
      "revisionEmotion": "Maak het verhaal oprechter en emotioneel.",
      "revisionStructure": "Bouw een duidelijker begin, midden en einde op.",
      "previewBack": "Terug naar voorvertoning",
      "revisionWelcome": "Wat zou je willen veranderen?",
      "revisionFailed": "Ik kon die wijziging niet toepassen. Kun je het nog eens beschrijven?",
      "finalQueued": "De laatste video staat in de wachtrij. Deze verschijnt onder Video's wanneer deze klaar is.",
      "watermarkUpgrade": "Kies een plan om een nieuwe definitieve uitvoer te maken zonder het Voxnela-watermerk.",
      "finalFailed": "De laatste video kon niet worden gestart.",
      "projectDeleteFailed": "Het project kon niet worden verwijderd.",
      "videoDescriptionWithBrief": "Deze video is gemaakt van “{{brief}}”. Voxnela heeft de sterkste momenten geselecteerd en het ritme en de scènevolgorde gebouwd rond de gekozen creatieve richting.",
      "videoDescriptionGeneric": "Voxnela evalueerde de materialen op inhoud, tempo en narratieve samenhang, waarbij de sterkste momenten werden benadrukt voor een gebalanceerde bewerking.",
      "play": "spelen",
      "deletesOn": "verwijdert op {{date}}",
      "projectsBelong": "Uw projecten zijn gekoppeld aan uw account.",
      "videosBelong": "Uw video's zijn gekoppeld aan uw account.",
      "signInToSeeProjects": "Meld u aan om uw projecten te bekijken en door te gaan op verschillende apparaten.",
      "signInToSeeVideos": "Meld u aan om uw video's te bekijken en door te gaan op verschillende apparaten.",
      "delete": "Verwijderen",
      "deleting": "Verwijderen…",
      "secondsVersion": "{{seconds}} sec · versie {{version}}",
      "deleteProject": "Project verwijderen",
      "projectCoverUnavailable": "Projectcover kon niet worden geladen",
      "videoCoverPreparing": "Video-cover voorbereiden",
      "deleteVideo": "Video verwijderen",
      "signed": "Voxnela merk",
      "failed": "Kon niet voltooiën",
      "tryAgain": "Je kunt het opnieuw proberen",
      "cancelled": "Geannuleerd",
      "noCreditUsed": "Geen tegoed gebruikt",
      "featuredStyles": "Aanbevolen visuele stijlen",
      "previousImage": "Eerdere afbeelding",
      "nextImage": "Volgende afbeelding",
      "reviewStyle": "Ontdek deze stijl",
      "featuredNavigation": "Aanbevolen visuele navigatie",
      "taskCategories": "Taakcategorieën",
      "projectOpening": "Openingsproject",
      "opening": "Opening...",
      "projectNotFound": "Project niet gevonden",
      "projectUnavailable": "Dit project is niet langer beschikbaar.",
      "backToProjects": "Terug naar mijn projecten",
      "editVideo": "Video bewerken",
      "versionContext": "Versie {{version}} · Voxnela kent je project en materialen",
      "livePreviewActions": "Live preview-acties",
      "edit": "Bewerken",
      "preparing": "Voorbereiden",
      "save": "Opslaan",
      "thinking": "Voxnela denkt",
      "revisionSuggestions": "Redactionele suggesties",
      "describeChange": "Beschrijf de verandering die je wilt",
      "sendEdit": "Verzend bewerkingsverzoek",
      "deleteProjectDescription": "Weet je zeker dat je “{{title}}” en alle gerelateerde materialen wilt verwijderen? Dit kan niet worden teruggedraaid.",
      "projects": "Projecten",
      "projectsPreparing": "Uw projecten voorbereiden",
      "noProjects": "Je hebt nog geen project. Begin met het beschrijven van je eerste idee.",
      "createNew": "Nieuwe afbeelding maken",
      "thisProject": "Dit project",
      "videos": "Video’s",
      "videosPreparing": "Uw video's voorbereiden",
      "noVideos": "Je hebt nog geen voltooide video. Deze verschijnt hier wanneer je eerste video klaar is.",
      "videoPlayFailed": "De video kon niet worden afgespeeld.",
      "videoNotReady": "Het videobestand is nog niet klaar om te downloaden.",
      "videoDownloadFailed": "De video kon niet worden gedownload.",
      "videoDeleteFailed": "De video kon niet worden verwijderd.",
      "videoLoading": "Video wordt geladen...",
      "videoActions": "Videobewerkingen",
      "showVideoDescription": "Toon videobeschrijving",
      "videoDownloading": "Video downloaden",
      "downloadVideo": "Video downloaden",
      "thisVideo": "Deze video",
      "deleteVideoDescription": "Weet je zeker dat je de video met de titel “{{title}}” wilt verwijderen? Dit kan niet worden teruggedraaid."
    },
    "studio": {
      "useStyle": "Gebruik deze stijl",
      "galleryFilters": "Galeriefilters",
      "modeStyleTransfer": "Voxnela Stijlen",
      "modeVirtualTryOn": "Virtuele Proefomslag",
      "modeMagazineCover": "Magazine & Cover",
      "modePosterStudio": "Poster Studio",
      "modeCommercial": "Productshowcase",
      "modeTimeWarp": "tijdreizen",
      "modeOutpaintRelight": "Uitbreiden & Oplaaien",
      "modeInfographic": "Infographic & Data",
      "modePortraitRetouch": "Portret Retouch",
      "modeArtisticCollage": "Artistieke Collage",
      "defaultStyle": "Voxnela Stijl",
      "signInToCreate": "Meld u aan om een afbeelding te maken.",
      "signInToEdit": "Meld u aan om een afbeelding te bewerken.",
      "creationSuccess": "Uw afbeelding is succesvol gemaakt. Laat het me direct weten als u de belichting, kleuren, objecten of kadering wilt wijzigen.",
      "imageReady": "Je afbeelding is klaar. Vertel me wat je leuk vindt of wat je wilt verbeteren.",
      "revisionSuccess": "De revisie is voltooid. Je kunt het vergelijken met de voor/na-slider of een andere wijziging aanvragen.",
      "versionReady": "Versie {{version}} is klaar.",
      "projectNotFound": "Project niet gevonden.",
      "styleApplied": "{{style}}-stijl toegepast",
      "imageCreation": "Afbeeldingscreatie",
      "defaultPrompt": "Studio-afbeelding",
      "aspectSquare": "vierkant",
      "aspectSquareDetail": "Instagram Feed, Profiel, Kunst",
      "aspectVertical": "verticaal",
      "aspectVerticalDetail": "Instagram Story, Reels, TikTok",
      "aspectHorizontal": "horizontaal",
      "aspectHorizontalDetail": "YouTube, Banner, Bioscoop",
      "aspectPortrait": "portret",
      "aspectPortraitDetail": "Instagram Portret, Poster, Showcase",
      "aspectPanoramic": "panoramisch",
      "aspectPanoramicDetail": "Ultra Breed, Cinematisch Landschap",
      "styles": "Voxnela-stijlen",
      "fullScreenStyle": "Stijl in volledig scherm bekijken",
      "closeDescription": "Sluit stijlbeschrijving",
      "moreWithVoxnela": "Doe meer met Voxnela",
      "quickStartBody": "Schrijf hieronder wat je wilt of voeg een bestand toe.",
      "createImage": "Afbeelding maken",
      "createImageDetail": "Bouw je idee vanaf nul op",
      "editImage": "Afbeelding bewerken",
      "editImageQuick": "Een afbeelding bewerken",
      "editImageDetail": "Herimagineer een geüploade afbeelding",
      "transformStyle": "Stijl en scène transformeren",
      "transformStyleDetail": "Verplaats je afbeelding naar een andere wereld",
      "visualizeDocument": "Visualiseer een document of presentatie",
      "visualizeDocumentDetail": "Maak de volledige inhoud om tot een ontwerp",
      "submittedImage": "Ingediende afbeelding",
      "generating": "Voxnela maakt je afbeelding…",
      "viewImage": "Afbeelding bekijken",
      "removeStyle": "Geselecteerde stijl verwijderen",
      "referenceImage": "Referentieafbeelding",
      "referenceNotice": "Deze afbeelding zal worden herzien of er zal een nieuwe stijl worden toegepast.",
      "removeReference": "Referentieafbeelding verwijderen",
      "remove": "verwijderen",
      "uploading": "Uploaden",
      "addFile": "Voeg een bestand of afbeelding toe",
      "addFileTitle": "Voeg tot 4 afbeeldingen of een document toe (PDF, Word, PPT, max. 12 MB)",
      "aspectRatio": "Aspectverhouding",
      "selectAspectRatio": "Aspectverhouding selecteren",
      "aspectOptions": "Aspectverhoudingsopties",
      "revisePlaceholder": "Wat zou je graag willen veranderen in deze afbeelding?",
      "styledPlaceholder": "Beschrijf het beeld dat je in deze stijl wilt (optioneel)...",
      "promptPlaceholder": "Beschrijf een afbeelding of schrijf een prompt...",
      "reviseImage": "Afbeelding herzien",
      "generateImage": "Afbeelding genereren",
      "generatedImage": "Generatiebeeld",
      "done": "Gereed",
      "fileLimitTitle": "Bestand te groot",
      "fileLimitMessage": "\"{{name}}\" overschrijdt de limiet van 12 MB ({{size}} MB). Kies een kleiner bestand.",
      "imageLimitTitle": "Afbeeldingslimiet",
      "imageLimitMessage": "U kunt tot 4 afbeeldingen uploaden. {{count}}-afbeeldingen zijn momenteel geselecteerd.",
      "uploadFailedTitle": "Upload mislukt",
      "uploadFailedMessage": "Er is een probleem opgetreden bij het uploaden van het bestand.",
      "revisionFailed": "Er is een fout opgetreden tijdens de revisie of het quotum is overschreden.",
      "generationFailed": "Er is een fout opgetreden tijdens de beeldgeneratie of het quotum is overschreden.",
      "imageDetails": "Afbeeldingsdetails",
      "close": "sluiten",
      "download": "Downloaden",
      "downloadImage": "Afbeelding downloaden",
      "downloading": "Downloaden",
      "versionImage": "beeld",
      "exploreTitle": "Welke stijl zoek je?",
      "explorePlaceholder": "Bijvoorbeeld: een cinematografisch portret met donkere tinten en een diep perspectief",
      "searchStyles": "Visuele stijlen zoeken",
      "clearSearch": "Zoekopdracht wissen",
      "exploreCategories": "Verken categorieën",
      "all": "Alles",
      "styleCount": "{{count}} stijlen",
      "noStyle": "Geen overeenkomende stijl gevonden",
      "noStyleBody": "Probeer het opnieuw met een kortere beschrijving of andere woorden.",
      "libraryKicker": "Uw persoonlijke afbeeldingsbibliotheek",
      "myImages": "Mijn afbeeldingen",
      "imageWorks": "{{count}} afbeelding werkt",
      "newImage": "Nieuwe afbeelding maken",
      "noImage": "Je hebt nog geen afbeelding gemaakt",
      "noCategoryImage": "Geen afbeeldingen in deze categorie",
      "emptyGalleryBody": "Maak je eerste afbeelding met stijloverdracht, virtuele pasvormtest, magazinecover of productshowcase.",
      "firstImage": "Maak je eerste afbeelding",
      "imageWork": "Afbeeldingswerk"
    },
    "create": {
      "briefTitle": "Beschrijf je idee of onderwerp",
      "briefPlaceholder": "Wat is het onderwerp? Bijvoorbeeld: de toekomst van AI, een reis naar Mars of een productlancering…",
      "briefLabel": "Creatiebrief",
      "contentType": "Inhoudstype",
      "media": "Afbeeldingen & Media",
      "added": "{{count}} toegevoegd",
      "optional": "Optioneel",
      "addMedia": "Voeg een foto of video toe als je wilt",
      "addMediaBody": "Upload je eigen media of laat het leeg en laat AI het vinden",
      "attachedMedia": "Bijgevoegde media",
      "add": "toevoegen",
      "mediaFallback": "Media",
      "aiCompletes": "Laat AI de visuele elementen voltooien",
      "noMedia": "Geen afbeeldingen geüpload; AI zal de scènes voltooien.",
      "productionFormat": "Productieformaat",
      "style": "Stijl",
      "customVisualWorld": "Beschrijf je visuele wereld",
      "colorsAtmosphere": "Kleuren, sfeer, camera, ritme",
      "customStyleShort": "Beschrijf de visuele wereld die je voor je hebt (bijvoorbeeld: pasteltinten en een kalme camera, of cyberpunk neon…)",
      "customStyleLong": "Beschrijf de visuele wereld, kleuren, sfeer en het ritme die je voor je hebt.",
      "voiceover": "Voice-over",
      "ownVoiceover": "Uw spraakondersteunde tekst",
      "voiceoverPlaceholder": "Schrijf hier je tekst. Als deze leeg blijft, bereidt Voxnela deze voor.",
      "duration": "Duur",
      "seconds": "{{count}} sec",
      "freeLimit": "De langste eindvideo op het gratis abonnement is 60 seconden.",
      "addSound": "Geluid of muziek toevoegen",
      "notAdded": "Niet toegevoegd",
      "files": "{{count}}-bestanden",
      "readySounds": "Gebruik kant-en-klare geluiden",
      "musicLibrary": "Muziekbibliotheek",
      "uploadOwn": "Upload je eigen",
      "captions": "Ondertiteling",
      "back": "Terug",
      "create": "Maken",
      "next": "Volgende",
      "researchingTopic": "Onderzoek doen naar het onderwerp...",
      "analyzingMaterials": "Materialen analyseren...",
      "researchBody": "Bronnen verifiëren en het script en het visuele plan voorbereiden.",
      "analyzeBody": "Sterke kaders, emotie, ritme en de korte samen evalueren.",
      "creativeDirection": "Creatieve richting {{count}}",
      "recommended": "Aanbevolen",
      "generationFailed": "Creatie kon niet worden voltooid",
      "retry": "Opnieuw voorbereiden",
      "backDirections": "Terug naar creatieve richtingen",
      "preparingVideo": "Je video voorbereiden",
      "voiceoverText": "Spraakondersteunde tekst",
      "describeStyle": "Beschrijf je eigen stijl",
      "topicDirection": "Onderwerp en richting",
      "styleEditorSubtitle": "Beschrijf de visuele wereld, kleuren en sfeer",
      "editorSubtitle": "Schrijf de tekst en voeg deze in op het creatieblad",
      "voiceoverEditorPlaceholder": "Schrijf de tekst die je gebruikt voor de ondertiteling.",
      "topicEditorPlaceholder": "Schrijf het onderwerp en hoe je het verteld wilt hebben.",
      "insertText": "Tekst invoegen",
      "bestFor": "Beste voor:",
      "useStyle": "Gebruik deze stijl",
      "musicSubtitle": "Echte nummers vrijgegeven voor commercieel gebruik",
      "adding": "Toevoegen...",
      "musicLicense": "Tracks worden geleverd onder CC0 1.0; commercieel gebruik is toegestaan en attributie is niet vereist.",
      "yes": "Ja",
      "no": "Nee",
      "newCreation": "Nieuwe creatie",
      "reviewing": "Voxnela beoordeelt",
      "chooseDirection": "Kies een van de drie bewerkingsbenaderingen",
      "ideaSubtitle": "Beschrijf je idee; upload visuele inhoud of laat Voxnela deze maken",
      "projectOpenFailed": "Het projectpakket kon niet worden geopend.",
      "tooManyAssets": "Je kunt tot 50 activa aan een project toevoegen.",
      "uploadSizeLimit": "De totale projectupload overschrijdt de limiet van 2 GB.",
      "filesAddFailed": "De bestanden konden niet worden toegevoegd.",
      "musicPreviewFailed": "De muziekpreview kon niet worden geopend.",
      "musicFetchFailed": "Het muziekbestand kon niet worden opgehaald.",
      "musicAddFailed": "De muziek kon niet worden toegevoegd.",
      "topicRequired": "Voer een onderwerp in en beschrijf waar je video over zal gaan.",
      "briefTooShort": "Beschrijf wat je in minimaal een paar woorden wilt vertellen.",
      "mediaRequired": "Upload een afbeelding of schakel AI-gegenereerde visuele inhoud in.",
      "proposalIntro": "Ik heb de afbeeldingen en video's bekeken en drie bewerkingsrichtlijnen opgesteld die passen bij uw stijl, formaat en audiokeuzes.",
      "removeMaterial": "{{name}} verwijderen",
      "aiVisualNotice": "Openlijk gelicentieerde echte afbeeldingen en AI-illustraties worden automatisch gevonden.",
      "stepProgress": "Stap {{current}} van {{total}}",
      "styleSampleAlt": "Voorbeeld dat de {{style}} videostijl toont",
      "reviewStyle": "Bekijk de {{style}}-stijl",
      "selectedDirectionPrompt": "Geselecteerde richting: {{title}}. {{summary}} Visuele richting: {{visual}}. Overgangsaanpak: {{transitions}}. Muziekaanpak: {{music}}.",
      "letVoxnelaChoose": "Laat Voxnela kiezen",
      "feminineVoice": "vrouwelijk",
      "masculineVoice": "mannelijk",
      "narrationStyle": "Vertelstijl",
      "voiceEstimate": "Over {{seconds}} sec · {{words}} woorden.",
      "voiceShort": "Als het een afkorting is van {{duration}} seconden, zal Voxnela het voltooien terwijl de betekenis behouden blijft.",
      "voiceNatural": "Voxnela past alleen de grammatica, formulering en natuurlijke flow aan.",
      "removeFile": "{{name}}-bestand verwijderen",
      "musicStop": "Stop {{title}}",
      "musicListen": "Luister naar {{title}}",
      "automatic": "auto",
      "all": "alles",
      "cinematic": "filmisch",
      "social": "Sociaal & Dynamisch",
      "designTypography": "Ontwerp & Typografie",
      "retroExperimental": "Retro & Experimenteel",
      "productionStage1": "Het selecteren van de sterkste kaders en scènes.",
      "productionStage2": "Het opbouwen van het verhaal, de beweging en de overgangen.",
      "productionStage3": "Balans tussen muziek, stem en ondertitels.",
      "productionStage4": "Laatste controles uitvoeren op de live preview.",
      "genericCreationError": "Er is een probleem opgetreden tijdens het voorbereiden van het videoplan. Uw materialen en keuzes worden bewaard; u kunt het opnieuw proberen.",
      "newVideo": "Nieuwe video",
      "topicNews": "nieuws",
      "topicDocumentary": "documentaire",
      "topicExplainer": "Uitleggever",
      "topicStory": "verhaal",
      "topicScience": "wetenschap",
      "topicPhilosophy": "filosofie",
      "topicMagazine": "tijdschrift",
      "topicEntertainment": "vermaak",
      "topicList": "lijst",
      "toneCalm": "kalm",
      "toneEmotional": "emotioneel",
      "toneEnergetic": "energiek",
      "toneStorytelling": "Verhalen vertellen",
      "toneCheerful": "vrolijk",
      "toneMysterious": "mysterieus",
      "toneNews": "nieuws",
      "styleCinematic": "filmisch",
      "styleDarkCinematic": "Donkere cinematografische",
      "styleDocumentary": "documentaire",
      "styleModernDocumentary": "Moderne documentaire",
      "stylePovImmersive": "Meeslepende POV",
      "styleUgcAuthentic": "Authentieke UGC",
      "styleMiniVlog": "Mini Vlog",
      "styleSocialViral": "Sociaal viraal",
      "styleHyperEdit": "Hyper-edit",
      "styleSportsHype": "Sporthype",
      "styleVelocityEdit": "Snelheidsbewerking",
      "styleMusicBeatEdit": "Muziek Beat Bewerking",
      "styleKineticTypography": "Kinetische typografie",
      "styleMinimalClean": "Minimaal & Schoon",
      "styleLuxuryMinimal": "Luxueus Minimalistisch",
      "styleCommercialProduct": "Commercieel product",
      "styleEditorialFashion": "Redactionele Mode",
      "styleCollageZine": "Collage Zine",
      "styleTechFuturistic": "Technologisch futuristisch",
      "styleRetroFuturism": "Retrofuturisme",
      "styleY2kDigital": "Y2K Digitaal",
      "styleVhsCamcorder": "VHS-camcorder",
      "styleAnalogFilm": "Analoge film",
      "styleGlitchCyber": "Glitch Cyber",
      "musicUpbeatMood": "Energiek · helder",
      "musicUpbeatDetail": "Echte instrumentale opnames voor vrolijke sociale content, reismomenten en levendige bewerkingen.",
      "musicElectronicMood": "Modern · ritmisch",
      "musicElectronicDetail": "Echte elektronische muziek voor steden, technologie, producten en snelle bewerkingen.",
      "musicRomanceMood": "Emotioneel · warm",
      "musicRomanceDetail": "Instrumentale muziek met een zachte emotionele boog voor familie, portretten, speciale dagen en herinneringen.",
      "musicScoringMood": "Narratief · cinematisch",
      "musicScoringDetail": "Cinematische achtergrondmuziek ter ondersteuning van verhalen, promoties en dramatische overgangen.",
      "musicEpicMood": "Krachtig · stijgend",
      "musicEpicDetail": "Gelaagde instrumentale muziek die zich opbouwt voor grote openingen, reizen en sterke finales.",
      "proposalBalancedTitle": "Gebalanceerd verhaal",
      "proposalBalancedSummary": "Een bewerking die de stroom van het materiaal behoudt en de sterkste frames benadrukt.",
      "proposalBalancedVisual": "Sterke hiërarchie en een coherent visueel systeem",
      "proposalBalancedTransitions": "Gladde sneden en gemeten duwinknappen",
      "proposalBalancedMusic": "Muziek die beweegt van emotie naar ritme",
      "proposalQuietTitle": "Stille verhaal",
      "proposalQuietSummary": "Een kalme aanpak die kaders meer tijd geeft en detail en natuurlijke emotie benadrukt.",
      "proposalQuietVisual": "Zachte tinten en langere opnames",
      "proposalQuietTransitions": "Kruis oplost en langzame pannen",
      "proposalQuietMusic": "Eenvoudige en emotionele muziek",
      "proposalRhythmicTitle": "Ritmische bewerking",
      "proposalRhythmicSummary": "Een bewerking met een sterke openingshaak die zich in het midden versnelt en aan het einde duidelijk afvalt.",
      "proposalRhythmicVisual": "Sterker contrast en dynamische kadering",
      "proposalRhythmicTransitions": "Beat-sneden en gecontroleerde zwaaiovergangen",
      "proposalRhythmicMusic": "Energiek, opkomende muziek",
      "underVoiceover": "zacht onder de voice-over",
      "withShortVoiceover": "met een korte, krachtige voice-over"
    },
    "information": {
      "home": "thuis",
      "documentInfo": "Documentinformatie",
      "version": "Versie",
      "effective": "Geldig vanaf",
      "updated": "Laatst bijgewerkt",
      "contents": "Inhoud",
      "officialReferences": "Officiële referenties",
      "referenceTitle": "Wetgeving en autoriteitsbronnen",
      "referenceBody": "Deze links worden verstrekt ter algemene informatie. De wettelijke voorschriften en huidige regels van de bevoegde autoriteiten prevaleren.",
      "supportKicker": "Ondersteuning van Sponelabs",
      "contactTitle": "Contact opnemen",
      "contactLead": "Neem contact op met het Voxnela-ondersteuningsteam over uw account, lidmaatschap, betaling, creatie, inhoudsrapporten, privacy of technische problemen.",
      "supportEmail": "Support-e-mail",
      "emailBody": "De knop hieronder opent uw standaard e-mailapp met een kant-en-klaar ondersteuningssjabloon, zodat we sneller kunnen onderzoeken.",
      "openEmail": "E-mailapp openen",
      "includeTitle": "Vermeld in je bericht",
      "includeItems": [
        "Of je nu Web, iOS of Mac gebruikt;",
        "Uw apparaat en besturingssysteemversie;",
        "Stappen om het probleem te reproduceren;",
        "De gerelateerde projectlink, transactiedetails of screenshot, indien beschikbaar."
      ],
      "sensitiveTitle": "Stuur geen gevoelige gegevens",
      "sensitiveBody": "Voeg geen verificatiecodes, wachtwoorden, volledige betaalkaartgegevens, identiteitsdocumenten, gezondheidsgegevens of andere gevoelige informatie toe die niet vereist zijn om het probleem op te lossen.",
      "securityTitle": "Beveiliging en inhoud melden",
      "securityBody": "Gebruik “Beveiliging” voor een kwetsbaarheid, “Privacyverzoek” voor een gegevensverzoek, of “Inhoudsrapport” voor schadelijke of inbreukmakende inhoud. Neem contact op met de lokale hulpdiensten in geval van onmiddellijk fysiek gevaar.",
      "mailSubject": "Voxnela ondersteuningsverzoek",
      "mailGreeting": "Hallo Voxnela Supportteam,",
      "mailTopic": "Ondersteunend onderwerp:",
      "mailPlatform": "Platform (Web / iOS / Mac):",
      "mailDevice": "Apparaat en besturingssysteem:",
      "mailProject": "Project-ID (indien beschikbaar):",
      "mailDescription": "Beschrijving van het probleem of verzoek:",
      "mailThanks": "Bedankt.",
      "termsEyebrow": "Voxnela gebruiksvoorwaarden",
      "termsTitle": "Gebruiksvoorwaarden",
      "termsLead": "Deze voorwaarden regelen het gebruik van AI-afbeeldingscreatie- en bewerkingsdiensten in de Voxnela-web- en iOS-apps.",
      "privacyEyebrow": "Voxnela gegevensgebruik",
      "privacyTitle": "Privacybeleid",
      "privacyLead": "Dit beleid legt uit hoe account, afbeelding, project, lidmaatschap en technische gegevens worden verwerkt in de Voxnela afbeeldingscreatie service.",
      "officialTurkishNotice": "Deze vertaling wordt verstrekt ter gemak. De Turkse wettelijke tekst bepaalt of de betekenissen verschillen."
    }
  },
  "ar": {
    "ui": {
      "home": "الرئيسية",
      "homeTitle": "المنزل",
      "explore": "استكشاف",
      "gallery": "المعرض",
      "myImages": "صوري",
      "settings": "الإعدادات",
      "createImage": "إنشاء صورة",
      "back": "رجوع",
      "search": "بحث",
      "account": "الحساب",
      "login": "تسجيل الدخول",
      "logout": "تسجيل الخروج",
      "profile": "الملف الشخصي",
      "profileSettings": "الملف الشخصي والإعدادات",
      "plans": "الخطط والاستخدام",
      "plansSubtitle": "اعتمادات الصورة والرسوم البيانية",
      "contact": "اتصل بنا",
      "contactSubtitle": "المساعدة والتغذية الراجعة",
      "discoverVoxnela": "اكتشف Voxnela",
      "discoverVoxnelaSubtitle": "راجع تجربة الاستوديو البصري",
      "privacy": "الخصوصية",
      "privacySubtitle": "كيف يتم حماية بياناتك",
      "terms": "شروط الاستخدام",
      "termsSubtitle": "شروط خدمة Voxnela",
      "preferencesSubtitle": "حسابك وتفضيلات Voxnela",
      "accountSubtitle": "تفاصيل الحساب والعضوية",
      "voxAccount": "حساب Voxnela",
      "accessEverywhere": "الوصول إلى صورك على كل جهاز",
      "imageRights": "{{count}} حقوق الصورة",
      "availableCredits": "الائتمانات المتاحة",
      "renewalDate": "تاريخ التجديد",
      "membershipStart": "بدأت العضوية",
      "registrationDate": "تاريخ التسجيل",
      "monthly": "شهري",
      "renewalOff": "إيقاف التجديد",
      "user": "مستخدم Voxnela",
      "language": "اللغة",
      "languageSubtitle": "اختر لغة التطبيق",
      "supportBody": "أرسل لنا رسالة إذا كان لديك مشكلة أو ترغب في مشاركة فكرة. يساعدنا تضمين معرف المشروع على الرد بشكل أسرع.",
      "studioTitle": "استوديو Voxnela للصور",
      "studioSubtitle": "ابتكر أسلوبك",
      "searchSubtitle": "صورك ومشاريعك",
      "searchPlaceholder": "ابحث عن صورة أو مشروع",
      "noSearchResults": "لم يتطابق شيء مع هذا البحث.",
      "project": "مشروع",
      "image": "صورة",
      "completed": "مكتمل",
      "currentPlan": "الخطة الحالية",
      "notSignedIn": "غير مسجل الدخول",
      "signInIntro": "سجل الدخول لبدء استخدام Voxnela.",
      "creditsAvailable": "حقوق الصورة الاستوديو {{count}} متاحة.",
      "noCredits": "ليس لديك أي رصيد لصور متبقي في هذه الفترة.",
      "membershipInfo": "تجدد رصيد الخطة السنوية كل شهر ولا يتم تحويله إلى حساب آخر. تظل المشتريات المستعادة محمية عبر حسابك.",
      "signedOutMembershipInfo": "بعد تسجيل الدخول، ستظهر رصيد الصور المتاح ومعلومات الخطة هنا.",
      "reviewPlans": "عرض الخطط",
      "versionUpdated": "النسخة {{version}} · آخر تحديث {{date}}",
      "onboardingWelcome": "مرحبًا بك في Voxnela",
      "skipIntro": "تخطي المقدمة",
      "continue": "متابعة",
      "startCreating": "ابدأ الإنشاء",
      "close": "إغلاق",
      "dragToClose": "اسحب لأسفل لإغلاق الورقة",
      "loading": "تحميل...",
      "sheetExpand": "ورقة توسيع",
      "sheetCollapse": "ورقة العودة إلى الارتفاع الطبيعي",
      "cannotClose": "لا يمكن إغلاقها أثناء إجراء العملية",
      "stylePreview": "معاينة الأسلوب",
      "stylePreviewSubtitle": "أنماط وتوجهات التوقيع",
      "categories": "الفئات",
      "useThisStyle": "استخدم هذا الأسلوب",
      "videoControls": "تحكمات الفيديو",
      "play": "العب",
      "pause": "توقف",
      "mute": "صامت",
      "unmute": "إيقاف الإيقاف",
      "minimize": "تقليل",
      "expandVideo": "التوسع في التطبيق",
      "videoProgress": "تقدم الفيديو",
      "toggleVideoControls": "إظهار أو إخفاء عناصر التحكم في الفيديو",
      "expandedVideo": "{{title}} عرض فيديو موسع",
      "goToImage": "انتقل إلى صورة {{title}}",
      "categoryVisualStyles": "{{category}} أنماط بصرية",
      "onboarding1Eyebrow": "إنشاء الصور",
      "onboarding1Title": "أنشئ صورتك.",
      "onboarding1Body": "حول فكرتك إلى إطار سينمائي مع فيلم 35 مم، ومحرر، ومنتج، وملصق وغيرها الكثير من أنماط التصوير البصري.",
      "onboarding2Eyebrow": "تجربة الملابس افتراضيًا",
      "onboarding2Title": "جرّب إطلالات جديدة.",
      "onboarding2Body": "حافظ على الهوية عبر الإنتاجات وأنشئ صورًا واقعية للموضة والإكسسوارات والمنتجات للتجربة.",
      "onboarding3Eyebrow": "تعديل الصور",
      "onboarding3Title": "عدّل صورتك.",
      "onboarding3Body": "راجع التكوين والإضاءة واللون والتفاصيل بشكل تفاعلي دون البدء من جديد.",
      "onboarding4Eyebrow": "3 صور مجانية",
      "onboarding4Title": "ابدأ مجانًا.",
      "onboarding4Body": "ابدأ الآن مع 3 عمليات إنشاء صور مجانية بالذكاء الاصطناعي لمرة واحدة. لا حاجة إلى حساب.",
      "onboardingFaceEyebrow": "تحليل الوجه والأسلوب",
      "onboardingFaceTitle": "اكتشف وجهك وأسلوبك.",
      "onboardingFaceBody": "استكشف أفكارًا للشعر والنظارات والملابس انطلاقًا من صورتك الشخصية في دليل مرئي واحد.",
      "onboardingHouseEyebrow": "السفر عبر الزمن",
      "onboardingHouseTitle": "سافر عبر الزمن.",
      "onboardingHouseBody": "اجمع صورك وتواريخك لتصور كيف تغير منزلك بمرور الوقت.",
      "onboardingFestivalEyebrow": "يوم المهرجان",
      "onboardingFestivalTitle": "خطط ليوم المهرجان بنظرة واحدة.",
      "onboardingFestivalBody": "حوّل البرنامج والمنصات والمواعيد التي تقدمها إلى مسار مرئي شخصي.",
      "onboardingStylesEyebrow": "أنماط Voxnela",
      "onboardingStylesTitle": "اختر أسلوبك.",
      "onboardingStylesBody": "حول فكرتك إلى إطار سينمائي مع فيلم 35 مم، ومحرر، ومنتج، وملصق وغيرها الكثير من أنماط التصوير البصري."
    },
    "auth": {
      "enterCode": "أدخل الرمز",
      "membershipAndAccount": "تفاصيل العضوية والحساب",
      "noPeriodInfo": "فترة غير متوفرة",
      "memberSince": "عضو منذ",
      "planSince": "{{plan}} منذ",
      "membershipRenewal": "تاريخ تجديد العضوية",
      "accountActions": "إجراءات الحساب",
      "manageSubscriptionTitle": "إنهاء الاشتراك",
      "manageSubscriptionSubtitle": "إدارة اشتراك متجرك والتجديد التلقائي.",
      "deleteAccountTitle": "حذف حسابي",
      "deleteAccountSubtitle": "عملية الحذف القابلة للعكس لمدة 15 يومًا.",
      "deleteDataTitle": "حذف بياناتي",
      "deleteDataSubtitle": "عملية حذف البيانات لمدة 30 يومًا قابلة للعكس.",
      "signingOut": "جارٍ تسجيل الخروج…",
      "signOut": "تسجيل الخروج",
      "signingIn": "جارٍ تسجيل الدخول…",
      "continueApple": "المتابعة باستخدام Apple",
      "continueGoogle": "المتابعة باستخدام Google",
      "or": "أو",
      "email": "البريد الإلكتروني",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "من خلال الاستمرار في استخدام Voxnela، فإنك تقبل",
      "legalTerms": "شروط الاستخدام",
      "legalJoin": "وتأكد من أنك قرأت وفهمت",
      "legalPrivacy": "إشعار الخصوصية",
      "legalSuffix": ".",
      "sendingCode": "جارٍ إرسال الرمز…",
      "emailSignIn": "تسجيل الدخول بالبريد الإلكتروني",
      "codeSent": "أرسلنا رمزًا إلى {{email}}.",
      "change": "تغيير",
      "sixDigitCode": "رمز من 6 أرقام",
      "emailCode": "رمز تسجيل الدخول عبر البريد الإلكتروني",
      "verifyingCode": "جارٍ التحقق…",
      "resendCode": "إعادة إرسال الرمز",
      "requestReceived": "تم استلام الطلب",
      "accountDeletionStarted": "بدأت عملية حذف حسابك",
      "dataDeletionStarted": "بدأ عملية حذف بياناتك",
      "accountAction": "إجراء الحساب",
      "accountDeletesAt": "سيتم حذف حسابك بشكل دائم على {{date}}.",
      "dataDeletesAt": "سيتم حذف بيانات Voxnela الشخصية الخاصة بك بشكل دائم على {{date}}.",
      "deletionUndo": "إذا قمت بتسجيل الدخول باستخدام نفس الحساب قبل هذا التاريخ، سيتم إلغاء عملية الحذف تلقائيًا. تم إغلاق جلستك الحالية لأن الطلب تم إنشاؤه.",
      "done": "تم",
      "cancel": "إلغاء",
      "preparing": "التحضير...",
      "invalidEmail": "أدخل عنوان بريد إلكتروني صالح.",
      "enterSixDigitCode": "أدخل الرمز المكون من 6 أرقام المرسل إلى بريدك الإلكتروني.",
      "signInFailed": "تعذر إكمال تسجيل الدخول. يرجى المحاولة مرة أخرى.",
      "codeSendFailed": "تعذر إرسال رمز تسجيل الدخول. يرجى المحاولة مرة أخرى.",
      "codeVerifyFailed": "تعذر التحقق من الرمز. يرجى المحاولة مرة أخرى.",
      "operationFailed": "تعذر إكمال العملية في الوقت الحالي. يرجى المحاولة مرة أخرى.",
      "popupClosed": "تم إغلاق نافذة تسجيل الدخول.",
      "unauthorizedDomain": "هذا النطاق غير مصرح به لتسجيل الدخول.",
      "methodUnavailable": "طريقة تسجيل الدخول هذه غير مفعلة بعد.",
      "tooManyCodes": "تم طلب الكثير من الرموز. حاول مرة أخرى خلال بضع دقائق.",
      "invalidCode": "الرمز غير صالح أو منتهي الصلاحية. اطلب رمزًا جديدًا.",
      "emailUnavailable": "التسليم عبر البريد الإلكتروني غير متاح حاليًا.",
      "actions": {
        "subscription": {
          "eyebrow": "إجراء الاشتراك",
          "title": "هل انتهت اشتراكك؟",
          "confirm": "إدارة الاشتراكات",
          "paragraphs": [
            "يفتح الاستمرار صفحة إدارة اشتراك متجر Apple App Store أو Google Play حيث اشتريت الاشتراك. يجب عليك إيقاف التجديد التلقائي في المتجر.",
            "بعد الإلغاء، تظل مزايا عضويتك الحالية متاحة حتى نهاية الفترة المدفوعة. حذف حسابك أو بياناتك لا يلغي اشتراك المتجر."
          ]
        },
        "account": {
          "eyebrow": "إجراءات الحساب الدائم",
          "title": "هل أنت متأكد من أنك تريد حذف حسابك؟",
          "confirm": "ابدأ عملية الحذف لمدة 15 يومًا",
          "paragraphs": [
            "يبدأ الاستمرار عملية حذف لمدة 15 يومًا ويؤدي إلى تسجيل خروجك لأغراض أمنية. إذا لم تسجل الدخول مرة أخرى خلال هذه الفترة، سيتم حذف حسابك وملفك الشخصي وإنشائاتك والمكتبة والمجموعات وبيانات Voxnela ذات الصلة بشكل دائم.",
            "تسجيل الدخول باستخدام نفس الحساب قبل 15 يوماً يلغي الحذف تلقائياً. حذف الحساب لا يلغي اشتراك المتجر النشط؛ قم بإلغائه بشكل منفصل في المتجر."
          ]
        },
        "data": {
          "eyebrow": "إجراءات بيانات دائمة",
          "title": "هل أنت متأكد من أنك تريد حذف بياناتك؟",
          "confirm": "ابدأ عملية الحذف لمدة 30 يومًا",
          "paragraphs": [
            "يبدأ الاستمرار عملية حذف لمدة 30 يوماً ويؤدي إلى تسجيل خروجك لأغراض أمنية. إذا لم تسجل الدخول مرة أخرى خلال هذه الفترة، سيتم حذف إبداعاتك والمكتبة والمجموعات والسجلات والتفاعلات وبيانات Voxnela الشخصية الأخرى بشكل دائم؛ وسيظل حساب تسجيل الدخول الخاص بك متاحاً.",
            "سيؤدي تسجيل الدخول مرة أخرى قبل 30 يوماً إلى إلغاء حذف البيانات تلقائياً. قد يتم الاحتفاظ بالسجلات التجارية والأمنية المحدودة التي يطلبها القانون مع الوصول المقيد للفترات القانونية المعنية."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "لا توجد رصيد لصور متبقي",
      "quotaFreeMessage": "لقد استخدمت رصيد الصورة في حسابك المجاني. اختر خطة لمواصلة الإبداع.",
      "later": "لاحقا",
      "currentCredit": "الرصيد الحالي: 0",
      "quotaProTitle": "تم الوصول إلى حصة Pro الشهرية",
      "quotaProMessage": "لقد استخدمت رصيد 100 صورة لهذا الشهر. قم بالترقية إلى Studio لمواصلة الإبداع.",
      "renewalDate": "تاريخ التجديد: {{date}}",
      "quotaStudioTitle": "تم الوصول إلى حصة الاستوديو الشهرية",
      "quotaStudioMessage": "سيتم تجديد رصيد صورك تلقائيًا على {{date}}.",
      "done": "تم",
      "membership": "عضوية Voxnela",
      "options": "خيارات العضوية",
      "credits": "أرصدة",
      "currentMembership": "العضوية الحالية",
      "yearlyDiscount": "خصم 17٪",
      "loadingPrice": "جارٍ تحميل سعر المتجر…",
      "loadingStorePrice": "تحميل السعر من المتجر",
      "year": "سنة",
      "month": "شهر",
      "renewDisclosure": "يتم التجديد تلقائيًا لكل {{period}}. إلغاء في أي وقت.",
      "legal": "قانوني",
      "terms": "الشروط",
      "alreadyMember": "لديك بالفعل {{plan}} {{period}}",
      "startPlan": "ابدأ خطة {{plan}}",
      "upgradeStudio": "الترقية إلى Studio",
      "yearlyAdvantage": "تحويل إلى الادخار السنوي",
      "upgrade": "ترقية العضوية",
      "signInRequired": "سجل الدخول إلى حساب Voxnela الخاص بك قبل بدء الاشتراك.",
      "catalogUnavailable": "تعذر التحقق من كتالوج الدفع لهذا الخطة. يرجى المحاولة مرة أخرى قريبًا.",
      "paymentUnavailable": "تعذر فتح شاشة الدفع. يرجى المحاولة مرة أخرى.",
      "benefits": [
        {
          "lead": "{{credits}} الاعتمادات",
          "label": "توليد صورة عالية الدقة كل شهر"
        },
        {
          "lead": "أكثر من 50 نمط استوديو",
          "label": "الحد الأدنى الجديد، السينمائي وكل طراز مميز"
        },
        {
          "lead": "قفل الوجه",
          "label": "تجربة الأزياء الافتراضية دون تغيير ملامح الوجه"
        },
        {
          "lead": "سلسلة انتظار الأولوية",
          "label": "معالجة GPU فائقة السرعة بدون انتظار"
        },
        {
          "lead": "مراجعات الدردشة",
          "label": "تحرير تفصيلي غير محدود متعدد الجولات باللغة الطبيعية"
        },
        {
          "lead": "الحقوق التجارية الكاملة",
          "label": "استخدام عالي الدقة وخالي من العلامات المائية"
        }
      ],
      "restorePurchases": "استعادة المشتريات",
      "restoringPurchases": "استعادة المشتريات...",
      "restoreSuccess": "تم استعادة عضويتك.",
      "restoreEmpty": "لم يتم العثور على اشتراك نشط لهذا حساب متجر التطبيقات.",
      "membershipSyncPending": "التحقق من العضوية وائتمانات الصورة...",
      "membershipSyncFailed": "تعذّرت مزامنة أرصدة الصور. حاول مرة أخرى.",
      "membershipUnavailable": "تعذّر تحميل العضوية.",
      "retry": "حاول مرة أخرى"
    },
    "video": {
      "revisionHook": "اجعل الثواني الثلاث الأولى أكثر تشويقًا.",
      "revisionPace": "وازن وتيرة العمل واختصر الأقسام البطيئة.",
      "revisionEnding": "اجعل النهاية أكثر ذكاءً.",
      "revisionTransition": "اجعل الانتقالات أكثر سلاسة وطبيعية.",
      "revisionFraming": "استخدم إطارًا أكثر توازنًا للتفاصيل المهمة.",
      "revisionColor": "اجعل الألوان أكثر توازنًا وسينمائية.",
      "revisionText": "اجعل النص أقصر وأسهل في القراءة.",
      "revisionAudio": "طابق الموسيقى بشكل أقرب مع إيقاع الصور.",
      "revisionEmotion": "اجعل القصة تبدو أكثر صدقًا وعاطفية.",
      "revisionStructure": "بناء بداية ووسط ونهاية أوضح.",
      "previewBack": "العودة إلى المعاينة",
      "revisionWelcome": "ماذا ترغب في التغيير؟",
      "revisionFailed": "لم أستطع تطبيق هذا التغيير. هل يمكنك وصفه مرة أخرى؟",
      "finalQueued": "الفيديو النهائي في قائمة الانتظار. سيظهر تحت الفيديوهات عندما يكون جاهزًا.",
      "watermarkUpgrade": "اختر خطة لإنشاء مخرجات نهائية جديدة دون علامة مائية Voxnela.",
      "finalFailed": "لم يتمكن الفيديو النهائي من البدء.",
      "projectDeleteFailed": "تعذر حذف المشروع.",
      "videoDescriptionWithBrief": "تم إنشاء هذا الفيديو من \"{{brief}}\". اختارت Voxnela أقوى اللحظات وبنت الإيقاع وترتيب المشهد حول الاتجاه الإبداعي المختار.",
      "videoDescriptionGeneric": "قامت Voxnela بتقييم المواد من حيث المحتوى والسرعة والتناسق السردي، مع تسليط الضوء على أقوى اللحظات لتحرير متوازن.",
      "play": "العب",
      "deletesOn": "يحذف على {{date}}",
      "projectsBelong": "مشاريعك مرتبطة بحسابك.",
      "videosBelong": "فيديوهاتك مرتبطة بحسابك.",
      "signInToSeeProjects": "سجل الدخول لعرض مشاريعك والاستمرار عبر الأجهزة.",
      "signInToSeeVideos": "سجل الدخول لعرض مقاطع الفيديو الخاصة بك والاستمرار عبر الأجهزة.",
      "delete": "حذف",
      "deleting": "جارٍ الحذف…",
      "secondsVersion": "{{seconds}} ثانية · الإصدار {{version}}",
      "deleteProject": "حذف المشروع",
      "projectCoverUnavailable": "تعذر تحميل غطاء المشروع",
      "videoCoverPreparing": "تحضير غطاء الفيديو",
      "deleteVideo": "حذف الفيديو",
      "signed": "مرسومة بعلامة Voxnela التجارية",
      "failed": "تعذر الإكمال",
      "tryAgain": "يمكنك المحاولة مرة أخرى",
      "cancelled": "ملغى",
      "noCreditUsed": "لم يتم استخدام أي رصيد",
      "featuredStyles": "أنماط بصرية مميزة",
      "previousImage": "الصورة السابقة",
      "nextImage": "الصورة التالية",
      "reviewStyle": "استكشف هذا الأسلوب",
      "featuredNavigation": "التنقل البصري المميز",
      "taskCategories": "فئات المهام",
      "projectOpening": "مشروع افتتاحي",
      "opening": "الافتتاح...",
      "projectNotFound": "المشروع غير موجود",
      "projectUnavailable": "لم يعد هذا المشروع متاحًا.",
      "backToProjects": "العودة إلى مشاريعي",
      "editVideo": "تحرير الفيديو",
      "versionContext": "النسخة {{version}} · يعرف Voxnela مشروعك وموادك",
      "livePreviewActions": "إجراءات المعاينة الحية",
      "edit": "تعديل",
      "preparing": "جارٍ التحضير",
      "save": "حفظ",
      "thinking": "فكسنيلا تفكر",
      "revisionSuggestions": "اقتراحات التحرير",
      "describeChange": "صف التغيير الذي تريده",
      "sendEdit": "إرسال طلب تعديل",
      "deleteProjectDescription": "هل أنت متأكد من رغبتك في حذف “{{title}}” وجميع المواد ذات الصلة؟ لا يمكن إلغاء ذلك.",
      "projects": "المشاريع",
      "projectsPreparing": "تحضير مشاريعك",
      "noProjects": "ليس لديك مشروع بعد. ابدأ بوصف فكرتك الأولى.",
      "createNew": "إنشاء صورة جديدة",
      "thisProject": "هذا المشروع",
      "videos": "الفيديوهات",
      "videosPreparing": "تحضير مقاطع الفيديو الخاصة بك",
      "noVideos": "ليس لديك فيديو مكتمل بعد. سيظهر هنا عندما يكون الفيديو الأول جاهزًا.",
      "videoPlayFailed": "تعذر تشغيل الفيديو.",
      "videoNotReady": "ملف الفيديو غير جاهز للتنزيل بعد.",
      "videoDownloadFailed": "تعذر تحميل الفيديو.",
      "videoDeleteFailed": "تعذر حذف الفيديو.",
      "videoLoading": "تحميل الفيديو...",
      "videoActions": "إجراءات الفيديو",
      "showVideoDescription": "إظهار وصف الفيديو",
      "videoDownloading": "تحميل الفيديو",
      "downloadVideo": "تحميل الفيديو",
      "thisVideo": "هذا الفيديو",
      "deleteVideoDescription": "هل أنت متأكد من رغبتك في حذف الفيديو بعنوان \"{{title}}\"؟ لا يمكن إلغاؤه."
    },
    "studio": {
      "useStyle": "استخدم هذا الأسلوب",
      "galleryFilters": "فلاتر المعرض",
      "modeStyleTransfer": "أنماط فوكسنيلا",
      "modeVirtualTryOn": "تجربة افتراضية",
      "modeMagazineCover": "مجلة وغلاف",
      "modePosterStudio": "استوديو الملصقات",
      "modeCommercial": "عرض المنتجات",
      "modeTimeWarp": "السفر عبر الزمن",
      "modeOutpaintRelight": "توسيع وإعادة الإضاءة",
      "modeInfographic": "إنفوجرافيك وبيانات",
      "modePortraitRetouch": "إعادة تلوين الصورة الشخصية",
      "modeArtisticCollage": "مجموعة فنية",
      "defaultStyle": "أسلوب فوكسنيلا",
      "signInToCreate": "سجل الدخول لإنشاء صورة.",
      "signInToEdit": "تسجيل الدخول لتحرير صورة.",
      "creationSuccess": "تم إنشاء صورتك بنجاح. أخبرني مباشرة إذا كنت ترغب في تغيير الإضاءة أو الألوان أو الأجسام أو الإطار.",
      "imageReady": "صورتك جاهزة أخبرني ما الذي يعجبك أو ما الذي تريد مراجعته",
      "revisionSuccess": "تم الانتهاء من المراجعة. يمكنك مقارنتها مع شريط التمرير قبل/بعد أو طلب تغيير آخر.",
      "versionReady": "النسخة {{version}} جاهزة.",
      "projectNotFound": "لم يتم العثور على المشروع.",
      "styleApplied": "تم تطبيق نمط {{style}}",
      "imageCreation": "إنشاء الصورة",
      "defaultPrompt": "صورة الاستوديو",
      "aspectSquare": "مربع",
      "aspectSquareDetail": "قائمة إنجسترام، الملف الشخصي، الفن",
      "aspectVertical": "عمودي",
      "aspectVerticalDetail": "قصص إنستغرام، ريلز، تيك توك",
      "aspectHorizontal": "أفقي",
      "aspectHorizontalDetail": "يوتيوب، بانر، سينما",
      "aspectPortrait": "بورتريه",
      "aspectPortraitDetail": "صورة شخصية على إنستغرام، ملصق، عرض تقديمي",
      "aspectPanoramic": "بانورامي",
      "aspectPanoramicDetail": "مناظر طبيعية سينمائية واسعة جدًا",
      "styles": "أنماط Voxnela",
      "fullScreenStyle": "عرض نمط الشاشة الكاملة",
      "closeDescription": "وصف النمط القريب",
      "moreWithVoxnela": "افعل المزيد مع Voxnela",
      "quickStartBody": "اكتب ما تريد أدناه أو أرفق ملفًا.",
      "createImage": "إنشاء صورة",
      "createImageDetail": "قم ببناء فكرتك من الصفر",
      "editImage": "تعديل الصورة",
      "editImageQuick": "تحرير صورة",
      "editImageDetail": "أعاد تخيل صورة تم تحميلها",
      "transformStyle": "تحويل الأسلوب والمشهد",
      "transformStyleDetail": "انقل صورتك إلى عالم آخر",
      "visualizeDocument": "تصور مستندًا أو عرضًا تقديميًا",
      "visualizeDocumentDetail": "حول المحتوى الكامل إلى تصميم",
      "submittedImage": "الصورة المقدمة",
      "generating": "يُنشئ Voxnela صورتك…",
      "viewImage": "عرض الصورة",
      "removeStyle": "إزالة النمط المحدد",
      "referenceImage": "صورة مرجعية",
      "referenceNotice": "سيتم مراجعة هذه الصورة أو تطبيق أسلوب جديد",
      "removeReference": "إزالة صورة المرجع",
      "remove": "إزالة",
      "uploading": "رفع",
      "addFile": "أضف ملفًا أو صورة",
      "addFileTitle": "أضف حتى 4 صور أو مستند (PDF، Word، PPT، بحد أقصى 12 ميجابايت)",
      "aspectRatio": "نسبة الأبعاد",
      "selectAspectRatio": "حدد نسبة العرض إلى الارتفاع",
      "aspectOptions": "خيارات نسبة الأبعاد",
      "revisePlaceholder": "ماذا ترغب في تغييره في هذه الصورة؟",
      "styledPlaceholder": "صف الصورة التي تريدها بهذا الأسلوب (اختياري)...",
      "promptPlaceholder": "وصف صورة أو اكتب طلبًا...",
      "reviseImage": "راجع الصورة",
      "generateImage": "إنشاء صورة",
      "generatedImage": "صورة تم إنشاؤها",
      "done": "تم",
      "fileLimitTitle": "الملف كبير جدًا",
      "fileLimitMessage": "يتجاوز \"{{name}}\" حد 12 ميجابايت ({{size}} ميجابايت). اختر ملفًا أصغر.",
      "imageLimitTitle": "حد الصورة",
      "imageLimitMessage": "يمكنك رفع ما يصل إلى 4 صور. تم اختيار صور {{count}} حاليًا.",
      "uploadFailedTitle": "فشل التحميل",
      "uploadFailedMessage": "حدثت مشكلة أثناء تحميل الملف.",
      "revisionFailed": "حدث خطأ أثناء المراجعة أو تم تجاوز الحد المسموح به.",
      "generationFailed": "حدث خطأ أثناء إنشاء الصورة أو تم تجاوز الحد المسموح به.",
      "imageDetails": "تفاصيل الصورة",
      "close": "إغلاق",
      "download": "تنزيل",
      "downloadImage": "تحميل الصورة",
      "downloading": "جارٍ التنزيل",
      "versionImage": "صورة",
      "exploreTitle": "ما النمط الذي تبحث عنه؟",
      "explorePlaceholder": "على سبيل المثال: صورة سينمائية بتدرجات ألوان داكنة ومنظور عميق",
      "searchStyles": "البحث في الأنماط",
      "clearSearch": "بحث واضح",
      "exploreCategories": "استكشف الفئات",
      "all": "الكل",
      "styleCount": "{{count}} أنماط",
      "noStyle": "لم يتم العثور على نمط مطابق",
      "noStyleBody": "حاول مرة أخرى بوصف أقصر أو كلمات مختلفة.",
      "libraryKicker": "مكتبة صورك الشخصية",
      "myImages": "صوري",
      "imageWorks": "صورة {{count}} تعمل",
      "newImage": "إنشاء صورة جديدة",
      "noImage": "لم تقم بإنشاء صورة بعد",
      "noCategoryImage": "لا توجد صور في هذه الفئة",
      "emptyGalleryBody": "أنشئ صورتك الأولى مع نقل الأسلوب، والتجربة الافتراضية، أو غلاف المجلة أو عرض المنتجات.",
      "firstImage": "أنشئ صورتك الأولى",
      "imageWork": "عمل الصور"
    },
    "create": {
      "briefTitle": "صف فكرتك أو موضوعك",
      "briefPlaceholder": "ما هو الموضوع؟ على سبيل المثال: مستقبل الذكاء الاصطناعي، رحلة إلى المريخ أو إطلاق منتج…",
      "briefLabel": "ملخص الإبداع",
      "contentType": "نوع المحتوى",
      "media": "الصور ووسائل الإعلام",
      "added": "تم إضافة {{count}}",
      "optional": "اختياري",
      "addMedia": "أضف صورة أو فيديو إذا كنت تريد",
      "addMediaBody": "قم بتحميل وسائطك الخاصة أو اتركها فارغة ودع الذكاء الاصطناعي يجدها",
      "attachedMedia": "المواد المرفقة",
      "add": "أضف",
      "mediaFallback": "وسائل الإعلام",
      "aiCompletes": "دع الذكاء الاصطناعي يكمل الرسوميات",
      "noMedia": "لم يتم تحميل أي صور؛ سيقوم الذكاء الاصطناعي بإكمال المشاهد.",
      "productionFormat": "تنسيق الإنتاج",
      "style": "النمط",
      "customVisualWorld": "صف عالمك البصري",
      "colorsAtmosphere": "الألوان، الجو، الكاميرا، الإيقاع",
      "customStyleShort": "صف العالم البصري الذي في بالك (على سبيل المثال: درجات الألوان الباستيلية وكاميرا هادئة، أو نيون سايبربانك...)",
      "customStyleLong": "صف العالم البصري، والألوان، والجو، والإيقاع الذي في بالك.",
      "voiceover": "التعليق الصوتي",
      "ownVoiceover": "نص التسجيل الصوتي الخاص بك",
      "voiceoverPlaceholder": "اكتب نصك هنا. إذا تركت فارغًا، فستقوم Voxnela بإعداده.",
      "duration": "المدة",
      "seconds": "{{count}} ثانية",
      "freeLimit": "أطول فيديو نهائي في الخطة المجانية هو 60 ثانية.",
      "addSound": "إضافة صوت أو موسيقى",
      "notAdded": "لم يضاف",
      "files": "ملفات {{count}}",
      "readySounds": "استخدم الأصوات الجاهزة",
      "musicLibrary": "مكتبة الموسيقى",
      "uploadOwn": "قم بتحميل الخاص بك",
      "captions": "الترجمة",
      "back": "رجوع",
      "create": "إنشاء",
      "next": "التالي",
      "researchingTopic": "البحث في الموضوع...",
      "analyzingMaterials": "تحليل المواد...",
      "researchBody": "التحقق من المصادر وإعداد السيناريو والخطة البصرية.",
      "analyzeBody": "تقييم الإطارات القوية، والعاطفة، والإيقاع، والملخص معًا.",
      "creativeDirection": "الاتجاه الإبداعي {{count}}",
      "recommended": "موصى به",
      "generationFailed": "لم يتمكن الإبداع من إتمامه",
      "retry": "استعد مرة أخرى",
      "backDirections": "العودة إلى الاتجاهات الإبداعية",
      "preparingVideo": "جارٍ إعداد الفيديو",
      "voiceoverText": "نص التسجيل الصوتي",
      "describeStyle": "صف أسلوبك الخاص",
      "topicDirection": "الموضوع والاتجاه",
      "styleEditorSubtitle": "وصف العالم البصري والألوان والجو",
      "editorSubtitle": "اكتب النص وأدخله في ورقة الإبداع",
      "voiceoverEditorPlaceholder": "اكتب النص لاستخدامه للتعليق الصوتي.",
      "topicEditorPlaceholder": "اكتب الموضوع وكيف تريد أن يتم إخباره.",
      "insertText": "أدخل النص",
      "bestFor": "الأفضل لـ:",
      "useStyle": "استخدم هذا الأسلوب",
      "musicSubtitle": "تم إزالة المسارات الحقيقية للاستخدام التجاري",
      "adding": "إضافة...",
      "musicLicense": "تتم توفير المسارات بموجب CC0 1.0؛ ويسمح باستخدامها التجاري ولا يُطلب الإسناد.",
      "yes": "نعم",
      "no": "لا",
      "newCreation": "إنشاء جديد",
      "reviewing": "فكسنيلا تقوم بمراجعة",
      "chooseDirection": "اختر أحد ثلاثة مناهج لتحرير المحتوى",
      "ideaSubtitle": "صف فكرتك؛ قم بتحميل الصور أو اسمح لـ Voxnela بإنشائها",
      "projectOpenFailed": "تعذر فتح حزمة المشروع.",
      "tooManyAssets": "يمكنك إضافة ما يصل إلى 50 أصلًا إلى مشروع.",
      "uploadSizeLimit": "يتجاوز تحميل المشروع الإجمالي حد 2 جيجابايت.",
      "filesAddFailed": "تعذر إضافة الملفات.",
      "musicPreviewFailed": "تعذر فتح معاينة الموسيقى.",
      "musicFetchFailed": "تعذر استرجاع ملف الموسيقى.",
      "musicAddFailed": "لم يتم إضافة الموسيقى.",
      "topicRequired": "أدخل موضوعًا واشرح ما سيكون حول الفيديو الخاص بك.",
      "briefTooShort": "صف ما تريد أن تخبر به بكلمات قليلة على الأقل.",
      "mediaRequired": "قم بتحميل صورة أو تمكين الرسوم البيانية التي تم إنشاؤها بواسطة الذكاء الاصطناعي.",
      "proposalIntro": "قمت بمراجعة الصور والفيديوهات وأعدت ثلاثة توجيهات لتحرير تناسب أسلوبك وتنسيقك واختياراتك الصوتية.",
      "removeMaterial": "إزالة {{name}}",
      "aiVisualNotice": "تُعثر على الصور الحقيقية المرخصة بشكل مفتوح والرسومات التوضيحية بالذكاء الاصطناعي تلقائيًا.",
      "stepProgress": "خطوة {{current}} من {{total}}",
      "styleSampleAlt": "مثال يوضح أسلوب الفيديو {{style}}",
      "reviewStyle": "راجع نمط {{style}}",
      "selectedDirectionPrompt": "الاتجاه المحدد: {{title}}. {{summary}} الاتجاه البصري: {{visual}}. نهج الانتقال: {{transitions}}. نهج الموسيقى: {{music}}.",
      "letVoxnelaChoose": "دع فوكسنيلا تختار",
      "feminineVoice": "أنثوية",
      "masculineVoice": "ذكري",
      "narrationStyle": "أسلوب السرد",
      "voiceEstimate": "حول {{seconds}} sec · كلمات {{words}}.",
      "voiceShort": "إذا كان اختصارًا لـ {{duration}} ثوانٍ، فستكمل Voxnela ذلك مع الحفاظ على المعنى.",
      "voiceNatural": "تعدل Voxnela فقط القواعد والصياغة والتدفق الطبيعي.",
      "removeFile": "إزالة ملف {{name}}",
      "musicStop": "توقف {{title}}",
      "musicListen": "استمع إلى {{title}}",
      "automatic": "سيارة",
      "all": "كل",
      "cinematic": "سينمائي",
      "social": "اجتماعي وديناميكي",
      "designTypography": "التصميم والخطوط",
      "retroExperimental": "عصري وتجريبي",
      "productionStage1": "اختيار أقوى الإطارات والمشاهد.",
      "productionStage2": "بناء القصة والحركة والانتقالات.",
      "productionStage3": "موازنة الموسيقى والصوت والترجمة.",
      "productionStage4": "يجري التحقق النهائي على العرض التقديمي المباشر.",
      "genericCreationError": "حدثت مشكلة أثناء إعداد خطة الفيديو. تم الحفاظ على موادك وخياراتك؛ يمكنك المحاولة مرة أخرى.",
      "newVideo": "فيديو جديد",
      "topicNews": "أخبار",
      "topicDocumentary": "وثائقي",
      "topicExplainer": "شرح توضيحي",
      "topicStory": "قصة",
      "topicScience": "العلوم",
      "topicPhilosophy": "الفلسفة",
      "topicMagazine": "مجلة",
      "topicEntertainment": "ترفيه",
      "topicList": "قائمة",
      "toneCalm": "هادئ",
      "toneEmotional": "عاطفي",
      "toneEnergetic": "طاقي",
      "toneStorytelling": "سرد القصص",
      "toneCheerful": "مبهج",
      "toneMysterious": "غامض",
      "toneNews": "أخبار",
      "styleCinematic": "سينمائي",
      "styleDarkCinematic": "سينمائي مظلم",
      "styleDocumentary": "وثائقي",
      "styleModernDocumentary": "وثائقي حديث",
      "stylePovImmersive": "منظور غامر",
      "styleUgcAuthentic": "محتوى UGC أصلي",
      "styleMiniVlog": "فيديو قصير",
      "styleSocialViral": "فيروسي اجتماعي",
      "styleHyperEdit": "تحرير عالي التكلفة",
      "styleSportsHype": "ضجة الرياضة",
      "styleVelocityEdit": "تحرير السرعة",
      "styleMusicBeatEdit": "تحرير إيقاع الموسيقى",
      "styleKineticTypography": "الخطوط الديناميكية",
      "styleMinimalClean": "أقل قدر ممكن ونظيف",
      "styleLuxuryMinimal": "رفاهية الحد الأدنى",
      "styleCommercialProduct": "منتج تجاري",
      "styleEditorialFashion": "الموضة التحريرية",
      "styleCollageZine": "كولاج زين",
      "styleTechFuturistic": "تقنية مستقبلية",
      "styleRetroFuturism": "الرترو المستقبلية",
      "styleY2kDigital": "الرقمي Y2K",
      "styleVhsCamcorder": "كاميرا فيديو VHS",
      "styleAnalogFilm": "فلم تناظري",
      "styleGlitchCyber": "خلل سيبراني",
      "musicUpbeatMood": "طاقة · ساطع",
      "musicUpbeatDetail": "تسجيلات موسيقية حقيقية للمحتوى الاجتماعي المبهج، ومقاطع السفر والمقاطع التحريرية الحيوية.",
      "musicElectronicMood": "حديث · إيقاعي",
      "musicElectronicDetail": "موسيقى إلكترونية حقيقية للمدن والتكنولوجيا والمنتجات والتعديلات السريعة.",
      "musicRomanceMood": "عاطفي · دافئ",
      "musicRomanceDetail": "موسيقى آلية مع قوس عاطفي لطيف للعائلة، واللوحات الشخصية، والأيام الخاصة والذكريات.",
      "musicScoringMood": "سردي · سينمائي",
      "musicScoringDetail": "موسيقى الخلفية السينمائية التي تدعم القصص والعروض الترويجية والانتقالات الدرامية.",
      "musicEpicMood": "قوي · متزايد",
      "musicEpicDetail": "موسيقى موسيقية آلية متدرجة تبني من أجل الافتتاحيات الكبرى والرحلات والنهايات القوية.",
      "proposalBalancedTitle": "سرد متوازن",
      "proposalBalancedSummary": "تحرير يحافظ على تدفق المواد ويبرز أقوى الإطارات.",
      "proposalBalancedVisual": "هيكل هرمي قوي ونظام بصري متسق",
      "proposalBalancedTransitions": "قصات سلسة ودفعات مقاسة",
      "proposalBalancedMusic": "الموسيقى التي تنتقل من العاطفة إلى الإيقاع",
      "proposalQuietTitle": "قصة هادئة",
      "proposalQuietSummary": "نهج هادئ يمنح الإطارات المزيد من الوقت ويزيد من التركيز على التفاصيل والعاطفة الطبيعية.",
      "proposalQuietVisual": "درجات ألوان ناعمة ولقطات أطول",
      "proposalQuietTransitions": "يذوب الصليب وتوابل بطيئة",
      "proposalQuietMusic": "موسيقى بسيطة وعاطفية",
      "proposalRhythmicTitle": "تحرير إيقاعي",
      "proposalRhythmicSummary": "تحرير مع حلقة افتتاحية قوية تتسارع في المنتصف وتستقر بوضوح في النهاية.",
      "proposalRhythmicVisual": "تباين أقوى وإطار ديناميكي",
      "proposalRhythmicTransitions": "قطع الإيقاع والانتقالات بالضربات المقيدة",
      "proposalRhythmicMusic": "موسيقى حيوية وصاعدة",
      "underVoiceover": "ناعم تحت المونتاج الصوتي",
      "withShortVoiceover": "مع تسجيل صوتي قصير وحازم"
    },
    "information": {
      "home": "الرئيسية",
      "documentInfo": "معلومات المستند",
      "version": "الإصدار",
      "effective": "ساري من",
      "updated": "آخر تحديث",
      "contents": "المحتويات",
      "officialReferences": "المراجع الرسمية",
      "referenceTitle": "مصادر القوانين والسلطة",
      "referenceBody": "هذه الروابط مقدمة للمعلومات العامة. القانون الإلزامي والقواعد الحالية من السلطات المختصة يأخذان الأولوية.",
      "supportKicker": "دعم Sponelabs",
      "contactTitle": "تواصل معنا",
      "contactLead": "اتصل بفريق دعم Voxnela بخصوص حسابك، العضوية، الدفع، الإنشاء، تقارير المحتوى، الخصوصية أو المشاكل التقنية.",
      "supportEmail": "بريد الدعم",
      "emailBody": "يفتح الزر أدناه تطبيق البريد الإلكتروني الافتراضي الخاص بك مع نموذج الدعم جاهز للاستخدام حتى نتمكن من التحقيق بشكل أسرع.",
      "openEmail": "فتح تطبيق البريد",
      "includeTitle": "أضف إلى رسالتك",
      "includeItems": [
        "سواء كنت تستخدم الويب أو iOS أو Mac؛",
        "نسخة جهازك ونظام التشغيل؛",
        "خطوات إعادة إنتاج المشكلة؛",
        "رابط المشروع ذي الصلة، تفاصيل المعاملة أو لقطة شاشة، إذا كانت متاحة."
      ],
      "sensitiveTitle": "لا ترسل معلومات حساسة",
      "sensitiveBody": "لا تقم بإدراج رموز التحقق أو كلمات المرور أو تفاصيل بطاقة الدفع الكاملة أو وثائق الهوية أو بيانات الصحة أو المعلومات الحساسة الأخرى التي ليست مطلوبة لحل المشكلة.",
      "securityTitle": "الأمان والإبلاغ عن المحتوى",
      "securityBody": "استخدم \"الأمان\" للمخاطر، أو \"طلب الخصوصية\" لطلب البيانات، أو \"تقرير المحتوى\" للمحتوى الضار أو المخالف. اتصل بخدمات الطوارئ المحلية في حال وجود خطر جسدي فوري.",
      "mailSubject": "طلب دعم Voxnela",
      "mailGreeting": "مرحباً فريق دعم Voxnela،",
      "mailTopic": "موضوع الدعم:",
      "mailPlatform": "المنصة (الويب / iOS / Mac):",
      "mailDevice": "الجهاز ونظام التشغيل:",
      "mailProject": "معرف المشروع (إذا كان متاحًا):",
      "mailDescription": "وصف المشكلة أو الطلب:",
      "mailThanks": "شكراً لك.",
      "termsEyebrow": "شروط خدمة Voxnela",
      "termsTitle": "شروط الاستخدام",
      "termsLead": "تنظم هذه الشروط استخدام خدمات إنشاء وتعديل الصور بالذكاء الاصطناعي في موقع Voxnela وتطبيقات iOS.",
      "privacyEyebrow": "استخدام بيانات Voxnela",
      "privacyTitle": "سياسة الخصوصية",
      "privacyLead": "تشرح هذه السياسة كيفية معالجة الحسابات والصور والمشاريع والعضوية والبيانات التقنية في خدمة إنشاء الصور Voxnela.",
      "officialTurkishNotice": "تم توفير هذه الترجمة لراحة المستخدم. ينظم النص القانوني التركي إذا اختلفت المعاني."
    }
  },
  "hi": {
    "ui": {
      "home": "होम",
      "homeTitle": "घर",
      "explore": "खोजें",
      "gallery": "गैलरी",
      "myImages": "मेरी छवियाँ",
      "settings": "सेटिंग्स",
      "createImage": "चित्र बनाएँ",
      "back": "वापस",
      "search": "खोजें",
      "account": "खाता",
      "login": "साइन इन",
      "logout": "साइन आउट",
      "profile": "प्रोफ़ाइल",
      "profileSettings": "प्रोफ़ाइल और सेटिंग्स",
      "plans": "प्लान और उपयोग",
      "plansSubtitle": "छवि क्रेडिट और बिलिंग",
      "contact": "संपर्क",
      "contactSubtitle": "मदद और प्रतिक्रिया",
      "discoverVoxnela": "Voxnela की खोज करें",
      "discoverVoxnelaSubtitle": "विज़ुअल स्टूडियो अनुभव की समीक्षा करें",
      "privacy": "गोपनीयता",
      "privacySubtitle": "आपका डेटा कैसे सुरक्षित है",
      "terms": "उपयोग की शर्तें",
      "termsSubtitle": "Voxnela सेवा की शर्तें",
      "preferencesSubtitle": "आपका खाता और Voxnela प्राथमिकताएँ",
      "accountSubtitle": "खाता और सदस्यता विवरण",
      "voxAccount": "Voxnela खाता",
      "accessEverywhere": "हर डिवाइस पर अपनी छवियों तक पहुंचें",
      "imageRights": "{{count}} छवि क्रेडिट",
      "availableCredits": "उपलब्ध क्रेडिट",
      "renewalDate": "नवीनीकरण तिथि",
      "membershipStart": "सदस्यता शुरू हुई",
      "registrationDate": "रजिस्ट्रेशन तिथि",
      "monthly": "मासिक",
      "renewalOff": "नवीनीकरण बंद",
      "user": "Voxnela उपयोगकर्ता",
      "language": "भाषा",
      "languageSubtitle": "ऐप की भाषा चुनें",
      "supportBody": "यदि आपके पास कोई समस्या है या आप कोई विचार साझा करना चाहते हैं, तो हमसे लिखें। प्रोजेक्ट आईडी शामिल करने से हमें जल्दी प्रतिक्रिया देने में मदद मिलती है।",
      "studioTitle": "Voxnela विज़ुअल स्टूडियो",
      "studioSubtitle": "अपनी शैली बनाएँ",
      "searchSubtitle": "आपकी छवियां और परियोजनाएं",
      "searchPlaceholder": "एक छवि या परियोजना खोजें",
      "noSearchResults": "इस खोज से कुछ भी मेल नहीं खाया।",
      "project": "परियोजना",
      "image": "छवि",
      "completed": "पूरा हुआ",
      "currentPlan": "वर्तमान योजना",
      "notSignedIn": "साइन नहीं किया गया",
      "signInIntro": "Voxnela का उपयोग शुरू करने के लिए साइन इन करें।",
      "creditsAvailable": "{{count}} स्टूडियो छवि क्रेडिट उपलब्ध हैं।",
      "noCredits": "इस अवधि में आपके पास कोई छवि क्रेडिट शेष नहीं है।",
      "membershipInfo": "वार्षिक योजना क्रेडिट हर महीने नवीनीकृत होते हैं और उन्हें रोलओवर नहीं किया जाता है। पुनर्स्थापित खरीदारी आपके खाते के माध्यम से सुरक्षित रहती हैं।",
      "signedOutMembershipInfo": "साइन इन करने के बाद, आपके उपलब्ध छवि क्रेडिट और योजना की जानकारी यहाँ दिखाई देगी।",
      "reviewPlans": "योजनाएं देखें",
      "versionUpdated": "संस्करण {{version}} · अंतिम अद्यतन {{date}}",
      "onboardingWelcome": "Voxnela में आपका स्वागत है",
      "skipIntro": "परिचय छोड़ें",
      "continue": "जारी रखें",
      "startCreating": "बनाना शुरू करें",
      "close": "बंद करें",
      "dragToClose": "शीट को बंद करने के लिए नीचे स्वाइप करें",
      "loading": "लोडिंग...",
      "sheetExpand": "शीट का विस्तार करें",
      "sheetCollapse": "रिटर्न शीट को सामान्य ऊंचाई पर वापस लाएं",
      "cannotClose": "संचालन प्रगति पर होने पर बंद नहीं किया जा सकता",
      "stylePreview": "स्टाइल पूर्वावलोकन",
      "stylePreviewSubtitle": "साइनचर शैलियाँ और रुझान",
      "categories": "श्रेणियाँ",
      "useThisStyle": "इस शैली का उपयोग करें",
      "videoControls": "वीडियो नियंत्रण",
      "play": "खेलें",
      "pause": "रुकावट",
      "mute": "म्यूट",
      "unmute": "अनम्यूट करें",
      "minimize": "न्यूनतम करें",
      "expandVideo": "ऐप में विस्तार करें",
      "videoProgress": "वीडियो प्रगति",
      "toggleVideoControls": "वीडियो नियंत्रण दिखाएं या छिपाएं",
      "expandedVideo": "{{title}} विस्तारित वीडियो दृश्य",
      "goToImage": "{{title}} छवि पर जाएं",
      "categoryVisualStyles": "{{category}} विज़ुअल शैलियाँ",
      "onboarding1Eyebrow": "चित्र निर्माण",
      "onboarding1Title": "अपना चित्र बनाएँ।",
      "onboarding1Body": "35 मिमी फिल्म, संपादकीय, उत्पाद, पोस्टर और कई अन्य दृश्य शैलियों के साथ अपने विचार को एक सिनेमैटिक फ्रेम में बदलें।",
      "onboarding2Eyebrow": "वर्चुअल कपड़े आज़माएँ",
      "onboarding2Title": "नए पहनावे आज़माएँ।",
      "onboarding2Body": "उत्पादनों में पहचान को बनाए रखें और यथार्थवादी फैशन, एक्सेसरी और उत्पाद ट्राई-ऑन विज़ुअल्स बनाएं।",
      "onboarding3Eyebrow": "चित्र संपादन",
      "onboarding3Title": "अपना चित्र संपादित करें।",
      "onboarding3Body": "बिना शुरुआत किए, बातचीत के माध्यम से रचना, प्रकाश, रंग और विवरण को संशोधित करें।",
      "onboarding4Eyebrow": "3 मुफ़्त चित्र",
      "onboarding4Title": "मुफ़्त में शुरू करें।",
      "onboarding4Body": "3 एक-बार की मुफ़्त AI इमेज के साथ अभी शुरू करें। खाते की ज़रूरत नहीं।",
      "onboardingFaceEyebrow": "चेहरे और शैली का विश्लेषण",
      "onboardingFaceTitle": "अपना चेहरा और शैली जानें।",
      "onboardingFaceBody": "अपने पोर्ट्रेट से बालों, चश्मे और कपड़ों के सुझाव एक दृश्य मार्गदर्शिका में देखें।",
      "onboardingHouseEyebrow": "समय यात्रा",
      "onboardingHouseTitle": "समय में यात्रा करें।",
      "onboardingHouseBody": "अपनी तस्वीरें और तारीखें जोड़कर देखें कि समय के साथ आपका घर कैसे बदला।",
      "onboardingFestivalEyebrow": "आपका उत्सव का दिन",
      "onboardingFestivalTitle": "अपने उत्सव के दिन की योजना एक नज़र में देखें।",
      "onboardingFestivalBody": "आपके दिए कार्यक्रम, मंचों और समय को निजी दृश्य मार्ग में बदलें।",
      "onboardingStylesEyebrow": "Voxnela शैलियाँ",
      "onboardingStylesTitle": "अपनी शैली चुनें।",
      "onboardingStylesBody": "35 मिमी फिल्म, संपादकीय, उत्पाद, पोस्टर और कई अन्य दृश्य शैलियों के साथ अपने विचार को एक सिनेमैटिक फ्रेम में बदलें।"
    },
    "auth": {
      "enterCode": "अपना कोड दर्ज करें",
      "membershipAndAccount": "सदस्यता और खाते के विवरण",
      "noPeriodInfo": "अवधि अनुपलब्ध",
      "memberSince": "सदस्य कब से",
      "planSince": "{{plan}} से",
      "membershipRenewal": "सदस्यता नवीनीकरण तिथि",
      "accountActions": "खाता कार्रवाइयाँ",
      "manageSubscriptionTitle": "सदस्यता समाप्त करें",
      "manageSubscriptionSubtitle": "अपने स्टोर सदस्यता और स्वचालित नवीनीकरण को प्रबंधित करें।",
      "deleteAccountTitle": "मेरा खाता हटाएँ",
      "deleteAccountSubtitle": "पुनर्वर्तनीय 15-दिवसीय हटाने की प्रक्रिया।",
      "deleteDataTitle": "मेरा डेटा हटा दें",
      "deleteDataSubtitle": "रिवर्सल 30-दिन का डेटा हटाने की प्रक्रिया।",
      "signingOut": "साइन आउट हो रहा है…",
      "signOut": "साइन आउट",
      "signingIn": "साइन इन हो रहा है…",
      "continueApple": "Apple से जारी रखें",
      "continueGoogle": "Google से जारी रखें",
      "or": "या",
      "email": "ईमेल",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "Voxnela के साथ जारी रखकर, आप स्वीकार करते हैं",
      "legalTerms": "उपयोग की शर्तें",
      "legalJoin": "और पुष्टि करें कि आपने पढ़ा और समझा है",
      "legalPrivacy": "गोपनीयता सूचना",
      "legalSuffix": ".",
      "sendingCode": "कोड भेजा जा रहा है…",
      "emailSignIn": "ईमेल से साइन इन करें",
      "codeSent": "हमने {{email}} पर एक कोड भेजा है।",
      "change": "बदलें",
      "sixDigitCode": "6 अंकों का कोड",
      "emailCode": "ईमेल साइन-इन कोड",
      "verifyingCode": "कोड सत्यापित हो रहा है…",
      "resendCode": "कोड फिर भेजें",
      "requestReceived": "अनुरोध प्राप्त हुआ",
      "accountDeletionStarted": "आपका खाता हटाने की प्रक्रिया शुरू हो गई है",
      "dataDeletionStarted": "आपका डेटा हटाने की प्रक्रिया शुरू हो गई है",
      "accountAction": "खाता कार्रवाई",
      "accountDeletesAt": "आपका खाता {{date}} पर स्थायी रूप से हटा दिया जाएगा।",
      "dataDeletesAt": "आपका व्यक्तिगत Voxnela डेटा {{date}} पर स्थायी रूप से हटा दिया जाएगा।",
      "deletionUndo": "यदि आप इस तिथि से पहले उसी खाते में साइन इन करते हैं, तो हटाने की प्रक्रिया स्वचालित रूप से रद्द कर दी जाएगी। आपका वर्तमान सत्र बंद कर दिया गया था क्योंकि अनुरोध बनाया गया था।",
      "done": "पूर्ण",
      "cancel": "रद्द करें",
      "preparing": "तैयारी कर रहा हूँ...",
      "invalidEmail": "एक मान्य ईमेल पता दर्ज करें।",
      "enterSixDigitCode": "अपने ईमेल पर भेजे गए 6-अंक वाले कोड को दर्ज करें।",
      "signInFailed": "साइन-इन पूरा नहीं किया जा सका। कृपया फिर से प्रयास करें।",
      "codeSendFailed": "साइन-इन कोड भेजा नहीं जा सका। कृपया फिर से प्रयास करें।",
      "codeVerifyFailed": "कोड की पुष्टि नहीं की जा सकी। कृपया फिर से प्रयास करें।",
      "operationFailed": "वर्तमान में ऑपरेशन पूरा नहीं किया जा सका। कृपया फिर से प्रयास करें।",
      "popupClosed": "साइन-इन विंडो बंद कर दी गई थी।",
      "unauthorizedDomain": "यह डोमेन साइन-इन के लिए अधिकृत नहीं है।",
      "methodUnavailable": "यह साइन-इन विधि अभी सक्षम नहीं है।",
      "tooManyCodes": "बहुत सारे कोड मांगे गए थे। कुछ मिनटों में फिर से प्रयास करें।",
      "invalidCode": "कोड अमान्य या समाप्त हो गया है। नया कोड अनुरोध करें।",
      "emailUnavailable": "ईमेल डिलीवरी वर्तमान में उपलब्ध नहीं है।",
      "actions": {
        "subscription": {
          "eyebrow": "सदस्यता कार्रवाई",
          "title": "अपनी सदस्यता समाप्त करें?",
          "confirm": "सदस्यता प्रबंधित करें",
          "paragraphs": [
            "Continuing Apple App Store या Google Play सब्सक्रिप्शन प्रबंधन पृष्ठ को खोलता है जहाँ आपने सब्सक्रिप्शन खरीदा था। आपको स्टोर में स्वचालित नवीनीकरण बंद करना होगा।",
            "रद्दीकरण के बाद, आपके मौजूदा सदस्यता लाभ भुगतान अवधि के अंत तक उपलब्ध रहेंगे। अपना खाता या डेटा हटाना स्टोर सदस्यता को रद्द नहीं करता है।"
          ]
        },
        "account": {
          "eyebrow": "स्थायी खाता कार्रवाई",
          "title": "क्या आप सुनिश्चित हैं कि आप अपना खाता हटाना चाहते हैं?",
          "confirm": "15-दिवसीय हटाने की प्रक्रिया शुरू करें",
          "paragraphs": [
            "Continuing 15-दिवसीय हटाने की प्रक्रिया शुरू करता है और सुरक्षा के लिए आपको साइन आउट कर देता है। यदि आप इस अवधि के दौरान फिर से साइन इन नहीं करते हैं, तो आपका खाता, प्रोफ़ाइल, रचनाएँ, लाइब्रेरी, संग्रह और संबंधित Voxnela डेटा स्थायी रूप से हटा दिया जाएगा।",
            "15 दिनों से पहले उसी खाते में साइन इन करने से स्वचालित रूप से डिलीशन रद्द हो जाता है। खाते को हटाने से एक सक्रिय स्टोर सब्सक्रिप्शन रद्द नहीं होता; इसे स्टोर में अलग से रद्द करें।"
          ]
        },
        "data": {
          "eyebrow": "स्थायी डेटा कार्रवाई",
          "title": "क्या आप सुनिश्चित हैं कि आप अपना डेटा हटाना चाहते हैं?",
          "confirm": "30-दिवसीय हटाने की प्रक्रिया शुरू करें",
          "paragraphs": [
            "निरंतरता 30-दिवसीय हटाने की प्रक्रिया शुरू करती है और सुरक्षा के लिए आपको साइन आउट कर देती है। यदि आप इस अवधि के दौरान फिर से साइन इन नहीं करते हैं, तो आपकी रचनाएँ, लाइब्रेरी, संग्रह, रिकॉर्ड्स, इंटरैक्शन और अन्य व्यक्तिगत Voxnela डेटा स्थायी रूप से हटा दिए जाएंगे; आपका साइन-इन खाता उपलब्ध रहेगा।",
            "30 दिनों से पहले फिर से साइन इन करने पर डेटा हटाना स्वचालित रूप से रद्द हो जाएगा। कानून द्वारा आवश्यक सीमित लेनदेन और सुरक्षा रिकॉर्ड को लागू कानूनी अवधि के लिए प्रतिबंधित पहुंच के साथ रखा जा सकता है।"
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "कोई छवि क्रेडिट शेष नहीं है",
      "quotaFreeMessage": "आपने अपने मुफ्त खाते में छवि क्रेडिट का उपयोग किया है। बनाना जारी रखने के लिए एक योजना चुनें।",
      "later": "बाद में",
      "currentCredit": "वर्तमान क्रेडिट: 0",
      "quotaProTitle": "मासिक प्रो कोटा प्राप्त हो गया है",
      "quotaProMessage": "आपने इस महीने के 100 छवि क्रेडिट का उपयोग कर लिया है। बनाना जारी रखने के लिए स्टूडियो में अपग्रेड करें।",
      "renewalDate": "नवीकरण तिथि: {{date}}",
      "quotaStudioTitle": "मासिक स्टूडियो कोटा प्राप्त हो गया है",
      "quotaStudioMessage": "{{date}} पर आपके छवि क्रेडिट स्वचालित रूप से नवीनीकृत हो जाएंगे।",
      "done": "हो गया",
      "membership": "Voxnela सदस्यता",
      "options": "सदस्यता विकल्प",
      "credits": "क्रेडिट",
      "currentMembership": "वर्तमान सदस्यता",
      "yearlyDiscount": "17% छूट",
      "loadingPrice": "स्टोर मूल्य लोड हो रहा है…",
      "loadingStorePrice": "स्टोर से कीमत लोडिंग",
      "year": "वर्ष",
      "month": "माह",
      "renewDisclosure": "{{period}} हर बार स्वचालित रूप से नवीनीकृत होता है। कभी भी रद्द करें।",
      "legal": "कानूनी",
      "terms": "शर्तें",
      "alreadyMember": "आपके पास पहले से ही {{plan}} {{period}} है।",
      "startPlan": "{{plan}} योजना शुरू करें",
      "upgradeStudio": "Studio में अपग्रेड करें",
      "yearlyAdvantage": "वार्षिक बचत में स्विच करें",
      "upgrade": "सदस्यता अपग्रेड करें",
      "signInRequired": "सदस्यता शुरू करने से पहले अपने Voxnela खाते में साइन इन करें।",
      "catalogUnavailable": "इस योजना के लिए भुगतान कैटलॉग सत्यापित नहीं किया जा सका। कृपया जल्द ही पुनः प्रयास करें।",
      "paymentUnavailable": "भुगतान स्क्रीन नहीं खोली जा सकी। कृपया फिर से प्रयास करें।",
      "benefits": [
        {
          "lead": "{{credits}} क्रेडिट",
          "label": "हर महीने उच्च-रिज़ॉल्यूशन छवि जनरेशन"
        },
        {
          "lead": "50+ स्टूडियो स्टाइल",
          "label": "न्यू-मिनिमलिज्म, सिनेमैटिक और हर हस्ताक्षर शैली"
        },
        {
          "lead": "चेहरे की लॉक",
          "label": "चेहरे के फीचर्स बदले बिना वर्चुअल फैशन ट्राई-ऑन"
        },
        {
          "lead": "प्राथमिकता कतार",
          "label": "बिना प्रतीक्षा के अल्ट्रा-फास्ट GPU प्रोसेसिंग"
        },
        {
          "lead": "चैट संशोधन",
          "label": "प्राकृतिक भाषा में असीमित बहु-टर्न विवरण संपादन"
        },
        {
          "lead": "पूर्ण वाणिज्यिक अधिकार",
          "label": "उच्च-रिज़ॉल्यूशन, वॉटरमार्क-मुक्त उपयोग"
        }
      ],
      "restorePurchases": "खरीद बहाल करें",
      "restoringPurchases": "पुनर्स्थापन खरीद...",
      "restoreSuccess": "आपकी सदस्यता बहाल कर दी गई है।",
      "restoreEmpty": "इस ऐप स्टोर खाते के लिए कोई सक्रिय सदस्यता नहीं मिली।",
      "membershipSyncPending": "सदस्यता और छवि क्रेडिट की पुष्टि करना...",
      "membershipSyncFailed": "इमेज क्रेडिट सिंक नहीं हो सके। फिर से प्रयास करें।",
      "membershipUnavailable": "सदस्यता लोड नहीं हो सकी।",
      "retry": "फिर से प्रयास करें"
    },
    "video": {
      "revisionHook": "पहले तीन सेकंड को अधिक आकर्षक बनाएं।",
      "revisionPace": "गति को संतुलित करें और धीमे खंडों को छोटा करें।",
      "revisionEnding": "अंत को अधिक यादगार बनाएं।",
      "revisionTransition": "परिवर्तन को और अधिक सहज और प्राकृतिक बनाएं।",
      "revisionFraming": "महत्वपूर्ण विवरणों के लिए अधिक संतुलित फ्रेमिंग का उपयोग करें।",
      "revisionColor": "रंगों को अधिक संतुलित और सिनेमैटिक बनाएं।",
      "revisionText": "पाठ को छोटा और पढ़ने में आसान बनाएं।",
      "revisionAudio": "संगीत को छवियों की लय के अधिक निकटता से मिलाएँ।",
      "revisionEmotion": "कहानी को अधिक सच्ची और भावनात्मक बनाएं।",
      "revisionStructure": "एक स्पष्ट शुरुआत, मध्य और अंत बनाएं।",
      "previewBack": "पूर्वावलोकन पर वापस जाएँ",
      "revisionWelcome": "आप क्या बदलना चाहेंगे?",
      "revisionFailed": "मैं उस बदलाव को लागू नहीं कर सका। क्या आप इसे फिर से वर्णन कर सकते हैं?",
      "finalQueued": "अंतिम वीडियो कतार में है। तैयार होने पर यह वीडियोज़ के अंतर्गत दिखाई देगा।",
      "watermarkUpgrade": "Voxnela वॉटरमार्क के बिना एक नया अंतिम आउटपुट बनाने के लिए एक योजना चुनें।",
      "finalFailed": "अंतिम वीडियो शुरू नहीं किया जा सका।",
      "projectDeleteFailed": "प्रोजेक्ट को हटाया नहीं जा सका।",
      "videoDescriptionWithBrief": "यह वीडियो “{{brief}}” से बनाया गया था। Voxnela ने सबसे शक्तिशाली क्षणों का चयन किया और चुने गए रचनात्मक दिशा के चारों ओर लय और दृश्य क्रम बनाया।",
      "videoDescriptionGeneric": "Voxnela ने सामग्री, गति और कथात्मक सुसंगति के लिए सामग्री का मूल्यांकन किया, संतुलित संपादन के लिए सबसे मजबूत क्षणों पर प्रकाश डाला।",
      "play": "खेलें",
      "deletesOn": "{{date}} पर हटाता है",
      "projectsBelong": "आपके प्रोजेक्ट आपके खाते से जुड़े हैं।",
      "videosBelong": "आपके वीडियो आपके खाते से जुड़े हैं।",
      "signInToSeeProjects": "अपने प्रोजेक्ट देखने और विभिन्न उपकरणों पर आगे बढ़ने के लिए साइन इन करें।",
      "signInToSeeVideos": "अपने वीडियो देखने और विभिन्न उपकरणों पर जारी रखने के लिए साइन इन करें।",
      "delete": "हटाएँ",
      "deleting": "हटाया जा रहा है…",
      "secondsVersion": "{{seconds}} सेकंड · संस्करण {{version}}",
      "deleteProject": "प्रोजेक्ट हटाएँ",
      "projectCoverUnavailable": "प्रोजेक्ट कवर लोड नहीं किया जा सका",
      "videoCoverPreparing": "वीडियो कवर तैयार करना",
      "deleteVideo": "वीडियो हटाएँ",
      "signed": "Voxnela ब्रांडेड",
      "failed": "पूरा नहीं कर सका",
      "tryAgain": "आप फिर से कोशिश कर सकते हैं",
      "cancelled": "रद्द कर दिया गया",
      "noCreditUsed": "कोई क्रेडिट उपयोग नहीं किया गया",
      "featuredStyles": "विशेष दृश्य शैलियाँ",
      "previousImage": "पिछली छवि",
      "nextImage": "अगली छवि",
      "reviewStyle": "इस शैली का अन्वेषण करें",
      "featuredNavigation": "विशेष दृश्य नेविगेशन",
      "taskCategories": "कार्य श्रेणियाँ",
      "projectOpening": "प्रारंभिक परियोजना",
      "opening": "प्रारंभ...",
      "projectNotFound": "प्रोजेक्ट नहीं मिला",
      "projectUnavailable": "यह परियोजना अब उपलब्ध नहीं है।",
      "backToProjects": "मेरे प्रोजेक्ट पर वापस",
      "editVideo": "वीडियो संपादित करें",
      "versionContext": "संस्करण {{version}} · Voxnela आपके प्रोजेक्ट और सामग्रियों को जानता है",
      "livePreviewActions": "लाइव पूर्वावलोकन क्रियाएँ",
      "edit": "संपादित करें",
      "preparing": "तैयार हो रहा है",
      "save": "सहेजें",
      "thinking": "Voxnela सोच रही है",
      "revisionSuggestions": "संपादन सुझाव",
      "describeChange": "आप चाहते हैं तो होने वाले बदलाव का वर्णन करें",
      "sendEdit": "संपादन अनुरोध भेजें",
      "deleteProjectDescription": "क्या आप सुनिश्चित हैं कि आप “{{title}}” और सभी संबंधित सामग्री को हटाना चाहते हैं? इसे वापस नहीं किया जा सकता।",
      "projects": "प्रोजेक्ट",
      "projectsPreparing": "अपने प्रोजेक्ट्स की तैयारी कर रहे हैं",
      "noProjects": "आपके पास अभी तक कोई प्रोजेक्ट नहीं है। अपने पहले विचार का वर्णन करके शुरुआत करें।",
      "createNew": "नई छवि बनाएँ",
      "thisProject": "यह परियोजना",
      "videos": "वीडियो",
      "videosPreparing": "अपने वीडियो तैयार करना",
      "noVideos": "आपके पास अभी तक एक पूरा वीडियो नहीं है। यह यहाँ दिखाई देगा जब आपका पहला वीडियो तैयार हो जाएगा।",
      "videoPlayFailed": "वीडियो नहीं चलाया जा सका।",
      "videoNotReady": "वीडियो फ़ाइल अभी डाउनलोड के लिए तैयार नहीं है।",
      "videoDownloadFailed": "वीडियो डाउनलोड नहीं किया जा सका।",
      "videoDeleteFailed": "वीडियो को हटाया नहीं जा सका।",
      "videoLoading": "वीडियो लोड हो रहा है...",
      "videoActions": "वीडियो क्रियाएँ",
      "showVideoDescription": "वीडियो विवरण दिखाएं",
      "videoDownloading": "वीडियो डाउनलोड करना",
      "downloadVideo": "वीडियो डाउनलोड करें",
      "thisVideo": "यह वीडियो",
      "deleteVideoDescription": "क्या आप सुनिश्चित हैं कि आप “{{title}}” शीर्षक वाले वीडियो को हटाना चाहते हैं? इसे वापस नहीं किया जा सकता।"
    },
    "studio": {
      "useStyle": "इस शैली का उपयोग करें",
      "galleryFilters": "गैलरी फ़िल्टर",
      "modeStyleTransfer": "Voxnela शैलियाँ",
      "modeVirtualTryOn": "वर्चुअल ट्राई-ऑन",
      "modeMagazineCover": "मैगज़ीन और कवर",
      "modePosterStudio": "पोस्टर स्टूडियो",
      "modeCommercial": "उत्पाद प्रदर्शन",
      "modeTimeWarp": "समय यात्रा",
      "modeOutpaintRelight": "विस्तार करें और पुनः प्रकाशित करें",
      "modeInfographic": "इन्फोग्राफिक और डेटा",
      "modePortraitRetouch": "पोर्ट्रेट रीटच",
      "modeArtisticCollage": "कलात्मक कोलाज",
      "defaultStyle": "Voxnela शैली",
      "signInToCreate": "एक छवि बनाने के लिए साइन इन करें।",
      "signInToEdit": "एक छवि संपादित करने के लिए साइन इन करें।",
      "creationSuccess": "आपकी छवि सफलतापूर्वक बनाई गई है। यदि आप प्रकाश, रंग, वस्तुएँ या फ़्रेमिंग बदलना चाहते हैं, तो मुझे सीधे बताएं।",
      "imageReady": "आपकी छवि तैयार है। मुझे बताएं कि आपको क्या पसंद है या आप क्या संशोधित करना चाहते हैं।",
      "revisionSuccess": "सुधार पूर्ण हो गया है। आप इसे पहले/बाद के स्लाइडर के साथ तुलना कर सकते हैं या कोई अन्य परिवर्तन का अनुरोध कर सकते हैं।",
      "versionReady": "संस्करण {{version}} तैयार है।",
      "projectNotFound": "प्रोजेक्ट नहीं मिला।",
      "styleApplied": "{{style}} शैली लागू",
      "imageCreation": "छवि निर्माण",
      "defaultPrompt": "स्टूडियो छवि",
      "aspectSquare": "वर्ग",
      "aspectSquareDetail": "इंस्टाग्राम फ़ीड, प्रोफ़ाइल, कला",
      "aspectVertical": "ऊर्ध्वाधर",
      "aspectVerticalDetail": "इंस्टाग्राम स्टोरी, रील्स, टिकटॉक",
      "aspectHorizontal": "क्षैतिज",
      "aspectHorizontalDetail": "यूट्यूब, बैनर, सिनेमा",
      "aspectPortrait": "पोर्ट्रेट",
      "aspectPortraitDetail": "इंस्टाग्राम पोर्ट्रेट, पोस्टर, शोकेस",
      "aspectPanoramic": "व्यापक दृश्य",
      "aspectPanoramicDetail": "अल्ट्रा वाइड, सिनेमैटिक लैंडस्केप",
      "styles": "Voxnela शैलियाँ",
      "fullScreenStyle": "पूर्ण स्क्रीन में शैली देखें",
      "closeDescription": "बंद शैली विवरण",
      "moreWithVoxnela": "Voxnela के साथ और अधिक करें",
      "quickStartBody": "नीचे लिखें जो आप चाहते हैं या एक फ़ाइल संलग्न करें।",
      "createImage": "चित्र बनाएँ",
      "createImageDetail": "अपने विचार को पूरी तरह से शुरू से बनाएं",
      "editImage": "चित्र संपादित करें",
      "editImageQuick": "एक छवि संपादित करें",
      "editImageDetail": "अपलोड की गई छवि को फिर से कल्पना करें",
      "transformStyle": "स्टाइल और दृश्य को बदलें",
      "transformStyleDetail": "अपनी छवि को एक अन्य दुनिया में ले जाएँ",
      "visualizeDocument": "एक दस्तावेज़ या प्रस्तुति का दृश्यमान करें",
      "visualizeDocumentDetail": "पूरा सामग्री को एक डिज़ाइन में बदलें",
      "submittedImage": "प्रस्तुत की गई छवि",
      "generating": "Voxnela आपका चित्र बना रहा है…",
      "viewImage": "छवि देखें",
      "removeStyle": "चयनित शैली हटाएँ",
      "referenceImage": "संदर्भ छवि",
      "referenceNotice": "इस छवि को संशोधित किया जाएगा या एक नया शैली लागू की जाएगी।",
      "removeReference": "संदर्भ छवि हटाएँ",
      "remove": "हटाएं",
      "uploading": "अपलोडिंग",
      "addFile": "फ़ाइल या छवि जोड़ें",
      "addFileTitle": "4 छवियों या एक दस्तावेज़ (PDF, Word, PPT, अधिकतम 12 MB) तक जोड़ें",
      "aspectRatio": "एस्पेक्ट अनुपात",
      "selectAspectRatio": "एस्पेक्ट रेशियो चुनें",
      "aspectOptions": "एस्पेक्ट अनुपात विकल्प",
      "revisePlaceholder": "आप इस छवि में क्या बदलना चाहेंगे?",
      "styledPlaceholder": "इस शैली में आप जो छवि चाहते हैं उसका वर्णन करें (वैकल्पिक)...",
      "promptPlaceholder": "एक छवि का वर्णन करें या एक प्रॉम्प्ट लिखें…",
      "reviseImage": "छवि को संशोधित करें",
      "generateImage": "छवि उत्पन्न करें",
      "generatedImage": "जनरेट की गई छवि",
      "done": "पूर्ण",
      "fileLimitTitle": "फ़ाइल बहुत बड़ी है",
      "fileLimitMessage": "“{{name}}” 12 MB सीमा ({{size}} MB) से अधिक है। एक छोटी फ़ाइल चुनें।",
      "imageLimitTitle": "छवि सीमा",
      "imageLimitMessage": "आप अधिकतम 4 छवियां अपलोड कर सकते हैं। {{count}} छवियां वर्तमान में चयनित हैं।",
      "uploadFailedTitle": "अपलोड विफल रहा",
      "uploadFailedMessage": "फ़ाइल अपलोड करते समय एक समस्या उत्पन्न हुई।",
      "revisionFailed": "पुनर्लेखन के दौरान एक त्रुटि हुई या कोटा पार हो गया।",
      "generationFailed": "छवि निर्माण के दौरान एक त्रुटि हुई या कोटा पार हो गया।",
      "imageDetails": "छवि विवरण",
      "close": "बंद करें",
      "download": "डाउनलोड",
      "downloadImage": "छवि डाउनलोड करें",
      "downloading": "डाउनलोड हो रहा है",
      "versionImage": "छवि",
      "exploreTitle": "आप कौन-सी शैली ढूँढ रहे हैं?",
      "explorePlaceholder": "उदाहरण के लिए: गहरे टोन और गहरी परिप्रेक्ष्य वाला एक सिनेमैटिक पोर्ट्रेट",
      "searchStyles": "दृश्य शैलियाँ खोजें",
      "clearSearch": "स्पष्ट खोज",
      "exploreCategories": "श्रेणियों का अन्वेषण करें",
      "all": "सभी",
      "styleCount": "{{count}} शैलियाँ",
      "noStyle": "कोई मेल खाने वाली शैली नहीं मिली",
      "noStyleBody": "एक छोटी विवरण या अलग शब्दों के साथ फिर से कोशिश करें।",
      "libraryKicker": "आपकी व्यक्तिगत छवि लाइब्रेरी",
      "myImages": "मेरे चित्र",
      "imageWorks": "{{count}} छवि काम करती है",
      "newImage": "नया चित्र बनाएँ",
      "noImage": "आपने अभी तक कोई छवि नहीं बनाई है।",
      "noCategoryImage": "इस श्रेणी में कोई छवियां नहीं हैं",
      "emptyGalleryBody": "स्टाइल ट्रांसफर, वर्चुअल ट्राई-ऑन, मैगज़ीन कवर या उत्पाद शोकेस के साथ अपनी पहली छवि बनाएं।",
      "firstImage": "अपनी पहली छवि बनाएं",
      "imageWork": "छवि कार्य"
    },
    "create": {
      "briefTitle": "अपने विचार या विषय का वर्णन करें",
      "briefPlaceholder": "विषय क्या है? उदाहरण के लिए: एआई का भविष्य, मंगल ग्रह की यात्रा या उत्पाद लॉन्च…",
      "briefLabel": "निर्माण संक्षिप्त",
      "contentType": "सामग्री प्रकार",
      "media": "छवियाँ और मीडिया",
      "added": "{{count}} जोड़ा गया",
      "optional": "वैकल्पिक",
      "addMedia": "यदि आप चाहें तो एक फोटो या वीडियो जोड़ें",
      "addMediaBody": "अपनी खुद की मीडिया अपलोड करें या इसे खाली छोड़ दें और AI इसे ढूंढने दें",
      "attachedMedia": "संलग्न मीडिया",
      "add": "जोड़ें",
      "mediaFallback": "मीडिया",
      "aiCompletes": "AI को दृश्य पूरा करने दें",
      "noMedia": "कोई छवियां अपलोड नहीं की गई हैं; AI दृश्यों को पूरा करेगा।",
      "productionFormat": "उत्पादन प्रारूप",
      "style": "शैली",
      "customVisualWorld": "अपनी दृश्य दुनिया का वर्णन करें",
      "colorsAtmosphere": "रंग, वातावरण, कैमरा, लय",
      "customStyleShort": "अपने मन में मौजूद दृश्य संसार का वर्णन करें (उदाहरण के लिए: पेस्टल रंग और एक शांत कैमरा, या साइबरपंक नीयन…)",
      "customStyleLong": "अपने मन में मौजूद दृश्य संसार, रंग, वातावरण और लय का वर्णन करें।",
      "voiceover": "वॉइसओवर",
      "ownVoiceover": "आपका वॉइसओवर टेक्स्ट",
      "voiceoverPlaceholder": "यहाँ अपना पाठ लिखें। यदि खाली छोड़ दिया जाता है, तो Voxnela इसे तैयार करेगा।",
      "duration": "अवधि",
      "seconds": "{{count}} सेकंड",
      "freeLimit": "फ्री प्लान पर सबसे लंबा अंतिम वीडियो 60 सेकंड का है।",
      "addSound": "ध्वनि या संगीत जोड़ें",
      "notAdded": "जोड़ा नहीं गया",
      "files": "{{count}} फ़ाइलें",
      "readySounds": "तैयार किए गए आवाज़ों का उपयोग करें",
      "musicLibrary": "संगीत लाइब्रेरी",
      "uploadOwn": "अपना खुद का अपलोड करें",
      "captions": "कैप्शन",
      "back": "वापस",
      "create": "बनाएँ",
      "next": "आगे",
      "researchingTopic": "विषय पर शोध कर रहा हूँ…",
      "analyzingMaterials": "सामग्रियों का विश्लेषण करना…",
      "researchBody": "स्रोत सत्यापित करना और स्क्रिप्ट और विज़ुअल योजना तैयार करना।",
      "analyzeBody": "मजबूत फ्रेम, भावना, लय और संक्षिप्तता का एक साथ मूल्यांकन करना।",
      "creativeDirection": "रचनात्मक दिशा {{count}}",
      "recommended": "अनुशंसित",
      "generationFailed": "निर्माण पूरा नहीं किया जा सका",
      "retry": "फिर से तैयार करें",
      "backDirections": "रचनात्मक दिशाओं में वापस",
      "preparingVideo": "आपका वीडियो तैयार हो रहा है",
      "voiceoverText": "वॉइसओवर टेक्स्ट",
      "describeStyle": "अपनी खुद की शैली का वर्णन करें",
      "topicDirection": "विषय और दिशा",
      "styleEditorSubtitle": "दृश्य संसार, रंग और वातावरण का वर्णन करें",
      "editorSubtitle": "पाठ लिखें और इसे निर्माण शीट में डालें।",
      "voiceoverEditorPlaceholder": "वॉइसओवर के लिए उपयोग करने के लिए पाठ लिखें।",
      "topicEditorPlaceholder": "विषय लिखें और आप इसे कैसे बताना चाहते हैं।",
      "insertText": "पाठ डालें",
      "bestFor": "सबसे अच्छा के लिए:",
      "useStyle": "इस शैली का उपयोग करें",
      "musicSubtitle": "व्यावसायिक उपयोग के लिए वास्तविक ट्रैक क्लियर किए गए हैं",
      "adding": "जोड़ना...",
      "musicLicense": "ट्रैक्स CC0 1.0 के तहत प्रदान किए जाते हैं; वाणिज्यिक उपयोग की अनुमति है और श्रेय की आवश्यकता नहीं है।",
      "yes": "हाँ",
      "no": "नहीं",
      "newCreation": "नया निर्माण",
      "reviewing": "Voxnela समीक्षा कर रही है",
      "chooseDirection": "तीन संपादन दृष्टिकोणों में से एक चुनें",
      "ideaSubtitle": "अपने विचार का वर्णन करें; दृश्य अपलोड करें या Voxnela को उन्हें बनाने की अनुमति दें।",
      "projectOpenFailed": "प्रोजेक्ट पैकेज खोला नहीं जा सका।",
      "tooManyAssets": "आप किसी प्रोजेक्ट में 50 तक एसेट्स जोड़ सकते हैं।",
      "uploadSizeLimit": "कुल प्रोजेक्ट अपलोड 2 जीबी सीमा से अधिक है।",
      "filesAddFailed": "फ़ाइलें जोड़ी नहीं जा सकीं।",
      "musicPreviewFailed": "संगीत पूर्वावलोकन खोला नहीं जा सका।",
      "musicFetchFailed": "संगीत फ़ाइल प्राप्त नहीं की जा सकी।",
      "musicAddFailed": "संगीत जोड़ा नहीं जा सका।",
      "topicRequired": "एक विषय दर्ज करें और वर्णन करें कि आपका वीडियो किस बारे में होगा।",
      "briefTooShort": "कम से कम कुछ शब्दों में वर्णन करें कि आप क्या बताना चाहते हैं।",
      "mediaRequired": "एक छवि अपलोड करें या एआई-जनरेटेड विज़ुअल्स सक्षम करें।",
      "proposalIntro": "मैंने छवियों और वीडियो की समीक्षा की और तीन संपादन दिशा-निर्देश तैयार किए जो आपके शैली, प्रारूप और ऑडियो विकल्पों के अनुरूप हैं।",
      "removeMaterial": "{{name}} हटाएँ",
      "aiVisualNotice": "खुले तौर पर लाइसेंस प्राप्त वास्तविक छवियां और एआई चित्रण स्वचालित रूप से पाए जाते हैं।",
      "stepProgress": "{{current}} का चरण {{total}}",
      "styleSampleAlt": "{{style}} वीडियो शैली को दर्शाने का उदाहरण",
      "reviewStyle": "{{style}} शैली की समीक्षा करें",
      "selectedDirectionPrompt": "चयनित दिशा: {{title}}. {{summary}} दृश्य दिशा: {{visual}}. संक्रमण दृष्टिकोण: {{transitions}}. संगीत दृष्टिकोण: {{music}}.",
      "letVoxnelaChoose": "Voxnela को चुनने दें",
      "feminineVoice": "महिलात्मक",
      "masculineVoice": "पुरुषवादितापूर्ण",
      "narrationStyle": "कथावाचक शैली",
      "voiceEstimate": "{{seconds}} सेकंड · {{words}} शब्द के बारे में।",
      "voiceShort": "यदि यह {{duration}} सेकंड का संक्षिप्त रूप है, तो Voxnela इसे अर्थ को बनाए रखते हुए पूरा कर देगा।",
      "voiceNatural": "Voxnela केवल व्याकरण, वाक्यांश और प्राकृतिक प्रवाह को समायोजित करता है।",
      "removeFile": "{{name}} फ़ाइल हटाएँ",
      "musicStop": "{{title}} बंद करें",
      "musicListen": "{{title}} सुनें",
      "automatic": "ऑटो",
      "all": "सभी",
      "cinematic": "सिनेमैटिक",
      "social": "सामाजिक और गतिशील",
      "designTypography": "डिज़ाइन और टाइपोग्राफी",
      "retroExperimental": "रेट्रो और प्रायोगिक",
      "productionStage1": "सबसे मजबूत फ्रेम और दृश्यों का चयन करना।",
      "productionStage2": "कहानी, गति और संक्रमण का निर्माण।",
      "productionStage3": "संगीत, आवाज़ और कैप्शन को संतुलित करना।",
      "productionStage4": "लाइव पूर्वावलोकन पर अंतिम जाँचें चल रही हैं।",
      "genericCreationError": "वीडियो योजना तैयार करते समय एक समस्या उत्पन्न हुई। आपके सामग्री और विकल्प सुरक्षित रखे गए हैं; आप फिर से प्रयास कर सकते हैं।",
      "newVideo": "नया वीडियो",
      "topicNews": "समाचार",
      "topicDocumentary": "डॉक्यूमेंटरी",
      "topicExplainer": "व्याख्याकर्ता",
      "topicStory": "कहानी",
      "topicScience": "विज्ञान",
      "topicPhilosophy": "दर्शनशास्त्र",
      "topicMagazine": "मैगज़ीन",
      "topicEntertainment": "मनोरंजन",
      "topicList": "सूची",
      "toneCalm": "शांत",
      "toneEmotional": "भावनात्मक",
      "toneEnergetic": "ऊर्जावान",
      "toneStorytelling": "कहानी सुनाना",
      "toneCheerful": "खुशमिजाज",
      "toneMysterious": "रहस्यमय",
      "toneNews": "समाचार",
      "styleCinematic": "सिनेमैटिक",
      "styleDarkCinematic": "डार्क सिनेमैटिक",
      "styleDocumentary": "डॉक्यूमेंटरी",
      "styleModernDocumentary": "आधुनिक वृत्तचित्र",
      "stylePovImmersive": "आmersive पीओवी",
      "styleUgcAuthentic": "प्रामाणिक UGC",
      "styleMiniVlog": "मिनी व्लॉग",
      "styleSocialViral": "सोशल वायरल",
      "styleHyperEdit": "हाइपर एडिट",
      "styleSportsHype": "खेलों का उत्साह",
      "styleVelocityEdit": "रफ़्तार संपादन",
      "styleMusicBeatEdit": "संगीत बीट एडिट",
      "styleKineticTypography": "काइनेटिक टाइपोग्राफी",
      "styleMinimalClean": "न्यूनतम और साफ",
      "styleLuxuryMinimal": "लक्जरी न्यूनतम",
      "styleCommercialProduct": "व्यावसायिक उत्पाद",
      "styleEditorialFashion": "प्रकाशन फैशन",
      "styleCollageZine": "कॉलेज ज़ीन",
      "styleTechFuturistic": "टेक्निकल भविष्यवादी",
      "styleRetroFuturism": "रेट्रो फ्यूचर्सिज्म",
      "styleY2kDigital": "Y2K डिजिटल",
      "styleVhsCamcorder": "VHS कैमराcorder",
      "styleAnalogFilm": "एनालॉग फिल्म",
      "styleGlitchCyber": "गलिच साइबर",
      "musicUpbeatMood": "ऊर्जावान · उज्ज्वल",
      "musicUpbeatDetail": "उत्तेजक सामाजिक सामग्री, यात्रा के पलों और जीवंत संपादन के लिए वास्तविक वाद्य यंत्र रिकॉर्डिंग।",
      "musicElectronicMood": "आधुनिक · लयबद्ध",
      "musicElectronicDetail": "शहरों, प्रौद्योगिकी, उत्पादों और तेज़-तर्रार संपादन के लिए असली इलेक्ट्रॉनिक संगीत।",
      "musicRomanceMood": "भावनात्मक · गर्मजोशी भरा",
      "musicRomanceDetail": "परिवार, पोर्ट्रेट, विशेष दिनों और यादों के लिए एक कोमल भावनात्मक चाप वाली वाद्य संगीत।",
      "musicScoringMood": "कथात्मक · सिनेमैटिक",
      "musicScoringDetail": "कहानी, प्रचार और नाटकीय ट्रांजिशन का समर्थन करने वाला सिनेमैटिक पृष्ठभूमि संगीत।",
      "musicEpicMood": "शक्तिशाली · बढ़ रहा है",
      "musicEpicDetail": "परतों में व्यवस्थित वाद्य संगीत जो भव्य उद्घाटन, यात्राओं और मजबूत समापन के लिए बनाया जाता है।",
      "proposalBalancedTitle": "संतुलित कथावाचक",
      "proposalBalancedSummary": "एक संपादन जो सामग्री के प्रवाह को बनाए रखता है और सबसे मजबूत फ्रेम को उजागर करता है।",
      "proposalBalancedVisual": "मजबूत पदानुक्रम और एक सुसंगत दृश्य प्रणाली",
      "proposalBalancedTransitions": "चिकने कट और मापे गए पुश-इन",
      "proposalBalancedMusic": "संगीत जो भावना से लय में बदलता है",
      "proposalQuietTitle": "शांत कहानी",
      "proposalQuietSummary": "एक शांत दृष्टिकोण जो फ्रेम को अधिक समय देता है और विवरण और प्राकृतिक भावना पर जोर देता है।",
      "proposalQuietVisual": "नरम स्वर और लंबे शॉट्स",
      "proposalQuietTransitions": "क्रॉस घुल जाता है और धीमी पैन",
      "proposalQuietMusic": "सरल और भावनात्मक संगीत",
      "proposalRhythmicTitle": "तालबद्ध संपादन",
      "proposalRhythmicSummary": "एक ऐसा संपादन जिसमें एक मजबूत ओपनिंग हुक हो जो बीच में तेज़ी से आगे बढ़ता है और अंत में स्पष्ट रूप से स्थिर हो जाता है।",
      "proposalRhythmicVisual": "मजबूत कंट्रास्ट और गतिशील फ्रेमिंग",
      "proposalRhythmicTransitions": "बीट कट और नियंत्रित व्हिप ट्रांजिशन",
      "proposalRhythmicMusic": "ऊर्जावान, बढ़ती हुई संगीत",
      "underVoiceover": "वॉइसओवर के नीचे नरम",
      "withShortVoiceover": "छोटी, प्रभावशाली वॉइसओवर के साथ"
    },
    "information": {
      "home": "होम",
      "documentInfo": "दस्तावेज़ जानकारी",
      "version": "संस्करण",
      "effective": "प्रभावी",
      "updated": "अंतिम अपडेट",
      "contents": "विषय सूची",
      "officialReferences": "आधिकारिक संदर्भ",
      "referenceTitle": "कानून और प्राधिकरण संसाधन",
      "referenceBody": "ये लिंक सामान्य जानकारी के लिए प्रदान किए गए हैं। सक्षम अधिकारियों के अनिवार्य कानून और वर्तमान नियम प्राथमिकता लेते हैं।",
      "supportKicker": "स्पोनेलैब्स समर्थन",
      "contactTitle": "संपर्क करें",
      "contactLead": "अपने खाते, सदस्यता, भुगतान, निर्माण, सामग्री रिपोर्ट, गोपनीयता या तकनीकी मुद्दों के बारे में Voxnela समर्थन टीम से संपर्क करें।",
      "supportEmail": "सहायता ईमेल",
      "emailBody": "नीचे दिया गया बटन आपके डिफ़ॉल्ट ईमेल ऐप को एक उपयोग के लिए तैयार समर्थन टेम्पलेट के साथ खोलता है ताकि हम जल्दी से जांच कर सकें।",
      "openEmail": "ईमेल ऐप खोलें",
      "includeTitle": "संदेश में शामिल करें",
      "includeItems": [
        "चाहे आप वेब, iOS या Mac का उपयोग करें;",
        "आपका डिवाइस और ऑपरेटिंग सिस्टम संस्करण;",
        "समस्या को पुनः उत्पन्न करने के चरण;",
        "संबंधित प्रोजेक्ट लिंक, लेनदेन विवरण या स्क्रीनशॉट, यदि उपलब्ध हो।"
      ],
      "sensitiveTitle": "संवेदनशील जानकारी न भेजें",
      "sensitiveBody": "समस्या को हल करने के लिए आवश्यक न होने वाले सत्यापन कोड, पासवर्ड, पूर्ण भुगतान कार्ड विवरण, पहचान दस्तावेज, स्वास्थ्य डेटा या अन्य संवेदनशील जानकारी शामिल न करें।",
      "securityTitle": "सुरक्षा और सामग्री रिपोर्ट",
      "securityBody": "खतरे की स्थिति के लिए “सुरक्षा” का उपयोग करें, डेटा अनुरोध के लिए “गोपनीयता अनुरोध” का उपयोग करें, या हानिकारक या उल्लंघनकारी सामग्री के लिए “सामग्री रिपोर्ट” का उपयोग करें। तत्काल शारीरिक खतरे की स्थिति में स्थानीय आपातकालीन सेवाओं से संपर्क करें।",
      "mailSubject": "Voxnela समर्थन अनुरोध",
      "mailGreeting": "नमस्ते Voxnela सपोर्ट टीम,",
      "mailTopic": "समर्थन विषय:",
      "mailPlatform": "प्लेटफ़ॉर्म (वेब / iOS / Mac):",
      "mailDevice": "डिवाइस और ऑपरेटिंग सिस्टम:",
      "mailProject": "प्रोजेक्ट आईडी (यदि उपलब्ध हो):",
      "mailDescription": "समस्या या अनुरोध का विवरण:",
      "mailThanks": "धन्यवाद।",
      "termsEyebrow": "Voxnela सेवा की शर्तें",
      "termsTitle": "उपयोग की शर्तें",
      "termsLead": "ये शर्तें Voxnela वेब और iOS ऐप्स में AI छवि निर्माण और संपादन सेवाओं के उपयोग को नियंत्रित करती हैं।",
      "privacyEyebrow": "Voxnela डेटा उपयोग",
      "privacyTitle": "गोपनीयता नीति",
      "privacyLead": "यह नीति बताती है कि Voxnela छवि निर्माण सेवा में खाते, छवि, परियोजना, सदस्यता और तकनीकी डेटा को कैसे संसाधित किया जाता है।",
      "officialTurkishNotice": "यह अनुवाद सुविधा के लिए प्रदान किया गया है। यदि अर्थ भिन्न होते हैं, तो तुर्की कानूनी पाठ लागू होता है।"
    }
  },
  "id": {
    "ui": {
      "home": "Beranda",
      "homeTitle": "Rumah",
      "explore": "Jelajahi",
      "gallery": "Galeri",
      "myImages": "Gambar Saya",
      "settings": "Pengaturan",
      "createImage": "Buat gambar",
      "back": "Kembali",
      "search": "Cari",
      "account": "Akun",
      "login": "Masuk",
      "logout": "Keluar",
      "profile": "Profil",
      "profileSettings": "Profil dan Pengaturan",
      "plans": "Paket dan penggunaan",
      "plansSubtitle": "Kredit gambar dan penagihan",
      "contact": "Kontak",
      "contactSubtitle": "Bantuan dan umpan balik",
      "discoverVoxnela": "Temukan Voxnela",
      "discoverVoxnelaSubtitle": "Tinjau pengalaman studio visual",
      "privacy": "Privasi",
      "privacySubtitle": "Bagaimana data Anda dilindungi",
      "terms": "Ketentuan Penggunaan",
      "termsSubtitle": "Syarat dan ketentuan layanan Voxnela",
      "preferencesSubtitle": "Akun Anda dan preferensi Voxnela",
      "accountSubtitle": "Detail akun dan keanggotaan",
      "voxAccount": "Akun Voxnela",
      "accessEverywhere": "Akses gambar Anda di setiap perangkat",
      "imageRights": "Kredit gambar {{count}}",
      "availableCredits": "Kredit yang tersedia",
      "renewalDate": "Tanggal perpanjangan",
      "membershipStart": "Keanggotaan dimulai",
      "registrationDate": "Tanggal pendaftaran",
      "monthly": "Bulanan",
      "renewalOff": "Perpanjangan dinonaktifkan",
      "user": "Pengguna Voxnela",
      "language": "Bahasa",
      "languageSubtitle": "Pilih bahasa aplikasi",
      "supportBody": "Hubungi kami jika Anda memiliki masalah atau ingin membagikan ide. Sertakan ID proyek membantu kami merespons lebih cepat.",
      "studioTitle": "Studio Visual Voxnela",
      "studioSubtitle": "Buat Gayamu",
      "searchSubtitle": "Gambar dan proyek Anda",
      "searchPlaceholder": "Cari gambar atau proyek",
      "noSearchResults": "Tidak ada yang cocok dengan pencarian ini.",
      "project": "Proyek",
      "image": "Gambar",
      "completed": "Selesai",
      "currentPlan": "Rencana saat ini",
      "notSignedIn": "Belum masuk",
      "signInIntro": "Masuk untuk mulai menggunakan Voxnela.",
      "creditsAvailable": "Kredit gambar studio {{count}} tersedia.",
      "noCredits": "Anda tidak memiliki kredit gambar yang tersisa dalam periode ini.",
      "membershipInfo": "Dana kredit rencana tahunan diperbarui setiap bulan dan tidak ditransfer ke bulan berikutnya. Pembelian yang dipulihkan tetap terlindungi melalui akun Anda.",
      "signedOutMembershipInfo": "Setelah masuk, kredit gambar yang tersedia dan informasi rencana Anda akan muncul di sini.",
      "reviewPlans": "Lihat rencana",
      "versionUpdated": "Versi {{version}} · Terakhir diperbarui {{date}}",
      "onboardingWelcome": "Selamat datang di Voxnela",
      "skipIntro": "Lewati pengantar",
      "continue": "Lanjutkan",
      "startCreating": "Mulai membuat",
      "close": "Tutup",
      "dragToClose": "Geser ke bawah untuk menutup lembar",
      "loading": "Memuat...",
      "sheetExpand": "Perluas lembar",
      "sheetCollapse": "Lembar pengembalian ke ketinggian normal",
      "cannotClose": "Tidak dapat ditutup selama operasi sedang berlangsung",
      "stylePreview": "Pratinjau Gaya",
      "stylePreviewSubtitle": "Gaya dan tren tanda tangan",
      "categories": "Kategori",
      "useThisStyle": "Gunakan gaya ini",
      "videoControls": "Kontrol video",
      "play": "Main",
      "pause": "Berhenti",
      "mute": "Membisu",
      "unmute": "Membunyikan suara",
      "minimize": "Meminimalkan",
      "expandVideo": "Perluas di aplikasi",
      "videoProgress": "Kemajuan video",
      "toggleVideoControls": "Tampilkan atau sembunyikan kontrol video",
      "expandedVideo": "{{title}} tampilan video yang diperluas",
      "goToImage": "Pergi ke gambar {{title}}",
      "categoryVisualStyles": "{{category}} gaya visual",
      "onboarding1Eyebrow": "Pembuatan Gambar",
      "onboarding1Title": "Buat gambarmu.",
      "onboarding1Body": "Ubah ide Anda menjadi bingkai sinematik dengan film 35mm, editorial, produk, poster, dan banyak gaya visual lainnya.",
      "onboarding2Eyebrow": "Coba Pakaian Virtual",
      "onboarding2Title": "Coba penampilan baru.",
      "onboarding2Body": "Pertahankan identitas di seluruh produksi dan buat visual coba-coba mode, aksesori, dan produk yang realistis.",
      "onboarding3Eyebrow": "Pengeditan Gambar",
      "onboarding3Title": "Edit gambarmu.",
      "onboarding3Body": "Perbaiki komposisi, cahaya, warna dan detail secara percakapan tanpa memulai dari awal.",
      "onboarding4Eyebrow": "3 Gambar Gratis",
      "onboarding4Title": "Mulai gratis.",
      "onboarding4Body": "Mulai sekarang dengan 3 pembuatan gambar AI gratis satu kali. Tanpa perlu akun.",
      "onboardingFaceEyebrow": "Analisis Wajah dan Gaya",
      "onboardingFaceTitle": "Kenali wajah dan gayamu.",
      "onboardingFaceBody": "Jelajahi ide rambut, kacamata, dan pakaian dari potretmu dalam satu panduan visual.",
      "onboardingHouseEyebrow": "Perjalanan Waktu",
      "onboardingHouseTitle": "Jelajahi waktu.",
      "onboardingHouseBody": "Gabungkan foto dan tanggalmu untuk melihat perubahan rumah dari waktu ke waktu.",
      "onboardingFestivalEyebrow": "Hari Festivalmu",
      "onboardingFestivalTitle": "Rencanakan hari festivalmu sekilas.",
      "onboardingFestivalBody": "Ubah jadwal, panggung, dan waktu yang kamu berikan menjadi rute visual pribadi.",
      "onboardingStylesEyebrow": "Gaya Voxnela",
      "onboardingStylesTitle": "Pilih gayamu.",
      "onboardingStylesBody": "Ubah ide Anda menjadi bingkai sinematik dengan film 35mm, editorial, produk, poster, dan banyak gaya visual lainnya."
    },
    "auth": {
      "enterCode": "Masukkan kode",
      "membershipAndAccount": "Detail keanggotaan dan akun",
      "noPeriodInfo": "Periode tidak tersedia",
      "memberSince": "Anggota sejak",
      "planSince": "{{plan}} sejak",
      "membershipRenewal": "Tanggal perpanjangan keanggotaan",
      "accountActions": "Tindakan akun",
      "manageSubscriptionTitle": "Akhiri langganan",
      "manageSubscriptionSubtitle": "Kelola langganan toko dan perpanjangan otomatis Anda.",
      "deleteAccountTitle": "Hapus akun saya",
      "deleteAccountSubtitle": "Proses penghapusan yang dapat dibalikkan selama 15 hari.",
      "deleteDataTitle": "Hapus data saya",
      "deleteDataSubtitle": "Proses penghapusan data reversibel selama 30 hari.",
      "signingOut": "Keluar…",
      "signOut": "Keluar",
      "signingIn": "Masuk…",
      "continueApple": "Lanjutkan dengan Apple",
      "continueGoogle": "Lanjutkan dengan Google",
      "or": "atau",
      "email": "Email",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "Dengan melanjutkan dengan Voxnela, Anda menyetujui",
      "legalTerms": "Syarat Penggunaan",
      "legalJoin": "dan konfirmasi bahwa Anda telah membaca dan memahami",
      "legalPrivacy": "Pengumuman Privasi",
      "legalSuffix": ".",
      "sendingCode": "Mengirim kode…",
      "emailSignIn": "Masuk dengan email",
      "codeSent": "Kami mengirimkan kode ke {{email}}.",
      "change": "Ubah",
      "sixDigitCode": "Kode 6 digit",
      "emailCode": "Kode masuk email",
      "verifyingCode": "Memverifikasi kode…",
      "resendCode": "Kirim ulang kode",
      "requestReceived": "Permintaan diterima",
      "accountDeletionStarted": "Proses penghapusan akun Anda telah dimulai",
      "dataDeletionStarted": "Proses penghapusan data Anda telah dimulai",
      "accountAction": "Tindakan akun",
      "accountDeletesAt": "Akun Anda akan dihapus secara permanen di {{date}}.",
      "dataDeletesAt": "Data Voxnela pribadi Anda akan dihapus secara permanen pada {{date}}.",
      "deletionUndo": "Jika Anda masuk menggunakan akun yang sama sebelum tanggal ini, proses penghapusan akan dibatalkan secara otomatis. Sesi Anda saat ini ditutup karena permintaan telah dibuat.",
      "done": "Selesai",
      "cancel": "Batal",
      "preparing": "Menyiapkan...",
      "invalidEmail": "Masukkan alamat email yang valid.",
      "enterSixDigitCode": "Masukkan kode 6 digit yang dikirim ke email Anda.",
      "signInFailed": "Masuk tidak dapat diselesaikan. Silakan coba lagi.",
      "codeSendFailed": "Kode masuk tidak dapat dikirim. Silakan coba lagi.",
      "codeVerifyFailed": "Kode tidak dapat diverifikasi. Silakan coba lagi.",
      "operationFailed": "Operasi tidak dapat diselesaikan saat ini. Silakan coba lagi.",
      "popupClosed": "Jendela masuk telah ditutup.",
      "unauthorizedDomain": "Domain ini tidak diizinkan untuk masuk.",
      "methodUnavailable": "Metode masuk ini belum diaktifkan.",
      "tooManyCodes": "Terlalu banyak kode yang diminta. Coba lagi dalam beberapa menit.",
      "invalidCode": "Kode tidak berlaku atau telah kedaluwarsa. Minta kode baru.",
      "emailUnavailable": "Pengiriman email saat ini tidak tersedia.",
      "actions": {
        "subscription": {
          "eyebrow": "Tindakan langganan",
          "title": "Berhenti berlangganan?",
          "confirm": "Kelola langganan",
          "paragraphs": [
            "Melanjutkan membuka halaman manajemen langganan Apple App Store atau Google Play di mana Anda membeli langganan tersebut. Anda harus mematikan perpanjangan otomatis di toko.",
            "Setelah pembatalan, manfaat keanggotaan Anda yang sudah ada tetap tersedia hingga akhir periode pembayaran. Menghapus akun atau data Anda tidak membatalkan langganan toko."
          ]
        },
        "account": {
          "eyebrow": "Tindakan akun permanen",
          "title": "Apakah Anda yakin ingin menghapus akun Anda?",
          "confirm": "Mulai proses penghapusan selama 15 hari",
          "paragraphs": [
            "Melanjutkan memulai proses penghapusan selama 15 hari dan menandatangani Anda keluar untuk keamanan. Jika Anda tidak masuk lagi selama periode ini, akun, profil, kreasi, perpustakaan, koleksi, dan data Voxnela terkait Anda akan dihapus secara permanen.",
            "Masuk dengan akun yang sama sebelum 15 hari membatalkan penghapusan secara otomatis. Menghapus akun tidak membatalkan langganan toko yang aktif; batalkan secara terpisah di toko."
          ]
        },
        "data": {
          "eyebrow": "Tindakan data permanen",
          "title": "Apakah Anda yakin ingin menghapus data Anda?",
          "confirm": "Mulai proses penghapusan selama 30 hari",
          "paragraphs": [
            "Melanjutkan memulai proses penghapusan selama 30 hari dan menandatangani Anda keluar untuk keamanan. Jika Anda tidak masuk lagi selama periode ini, kreasi, perpustakaan, koleksi, catatan, interaksi, dan data Voxnela pribadi lainnya Anda akan dihapus secara permanen; akun masuk Anda tetap tersedia.",
            "Masuk kembali sebelum 30 hari membatalkan penghapusan data secara otomatis. Transaksi terbatas dan catatan keamanan yang diwajibkan oleh hukum dapat disimpan dengan akses terbatas selama periode hukum yang berlaku."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "Tidak ada kredit gambar yang tersisa",
      "quotaFreeMessage": "Anda telah menggunakan kredit gambar di akun gratis Anda. Pilih rencana untuk melanjutkan membuat.",
      "later": "Nanti",
      "currentCredit": "Kredit saat ini: 0",
      "quotaProTitle": "Kuota Pro bulanan telah tercapai",
      "quotaProMessage": "Anda telah menggunakan 100 kredit gambar bulan ini. Tingkatkan ke Studio untuk terus membuat.",
      "renewalDate": "Tanggal perpanjangan: {{date}}",
      "quotaStudioTitle": "Kuota Studio bulanan telah tercapai",
      "quotaStudioMessage": "Kredit gambar Anda akan diperpanjang secara otomatis pada {{date}}.",
      "done": "Selesai",
      "membership": "Keanggotaan Voxnela",
      "options": "Pilihan keanggotaan",
      "credits": "Kredit",
      "currentMembership": "Keanggotaan saat ini",
      "yearlyDiscount": "Diskon 17%",
      "loadingPrice": "Memuat harga toko…",
      "loadingStorePrice": "Pengisian harga dari toko",
      "year": "tahun",
      "month": "bulan",
      "renewDisclosure": "Perpanjang otomatis setiap {{period}}. Batalkan kapan saja.",
      "legal": "Hukum",
      "terms": "Ketentuan",
      "alreadyMember": "Anda sudah memiliki {{plan}} {{period}}",
      "startPlan": "Mulai Paket {{plan}}",
      "upgradeStudio": "Tingkatkan ke Studio",
      "yearlyAdvantage": "Beralih ke tabungan tahunan",
      "upgrade": "Tingkatkan keanggotaan",
      "signInRequired": "Masuk ke akun Voxnela Anda sebelum memulai langganan.",
      "catalogUnavailable": "Katalog pembayaran tidak dapat diverifikasi untuk rencana ini. Silakan coba lagi segera.",
      "paymentUnavailable": "Tampilan pembayaran tidak dapat dibuka. Silakan coba lagi.",
      "benefits": [
        {
          "lead": "{{credits}} Kredit",
          "label": "Pembuatan gambar resolusi tinggi setiap bulan"
        },
        {
          "lead": "50+ Gaya Studio",
          "label": "Neo-Minimalisme, Sinematik dan setiap gaya khas"
        },
        {
          "lead": "Kunci Wajah",
          "label": "Coba-coba mode virtual tanpa mengubah fitur wajah"
        },
        {
          "lead": "Antrean Prioritas",
          "label": "Pemrosesan GPU ultra-cepat tanpa menunggu"
        },
        {
          "lead": "Perbaikan Obrolan",
          "label": "Edit detail multi-putaran tanpa batas dalam bahasa alami"
        },
        {
          "lead": "Hak Komersial Lengkap",
          "label": "Penggunaan resolusi tinggi, bebas watermark"
        }
      ],
      "restorePurchases": "Memulihkan pembelian",
      "restoringPurchases": "Memulihkan pembelian...",
      "restoreSuccess": "Keanggotaan Anda telah dipulihkan.",
      "restoreEmpty": "Tidak ditemukan langganan aktif untuk akun App Store ini.",
      "membershipSyncPending": "Memverifikasi keanggotaan dan kredit gambar...",
      "membershipSyncFailed": "Kredit gambar tidak dapat disinkronkan. Coba lagi.",
      "membershipUnavailable": "Keanggotaan tidak dapat dimuat.",
      "retry": "Coba lagi"
    },
    "video": {
      "revisionHook": "Buat tiga detik pertama lebih menarik.",
      "revisionPace": "Seimbangkan kecepatan dan singkirkan bagian-bagian yang lambat.",
      "revisionEnding": "Buat akhirnya lebih berkesan.",
      "revisionTransition": "Buat transisi menjadi lebih lancar dan lebih alami.",
      "revisionFraming": "Gunakan bingkai yang lebih seimbang untuk detail penting.",
      "revisionColor": "Buat warna-warnanya lebih seimbang dan sinematik.",
      "revisionText": "Buat teks lebih singkat dan lebih mudah dibaca.",
      "revisionAudio": "Sesuaikan musik lebih dekat dengan ritme gambar.",
      "revisionEmotion": "Buat cerita terasa lebih tulus dan emosional.",
      "revisionStructure": "Bangun awal, tengah, dan akhir yang lebih jelas.",
      "previewBack": "Kembali ke pratinjau",
      "revisionWelcome": "Apa yang ingin kamu ubah?",
      "revisionFailed": "Saya tidak bisa menerapkan perubahan itu. Bisakah Anda menjelaskannya lagi?",
      "finalQueued": "Video terakhir sedang dalam antrean. Video tersebut akan muncul di bawah Video ketika sudah siap.",
      "watermarkUpgrade": "Pilih rencana untuk membuat output akhir baru tanpa watermark Voxnela.",
      "finalFailed": "Video terakhir tidak dapat dimulai.",
      "projectDeleteFailed": "Proyek tidak dapat dihapus.",
      "videoDescriptionWithBrief": "Video ini dibuat dari “{{brief}}”. Voxnela memilih momen-momen terkuat dan membangun ritme serta urutan adegan di sekitar arah kreatif yang dipilih.",
      "videoDescriptionGeneric": "Voxnela mengevaluasi materi untuk konten, kecepatan, dan koherensi naratif, menyoroti momen-momen terkuat untuk penyuntingan yang seimbang.",
      "play": "Main",
      "deletesOn": "menghapus pada {{date}}",
      "projectsBelong": "Proyek Anda terhubung dengan akun Anda.",
      "videosBelong": "Video Anda terhubung ke akun Anda.",
      "signInToSeeProjects": "Masuk untuk melihat proyek Anda dan melanjutkan di berbagai perangkat.",
      "signInToSeeVideos": "Masuk untuk melihat video Anda dan melanjutkan di berbagai perangkat.",
      "delete": "Hapus",
      "deleting": "Menghapus…",
      "secondsVersion": "{{seconds}} sek · versi {{version}}",
      "deleteProject": "Hapus proyek",
      "projectCoverUnavailable": "Latar belakang proyek tidak dapat dimuat",
      "videoCoverPreparing": "Menyiapkan sampul video",
      "deleteVideo": "Hapus video",
      "signed": "Berlabel Voxnela",
      "failed": "Tidak dapat menyelesaikan",
      "tryAgain": "Anda dapat mencoba lagi",
      "cancelled": "Dibatalkan",
      "noCreditUsed": "Tidak ada kredit yang digunakan",
      "featuredStyles": "Gaya visual yang dipamerkan",
      "previousImage": "Gambar sebelumnya",
      "nextImage": "Gambar berikutnya",
      "reviewStyle": "Telusuri Gaya Ini",
      "featuredNavigation": "Navigasi visual yang dipamerkan",
      "taskCategories": "Kategori tugas",
      "projectOpening": "Proyek pembukaan",
      "opening": "Pembukaan...",
      "projectNotFound": "Proyek tidak ditemukan",
      "projectUnavailable": "Proyek ini tidak lagi tersedia.",
      "backToProjects": "Kembali ke proyek saya",
      "editVideo": "Edit video",
      "versionContext": "Versi {{version}} · Voxnela mengenal proyek dan materi Anda",
      "livePreviewActions": "Tindakan pratinjau langsung",
      "edit": "Edit",
      "preparing": "Menyiapkan",
      "save": "Simpan",
      "thinking": "Voxnela sedang berpikir",
      "revisionSuggestions": "Saran pengeditan",
      "describeChange": "Jelaskan perubahan yang Anda inginkan",
      "sendEdit": "Kirim permintaan pengeditan",
      "deleteProjectDescription": "Apakah Anda yakin ingin menghapus “{{title}}” dan semua materi terkait? Ini tidak dapat dibalik.",
      "projects": "Proyek",
      "projectsPreparing": "Menyiapkan proyek Anda",
      "noProjects": "Anda belum memiliki proyek. Mulailah dengan menggambarkan ide pertama Anda.",
      "createNew": "Buat gambar baru",
      "thisProject": "Proyek ini",
      "videos": "Video",
      "videosPreparing": "Menyiapkan video Anda",
      "noVideos": "Anda belum memiliki video yang selesai. Video tersebut akan muncul di sini ketika video pertama Anda siap.",
      "videoPlayFailed": "Video tidak dapat diputar.",
      "videoNotReady": "Berkas video belum siap untuk diunduh.",
      "videoDownloadFailed": "Video tidak dapat diunduh.",
      "videoDeleteFailed": "Video tidak dapat dihapus.",
      "videoLoading": "Memuat video...",
      "videoActions": "Tindakan video",
      "showVideoDescription": "Tampilkan deskripsi video",
      "videoDownloading": "Mengunduh video",
      "downloadVideo": "Unduh video",
      "thisVideo": "Video ini",
      "deleteVideoDescription": "Apakah Anda yakin ingin menghapus video berjudul “{{title}}”? Ini tidak dapat dibatalkan."
    },
    "studio": {
      "useStyle": "Gunakan Gaya Ini",
      "galleryFilters": "Filter galeri",
      "modeStyleTransfer": "Gaya Voxnela",
      "modeVirtualTryOn": "Coba-Coba Virtual",
      "modeMagazineCover": "Majalah & Sampul",
      "modePosterStudio": "Studio Poster",
      "modeCommercial": "Pameran Produk",
      "modeTimeWarp": "Perjalanan Waktu",
      "modeOutpaintRelight": "Kembangkan & Nyalakan Kembali",
      "modeInfographic": "Infografik & Data",
      "modePortraitRetouch": "Retouch Potret",
      "modeArtisticCollage": "Kolase Artistik",
      "defaultStyle": "Gaya Voxnela",
      "signInToCreate": "Masuk untuk membuat gambar.",
      "signInToEdit": "Masuk untuk mengedit gambar.",
      "creationSuccess": "Gambar Anda berhasil dibuat. Beritahu saya langsung jika Anda ingin mengubah pencahayaan, warna, objek, atau bingkai.",
      "imageReady": "Gambar Anda sudah siap. Beritahu saya apa yang Anda sukai atau apa yang ingin Anda perbaiki.",
      "revisionSuccess": "Revisi telah selesai. Anda dapat membandingkannya dengan slider sebelum/sesudah atau meminta perubahan lain.",
      "versionReady": "Versi {{version}} sudah siap.",
      "projectNotFound": "Proyek tidak ditemukan.",
      "styleApplied": "Gaya {{style}} diterapkan",
      "imageCreation": "Pembuatan gambar",
      "defaultPrompt": "Gambar studio",
      "aspectSquare": "Kotak",
      "aspectSquareDetail": "Jurnal Instagram, Profil, Seni",
      "aspectVertical": "Vertikal",
      "aspectVerticalDetail": "Instagram Story, Reels, TikTok",
      "aspectHorizontal": "Horizontal",
      "aspectHorizontalDetail": "YouTube, Spanduk, Bioskop",
      "aspectPortrait": "Potret",
      "aspectPortraitDetail": "Potret Instagram, Poster, Tampilkan",
      "aspectPanoramic": "Panorama",
      "aspectPanoramicDetail": "Lanskap Cinematik Luas Ultra",
      "styles": "Gaya Voxnela",
      "fullScreenStyle": "Lihat gaya penuh layar",
      "closeDescription": "Deskripsi gaya close",
      "moreWithVoxnela": "Lakukan lebih banyak dengan Voxnela",
      "quickStartBody": "Tuliskan apa yang Anda inginkan di bawah ini atau lampirkan sebuah file.",
      "createImage": "Buat gambar",
      "createImageDetail": "Bangun ide Anda dari nol",
      "editImage": "Edit gambar",
      "editImageQuick": "Edit sebuah gambar",
      "editImageDetail": "Bayangkan ulang gambar yang diunggah",
      "transformStyle": "Transformasi gaya dan adegan",
      "transformStyleDetail": "Pindahkan gambar Anda ke dunia lain",
      "visualizeDocument": "Visualisasikan sebuah dokumen atau presentasi",
      "visualizeDocumentDetail": "Ubah konten lengkap menjadi desain",
      "submittedImage": "Gambar yang diserahkan",
      "generating": "Voxnela sedang membuat gambar…",
      "viewImage": "Lihat gambar",
      "removeStyle": "Hapus gaya yang dipilih",
      "referenceImage": "Gambar referensi",
      "referenceNotice": "Gambar ini akan direvisi atau gaya baru akan diterapkan",
      "removeReference": "Hapus gambar referensi",
      "remove": "Hapus",
      "uploading": "Mengunggah",
      "addFile": "Tambahkan sebuah file atau gambar",
      "addFileTitle": "Tambahkan hingga 4 gambar atau dokumen (PDF, Word, PPT, maksimal 12 MB)",
      "aspectRatio": "Rasio aspek",
      "selectAspectRatio": "Pilih rasio aspek",
      "aspectOptions": "Opsi rasio aspek",
      "revisePlaceholder": "Apa yang ingin Anda ubah pada gambar ini?",
      "styledPlaceholder": "Jelaskan gambar yang Anda inginkan dalam gaya ini (opsional)...",
      "promptPlaceholder": "Gambarkan sebuah gambar atau tulis sebuah prompt...",
      "reviseImage": "Perbaiki gambar",
      "generateImage": "Buat gambar",
      "generatedImage": "Gambar yang dihasilkan",
      "done": "Selesai",
      "fileLimitTitle": "File terlalu besar",
      "fileLimitMessage": "“{{name}}” melebihi batas 12 MB ({{size}} MB). Pilih file yang lebih kecil.",
      "imageLimitTitle": "Batasan gambar",
      "imageLimitMessage": "Anda dapat mengunggah hingga 4 gambar. Gambar {{count}} saat ini dipilih.",
      "uploadFailedTitle": "Unduhan gagal",
      "uploadFailedMessage": "Terjadi masalah saat mengunggah file.",
      "revisionFailed": "Terjadi kesalahan selama revisi atau kuota telah terlebihi.",
      "generationFailed": "Terjadi kesalahan selama pembuatan gambar atau kuota telah terlanjut.",
      "imageDetails": "Detail gambar",
      "close": "Tutup",
      "download": "Unduh",
      "downloadImage": "Unduh gambar",
      "downloading": "Mengunduh",
      "versionImage": "Gambar",
      "exploreTitle": "Gaya seperti apa yang Anda cari?",
      "explorePlaceholder": "Misalnya: potret sinematik dengan nada gelap dan perspektif yang dalam",
      "searchStyles": "Cari gaya visual",
      "clearSearch": "Pencarian bersih",
      "exploreCategories": "Telusuri kategori",
      "all": "Semua",
      "styleCount": "Gaya {{count}}",
      "noStyle": "Tidak ditemukan gaya yang cocok",
      "noStyleBody": "Coba lagi dengan deskripsi yang lebih singkat atau kata-kata yang berbeda.",
      "libraryKicker": "Pustaka gambar pribadi Anda",
      "myImages": "Gambar saya",
      "imageWorks": "Gambar {{count}} berfungsi",
      "newImage": "Buat gambar baru",
      "noImage": "Anda belum membuat gambar",
      "noCategoryImage": "Tidak ada gambar di kategori ini",
      "emptyGalleryBody": "Buat gambar pertama Anda dengan transfer gaya, coba-coba virtual, sampul majalah atau pameran produk.",
      "firstImage": "Buat gambar pertama Anda",
      "imageWork": "Pekerjaan gambar"
    },
    "create": {
      "briefTitle": "Jelaskan ide atau topik Anda",
      "briefPlaceholder": "Apa subjeknya? Misalnya: masa depan AI, perjalanan ke Mars, atau peluncuran produk…",
      "briefLabel": "Ringkasan penciptaan",
      "contentType": "Jenis konten",
      "media": "Gambar & Media",
      "added": "{{count}} ditambahkan",
      "optional": "Opsional",
      "addMedia": "Tambahkan foto atau video jika Anda mau",
      "addMediaBody": "Unggah media Anda sendiri atau biarkan kosong dan biarkan AI menemukannya",
      "attachedMedia": "Media terlampir",
      "add": "Tambahkan",
      "mediaFallback": "Media",
      "aiCompletes": "Biarkan AI menyelesaikan visualnya",
      "noMedia": "Tidak ada gambar yang diunggah; AI akan menyelesaikan adegan tersebut.",
      "productionFormat": "Format produksi",
      "style": "Gaya",
      "customVisualWorld": "Jelaskan Dunia Visual Anda",
      "colorsAtmosphere": "Warna, suasana, kamera, ritme",
      "customStyleShort": "Jelaskan dunia visual yang Anda pikirkan (misalnya: nada pastel dan kamera yang tenang, atau neon cyberpunk…)",
      "customStyleLong": "Jelaskan dunia visual, warna, suasana, dan ritme yang ada dalam pikiran Anda.",
      "voiceover": "Sulih suara",
      "ownVoiceover": "Teks pengisi suara Anda",
      "voiceoverPlaceholder": "Tulis teks Anda di sini. Jika kosong, Voxnela akan menyiapkannya.",
      "duration": "Durasi",
      "seconds": "{{count}} detik",
      "freeLimit": "Video akhir terpanjang pada paket gratis adalah 60 detik.",
      "addSound": "Tambahkan suara atau musik",
      "notAdded": "Tidak ditambahkan",
      "files": "File {{count}}",
      "readySounds": "Gunakan suara yang sudah siap pakai",
      "musicLibrary": "Pustaka musik",
      "uploadOwn": "Unggah milikmu sendiri",
      "captions": "Takarir",
      "back": "Kembali",
      "create": "Buat",
      "next": "Berikutnya",
      "researchingTopic": "Meneliti topik tersebut...",
      "analyzingMaterials": "Menganalisis bahan...",
      "researchBody": "Memverifikasi sumber dan menyiapkan skrip dan rencana visual.",
      "analyzeBody": "Menilai bingkai yang kuat, emosi, ritme dan singkatnya bersama.",
      "creativeDirection": "Arah kreatif {{count}}",
      "recommended": "Direkomendasikan",
      "generationFailed": "Pembuatan tidak dapat diselesaikan",
      "retry": "Persiapkan lagi",
      "backDirections": "Kembali ke arah kreatif",
      "preparingVideo": "Menyiapkan video",
      "voiceoverText": "Teks rekaman suara",
      "describeStyle": "Jelaskan gaya Anda sendiri",
      "topicDirection": "Topik dan arah",
      "styleEditorSubtitle": "Jelaskan dunia visual, warna dan suasana",
      "editorSubtitle": "Tulis teks dan masukkan ke dalam lembar pembuatan",
      "voiceoverEditorPlaceholder": "Tulis teks untuk digunakan untuk penyampaian suara.",
      "topicEditorPlaceholder": "Tulis topik dan bagaimana Anda ingin itu disampaikan.",
      "insertText": "Masukkan teks",
      "bestFor": "Paling cocok untuk:",
      "useStyle": "Gunakan gaya ini",
      "musicSubtitle": "Lagu asli telah disetujui untuk penggunaan komersial",
      "adding": "Menambahkan...",
      "musicLicense": "Lagu disediakan di bawah CC0 1.0; penggunaan komersial diperbolehkan dan atribusi tidak diperlukan.",
      "yes": "Ya",
      "no": "Tidak",
      "newCreation": "Kreati baru",
      "reviewing": "Voxnela sedang meninjau",
      "chooseDirection": "Pilih salah satu dari tiga pendekatan pengeditan",
      "ideaSubtitle": "Jelaskan ide Anda; unggah visual atau izinkan Voxnela untuk membuatnya",
      "projectOpenFailed": "Paket proyek tidak dapat dibuka.",
      "tooManyAssets": "Anda dapat menambahkan hingga 50 aset ke sebuah proyek.",
      "uploadSizeLimit": "Unggahan proyek total melebihi batas 2 GB.",
      "filesAddFailed": "File tidak dapat ditambahkan.",
      "musicPreviewFailed": "Pratinjau musik tidak dapat dibuka.",
      "musicFetchFailed": "Berkas musik tidak dapat diambil.",
      "musicAddFailed": "Musik tidak dapat ditambahkan.",
      "topicRequired": "Masukkan sebuah topik dan jelaskan tentang apa video Anda akan membahas.",
      "briefTooShort": "Jelaskan apa yang ingin Anda sampaikan dalam setidaknya beberapa kata.",
      "mediaRequired": "Unggah gambar atau aktifkan visual yang dihasilkan AI.",
      "proposalIntro": "Saya meninjau gambar dan video dan menyiapkan tiga petunjuk editing yang sesuai dengan gaya, format, dan pilihan audio Anda.",
      "removeMaterial": "Hapus {{name}}",
      "aiVisualNotice": "Gambar asli dan ilustrasi AI yang dilisensikan secara terbuka ditemukan secara otomatis.",
      "stepProgress": "Langkah {{current}} dari {{total}}",
      "styleSampleAlt": "Contoh yang menunjukkan gaya video {{style}}",
      "reviewStyle": "Tinjau gaya {{style}}",
      "selectedDirectionPrompt": "Arah yang dipilih: {{title}}. Arah visual {{summary}}: {{visual}}. Pendekatan transisi: {{transitions}}. Pendekatan musik: {{music}}.",
      "letVoxnelaChoose": "Biarkan Voxnela memilih",
      "feminineVoice": "Feminin",
      "masculineVoice": "Jantan",
      "narrationStyle": "Gaya narasi",
      "voiceEstimate": "Tentang {{seconds}} sek · kata-kata {{words}}.",
      "voiceShort": "Jika itu singkatan dari {{duration}} detik, Voxnela akan menyelesaikannya sambil mempertahankan makna.",
      "voiceNatural": "Voxnela hanya menyesuaikan tata bahasa, frasa dan alur alami.",
      "removeFile": "Hapus file {{name}}",
      "musicStop": "Berhenti {{title}}",
      "musicListen": "Dengarkan {{title}}",
      "automatic": "Mobil",
      "all": "Semua",
      "cinematic": "Sinematik",
      "social": "Sosial & Dinamis",
      "designTypography": "Desain & Tipografi",
      "retroExperimental": "Retro & Eksperimental",
      "productionStage1": "Memilih bingkai dan adegan terkuat.",
      "productionStage2": "Membangun cerita, gerakan dan transisi.",
      "productionStage3": "Menyeimbangkan musik, suara, dan keterangan.",
      "productionStage4": "Melakukan pemeriksaan akhir pada pratinjau langsung.",
      "genericCreationError": "Terjadi masalah saat menyiapkan rencana video. Materi dan pilihan Anda telah disimpan; Anda dapat mencoba lagi.",
      "newVideo": "Video baru",
      "topicNews": "Berita",
      "topicDocumentary": "Dokumenter",
      "topicExplainer": "Penjelas",
      "topicStory": "Cerita",
      "topicScience": "Ilmu pengetahuan",
      "topicPhilosophy": "Filosofi",
      "topicMagazine": "Majalah",
      "topicEntertainment": "Hiburan",
      "topicList": "Daftar",
      "toneCalm": "Tenang",
      "toneEmotional": "Emosional",
      "toneEnergetic": "Energis",
      "toneStorytelling": "Menceritakan cerita",
      "toneCheerful": "Semangat",
      "toneMysterious": "Misterius",
      "toneNews": "Berita",
      "styleCinematic": "Sinematik",
      "styleDarkCinematic": "Ksinematik Gelap",
      "styleDocumentary": "Dokumenter",
      "styleModernDocumentary": "Dokumenter Modern",
      "stylePovImmersive": "POV imersif",
      "styleUgcAuthentic": "UGC otentik",
      "styleMiniVlog": "Mini Vlog",
      "styleSocialViral": "Viral Sosial",
      "styleHyperEdit": "Pereditan Hyper",
      "styleSportsHype": "Hype Olahraga",
      "styleVelocityEdit": "Edit Kecepatan",
      "styleMusicBeatEdit": "Edit Jeda Musik",
      "styleKineticTypography": "Tipografi Kinetik",
      "styleMinimalClean": "Minimal & Bersih",
      "styleLuxuryMinimal": "Minimalis Mewah",
      "styleCommercialProduct": "Produk Komersial",
      "styleEditorialFashion": "Mode Editorial",
      "styleCollageZine": "Zine Kolase",
      "styleTechFuturistic": "Teknologi Futuristik",
      "styleRetroFuturism": "Futurisme Retro",
      "styleY2kDigital": "Digital Y2K",
      "styleVhsCamcorder": "Kamera VHS",
      "styleAnalogFilm": "Film Analog",
      "styleGlitchCyber": "Glitch Siber",
      "musicUpbeatMood": "Energi · cerah",
      "musicUpbeatDetail": "Rekaman instrumen asli untuk konten sosial yang ceria, momen perjalanan, dan edisi yang hidup.",
      "musicElectronicMood": "Modern · ritmis",
      "musicElectronicDetail": "Musik elektronik nyata untuk kota, teknologi, produk, dan edisi yang cepat.",
      "musicRomanceMood": "Emosional · hangat",
      "musicRomanceDetail": "Musik instrumen dengan alur emosional yang lembut untuk keluarga, potret, hari spesial dan kenangan.",
      "musicScoringMood": "Naratif · sinematik",
      "musicScoringDetail": "Musik latar sinematik yang mendukung cerita, promosi, dan transisi dramatis.",
      "musicEpicMood": "Berdaya · meningkat",
      "musicEpicDetail": "Musik instrumental berlapis yang membangun untuk pembukaan besar, perjalanan dan akhir yang kuat.",
      "proposalBalancedTitle": "Narasi yang seimbang",
      "proposalBalancedSummary": "Edit yang mempertahankan alur materi dan menonjolkan frame yang paling kuat.",
      "proposalBalancedVisual": "Hierarki yang kuat dan sistem visual yang koheren",
      "proposalBalancedTransitions": "Potongan halus dan push-in yang diukur",
      "proposalBalancedMusic": "Musik yang bergerak dari emosi ke ritme",
      "proposalQuietTitle": "Cerita yang tenang",
      "proposalQuietSummary": "Pendekatan yang tenang yang memberikan bingkai lebih banyak waktu dan menekankan detail dan emosi alami.",
      "proposalQuietVisual": "Nada lembut dan pengambilan gambar yang lebih panjang",
      "proposalQuietTransitions": "Larut silang dan piring lambat",
      "proposalQuietMusic": "Musik sederhana dan emosional",
      "proposalRhythmicTitle": "Edit ritmis",
      "proposalRhythmicSummary": "Sebuah edit dengan hook pembukaan yang kuat yang mempercepat di tengah dan jelas menetap di akhir.",
      "proposalRhythmicVisual": "Kontras yang lebih kuat dan bingkai dinamis",
      "proposalRhythmicTransitions": "Potongan beat dan transisi cambuk yang dikendalikan",
      "proposalRhythmicMusic": "Musik enerjik dan sedang naik daun",
      "underVoiceover": "lembut di bawah suara latar",
      "withShortVoiceover": "dengan suara narasi singkat dan tegas"
    },
    "information": {
      "home": "Beranda",
      "documentInfo": "Informasi dokumen",
      "version": "Versi",
      "effective": "Berlaku",
      "updated": "Terakhir diperbarui",
      "contents": "Daftar isi",
      "officialReferences": "Referensi resmi",
      "referenceTitle": "Sumber daya hukum dan otoritas",
      "referenceBody": "Tautan-tautan ini disediakan untuk informasi umum. Hukum wajib dan peraturan terkini dari otoritas yang berwenang lebih diutamakan.",
      "supportKicker": "Dukungan Sponelabs",
      "contactTitle": "Hubungi kami",
      "contactLead": "Hubungi tim dukungan Voxnela mengenai akun, keanggotaan, pembayaran, pembuatan, laporan konten, privasi atau masalah teknis Anda.",
      "supportEmail": "Email dukungan",
      "emailBody": "Tombol di bawah ini membuka aplikasi email default Anda dengan templat dukungan yang siap digunakan sehingga kami dapat menyelidiki lebih cepat.",
      "openEmail": "Buka aplikasi email",
      "includeTitle": "Sertakan dalam pesan",
      "includeItems": [
        "Baik Anda menggunakan Web, iOS atau Mac;",
        "Versi perangkat dan sistem operasi Anda;",
        "Langkah-langkah untuk mereproduksi masalah tersebut;",
        "Tautan proyek terkait, detail transaksi atau tangkapan layar, jika tersedia."
      ],
      "sensitiveTitle": "Jangan kirim informasi sensitif",
      "sensitiveBody": "Jangan sertakan kode verifikasi, kata sandi, detail kartu pembayaran lengkap, dokumen identitas, data kesehatan atau informasi sensitif lainnya yang tidak diperlukan untuk menyelesaikan masalah.",
      "securityTitle": "Keamanan dan laporan konten",
      "securityBody": "Gunakan “Keamanan” untuk kerentanan, “Permintaan Privasi” untuk permintaan data, atau “Laporan Konten” untuk konten berbahaya atau melanggar hak cipta. Hubungi layanan darurat setempat dalam kasus bahaya fisik langsung.",
      "mailSubject": "Permintaan dukungan Voxnela",
      "mailGreeting": "Halo Tim Dukungan Voxnela,",
      "mailTopic": "Topik dukungan:",
      "mailPlatform": "Platform (Web / iOS / Mac):",
      "mailDevice": "Perangkat dan sistem operasi:",
      "mailProject": "ID Proyek (jika tersedia):",
      "mailDescription": "Deskripsi masalah atau permintaan:",
      "mailThanks": "Terima kasih.",
      "termsEyebrow": "Syarat dan ketentuan layanan Voxnela",
      "termsTitle": "Syarat Penggunaan",
      "termsLead": "Syarat dan ketentuan ini mengatur penggunaan layanan pembuatan dan pengeditan gambar AI di situs web Voxnela dan aplikasi iOS.",
      "privacyEyebrow": "Penggunaan data Voxnela",
      "privacyTitle": "Kebijakan Privasi",
      "privacyLead": "Kebijakan ini menjelaskan bagaimana akun, gambar, proyek, keanggotaan dan data teknis diproses dalam layanan pembuatan gambar Voxnela.",
      "officialTurkishNotice": "Terjemahan ini disediakan untuk kemudahan. Teks hukum Turki mengatur jika arti berbeda."
    }
  },
  "ja": {
    "ui": {
      "home": "ホーム",
      "homeTitle": "ホーム",
      "explore": "見つける",
      "gallery": "ギャラリー",
      "myImages": "私の画像",
      "settings": "設定",
      "createImage": "画像を作成",
      "back": "戻る",
      "search": "検索",
      "account": "アカウント",
      "login": "ログイン",
      "logout": "ログアウト",
      "profile": "プロフィール",
      "profileSettings": "プロフィールと設定",
      "plans": "プランと利用状況",
      "plansSubtitle": "画像クレジットと請求",
      "contact": "お問い合わせ",
      "contactSubtitle": "ヘルプとフィードバック",
      "discoverVoxnela": "Voxnelaを発見する",
      "discoverVoxnelaSubtitle": "ビジュアルスタジオの体験をレビューする",
      "privacy": "プライバシー",
      "privacySubtitle": "あなたのデータがどのように保護されているか",
      "terms": "利用規約",
      "termsSubtitle": "Voxnela利用規約",
      "preferencesSubtitle": "あなたのアカウントとVoxnelaの好み",
      "accountSubtitle": "アカウントと会員の詳細",
      "voxAccount": "Voxnelaアカウント",
      "accessEverywhere": "すべてのデバイスで画像にアクセスする",
      "imageRights": "{{count}}画像クレジット",
      "availableCredits": "利用可能なクレジット",
      "renewalDate": "更新日",
      "membershipStart": "会員登録が開始されました",
      "registrationDate": "登録日",
      "monthly": "月次",
      "renewalOff": "更新オフ",
      "user": "Voxnelaユーザー",
      "language": "言語",
      "languageSubtitle": "アプリの言語を選択",
      "supportBody": "問題がある場合やアイデアを共有したい場合は、私たちに連絡してください。プロジェクトIDを含めることで、より迅速に返信できるようになります。",
      "studioTitle": "Voxnela ビジュアルスタジオ",
      "studioSubtitle": "自分のスタイルを作成",
      "searchSubtitle": "あなたの画像とプロジェクト",
      "searchPlaceholder": "画像またはプロジェクトを検索する",
      "noSearchResults": "この検索に一致するものはありませんでした。",
      "project": "プロジェクト",
      "image": "画像",
      "completed": "完了しました",
      "currentPlan": "現在の計画",
      "notSignedIn": "サインインしていません",
      "signInIntro": "Voxnelaの利用を開始するには、サインインしてください。",
      "creditsAvailable": "{{count}}スタジオ画像クレジットは利用可能です。",
      "noCredits": "この期間で画像クレジットは残っていません。",
      "membershipInfo": "年間プランのクレジットは毎月更新され、繰り越されません。復元された購入はアカウントを通じて保護されたままです。",
      "signedOutMembershipInfo": "サインイン後、利用可能な画像クレジットとプラン情報がここに表示されます。",
      "reviewPlans": "プランを見る",
      "versionUpdated": "バージョン{{version}} · 最終更新 {{date}}",
      "onboardingWelcome": "Voxnelaへようこそ",
      "skipIntro": "紹介をスキップ",
      "continue": "続ける",
      "startCreating": "作成を始める",
      "close": "閉じる",
      "dragToClose": "スワイプダウンしてシートを閉じる",
      "loading": "読み込み中...",
      "sheetExpand": "シートを拡大する",
      "sheetCollapse": "返品シートを通常の高さに戻す",
      "cannotClose": "操作が進行中の間は閉じることはできません",
      "stylePreview": "スタイルプレビュー",
      "stylePreviewSubtitle": "シグネチャースタイルとトレンド",
      "categories": "カテゴリ",
      "useThisStyle": "このスタイルを使用する",
      "videoControls": "ビデオコントロール",
      "play": "プレイ",
      "pause": "一時停止する",
      "mute": "ミュート",
      "unmute": "ミュート解除",
      "minimize": "最小限にする",
      "expandVideo": "アプリで展開する",
      "videoProgress": "ビデオの進捗状況",
      "toggleVideoControls": "ビデオコントロールを表示または非表示にする",
      "expandedVideo": "{{title}}拡張ビデオビュー",
      "goToImage": "{{title}}画像へ行く",
      "categoryVisualStyles": "{{category}} ビジュアルスタイル",
      "onboarding1Eyebrow": "画像を作成",
      "onboarding1Title": "画像を作ろう。",
      "onboarding1Body": "35mmフィルム、編集、製品、ポスターなど、さまざまなビジュアルスタイルであなたのアイデアをシネマティックなフレームに変えてください。",
      "onboarding2Eyebrow": "バーチャル試着",
      "onboarding2Title": "新しい服を試そう。",
      "onboarding2Body": "プロダクション全体でアイデンティティを維持し、リアルなファッション、アクセサリー、製品の試着ビジュアルを作成します。",
      "onboarding3Eyebrow": "画像編集",
      "onboarding3Title": "画像を編集しよう。",
      "onboarding3Body": "構成、光、色、ディテールを最初からやり直さずに、会話しながら見直しましょう。",
      "onboarding4Eyebrow": "無料画像3枚",
      "onboarding4Title": "無料で始めよう。",
      "onboarding4Body": "1回限りの無料AI画像生成3回ですぐに始められます。アカウントは不要です。",
      "onboardingFaceEyebrow": "顔とスタイルの分析",
      "onboardingFaceTitle": "顔とスタイルを見つけよう。",
      "onboardingFaceBody": "ポートレートをもとに、髪型・眼鏡・服装のアイデアを一つのビジュアルガイドで確認できます。",
      "onboardingHouseEyebrow": "タイムトラベル",
      "onboardingHouseTitle": "時を旅しよう。",
      "onboardingHouseBody": "写真と日付を組み合わせ、家が時とともにどう変わったかを可視化します。",
      "onboardingFestivalEyebrow": "フェスティバルの一日",
      "onboardingFestivalTitle": "フェスティバルの予定をひと目で。",
      "onboardingFestivalBody": "入力したプログラム、会場、時刻を自分だけのビジュアルルートにまとめます。",
      "onboardingStylesEyebrow": "Voxnelaのスタイル",
      "onboardingStylesTitle": "スタイルを選ぼう。",
      "onboardingStylesBody": "35mmフィルム、編集、製品、ポスターなど、さまざまなビジュアルスタイルであなたのアイデアをシネマティックなフレームに変えてください。"
    },
    "auth": {
      "enterCode": "コードを入力",
      "membershipAndAccount": "会員登録とアカウントの詳細",
      "noPeriodInfo": "期間利用不可",
      "memberSince": "メンバーになってから",
      "planSince": "{{plan}}以来",
      "membershipRenewal": "会員更新日",
      "accountActions": "アカウント操作",
      "manageSubscriptionTitle": "サブスクリプションを終了する",
      "manageSubscriptionSubtitle": "ストアのサブスクリプションと自動更新を管理します。",
      "deleteAccountTitle": "アカウントを削除する",
      "deleteAccountSubtitle": "15日間の取り消し可能な削除プロセス。",
      "deleteDataTitle": "私のデータを削除する",
      "deleteDataSubtitle": "元に戻せる30日間のデータ削除プロセス。",
      "signingOut": "ログアウト中…",
      "signOut": "ログアウト",
      "signingIn": "ログイン中…",
      "continueApple": "Appleで続ける",
      "continueGoogle": "Googleで続ける",
      "or": "または",
      "email": "メール",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "Voxnelaを続けることで、あなたは同意します",
      "legalTerms": "利用規約",
      "legalJoin": "そして、あなたがそれを読み、理解したことを確認してください",
      "legalPrivacy": "プライバシーに関するお知らせ",
      "legalSuffix": "。",
      "sendingCode": "コードを送信中…",
      "emailSignIn": "メールでログイン",
      "codeSent": "{{email}}にコードを送りました。",
      "change": "変更",
      "sixDigitCode": "6桁のコード",
      "emailCode": "メールサインインコード",
      "verifyingCode": "コードを確認中…",
      "resendCode": "コードを再送信",
      "requestReceived": "リクエストを受領しました",
      "accountDeletionStarted": "アカウント削除プロセスが開始されました",
      "dataDeletionStarted": "データの削除プロセスが開始されました",
      "accountAction": "アカウントアクション",
      "accountDeletesAt": "{{date}}のアカウントは永久に削除されます。",
      "dataDeletesAt": "{{date}}のあなたの個人データは永久に削除されます。",
      "deletionUndo": "この日付までに同じアカウントでログインした場合、削除プロセスは自動的にキャンセルされます。リクエストが作成されたため、現在のセッションが終了しました。",
      "done": "完了",
      "cancel": "キャンセル",
      "preparing": "準備中…",
      "invalidEmail": "有効なメールアドレスを入力してください。",
      "enterSixDigitCode": "メールに送信された6桁のコードを入力してください。",
      "signInFailed": "サインインが完了できませんでした。もう一度お試しください。",
      "codeSendFailed": "サインインコードを送信できませんでした。もう一度お試しください。",
      "codeVerifyFailed": "コードを検証できませんでした。再度お試しください。",
      "operationFailed": "現在、操作を完了できませんでした。再度お試しください。",
      "popupClosed": "サインインウィンドウが閉じられました。",
      "unauthorizedDomain": "このドメインはサインインに許可されていません。",
      "methodUnavailable": "このサインイン方法はまだ有効になっていません。",
      "tooManyCodes": "コードが多すぎました。数分後に再度お試しください。",
      "invalidCode": "コードが無効または期限切れです。新しいコードをリクエストしてください。",
      "emailUnavailable": "現在、メールの配信は利用できません。",
      "actions": {
        "subscription": {
          "eyebrow": "サブスクリプションアクション",
          "title": "購読を終了しますか？",
          "confirm": "サブスクリプションを管理する",
          "paragraphs": [
            "「継続」を選択すると、購読したApple App StoreまたはGoogle Playのサブスクリプション管理ページが開きます。ストアで自動更新をオフにしてください。",
            "キャンセル後、既存の会員特典は有料期間終了まで有効です。アカウントまたはデータを削除しても、ストアのサブスクリプションはキャンセルされません。"
          ]
        },
        "account": {
          "eyebrow": "永続的なアカウントアクション",
          "title": "アカウントを削除したいと本当に思っていますか？",
          "confirm": "15日間の削除プロセスを開始する",
          "paragraphs": [
            "継続すると、15日間の削除プロセスが開始され、セキュリティのためにログアウトされます。この期間中に再度ログインしない場合、アカウント、プロフィール、作成物、ライブラリ、コレクション、および関連するVoxnelaデータは永久に削除されます。",
            "15日以内に同じアカウントでログインすると、削除が自動的にキャンセルされます。アカウントを削除しても、有効なストアサブスクリプションはキャンセルされません。ストアで別途キャンセルしてください。"
          ]
        },
        "data": {
          "eyebrow": "永続的なデータアクション",
          "title": "データを削除したいことを本当に確認していますか？",
          "confirm": "30日間の削除プロセスを開始する",
          "paragraphs": [
            "継続すると、30日間の削除プロセスが開始され、セキュリティのためにログアウトされます。この期間中に再度ログインしない場合、あなたの作成物、ライブラリ、コレクション、記録、インタラクション、その他の個人用Voxnelaデータは永久に削除されます。ログインアカウントは引き続き利用可能です。",
            "30日以内に再度ログインすると、データ削除が自動的にキャンセルされます。法律で義務付けられている限られた取引およびセキュリティ記録は、適用される法的期間の間、アクセス制限付きで保持される場合があります。"
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "画像クレジットが残っていません",
      "quotaFreeMessage": "無料アカウントで画像クレジットを使用しました。作成を続けるにはプランを選択してください。",
      "later": "後で",
      "currentCredit": "現在のクレジット：0",
      "quotaProTitle": "月額Proクォータに達しました",
      "quotaProMessage": "今月の100枚の画像クレジットが使用されました。引き続き作成するにはStudioにアップグレードしてください。",
      "renewalDate": "更新日：{{date}}",
      "quotaStudioTitle": "月次スタジオ枠に達しました",
      "quotaStudioMessage": "{{date}}の画像クレジットは自動的に更新されます。",
      "done": "終わった",
      "membership": "Voxnelaメンバーシップ",
      "options": "メンバーシップの選択肢",
      "credits": "クレジット",
      "currentMembership": "現在のメンバーシップ",
      "yearlyDiscount": "17%割引",
      "loadingPrice": "ストア価格を読み込み中…",
      "loadingStorePrice": "店舗からの価格ロード",
      "year": "年",
      "month": "月",
      "renewDisclosure": "{{period}}ごとに自動更新されます。いつでもキャンセルできます。",
      "legal": "法的情報",
      "terms": "規約",
      "alreadyMember": "{{plan}} {{period}}はすでに持っています。",
      "startPlan": "{{plan}}プランを開始する",
      "upgradeStudio": "Studioにアップグレード",
      "yearlyAdvantage": "年間の節約に変更する",
      "upgrade": "メンバーシップをアップグレード",
      "signInRequired": "サブスクリプションを開始する前に、Voxnelaアカウントにサインインしてください。",
      "catalogUnavailable": "このプランの支払いカタログを検証できませんでした。もう一度お試しください。",
      "paymentUnavailable": "お支払い画面が開けませんでした。再度お試しください。",
      "benefits": [
        {
          "lead": "{{credits}}クレジット",
          "label": "毎月高解像度画像生成"
        },
        {
          "lead": "50以上のスタジオスタイル",
          "label": "ネオミニマリズム、シネマティック、そしてあらゆるシグネチャースタイル"
        },
        {
          "lead": "フェイスロック",
          "label": "顔の特徴を変えずにできるバーチャルファッション試着"
        },
        {
          "lead": "優先度キュー",
          "label": "待たずに高速なGPU処理"
        },
        {
          "lead": "チャットの修正",
          "label": "自然言語での無制限の複数回の詳細編集"
        },
        {
          "lead": "完全な商業的権利",
          "label": "高解像度、透かしなし使用"
        }
      ],
      "restorePurchases": "購入を復元する",
      "restoringPurchases": "購入の復元…",
      "restoreSuccess": "あなたの会員資格が回復しました。",
      "restoreEmpty": "このApp Storeアカウントには有効なサブスクリプションが見つかりませんでした。",
      "membershipSyncPending": "会員確認と画像クレジットの確認…",
      "membershipSyncFailed": "画像クレジットを同期できませんでした。もう一度お試しください。",
      "membershipUnavailable": "メンバーシップを読み込めませんでした。",
      "retry": "再試行"
    },
    "video": {
      "revisionHook": "最初の3秒をより魅力的にします。",
      "revisionPace": "ペースを調整し、遅いセクションを短縮します。",
      "revisionEnding": "エンディングをより記憶に残るものにする。",
      "revisionTransition": "移行をよりスムーズで自然にします。",
      "revisionFraming": "重要な詳細については、よりバランスの取れたフレーミングを使用してください。",
      "revisionColor": "色をよりバランスが取れて映画的で表現してください。",
      "revisionText": "テキストを短くして読みやすくします。",
      "revisionAudio": "音楽を画像のリズムにもっと近づけてください。",
      "revisionEmotion": "物語をより本物で感情的で感じさせるようにしてください。",
      "revisionStructure": "より明確な始まり、中間、終わりを作りましょう。",
      "previewBack": "プレビューに戻る",
      "revisionWelcome": "何を変えたいですか？",
      "revisionFailed": "その変更を適用できませんでした。もう一度説明していただけますか？",
      "finalQueued": "最終動画はキューに入れられています。準備ができたら「動画」の下に表示されます。",
      "watermarkUpgrade": "Voxnelaの透かしなしで新しい最終出力を作成するには、プランを選択してください。",
      "finalFailed": "最終動画を起動できませんでした。",
      "projectDeleteFailed": "プロジェクトを削除できませんでした。",
      "videoDescriptionWithBrief": "この動画は「{{brief}}」から作成されました。Voxnelaは最も強い瞬間を選び、選んだクリエイティブな方向性に基づいてリズムとシーンの順序を構築しました。",
      "videoDescriptionGeneric": "Voxnelaはコンテンツ、ペース、物語の一貫性を評価し、バランスの取れた編集のために最も強力な瞬間を強調しました。",
      "play": "プレイ",
      "deletesOn": "{{date}}で削除する",
      "projectsBelong": "あなたのプロジェクトはあなたのアカウントにリンクされています。",
      "videosBelong": "あなたのビデオはあなたのアカウントにリンクされています。",
      "signInToSeeProjects": "サインインしてプロジェクトを確認し、デバイスを横断して続行します。",
      "signInToSeeVideos": "サインインして動画を表示し、デバイスを横断して続行します。",
      "delete": "削除",
      "deleting": "削除中…",
      "secondsVersion": "{{seconds}} セクション · バージョン {{version}}",
      "deleteProject": "プロジェクトを削除",
      "projectCoverUnavailable": "プロジェクトカバーを読み込めませんでした",
      "videoCoverPreparing": "ビデオカバーの準備",
      "deleteVideo": "動画を削除",
      "signed": "Voxnelaブランド",
      "failed": "完了できませんでした",
      "tryAgain": "もう一度試すことができます",
      "cancelled": "キャンセルされた",
      "noCreditUsed": "クレジットは使用されていません",
      "featuredStyles": "注目のビジュアルスタイル",
      "previousImage": "前の画像",
      "nextImage": "次の画像",
      "reviewStyle": "このスタイルを探る",
      "featuredNavigation": "注目の視覚ナビゲーション",
      "taskCategories": "タスクカテゴリ",
      "projectOpening": "オープニングプロジェクト",
      "opening": "開く…",
      "projectNotFound": "プロジェクトが見つかりません",
      "projectUnavailable": "このプロジェクトはもう利用できません。",
      "backToProjects": "プロジェクトに戻る",
      "editVideo": "ビデオを編集する",
      "versionContext": "バージョン{{version}} · Voxnelaはあなたのプロジェクトと資料を知っています",
      "livePreviewActions": "ライブプレビューアクション",
      "edit": "編集",
      "preparing": "準備中",
      "save": "保存",
      "thinking": "Voxnelaは考えています",
      "revisionSuggestions": "編集の提案",
      "describeChange": "あなたが望む変化を説明してください",
      "sendEdit": "編集リクエストを送信する",
      "deleteProjectDescription": "「{{title}}」および関連するすべての資料を削除したいことを確認していますか？これは元に戻すことはできません。",
      "projects": "プロジェクト",
      "projectsPreparing": "プロジェクトの準備",
      "noProjects": "まだプロジェクトがありません。まずは最初のアイデアを説明することから始めてください。",
      "createNew": "新しい画像を作成",
      "thisProject": "このプロジェクト",
      "videos": "動画",
      "videosPreparing": "ビデオの準備",
      "noVideos": "まだ完成したビデオがありません。最初のビデオが準備できたら、ここに表示されます。",
      "videoPlayFailed": "ビデオを再生できませんでした。",
      "videoNotReady": "ビデオファイルはまだダウンロード準備ができていません。",
      "videoDownloadFailed": "ビデオをダウンロードできませんでした。",
      "videoDeleteFailed": "ビデオを削除できませんでした。",
      "videoLoading": "動画を読み込んでいます…",
      "videoActions": "ビデオアクション",
      "showVideoDescription": "動画の説明を表示する",
      "videoDownloading": "動画をダウンロードする",
      "downloadVideo": "ビデオをダウンロードする",
      "thisVideo": "このビデオ",
      "deleteVideoDescription": "「{{title}}」というタイトルの動画を削除したいと本当に思っていますか？これは元に戻すことができません。"
    },
    "studio": {
      "useStyle": "このスタイルを使用する",
      "galleryFilters": "ギャラリーフィルター",
      "modeStyleTransfer": "Voxnelaスタイル",
      "modeVirtualTryOn": "バーチャル試着",
      "modeMagazineCover": "雑誌と表紙",
      "modePosterStudio": "ポスタースタジオ",
      "modeCommercial": "製品ショーケース",
      "modeTimeWarp": "タイムトラベル",
      "modeOutpaintRelight": "拡大＆再点灯",
      "modeInfographic": "インフォグラフィックとデータ",
      "modePortraitRetouch": "ポートレートリタッチ",
      "modeArtisticCollage": "芸術的コラージュ",
      "defaultStyle": "Voxnelaスタイル",
      "signInToCreate": "画像を作成するには、サインインしてください。",
      "signInToEdit": "画像を編集するには、サインインしてください。",
      "creationSuccess": "画像が正常に作成されました。照明、色、オブジェクト、枠組みを変更したい場合は、直接お知らせください。",
      "imageReady": "あなたの画像は準備できました。気に入ったものや修正したいものを教えてください。",
      "revisionSuccess": "修正が完了しました。前後スライダーと比較するか、別の変更をリクエストできます。",
      "versionReady": "バージョン{{version}}が準備できました。",
      "projectNotFound": "プロジェクトが見つかりません。",
      "styleApplied": "{{style}}スタイルが適用されました",
      "imageCreation": "画像作成",
      "defaultPrompt": "スタジオ画像",
      "aspectSquare": "正方形",
      "aspectSquareDetail": "Instagram フィード、プロフィール、アート",
      "aspectVertical": "垂直",
      "aspectVerticalDetail": "Instagramストーリー、リール、TikTok",
      "aspectHorizontal": "水平",
      "aspectHorizontalDetail": "YouTube、バナー、映画館",
      "aspectPortrait": "ポートレート",
      "aspectPortraitDetail": "Instagramポートレート、ポスター、ショーケース",
      "aspectPanoramic": "パノラマ",
      "aspectPanoramicDetail": "超ワイド、シネマティックな風景",
      "styles": "Voxnelaスタイル",
      "fullScreenStyle": "フルスクリーンでスタイルを表示する",
      "closeDescription": "クローズスタイル説明",
      "moreWithVoxnela": "Voxnelaでさらに多くのことをする",
      "quickStartBody": "以下に書きたいものやファイルを添付してください。",
      "createImage": "画像を作成",
      "createImageDetail": "ゼロからアイデアを構築する",
      "editImage": "画像を編集",
      "editImageQuick": "画像を編集する",
      "editImageDetail": "アップロードされた画像を再想像する",
      "transformStyle": "スタイルとシーンを変える",
      "transformStyleDetail": "画像を別の世界に移動する",
      "visualizeDocument": "ドキュメントまたはプレゼンテーションを視覚化する",
      "visualizeDocumentDetail": "完全なコンテンツをデザインに変える",
      "submittedImage": "提出された画像",
      "generating": "Voxnelaが画像を作成中…",
      "viewImage": "画像を見る",
      "removeStyle": "選択したスタイルを削除する",
      "referenceImage": "参照画像",
      "referenceNotice": "この画像は修正または新しいスタイルが適用されます",
      "removeReference": "参照画像を取り除く",
      "remove": "取り除く",
      "uploading": "アップロード中",
      "addFile": "ファイルまたは画像を追加する",
      "addFileTitle": "最大4枚の画像またはドキュメント（PDF、Word、PPT、最大12MB）を追加してください。",
      "aspectRatio": "アスペクト比",
      "selectAspectRatio": "アスペクト比を選択する",
      "aspectOptions": "アスペクト比オプション",
      "revisePlaceholder": "この画像で変更したいものは何ですか？",
      "styledPlaceholder": "このスタイルで希望する画像を説明してください（任意）…",
      "promptPlaceholder": "画像を描写するか、プロンプトを書く…",
      "reviseImage": "画像を修正する",
      "generateImage": "画像を生成する",
      "generatedImage": "生成された画像",
      "done": "完了",
      "fileLimitTitle": "ファイルが大きすぎる",
      "fileLimitMessage": "「{{name}}」は12MBの制限を超えています（{{size}} MB）。より小さなファイルを選択してください。",
      "imageLimitTitle": "画像制限",
      "imageLimitMessage": "最大4枚の画像までアップロードできます。{{count}}の画像が現在選択されています。",
      "uploadFailedTitle": "アップロード失敗",
      "uploadFailedMessage": "ファイルのアップロード中に問題が発生しました。",
      "revisionFailed": "改訂中にエラーが発生したか、制限を超えました。",
      "generationFailed": "画像生成中にエラーが発生したか、クォータを超えました。",
      "imageDetails": "画像の詳細",
      "close": "閉じる",
      "download": "ダウンロード",
      "downloadImage": "画像をダウンロードする",
      "downloading": "ダウンロード中",
      "versionImage": "画像",
      "exploreTitle": "どのようなスタイルをお探しですか？",
      "explorePlaceholder": "例えば：暗いトーンと深い視点を持つシネマティックなポートレート",
      "searchStyles": "ビジュアルスタイルを検索",
      "clearSearch": "検索をクリアする",
      "exploreCategories": "カテゴリを調べる",
      "all": "すべて",
      "styleCount": "{{count}}スタイル",
      "noStyle": "一致するスタイルが見つかりません",
      "noStyleBody": "より短い説明や異なる言葉で再度試してください。",
      "libraryKicker": "あなたの個人画像ライブラリ",
      "myImages": "マイ画像",
      "imageWorks": "{{count}}画像は正常に動作します",
      "newImage": "新しい画像を作成",
      "noImage": "まだ画像を作成していません",
      "noCategoryImage": "このカテゴリに画像はありません",
      "emptyGalleryBody": "スタイル転送、バーチャル試着、雑誌の表紙または製品ショーケースで、最初の画像を作成してください。",
      "firstImage": "最初の画像を作成する",
      "imageWork": "画像作業"
    },
    "create": {
      "briefTitle": "あなたのアイデアやトピックを説明してください",
      "briefPlaceholder": "テーマは何ですか？例えば：AIの未来、火星への旅、あるいは製品の発売…",
      "briefLabel": "作成概要",
      "contentType": "コンテンツの種類",
      "media": "画像とメディア",
      "added": "{{count}}を追加",
      "optional": "任意",
      "addMedia": "必要であれば写真やビデオを追加してください",
      "addMediaBody": "独自のメディアをアップロードするか、空にしてAIに探させます",
      "attachedMedia": "添付メディア",
      "add": "追加する",
      "mediaFallback": "メディア",
      "aiCompletes": "AIにビジュアルを完成させましょう",
      "noMedia": "画像がアップロードされていません。AIがシーンを完成させます。",
      "productionFormat": "生産形式",
      "style": "スタイル",
      "customVisualWorld": "あなたの視覚世界を説明してください",
      "colorsAtmosphere": "色、雰囲気、カメラ、リズム",
      "customStyleShort": "思い浮かべる視覚世界を説明してください（例えば、パステルカラーと落ち着いたカメラ、またはサイバーパンクのネオンなど…）",
      "customStyleLong": "あなたが思い浮かべている視覚世界、色、雰囲気、リズムを説明してください。",
      "voiceover": "ナレーション",
      "ownVoiceover": "あなたのナレーションテキスト",
      "voiceoverPlaceholder": "ここにテキストを書いてください。空欄のままにすると、Voxnelaが準備します。",
      "duration": "長さ",
      "seconds": "{{count}}秒",
      "freeLimit": "無料プランの最長最終動画は60秒です。",
      "addSound": "音や音楽を追加する",
      "notAdded": "追加されていません",
      "files": "{{count}}ファイル",
      "readySounds": "既製の音を使用する",
      "musicLibrary": "音楽ライブラリ",
      "uploadOwn": "あなた自身のものをアップロードする",
      "captions": "字幕",
      "back": "戻る",
      "create": "作成",
      "next": "次へ",
      "researchingTopic": "そのトピックを調べています...",
      "analyzingMaterials": "材料の分析…",
      "researchBody": "ソースの確認とスクリプトとビジュアルプランの準備。",
      "analyzeBody": "強いフレーム、感情、リズム、そして短いものを一緒に評価する。",
      "creativeDirection": "クリエイティブディレクション {{count}}",
      "recommended": "おすすめ",
      "generationFailed": "作成が完了できませんでした",
      "retry": "もう一度準備する",
      "backDirections": "創造的な方向へ戻る",
      "preparingVideo": "動画を準備中",
      "voiceoverText": "音声オーバーテキスト",
      "describeStyle": "あなた自身のスタイルを説明してください",
      "topicDirection": "トピックと方向性",
      "styleEditorSubtitle": "視覚世界、色、雰囲気を描写する",
      "editorSubtitle": "テキストを書いて作成シートに挿入してください。",
      "voiceoverEditorPlaceholder": "ボイスオーバーに使用するテキストを書いてください。",
      "topicEditorPlaceholder": "トピックとそれをどのように伝えたいかを書いてください。",
      "insertText": "テキストを挿入する",
      "bestFor": "最適です：",
      "useStyle": "このスタイルを使用する",
      "musicSubtitle": "実物のトラックが商業利用のためにクリアされました",
      "adding": "追加中…",
      "musicLicense": "トラックはCC0 1.0の下で提供されています。商業利用は許可されており、帰属表示は必要ありません。",
      "yes": "はい",
      "no": "いいえ",
      "newCreation": "新しい創造",
      "reviewing": "Voxnelaはレビューしています",
      "chooseDirection": "3つの編集アプローチのいずれかを選択してください",
      "ideaSubtitle": "あなたのアイデアを説明してください。ビジュアルをアップロードするか、Voxnelaに作成させます。",
      "projectOpenFailed": "プロジェクトパッケージを開くことができませんでした。",
      "tooManyAssets": "プロジェクトに最大50個のアセットを追加できます。",
      "uploadSizeLimit": "プロジェクトのアップロード総量は2GBの制限を超えています。",
      "filesAddFailed": "ファイルを追加できませんでした。",
      "musicPreviewFailed": "音楽プレビューを開くことができませんでした。",
      "musicFetchFailed": "音楽ファイルが取得できませんでした。",
      "musicAddFailed": "音楽を追加できませんでした。",
      "topicRequired": "トピックを入力し、ビデオの内容を説明してください。",
      "briefTooShort": "少なくとも数文で、何を伝えたいかを説明してください。",
      "mediaRequired": "画像をアップロードするか、AI生成のビジュアルを有効にします。",
      "proposalIntro": "画像とビデオをレビューし、あなたのスタイル、フォーマット、オーディオの選択に合った3つの編集指示を作成しました。",
      "removeMaterial": "{{name}}を削除する",
      "aiVisualNotice": "オープンライセンスのリアル画像とAIイラストが自動的に見つかります。",
      "stepProgress": "{{current}}の{{total}}ステップ",
      "styleSampleAlt": "{{style}}ビデオスタイルの例",
      "reviewStyle": "{{style}}スタイルを確認してください",
      "selectedDirectionPrompt": "選択された方向：{{title}}。{{summary}} ビジュアル方向：{{visual}}。トランジションアプローチ：{{transitions}}。音楽アプローチ：{{music}}。",
      "letVoxnelaChoose": "Voxnelaに選ばせましょう",
      "feminineVoice": "フェミニン",
      "masculineVoice": "男性的な",
      "narrationStyle": "ナレーションスタイル",
      "voiceEstimate": "{{seconds}} sec · {{words}}の単語について。",
      "voiceShort": "{{duration}}の略である場合、Voxnelaは意味を保ちながらそれを完了します。",
      "voiceNatural": "Voxnelaは文法、表現、自然な流れのみを調整します。",
      "removeFile": "{{name}}ファイルを取り除く",
      "musicStop": "{{title}}を停止する",
      "musicListen": "{{title}}を聴く",
      "automatic": "オート",
      "all": "すべて",
      "cinematic": "映画的",
      "social": "社会的でダイナミック",
      "designTypography": "デザインとタイポグラフィ",
      "retroExperimental": "レトロ＆エキスポエンシブ",
      "productionStage1": "最も強力なフレームとシーンを選択する。",
      "productionStage2": "ストーリー、動き、トランジションを構築する。",
      "productionStage3": "音楽、音声、字幕のバランスを取る。",
      "productionStage4": "ライブプレビューの最終チェックを実行しています。",
      "genericCreationError": "ビデオプランの作成中に問題が発生しました。素材と選択は保持されますので、再度お試しください。",
      "newVideo": "新しいビデオ",
      "topicNews": "ニュース",
      "topicDocumentary": "ドキュメンタリー",
      "topicExplainer": "説明者",
      "topicStory": "ストーリー",
      "topicScience": "科学",
      "topicPhilosophy": "哲学",
      "topicMagazine": "雑誌",
      "topicEntertainment": "エンターテイメント",
      "topicList": "リスト",
      "toneCalm": "落ち着いた",
      "toneEmotional": "感情的",
      "toneEnergetic": "エネルギッシュ",
      "toneStorytelling": "ストーリーテリング",
      "toneCheerful": "元気いっぱいな",
      "toneMysterious": "謎めいた",
      "toneNews": "ニュース",
      "styleCinematic": "映画的",
      "styleDarkCinematic": "ダークシネマティック",
      "styleDocumentary": "ドキュメンタリー",
      "styleModernDocumentary": "現代ドキュメンタリー",
      "stylePovImmersive": "没入型POV",
      "styleUgcAuthentic": "本物のUGC",
      "styleMiniVlog": "ミニVlog",
      "styleSocialViral": "ソーシャルバイラル",
      "styleHyperEdit": "ハイパーエディット",
      "styleSportsHype": "スポーツのヒープ",
      "styleVelocityEdit": "速度編集",
      "styleMusicBeatEdit": "ミュージックビート編集",
      "styleKineticTypography": "キネティックタイポグラフィ",
      "styleMinimalClean": "ミニマルで清潔",
      "styleLuxuryMinimal": "ラグジュアリーミニマル",
      "styleCommercialProduct": "商業製品",
      "styleEditorialFashion": "編集ファッション",
      "styleCollageZine": "コラージュジン",
      "styleTechFuturistic": "テクノロジーの未来志向",
      "styleRetroFuturism": "レトロフューリズム",
      "styleY2kDigital": "Y2Kデジタル",
      "styleVhsCamcorder": "VHSカメcorder",
      "styleAnalogFilm": "アナログフィルム",
      "styleGlitchCyber": "グリッチサイバー",
      "musicUpbeatMood": "エネルギッシュ・明るい",
      "musicUpbeatDetail": "盛り上がるソーシャルコンテンツ、旅行の瞬間、活気あるエディットのための本格的なインストゥルメンタル録音。",
      "musicElectronicMood": "モダン・リズム",
      "musicElectronicDetail": "都市、テクノロジー、製品、そして高速な編集のための本格的な電子音楽。",
      "musicRomanceMood": "感情的・温かい",
      "musicRomanceDetail": "家族、ポートレート、特別な日や思い出のための優しい感情の弧を持つ楽器音楽。",
      "musicScoringMood": "物語・映画的",
      "musicScoringDetail": "ストーリー、プロモーション、ドラマチックなトランジションをサポートするシネマティックなバックグラウンド音楽。",
      "musicEpicMood": "強力・上昇中",
      "musicEpicDetail": "グランドオープニング、旅、そして力強いフィナーレに向けて構築される、レイヤー状のインストゥルメンタル音楽。",
      "proposalBalancedTitle": "バランスの取れた物語",
      "proposalBalancedSummary": "素材の流れを保ち、最も強いフレームを強調する編集。",
      "proposalBalancedVisual": "強力な階層構造と整合性の取れた視覚システム",
      "proposalBalancedTransitions": "滑らかなカットと測定されたプッシュイン",
      "proposalBalancedMusic": "感情からリズムへと移り変わる音楽",
      "proposalQuietTitle": "静かな物語",
      "proposalQuietSummary": "フレームにもっと時間を与え、ディテールと自然な感情を強調する落ち着いたアプローチ。",
      "proposalQuietVisual": "柔らかいトーンと長いショット",
      "proposalQuietTransitions": "クロス溶解とスローパン",
      "proposalQuietMusic": "シンプルで感情的な音楽",
      "proposalRhythmicTitle": "リズム編集",
      "proposalRhythmicSummary": "中盤で加速し、終盤で明確に収まる強いオープニングフックを効かせたエディット。",
      "proposalRhythmicVisual": "より強いコントラストとダイナミックなフレーミング",
      "proposalRhythmicTransitions": "ビートカットと制御されたウィップトランジション",
      "proposalRhythmicMusic": "エネルギッシュで上昇する音楽",
      "underVoiceover": "ナレーションの下で柔らかく",
      "withShortVoiceover": "短く力強いナレーションで"
    },
    "information": {
      "home": "ホーム",
      "documentInfo": "文書情報",
      "version": "バージョン",
      "effective": "発効日",
      "updated": "最終更新",
      "contents": "目次",
      "officialReferences": "公式参照",
      "referenceTitle": "法律と権限リソース",
      "referenceBody": "これらのリンクは一般的な情報提供を目的として提供されています。法令および関係当局の現在の規則が優先されます。",
      "supportKicker": "Sponelabsサポート",
      "contactTitle": "お問い合わせ",
      "contactLead": "アカウント、メンバーシップ、支払い、作成、コンテンツレポート、プライバシー、または技術的な問題について、Voxnelaサポートチームに連絡してください。",
      "supportEmail": "サポートメール",
      "emailBody": "以下のボタンをクリックすると、すぐに使えるサポートテンプレートが用意されたデフォルトのメールアプリが開きますので、より迅速に調査できます。",
      "openEmail": "メールアプリを開く",
      "includeTitle": "メッセージに含める内容",
      "includeItems": [
        "Web、iOS、またはMacを使用しているかどうかに関わらず;",
        "あなたのデバイスとオペレーティングシステムバージョン;",
        "問題を再現するための手順；",
        "関連プロジェクトのリンク、取引の詳細、またはスクリーンショットがあれば。"
      ],
      "sensitiveTitle": "機密情報を送信しないでください",
      "sensitiveBody": "問題の解決に必要ではない検証コード、パスワード、完全な支払いカードの詳細、身分証明書、健康データ、その他の機密情報を含めないでください。",
      "securityTitle": "セキュリティとコンテンツ報告",
      "securityBody": "脆弱性には「セキュリティ」、データリクエストには「プライバシーリクエスト」、有害または侵害コンテンツには「コンテンツレポート」を使用してください。緊急の身体的危険がある場合は、地元の救急サービスに連絡してください。",
      "mailSubject": "Voxnelaサポートリクエスト",
      "mailGreeting": "Voxnelaサポートチームの皆様、こんにちは。",
      "mailTopic": "サポートトピック：",
      "mailPlatform": "プラットフォーム（Web / iOS / Mac）：",
      "mailDevice": "デバイスとオペレーティングシステム：",
      "mailProject": "プロジェクトID（利用可能であれば）：",
      "mailDescription": "問題またはリクエストの説明：",
      "mailThanks": "ありがとうございます。",
      "termsEyebrow": "Voxnela利用規約",
      "termsTitle": "利用規約",
      "termsLead": "これらの条件は、VoxnelaのウェブおよびiOSアプリにおけるAI画像作成および編集サービスの利用を規定します。",
      "privacyEyebrow": "Voxnelaデータ使用",
      "privacyTitle": "プライバシーポリシー",
      "privacyLead": "このポリシーは、Voxnela画像作成サービスにおけるアカウント、画像、プロジェクト、メンバーシップ、技術データ処理方法を説明しています。",
      "officialTurkishNotice": "この翻訳は便宜上提供されています。意味が異なる場合は、トルコの法的テキストが適用されます。"
    }
  },
  "ko": {
    "ui": {
      "home": "홈",
      "homeTitle": "집",
      "explore": "둘러보기",
      "gallery": "갤러리",
      "myImages": "내 이미지",
      "settings": "설정",
      "createImage": "이미지 만들기",
      "back": "뒤로",
      "search": "검색",
      "account": "계정",
      "login": "로그인",
      "logout": "로그아웃",
      "profile": "프로필",
      "profileSettings": "프로필 및 설정",
      "plans": "요금제 및 사용량",
      "plansSubtitle": "이미지 크레딧 및 청구",
      "contact": "문의",
      "contactSubtitle": "도움과 피드백",
      "discoverVoxnela": "Voxnela를 발견하세요",
      "discoverVoxnelaSubtitle": "시각 스튜디오 경험을 검토하십시오.",
      "privacy": "개인정보 보호",
      "privacySubtitle": "당신의 데이터가 어떻게 보호되는지",
      "terms": "이용 약관",
      "termsSubtitle": "Voxnela 이용약관",
      "preferencesSubtitle": "당신의 계정과 Voxnela 선호도",
      "accountSubtitle": "계정 및 멤버십 세부 정보",
      "voxAccount": "Voxnela 계정",
      "accessEverywhere": "모든 기기에서 이미지를 액세스하세요",
      "imageRights": "{{count}} 이미지 크레딧",
      "availableCredits": "사용 가능한 크레딧",
      "renewalDate": "갱신 날짜",
      "membershipStart": "회원십이 시작되었습니다",
      "registrationDate": "등록일",
      "monthly": "한 달에 한 번",
      "renewalOff": "갱신 꺼짐",
      "user": "Voxnela 사용자",
      "language": "언어",
      "languageSubtitle": "앱 언어 선택",
      "supportBody": "문제가 있거나 아이디어를 공유하고 싶다면 저희에게 연락해 주세요. 프로젝트 ID를 포함하면 더 빠르게 답변해 드릴 수 있습니다.",
      "studioTitle": "Voxnela 비주얼 스튜디오",
      "studioSubtitle": "나만의 스타일 만들기",
      "searchSubtitle": "당신의 이미지와 프로젝트",
      "searchPlaceholder": "이미지나 프로젝트를 검색하세요",
      "noSearchResults": "이 검색과 일치하는 것은 없습니다.",
      "project": "계획",
      "image": "이미지",
      "completed": "완료됨",
      "currentPlan": "현재 계획",
      "notSignedIn": "로그인하지 않음",
      "signInIntro": "Voxnela를 사용하기 시작하려면 로그인하세요.",
      "creditsAvailable": "{{count}} 스튜디오 이미지 크레딧이 제공됩니다.",
      "noCredits": "이 기간 동안 이미지 크레딧이 남아 있지 않습니다.",
      "membershipInfo": "연간 플랜 크레딧은 매월 갱신되며 연장되지 않습니다. 복구된 구매는 계정을 통해 계속 보호됩니다.",
      "signedOutMembershipInfo": "로그인 후, 사용 가능한 이미지 크레딧과 플랜 정보가 여기에 표시됩니다.",
      "reviewPlans": "계획 보기",
      "versionUpdated": "버전 {{version}} · 마지막 업데이트 {{date}}",
      "onboardingWelcome": "Voxnela에 오신 것을 환영합니다",
      "skipIntro": "소개 건너뛰기",
      "continue": "계속",
      "startCreating": "만들기 시작",
      "close": "가까운",
      "dragToClose": "시트를 닫으려면 아래로 스와이프하세요.",
      "loading": "로딩 중...",
      "sheetExpand": "시트 확장",
      "sheetCollapse": "반환 시트를 정상 높이로 되돌리기",
      "cannotClose": "작업이 진행 중인 동안 닫을 수 없습니다.",
      "stylePreview": "스타일 미리보기",
      "stylePreviewSubtitle": "시그니처 스타일과 트렌드",
      "categories": "카테고리",
      "useThisStyle": "이 스타일을 사용하세요",
      "videoControls": "비디오 컨트롤",
      "play": "놀다",
      "pause": "중간 휴식",
      "mute": "벙어리",
      "unmute": "음소거 해제",
      "minimize": "최소 한도로 평가하다",
      "expandVideo": "앱에서 확장",
      "videoProgress": "비디오 진행 상황",
      "toggleVideoControls": "비디오 컨트롤 표시 또는 숨기기",
      "expandedVideo": "{{title}} 확장된 비디오 보기",
      "goToImage": "{{title}} 이미지로 이동하세요",
      "categoryVisualStyles": "{{category}} 시각 스타일",
      "onboarding1Eyebrow": "이미지 만들기",
      "onboarding1Title": "이미지를 만들어 보세요.",
      "onboarding1Body": "35mm 필름, 에디토리얼, 제품, 포스터 및 그 외 많은 시각 스타일로 아이디어를 시네마틱한 프레임으로 바꿔보세요.",
      "onboarding2Eyebrow": "가상 의상 체험",
      "onboarding2Title": "새로운 의상을 입어 보세요.",
      "onboarding2Body": "프로덕션 전반에 걸쳐 정체성을 유지하고 사실적인 패션, 액세서리 및 제품 시착 시각을 만듭니다.",
      "onboarding3Eyebrow": "이미지 편집",
      "onboarding3Title": "이미지를 편집해 보세요.",
      "onboarding3Body": "재시작하지 않고 대화적으로 구도, 조명, 색상 및 디테일을 수정하세요.",
      "onboarding4Eyebrow": "무료 이미지 3장",
      "onboarding4Title": "무료로 시작하세요.",
      "onboarding4Body": "1회 제공되는 무료 AI 이미지 생성 3회로 바로 시작하세요. 계정이 필요 없습니다.",
      "onboardingFaceEyebrow": "얼굴 및 스타일 분석",
      "onboardingFaceTitle": "얼굴과 스타일을 알아보세요.",
      "onboardingFaceBody": "인물 사진을 바탕으로 헤어스타일, 안경, 의상 아이디어를 하나의 시각 가이드에서 살펴보세요.",
      "onboardingHouseEyebrow": "시간 여행",
      "onboardingHouseTitle": "시간을 여행해 보세요.",
      "onboardingHouseBody": "사진과 날짜를 모아 시간이 흐르며 집이 어떻게 변했는지 시각화하세요.",
      "onboardingFestivalEyebrow": "페스티벌의 하루",
      "onboardingFestivalTitle": "페스티벌 일정을 한눈에 계획하세요.",
      "onboardingFestivalBody": "제공한 프로그램, 무대, 시간을 나만의 시각적 동선으로 만들어 보세요.",
      "onboardingStylesEyebrow": "Voxnela 스타일",
      "onboardingStylesTitle": "스타일을 선택하세요.",
      "onboardingStylesBody": "35mm 필름, 에디토리얼, 제품, 포스터 및 그 외 많은 시각 스타일로 아이디어를 시네마틱한 프레임으로 바꿔보세요."
    },
    "auth": {
      "enterCode": "코드 입력",
      "membershipAndAccount": "멤버십 및 계정 상세 정보",
      "noPeriodInfo": "기간 불가능",
      "memberSince": "가입일로부터",
      "planSince": "{{plan}}부터",
      "membershipRenewal": "회원 갱신일",
      "accountActions": "계정 작업",
      "manageSubscriptionTitle": "구독 종료",
      "manageSubscriptionSubtitle": "당신의 매장 구독과 자동 갱신을 관리하세요.",
      "deleteAccountTitle": "내 계정 삭제",
      "deleteAccountSubtitle": "반복 가능한 15일 삭제 프로세스.",
      "deleteDataTitle": "내 데이터를 삭제하세요",
      "deleteDataSubtitle": "반복 가능한 30일 데이터 삭제 프로세스.",
      "signingOut": "로그아웃 중…",
      "signOut": "로그아웃",
      "signingIn": "로그인 중…",
      "continueApple": "Apple로 계속",
      "continueGoogle": "Google로 계속",
      "or": "또는",
      "email": "이메일",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "Voxnela를 계속 진행함으로써, 당신은 동의합니다",
      "legalTerms": "이용 약관",
      "legalJoin": "그리고 읽고 이해했음을 확인하십시오",
      "legalPrivacy": "개인정보 보호 안내",
      "legalSuffix": ".",
      "sendingCode": "코드 전송 중…",
      "emailSignIn": "이메일로 로그인",
      "codeSent": "우리는 {{email}}로 코드를 보냈습니다.",
      "change": "변경",
      "sixDigitCode": "6자리 코드",
      "emailCode": "이메일 로그인 코드",
      "verifyingCode": "코드 확인 중…",
      "resendCode": "코드 다시 보내기",
      "requestReceived": "요청 접수됨",
      "accountDeletionStarted": "당신의 계정 삭제 프로세스가 시작되었습니다",
      "dataDeletionStarted": "데이터 삭제 프로세스가 시작되었습니다",
      "accountAction": "계정 조치",
      "accountDeletesAt": "{{date}}의 계정은 영구적으로 삭제됩니다.",
      "dataDeletesAt": "{{date}}의 귀하의 개인 Voxnela 데이터는 영구적으로 삭제됩니다.",
      "deletionUndo": "이 날짜 이전에 동일한 계정으로 로그인하시면 삭제 프로세스가 자동으로 취소됩니다. 요청이 생성되어 현재 세션이 종료되었습니다.",
      "done": "완료",
      "cancel": "취소",
      "preparing": "준비 중...",
      "invalidEmail": "유효한 이메일 주소를 입력하세요.",
      "enterSixDigitCode": "이메일로 발송된 6자리 코드를 입력하세요.",
      "signInFailed": "로그인이 완료되지 않았습니다. 다시 시도해 주세요.",
      "codeSendFailed": "로그인 코드를 보낼 수 없었습니다. 다시 시도해 주세요.",
      "codeVerifyFailed": "코드를 확인할 수 없었습니다. 다시 시도해 주세요.",
      "operationFailed": "현재 작업이 완료되지 않았습니다. 다시 시도해 주세요.",
      "popupClosed": "로그인 창이 닫혔습니다.",
      "unauthorizedDomain": "이 도메인은 로그인에 승인되지 않았습니다.",
      "methodUnavailable": "이 로그인 방법은 아직 활성화되지 않았습니다.",
      "tooManyCodes": "코드가 너무 많이 요청되었습니다. 몇 분 후에 다시 시도해 주세요.",
      "invalidCode": "코드가 유효하지 않거나 만료되었습니다. 새로운 코드를 요청하세요.",
      "emailUnavailable": "이메일 배송은 현재 이용할 수 없습니다.",
      "actions": {
        "subscription": {
          "eyebrow": "구독 조치",
          "title": "구독을 종료하시겠습니까?",
          "confirm": "구독 관리",
          "paragraphs": [
            "계속하려면 Apple App Store 또는 Google Play 구독 관리 페이지로 이동하여 구독을 구매한 곳에서 자동으로 갱신을 비활성화해야 합니다.",
            "취소 후에는 기존 멤버십 혜택이 유료 기간이 종료될 때까지 계속 제공됩니다. 계정이나 데이터를 삭제한다고 해서 매장 구독이 취소되지는 않습니다."
          ]
        },
        "account": {
          "eyebrow": "영구 계정 조치",
          "title": "계정을 삭제하고 싶으신가요?",
          "confirm": "15일 삭제 프로세스 시작",
          "paragraphs": [
            "계속하면 15일간 삭제 프로세스가 시작되며 보안을 위해 로그아웃됩니다. 이 기간 동안 다시 로그인하지 않으면 계정, 프로필, 창작물, 라이브러리, 컬렉션 및 관련 Voxnela 데이터가 영구적으로 삭제됩니다.",
            "15일 이내에 동일한 계정으로 로그인하면 자동으로 삭제가 취소됩니다. 계정을 삭제한다고 해서 활성 스토어 구독이 취소되는 것은 아니며, 스토어에서 별도로 취소해야 합니다."
          ]
        },
        "data": {
          "eyebrow": "영구 데이터 조치",
          "title": "데이터를 삭제하고 싶으신가요?",
          "confirm": "30일 삭제 프로세스 시작",
          "paragraphs": [
            "계속하면 30일간 삭제 프로세스가 시작되며 보안을 위해 로그아웃됩니다. 이 기간 동안 다시 로그인하지 않으면 창작물, 라이브러리, 컬렉션, 기록, 상호작용 및 기타 개인 Voxnela 데이터가 영구적으로 삭제되며, 로그인 계정은 계속 사용할 수 있습니다.",
            "30일 이내에 다시 로그인하시면 자동으로 데이터 삭제가 취소됩니다. 법률에 따라 제한된 거래 및 보안 기록이 적용되는 기간 동안 제한된 접근 권한으로 보관될 수 있습니다."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "이미지 크레딧이 남아 있지 않습니다",
      "quotaFreeMessage": "무료 계정에서 이미지 크레딧을 사용하셨습니다. 계속 창작하려면 플랜을 선택하세요.",
      "later": "나중에",
      "currentCredit": "현재 크레딧: 0",
      "quotaProTitle": "월간 프로 할당량이 도달했습니다",
      "quotaProMessage": "이번 달 100장의 이미지 크레딧을 사용하셨습니다. 계속 창작하려면 Studio로 업그레이드하세요.",
      "renewalDate": "갱신 날짜: {{date}}",
      "quotaStudioTitle": "월간 스튜디오 할당량이 도달했습니다",
      "quotaStudioMessage": "{{date}}에서 이미지 크레딧이 자동으로 갱신됩니다.",
      "done": "다 된",
      "membership": "Voxnela 멤버십",
      "options": "멤버십 옵션",
      "credits": "크레딧",
      "currentMembership": "현재 멤버십",
      "yearlyDiscount": "17% 할인",
      "loadingPrice": "스토어 가격 불러오는 중…",
      "loadingStorePrice": "매장 가격 로딩",
      "year": "년",
      "month": "개월",
      "renewDisclosure": "{{period}}마다 자동으로 갱신됩니다. 언제든지 취소할 수 있습니다.",
      "legal": "법적 고지",
      "terms": "약관",
      "alreadyMember": "이미 {{plan}} {{period}}를 가지고 있습니다.",
      "startPlan": "{{plan}} 플랜 시작",
      "upgradeStudio": "Studio로 업그레이드",
      "yearlyAdvantage": "연간 저축으로 전환",
      "upgrade": "멤버십 업그레이드",
      "signInRequired": "구독을 시작하기 전에 Voxnela 계정에 로그인하세요.",
      "catalogUnavailable": "이 요금제에 대한 결제 카탈로그를 확인할 수 없었습니다. 잠시만 더 시도해 주세요.",
      "paymentUnavailable": "결제 화면을 열 수 없었습니다. 다시 시도해 주세요.",
      "benefits": [
        {
          "lead": "{{credits}} 크레딧",
          "label": "매월 고해상도 이미지 생성"
        },
        {
          "lead": "50개 이상의 스튜디오 스타일",
          "label": "네오 미니멀리즘, 시네마틱하고 모든 시그니처 스타일"
        },
        {
          "lead": "페이스락",
          "label": "얼굴 특징을 바꾸지 않고 하는 가상 패션 시착"
        },
        {
          "lead": "우선순위 대기열",
          "label": "대기 없이 초고속 GPU 처리"
        },
        {
          "lead": "채팅 수정",
          "label": "자연어에서 무제한 다단계 디테일 편집"
        },
        {
          "lead": "전체 상업적 권리",
          "label": "고해상도, 워터마크 없는 사용"
        }
      ],
      "restorePurchases": "구매 복구",
      "restoringPurchases": "구매 복구...",
      "restoreSuccess": "귀하의 멤버십이 복원되었습니다.",
      "restoreEmpty": "이 App Store 계정에 대한 활성 구독이 발견되지 않았습니다.",
      "membershipSyncPending": "멤버십 및 이미지 크레딧 확인...",
      "membershipSyncFailed": "이미지 크레딧을 동기화하지 못했습니다. 다시 시도하세요.",
      "membershipUnavailable": "멤버십을 불러오지 못했습니다.",
      "retry": "다시 시도"
    },
    "video": {
      "revisionHook": "처음 세 초를 더 흥미롭게 만들어라.",
      "revisionPace": "속도를 조절하고 느린 부분을 줄이세요.",
      "revisionEnding": "마무리 부분을 더 기억에 남게 만들어라.",
      "revisionTransition": "전환을 더 부드럽고 자연스럽게 만드세요.",
      "revisionFraming": "중요한 세부 사항에 더 균형 잡힌 프레임워크를 사용하세요.",
      "revisionColor": "색상을 더 균형 있고 시네마틱하게 만드세요.",
      "revisionText": "텍스트를 더 짧고 읽기 쉽게 만드세요.",
      "revisionAudio": "음악을 이미지의 리듬에 더 가깝게 맞추세요.",
      "revisionEmotion": "이야기를 더 진심 있고 감정적으로 만들어라.",
      "revisionStructure": "더 명확한 시작, 중간 및 끝을 구축하십시오.",
      "previewBack": "프리뷰로 돌아가기",
      "revisionWelcome": "무엇을 바꾸고 싶으신가요?",
      "revisionFailed": "그 변경 사항을 적용할 수 없었습니다. 다시 한번 설명해 주실 수 있나요?",
      "finalQueued": "최종 영상이 대기열에 있습니다. 준비되면 동영상 아래에 표시됩니다.",
      "watermarkUpgrade": "Voxnela 워터마크 없이 새로운 최종 출력을 생성하려면 계획을 선택하세요.",
      "finalFailed": "마지막 비디오를 시작할 수 없었습니다.",
      "projectDeleteFailed": "프로젝트를 삭제할 수 없었습니다.",
      "videoDescriptionWithBrief": "이 영상은 “{{brief}}”에서 제작되었습니다. Voxnela는 가장 강렬한 순간들을 선정하고 선택한 창의적인 방향성을 중심으로 리듬과 장면 순서를 구성했습니다.",
      "videoDescriptionGeneric": "Voxnela는 콘텐츠, 속도 및 내러티브 일관성을 평가했으며, 균형 잡힌 편집을 위해 가장 강한 순간들을 강조했습니다.",
      "play": "놀다",
      "deletesOn": "{{date}}에서 삭제됨",
      "projectsBelong": "당신의 프로젝트는 당신의 계정에 연결되어 있습니다.",
      "videosBelong": "당신의 동영상은 당신의 계정에 연결되어 있습니다.",
      "signInToSeeProjects": "프로젝트를 보고 기기 간에 계속 진행하려면 로그인하세요.",
      "signInToSeeVideos": "로그인하여 동영상을 보고 기기 간에 계속 진행하세요.",
      "delete": "삭제",
      "deleting": "삭제 중…",
      "secondsVersion": "{{seconds}} sec · 버전 {{version}}",
      "deleteProject": "프로젝트 삭제",
      "projectCoverUnavailable": "프로젝트 표지가 로드되지 않았습니다.",
      "videoCoverPreparing": "비디오 커버 준비하기",
      "deleteVideo": "동영상 삭제",
      "signed": "Voxnela 브랜드",
      "failed": "완료할 수 없었습니다",
      "tryAgain": "다시 시도할 수 있습니다",
      "cancelled": "취소됨",
      "noCreditUsed": "신용이 사용되지 않았습니다",
      "featuredStyles": "특징적인 시각 스타일",
      "previousImage": "이전 이미지",
      "nextImage": "다음 이미지",
      "reviewStyle": "이 스타일을 탐색하세요",
      "featuredNavigation": "특징 시각 탐색",
      "taskCategories": "작업 카테고리",
      "projectOpening": "오픈 프로젝트",
      "opening": "개봉...",
      "projectNotFound": "프로젝트를 찾을 수 없음",
      "projectUnavailable": "이 프로젝트는 더 이상 사용할 수 없습니다.",
      "backToProjects": "내 프로젝트로 돌아가기",
      "editVideo": "비디오 편집",
      "versionContext": "버전 {{version}} · Voxnela는 당신의 프로젝트와 자료를 알고 있습니다",
      "livePreviewActions": "라이브 미리보기 동작",
      "edit": "편집",
      "preparing": "준비 중",
      "save": "저장",
      "thinking": "Voxnela는 생각하고 있다",
      "revisionSuggestions": "편집 제안",
      "describeChange": "원하는 변화를 설명하세요",
      "sendEdit": "편집 요청 보내기",
      "deleteProjectDescription": "“{{title}}”와 관련된 모든 자료를 삭제하시겠다고 확신하십니까? 이는 되돌릴 수 없습니다.",
      "projects": "프로젝트",
      "projectsPreparing": "당신의 프로젝트를 준비하는 중",
      "noProjects": "아직 프로젝트가 없습니다. 먼저 첫 번째 아이디어를 설명하는 것부터 시작하세요.",
      "createNew": "새 이미지 만들기",
      "thisProject": "이 프로젝트",
      "videos": "동영상",
      "videosPreparing": "비디오를 준비하는 중",
      "noVideos": "아직 완성된 동영상이 없습니다. 첫 번째 동영상이 준비되면 여기에서 표시됩니다.",
      "videoPlayFailed": "비디오를 재생할 수 없었습니다.",
      "videoNotReady": "비디오 파일은 아직 다운로드 준비가 되지 않았습니다.",
      "videoDownloadFailed": "비디오를 다운로드할 수 없었습니다.",
      "videoDeleteFailed": "비디오를 삭제할 수 없었습니다.",
      "videoLoading": "비디오 로딩 중...",
      "videoActions": "비디오 동작",
      "showVideoDescription": "비디오 설명 보기",
      "videoDownloading": "비디오 다운로드",
      "downloadVideo": "비디오 다운로드",
      "thisVideo": "이 비디오",
      "deleteVideoDescription": "제목이 “{{title}}”인 비디오를 삭제하시겠습니까? 이는 되돌릴 수 없습니다."
    },
    "studio": {
      "useStyle": "이 스타일을 사용하세요",
      "galleryFilters": "갤러리 필터",
      "modeStyleTransfer": "Voxnela 스타일",
      "modeVirtualTryOn": "가상 시착",
      "modeMagazineCover": "잡지 & 표지",
      "modePosterStudio": "포스터 스튜디오",
      "modeCommercial": "제품 쇼케이스",
      "modeTimeWarp": "시간 여행",
      "modeOutpaintRelight": "확장 및 다시 밝히기",
      "modeInfographic": "인포그래픽 및 데이터",
      "modePortraitRetouch": "포트레이트 리터치",
      "modeArtisticCollage": "예술적 콜라주",
      "defaultStyle": "보크스네라 스타일",
      "signInToCreate": "이미지를 만들려면 로그인하세요.",
      "signInToEdit": "이미지를 편집하려면 로그인하세요.",
      "creationSuccess": "이미지가 성공적으로 생성되었습니다. 조명, 색상, 객체 또는 프레임 변경을 원하시면 직접 알려주세요.",
      "imageReady": "이미지가 준비되었습니다. 마음에 드는 점이나 수정하고 싶은 점을 알려주세요.",
      "revisionSuccess": "수정이 완료되었습니다. 이전/현재 슬라이더와 비교하거나 다른 변경을 요청할 수 있습니다.",
      "versionReady": "버전 {{version}}가 준비되었습니다.",
      "projectNotFound": "프로젝트를 찾을 수 없습니다.",
      "styleApplied": "{{style}} 스타일 적용",
      "imageCreation": "이미지 생성",
      "defaultPrompt": "스튜디오 이미지",
      "aspectSquare": "정사각형",
      "aspectSquareDetail": "인스타그램 피드, 프로필, 아트",
      "aspectVertical": "수직의",
      "aspectVerticalDetail": "인스타그램 스토리, 릴스, 틱톡",
      "aspectHorizontal": "수평의",
      "aspectHorizontalDetail": "유튜브, 배너, 영화관",
      "aspectPortrait": "얼굴 사진",
      "aspectPortraitDetail": "인스타그램 포트레이트, 포스터, 쇼케이스",
      "aspectPanoramic": "파노라마의",
      "aspectPanoramicDetail": "초광각, 시네마틱한 풍경",
      "styles": "Voxnela 스타일",
      "fullScreenStyle": "스타일 전체 화면 보기",
      "closeDescription": "닫기 스타일 설명",
      "moreWithVoxnela": "Voxnela와 함께 더 많은 것을 하세요",
      "quickStartBody": "아래에 원하는 것을 쓰거나 파일을 첨부하세요.",
      "createImage": "이미지 만들기",
      "createImageDetail": "아이디어를 처음부터 만들어보세요",
      "editImage": "이미지 편집",
      "editImageQuick": "이미지를 편집하다",
      "editImageDetail": "업로드된 이미지를 다시 생각해 보세요",
      "transformStyle": "스타일과 장면을 변형하다",
      "transformStyleDetail": "이미지를 다른 세계로 이동하세요",
      "visualizeDocument": "문서 또는 프레젠테이션을 시각화하다",
      "visualizeDocumentDetail": "전체 내용을 디자인으로 변환하세요",
      "submittedImage": "제출된 이미지",
      "generating": "Voxnela가 이미지를 만드는 중…",
      "viewImage": "이미지 보기",
      "removeStyle": "선택한 스타일 제거",
      "referenceImage": "참조 이미지",
      "referenceNotice": "이 이미지는 수정되거나 새로운 스타일이 적용될 것입니다.",
      "removeReference": "참조 이미지 제거",
      "remove": "제거하다",
      "uploading": "업로드 중",
      "addFile": "파일 또는 이미지 추가",
      "addFileTitle": "최대 4장의 이미지 또는 문서(PDF, Word, PPT, 최대 12MB)를 추가하세요.",
      "aspectRatio": "가로세로비",
      "selectAspectRatio": "비례비 선택",
      "aspectOptions": "비례비 옵션",
      "revisePlaceholder": "이 이미지에서 무엇을 변경하고 싶으신가요?",
      "styledPlaceholder": "이 스타일로 원하는 이미지를 설명하세요(선택 사항)...",
      "promptPlaceholder": "이미지를 설명하거나 프롬프트를 작성하세요...",
      "reviseImage": "이미지 수정",
      "generateImage": "이미지 생성",
      "generatedImage": "생성된 이미지",
      "done": "완료",
      "fileLimitTitle": "파일이 너무 큽니다",
      "fileLimitMessage": "\"{{name}}\"는 12MB 제한({{size}} MB)을 초과합니다. 더 작은 파일을 선택하세요.",
      "imageLimitTitle": "이미지 제한",
      "imageLimitMessage": "최대 4장의 이미지를 업로드할 수 있습니다. {{count}} 이미지가 현재 선택되었습니다.",
      "uploadFailedTitle": "업로드 실패",
      "uploadFailedMessage": "파일 업로드 중에 문제가 발생했습니다.",
      "revisionFailed": "수정 중에 오류가 발생하거나 할당량이 초과되었습니다.",
      "generationFailed": "이미지 생성 중에 오류가 발생하거나 할당량이 초과되었습니다.",
      "imageDetails": "이미지 세부 정보",
      "close": "가까운",
      "download": "다운로드",
      "downloadImage": "이미지 다운로드",
      "downloading": "다운로드 중",
      "versionImage": "이미지",
      "exploreTitle": "어떤 스타일을 찾고 계신가요?",
      "explorePlaceholder": "예를 들어: 어두운 톤과 깊은 구도를 가진 시네마틱 초상화",
      "searchStyles": "비주얼 스타일 검색",
      "clearSearch": "검색 지우기",
      "exploreCategories": "카테고리 탐색",
      "all": "전체",
      "styleCount": "{{count}} 스타일",
      "noStyle": "매칭되는 스타일을 찾을 수 없습니다",
      "noStyleBody": "더 짧은 설명이나 다른 단어로 다시 시도해 보세요.",
      "libraryKicker": "당신의 개인 이미지 라이브러리",
      "myImages": "내 이미지",
      "imageWorks": "{{count}} 이미지가 작동합니다.",
      "newImage": "새 이미지 만들기",
      "noImage": "아직 이미지를 생성하지 않았습니다",
      "noCategoryImage": "이 카테고리에는 이미지가 없습니다.",
      "emptyGalleryBody": "스타일 트랜스퍼, 가상 시착, 잡지 표지 또는 제품 쇼케이스로 첫 이미지를 만들어 보세요.",
      "firstImage": "첫 번째 이미지를 만드세요",
      "imageWork": "이미지 작업"
    },
    "create": {
      "briefTitle": "당신의 아이디어나 주제를 설명하세요",
      "briefPlaceholder": "주제는 무엇인가요? 예를 들어: AI의 미래, 화성으로의 여정 또는 제품 출시…",
      "briefLabel": "창작 브리핑",
      "contentType": "콘텐츠 유형",
      "media": "이미지 및 미디어",
      "added": "{{count}} 추가됨",
      "optional": "선택 사항",
      "addMedia": "원하시면 사진이나 동영상을 추가하세요",
      "addMediaBody": "자신의 미디어를 업로드하거나 비워두고 AI가 찾도록 하세요.",
      "attachedMedia": "첨부 미디어",
      "add": "첨가하다",
      "mediaFallback": "매스 미디어",
      "aiCompletes": "AI가 시각적 요소를 완성하도록 하세요",
      "noMedia": "이미지가 업로드되지 않았습니다; AI가 장면을 완성할 것입니다.",
      "productionFormat": "생산 형식",
      "style": "스타일",
      "customVisualWorld": "당신의 시각적 세계를 설명하세요",
      "colorsAtmosphere": "색상, 분위기, 카메라, 리듬",
      "customStyleShort": "당신이 상상하는 시각적 세계를 설명하세요(예: 파스텔 톤과 차분한 카메라, 또는 사이버펑크 네온…)",
      "customStyleLong": "마음에 떠오르는 시각적 세계, 색상, 분위기 및 리듬을 설명하세요.",
      "voiceover": "보이스오버",
      "ownVoiceover": "당신의 음성 해설 텍스트",
      "voiceoverPlaceholder": "여기에 당신의 텍스트를 작성하세요. 비워두시면 Voxnela가 준비해 드리겠습니다.",
      "duration": "길이",
      "seconds": "{{count}} 초",
      "freeLimit": "무료 플랜의 가장 긴 최종 영상은 60초입니다.",
      "addSound": "소리 또는 음악 추가",
      "notAdded": "추가되지 않음",
      "files": "{{count}} 파일",
      "readySounds": "준비된 소리를 사용하세요",
      "musicLibrary": "음악 라이브러리",
      "uploadOwn": "당신의 것을 업로드하세요",
      "captions": "자막",
      "back": "뒤로",
      "create": "만들기",
      "next": "다음",
      "researchingTopic": "주제를 연구하고 있다...",
      "analyzingMaterials": "자료 분석...",
      "researchBody": "출처를 확인하고 스크립트와 시각 계획을 준비합니다.",
      "analyzeBody": "강력한 프레임, 감정, 리듬 그리고 짧은 것을 함께 평가한다.",
      "creativeDirection": "창의적 방향 {{count}}",
      "recommended": "추천",
      "generationFailed": "생성이 완료되지 않았습니다",
      "retry": "다시 준비해",
      "backDirections": "창의적인 방향으로 돌아가기",
      "preparingVideo": "동영상 준비 중",
      "voiceoverText": "보이스오버 텍스트",
      "describeStyle": "당신의 자신의 스타일을 설명하세요",
      "topicDirection": "주제와 방향",
      "styleEditorSubtitle": "시각적 세계, 색상 및 분위기를 설명하십시오.",
      "editorSubtitle": "텍스트를 작성하고 창작 시트에 삽입하세요.",
      "voiceoverEditorPlaceholder": "보이스오버에 사용할 텍스트를 작성합니다.",
      "topicEditorPlaceholder": "주제를 쓰고 그것을 어떻게 전달하고 싶은지 적어라.",
      "insertText": "텍스트 삽입",
      "bestFor": "가장 적합한 곳:",
      "useStyle": "이 스타일을 사용하세요",
      "musicSubtitle": "실제 트랙이 상업용으로 승인되었습니다",
      "adding": "추가 중...",
      "musicLicense": "트랙은 CC0 1.0에 따라 제공됩니다; 상업적 사용이 허용되며 출처 표시는 필요하지 않습니다.",
      "yes": "예",
      "no": "아니요",
      "newCreation": "새로운 창조",
      "reviewing": "Voxnela는 검토 중입니다.",
      "chooseDirection": "세 가지 편집 접근 방식 중 하나를 선택하세요.",
      "ideaSubtitle": "아이디어를 설명하세요; 시각 자료를 업로드하거나 Voxnela가 생성하도록 허용하세요.",
      "projectOpenFailed": "프로젝트 패키지를 열 수 없었습니다.",
      "tooManyAssets": "프로젝트에 최대 50개의 자산을 추가할 수 있습니다.",
      "uploadSizeLimit": "총 프로젝트 업로드가 2GB 제한을 초과했습니다.",
      "filesAddFailed": "파일을 추가할 수 없었습니다.",
      "musicPreviewFailed": "음악 미리보기를 열 수 없었습니다.",
      "musicFetchFailed": "음악 파일을 복구할 수 없었습니다.",
      "musicAddFailed": "음악을 추가할 수 없었습니다.",
      "topicRequired": "주제를 입력하고 비디오가 무엇에 관한 것인지 설명하세요.",
      "briefTooShort": "최소 몇 단어로 당신이 말하고 싶은 것을 설명하세요.",
      "mediaRequired": "이미지를 업로드하거나 AI 생성 시각화를 활성화하세요.",
      "proposalIntro": "이미지와 동영상을 검토하고 당신의 스타일, 형식 및 오디오 선택에 맞는 세 가지 편집 지침을 준비했습니다.",
      "removeMaterial": "{{name}} 제거",
      "aiVisualNotice": "오픈 라이선스 실물 이미지와 AI 일러스트는 자동으로 찾아옵니다.",
      "stepProgress": "{{current}}의 {{total}} 단계",
      "styleSampleAlt": "{{style}} 비디오 스타일을 보여주는 예시",
      "reviewStyle": "{{style}} 스타일을 검토하세요",
      "selectedDirectionPrompt": "선택된 방향: {{title}}. {{summary}} 시각 방향: {{visual}}. 전환 접근법: {{transitions}}. 음악 접근법: {{music}}.",
      "letVoxnelaChoose": "Voxnela가 선택하게 하세요",
      "feminineVoice": "여성",
      "masculineVoice": "남자 같은",
      "narrationStyle": "내레이션 스타일",
      "voiceEstimate": "{{seconds}} sec · {{words}} 단어에 대해.",
      "voiceShort": "{{duration}} 초의 약자인 경우 Voxnela는 의미를 보존하면서 그것을 완성할 것입니다.",
      "voiceNatural": "Voxnela는 문법, 표현 및 자연스러운 흐름만 조정합니다.",
      "removeFile": "{{name}} 파일을 제거합니다.",
      "musicStop": "{{title}} 중지",
      "musicListen": "{{title}}를 듣다",
      "automatic": "자동차",
      "all": "모두",
      "cinematic": "영화의",
      "social": "사회적 & 역동적인",
      "designTypography": "디자인 & 타이포그래피",
      "retroExperimental": "레트로 & 실험적인",
      "productionStage1": "가장 강한 프레임과 장면을 선택하는 것.",
      "productionStage2": "이야기, 움직임 및 전환을 구축합니다.",
      "productionStage3": "음악, 목소리 및 자막의 균형을 맞추는 것.",
      "productionStage4": "라이브 미리보기를 최종 검토 중입니다.",
      "genericCreationError": "비디오 계획을 준비하는 동안 문제가 발생했습니다. 자료와 선택 사항은 그대로 유지되며 다시 시도하실 수 있습니다.",
      "newVideo": "새로운 영상",
      "topicNews": "뉴스",
      "topicDocumentary": "다큐멘터리 on",
      "topicExplainer": "설명하는 사람",
      "topicStory": "이야기",
      "topicScience": "과학",
      "topicPhilosophy": "인생 철학",
      "topicMagazine": "잡지",
      "topicEntertainment": "즐겁게 해주는 것",
      "topicList": "목록",
      "toneCalm": "침착",
      "toneEmotional": "감정적인",
      "toneEnergetic": "정력적인",
      "toneStorytelling": "이야기를 하는",
      "toneCheerful": "쾌활한",
      "toneMysterious": "불가사의한",
      "toneNews": "뉴스",
      "styleCinematic": "영화의",
      "styleDarkCinematic": "어두운 시네마틱",
      "styleDocumentary": "다큐멘터리 on",
      "styleModernDocumentary": "현대 다큐멘터리",
      "stylePovImmersive": "몰입형 POV",
      "styleUgcAuthentic": "진짜 UGC",
      "styleMiniVlog": "미니 브이로그",
      "styleSocialViral": "소셜 바이럴",
      "styleHyperEdit": "하이퍼 편집",
      "styleSportsHype": "스포츠 열풍",
      "styleVelocityEdit": "속도 편집",
      "styleMusicBeatEdit": "음악 비트 편집",
      "styleKineticTypography": "키네틱 타이포그래피",
      "styleMinimalClean": "미니멀하고 깨끗한",
      "styleLuxuryMinimal": "럭셔리 미니멀",
      "styleCommercialProduct": "상업용 제품",
      "styleEditorialFashion": "에디터리 패션",
      "styleCollageZine": "콜라주 진",
      "styleTechFuturistic": "기술 미래지향적",
      "styleRetroFuturism": "레트로 포스트모던",
      "styleY2kDigital": "Y2K 디지털",
      "styleVhsCamcorder": "VHS 캠코더",
      "styleAnalogFilm": "아날로그 필름",
      "styleGlitchCyber": "글리치 사이버",
      "musicUpbeatMood": "에너제틱 · 밝은",
      "musicUpbeatDetail": "활기찬 사회 콘텐츠, 여행 순간 및 활기찬 편집을 위한 실제 악기 연주 녹음.",
      "musicElectronicMood": "현대적인 · 리듬감 있는",
      "musicElectronicDetail": "도시, 기술, 제품 및 빠른 편집을 위한 진정한 일렉트로닉 음악.",
      "musicRomanceMood": "감정적 · 따뜻함",
      "musicRomanceDetail": "가족, 초상화, 특별한 날과 추억을 위한 부드러운 감정의 흐름이 있는 악기 음악.",
      "musicScoringMood": "내러티브 · 시네마틱",
      "musicScoringDetail": "스토리, 프로모션 및 극적인 전환을 지원하는 시네마틱 배경 음악.",
      "musicEpicMood": "강력한 · 상승 중",
      "musicEpicDetail": "그랜드 오프닝, 여정 및 강렬한 피날레를 위해 구축되는 레이어드 악기 음악.",
      "proposalBalancedTitle": "균형 잡힌 서사",
      "proposalBalancedSummary": "재료의 흐름을 보존하고 가장 강력한 프레임을 강조하는 편집.",
      "proposalBalancedVisual": "강력한 계층 구조와 일관된 시각 시스템",
      "proposalBalancedTransitions": "부드러운 절단과 측정된 푸시인",
      "proposalBalancedMusic": "감정에서 리듬으로 이어지는 음악",
      "proposalQuietTitle": "조용한 이야기",
      "proposalQuietSummary": "프레임에 더 많은 시간을 주고 디테일과 자연스러운 감정을 강조하는 차분한 접근법.",
      "proposalQuietVisual": "부드러운 톤과 더 긴 촬영",
      "proposalQuietTransitions": "크로스 용해 및 슬로우 팬",
      "proposalQuietMusic": "간단하고 감성적인 음악",
      "proposalRhythmicTitle": "리듬 편집",
      "proposalRhythmicSummary": "중반에 가속화되고 끝에서 명확하게 마무리되는 강한 오프닝 훅이 있는 편집.",
      "proposalRhythmicVisual": "더 강한 대비와 역동적인 프레이밍",
      "proposalRhythmicTransitions": "비트 컷과 제어된 휘프 전환",
      "proposalRhythmicMusic": "에너제틱하고 상승하는 음악",
      "underVoiceover": "오디오 내레이션 아래 부드러운",
      "withShortVoiceover": "짧고 강렬한 보이스오버와 함께"
    },
    "information": {
      "home": "홈",
      "documentInfo": "문서 정보",
      "version": "버전",
      "effective": "시행일",
      "updated": "최종 업데이트",
      "contents": "목차",
      "officialReferences": "공식 참조",
      "referenceTitle": "법률 및 권한 자료",
      "referenceBody": "이 링크는 일반적인 정보 제공을 위한 것입니다. 관련 당국의 의무 법령 및 현재 규정이 우선합니다.",
      "supportKicker": "스폰엘랩스 지원",
      "contactTitle": "문의하기",
      "contactLead": "계정, 멤버십, 결제, 생성, 콘텐츠 보고서, 개인정보 또는 기술 문제에 대해 Voxnela 지원팀에 연락하십시오.",
      "supportEmail": "지원 이메일",
      "emailBody": "아래 버튼을 클릭하면 사용 가능한 지원 템플릿이 포함된 기본 이메일 앱이 열리므로 더 빠르게 조사할 수 있습니다.",
      "openEmail": "이메일 앱 열기",
      "includeTitle": "메시지에 포함할 내용",
      "includeItems": [
        "웹, iOS 또는 Mac을 사용하든;",
        "당신의 기기 및 운영체제 버전;",
        "문제를 재현하는 단계;",
        "관련 프로젝트 링크, 거래 세부 사항 또는 스크린샷이 있는 경우."
      ],
      "sensitiveTitle": "민감한 정보를 보내지 마세요",
      "sensitiveBody": "문제를 해결하는 데 필요한 것이 아닌 확인 코드, 비밀번호, 전체 결제 카드 세부 정보, 신분증, 건강 데이터 또는 기타 민감한 정보를 포함하지 마십시오.",
      "securityTitle": "보안 및 콘텐츠 신고",
      "securityBody": "취약점에는 “보안”, 데이터 요청에는 “개인정보 요청”, 유해하거나 침해적인 콘텐츠에는 “콘텐츠 보고서”를 사용하십시오. 즉각적인 신체적 위험이 발생하면 현지 긴급 서비스에 연락하십시오.",
      "mailSubject": "Voxnela 지원 요청",
      "mailGreeting": "안녕하세요 Voxnela 지원팀,",
      "mailTopic": "지원 주제:",
      "mailPlatform": "플랫폼(웹 / iOS / Mac):",
      "mailDevice": "기기 및 운영 체제:",
      "mailProject": "프로젝트 ID(가능한 경우):",
      "mailDescription": "문제 또는 요청 설명:",
      "mailThanks": "감사합니다.",
      "termsEyebrow": "Voxnela 이용약관",
      "termsTitle": "이용 약관",
      "termsLead": "이 약관은 Voxnela 웹 및 iOS 앱에서 AI 이미지 생성 및 편집 서비스의 사용을 규정합니다.",
      "privacyEyebrow": "Voxnela 데이터 사용",
      "privacyTitle": "개인정보 보호정책",
      "privacyLead": "이 정책은 Voxnela 이미지 생성 서비스에서 계정, 이미지, 프로젝트, 멤버십 및 기술 데이터가 처리되는 방법을 설명합니다.",
      "officialTurkishNotice": "이 번역은 편의를 위해 제공됩니다. 터키 법적 텍스트는 의미가 다를 경우를 규정합니다."
    }
  },
  "pl": {
    "ui": {
      "home": "Strona główna",
      "homeTitle": "Dom",
      "explore": "Odkrywaj",
      "gallery": "Galeria",
      "myImages": "Moje Zdjęcia",
      "settings": "Ustawienia",
      "createImage": "Utwórz obraz",
      "back": "Wstecz",
      "search": "Szukaj",
      "account": "Konto",
      "login": "Zaloguj się",
      "logout": "Wyloguj się",
      "profile": "Profil",
      "profileSettings": "Profil i ustawienia",
      "plans": "Plany i wykorzystanie",
      "plansSubtitle": "Źródła obrazów i opłaty",
      "contact": "Kontakt",
      "contactSubtitle": "Pomoc i opinie",
      "discoverVoxnela": "Odkryj Voxnela",
      "discoverVoxnelaSubtitle": "Przejrzyj doświadczenie w studio wizualnym",
      "privacy": "Prywatność",
      "privacySubtitle": "Jak Twoje dane są chronione",
      "terms": "Warunki użytkowania",
      "termsSubtitle": "Warunki świadczenia usług Voxnela",
      "preferencesSubtitle": "Twoje konto i preferencje Voxnela",
      "accountSubtitle": "Dane konta i członkostwa",
      "voxAccount": "Akonte Voxnela",
      "accessEverywhere": "Uzyskaj dostęp do swoich obrazów na każdym urządzeniu",
      "imageRights": "{{count}} kredyty obrazowe",
      "availableCredits": "Dostępne kredyty",
      "renewalDate": "Data odnowienia",
      "membershipStart": "Założono członkostwo",
      "registrationDate": "Data rejestracji",
      "monthly": "Miesięcznie",
      "renewalOff": "Odnowienie wyłączone",
      "user": "Użytkownik Voxnela",
      "language": "Język",
      "languageSubtitle": "Wybierz język aplikacji",
      "supportBody": "Napisz do nas, jeśli masz problem lub chcesz podzielić się pomysłem. Uwzględnienie ID projektu pomaga nam szybciej odpowiedzieć.",
      "studioTitle": "Studio wizualne Voxnela",
      "studioSubtitle": "Stwórz swój styl",
      "searchSubtitle": "Twoje zdjęcia i projekty",
      "searchPlaceholder": "Szukaj obrazu lub projektu",
      "noSearchResults": "Nic nie pasowało do tego wyszukiwania.",
      "project": "Projekt",
      "image": "Obraz",
      "completed": "Zrealizowany",
      "currentPlan": "Obecny plan",
      "notSignedIn": "Nie zalogowany",
      "signInIntro": "Zaloguj się, aby rozpocząć korzystanie z Voxnela.",
      "creditsAvailable": "Dostępne są licencje zdjęciowe studio {{count}}.",
      "noCredits": "Nie masz już żadnych kredytów na obrazy w tym okresie.",
      "membershipInfo": "Kredyty w ramach rocznego planu odnawiają się co miesiąc i nie przechodzą na kolejny miesiąc. Odnowione zakupy pozostają chronione w ramach Twojego konta.",
      "signedOutMembershipInfo": "Po zalogowaniu dostępne kredyty na zdjęcia oraz informacje o planie pojawią się tutaj.",
      "reviewPlans": "Zobacz plany",
      "versionUpdated": "Wersja {{version}} · Ostatnio zaktualizowana {{date}}",
      "onboardingWelcome": "Witamy w Voxnela",
      "skipIntro": "Pomiń wprowadzenie",
      "continue": "Kontynuuj",
      "startCreating": "Zacznij tworzyć",
      "close": "Zamyknij",
      "dragToClose": "Przesuń w dół, aby zamknąć arkusz",
      "loading": "Ładowanie...",
      "sheetExpand": "Rozszerz kartę",
      "sheetCollapse": "Powrót arkusza do normalnej wysokości",
      "cannotClose": "Nie można zamknąć podczas trwania operacji",
      "stylePreview": "Przewiew stylu",
      "stylePreviewSubtitle": "Stylizacje i trendy z podpisem",
      "categories": "Kategorie",
      "useThisStyle": "Użyj tego stylu",
      "videoControls": "Kontrolery wideo",
      "play": "Graj",
      "pause": "Przerwa",
      "mute": "Mocno głośno",
      "unmute": "Wyłączaj milczenie",
      "minimize": "Zmniejszyć",
      "expandVideo": "Rozszerz w aplikacji",
      "videoProgress": "Postęp wideo",
      "toggleVideoControls": "Pokaż lub ukryj kontrolę wideo",
      "expandedVideo": "{{title}} rozszerzony widok wideo",
      "goToImage": "Przejdź do obrazu {{title}}",
      "categoryVisualStyles": "Stylistyki wizualne {{category}}",
      "onboarding1Eyebrow": "Tworzenie obrazów",
      "onboarding1Title": "Utwórz swój obraz.",
      "onboarding1Body": "Przekształć swoją pomysł w kinowe kadry z użyciem filmu 35 mm, edycyjnego, produktu, postera i wielu innych stylów wizualnych.",
      "onboarding2Eyebrow": "Wirtualna przymierzalnia",
      "onboarding2Title": "Przymierz nowe stroje.",
      "onboarding2Body": "Zachowaj tożsamość w różnych produkcjach i tworz realistyczne wizualizacje prób produktów, akcesoriów i mody.",
      "onboarding3Eyebrow": "Edycja obrazów",
      "onboarding3Title": "Edytuj swój obraz.",
      "onboarding3Body": "Popraw kompozycję, światło, kolor i detale rozmową bez konieczności od nowa.",
      "onboarding4Eyebrow": "3 darmowych obrazów",
      "onboarding4Title": "Zacznij za darmo.",
      "onboarding4Body": "Zacznij od razu z 3 jednorazowymi darmowymi generacjami obrazów AI. Konto nie jest potrzebne.",
      "onboardingFaceEyebrow": "Analiza twarzy i stylu",
      "onboardingFaceTitle": "Poznaj twarz i styl.",
      "onboardingFaceBody": "Na podstawie portretu poznaj pomysły na fryzurę, okulary i ubrania w jednym wizualnym przewodniku.",
      "onboardingHouseEyebrow": "Podróż w czasie",
      "onboardingHouseTitle": "Podróżuj w czasie.",
      "onboardingHouseBody": "Połącz zdjęcia i daty, aby zobaczyć, jak Twój dom zmieniał się z czasem.",
      "onboardingFestivalEyebrow": "Twój dzień na festiwalu",
      "onboardingFestivalTitle": "Zaplanuj dzień na festiwalu jednym spojrzeniem.",
      "onboardingFestivalBody": "Zmień podany program, sceny i godziny w osobistą wizualną trasę.",
      "onboardingStylesEyebrow": "Style Voxnela",
      "onboardingStylesTitle": "Wybierz swój styl.",
      "onboardingStylesBody": "Przekształć swoją pomysł w kinowe kadry z użyciem filmu 35 mm, edycyjnego, produktu, postera i wielu innych stylów wizualnych."
    },
    "auth": {
      "enterCode": "Wpisz kod",
      "membershipAndAccount": "Dane członkostwa i konta",
      "noPeriodInfo": "Okres niedostępny",
      "memberSince": "Członek od",
      "planSince": "{{plan}} od",
      "membershipRenewal": "Data odnowienia członkostwa",
      "accountActions": "Działania na koncie",
      "manageSubscriptionTitle": "Kończenie subskrypcji",
      "manageSubscriptionSubtitle": "Zarządzaj subskrypcją sklepu i automatycznym odnowieniem.",
      "deleteAccountTitle": "Usuń mój konto",
      "deleteAccountSubtitle": "Wymienny proces usuwania w ciągu 15 dni.",
      "deleteDataTitle": "Usuń moje dane",
      "deleteDataSubtitle": "Wymienny proces usuwania danych na 30 dni.",
      "signingOut": "Wylogowywanie…",
      "signOut": "Wyloguj się",
      "signingIn": "Logowanie…",
      "continueApple": "Kontynuuj z Apple",
      "continueGoogle": "Kontynuuj z Google",
      "or": "lub",
      "email": "E-mail",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "Kontynuując z Voxnela, akceptujesz",
      "legalTerms": "Warunki użytkowania",
      "legalJoin": "i potwierdź, że przeczytałeś i zrozumiasz",
      "legalPrivacy": "Informacja o prywatności",
      "legalSuffix": ".",
      "sendingCode": "Wysyłanie kodu…",
      "emailSignIn": "Zaloguj się e-mailem",
      "codeSent": "Wyśleliśmy kod na {{email}}.",
      "change": "Zmień",
      "sixDigitCode": "Kod 6-cyfrowy",
      "emailCode": "Kod logowania przez e-mail",
      "verifyingCode": "Weryfikowanie kodu…",
      "resendCode": "Wyślij kod ponownie",
      "requestReceived": "Żądanie otrzymane",
      "accountDeletionStarted": "Proces usuwania Twojego konta rozpoczął się",
      "dataDeletionStarted": "Twój proces usuwania danych rozpoczął się",
      "accountAction": "Działanie konta",
      "accountDeletesAt": "Twoje konto zostanie na stałe usunięte na {{date}}.",
      "dataDeletesAt": "Twoje osobiste dane Voxnela zostaną na stałe usunięte na {{date}}.",
      "deletionUndo": "Jeśli zalogujesz się z tym samym kontem przed tym terminem, proces usuwania zostanie automatycznie anulowany. Twoja aktualna sesja została zamknięta, ponieważ złożono żądanie.",
      "done": "Gotowe",
      "cancel": "Anuluj",
      "preparing": "Przygotowywanie...",
      "invalidEmail": "Wprowadź ważny adres e-mail.",
      "enterSixDigitCode": "Wprowadź 6-cyfrowy kod wysłany na Twój e-mail.",
      "signInFailed": "Logowanie nie mogło zostać zakończone. Spróbuj ponownie.",
      "codeSendFailed": "Kod logowania nie mógł zostać wysłany. Spróbuj ponownie.",
      "codeVerifyFailed": "Kod nie mógł zostać zweryfikowany. Spróbuj ponownie.",
      "operationFailed": "Operacja nie mogła zostać zakończona w tej chwili. Spróbuj ponownie.",
      "popupClosed": "Oknie logowania zostało zamknięte.",
      "unauthorizedDomain": "Ten domena nie jest dozwolona do logowania.",
      "methodUnavailable": "Ten sposób logowania nie jest jeszcze włączony.",
      "tooManyCodes": "Wystarczająco wiele kodów zostało poproszonych. Spróbuj ponownie za kilka minut.",
      "invalidCode": "Kod jest niepoprawny lub wygasł. Poproś o nowy kod.",
      "emailUnavailable": "Dostawa e-maili jest obecnie niedostępna.",
      "actions": {
        "subscription": {
          "eyebrow": "Akcja subskrypcji",
          "title": "Kończ swoją subskrypcję?",
          "confirm": "Zarządzaj subskrypcjami",
          "paragraphs": [
            "Kontynuowanie otwiera stronę zarządzania subskrypcją Apple App Store lub Google Play, gdzie kupiłeś subskrypcję. Musisz wyłączyć automatyczne odnowienie w sklepie.",
            "Po anulowaniu istniejące korzyści z członkostwa pozostają dostępne do końca okresu płatnego. Usuwanie konta lub danych nie anuluje subskrypcji sklepu."
          ]
        },
        "account": {
          "eyebrow": "Działanie konta stałego",
          "title": "Czy jesteś pewien, że chcesz usunąć swój konto?",
          "confirm": "Rozpocznij proces usuwania na 15 dni",
          "paragraphs": [
            "Kontynuowanie rozpoczyna 15-dniowy proces usuwania i logujesz się z wyłączonymi danymi w celu bezpieczeństwa. Jeśli nie zalogujesz się ponownie w tym okresie, Twoje konto, profil, tworzenia, biblioteka, kolekcje oraz powiązane dane Voxnela zostaną na stałe usunięte.",
            "Logowanie z tym samym kontem przed 15 dniem automatycznie anuluje usunięcie. Usuwanie konta nie anuluje aktywnego subskrypcji sklepu; anuluj ją osobno w sklepie."
          ]
        },
        "data": {
          "eyebrow": "Trwałe działanie danych",
          "title": "Czy jesteś pewien, że chcesz usunąć swoje dane?",
          "confirm": "Rozpocznij proces usuwania na 30 dni",
          "paragraphs": [
            "Kontynuowanie rozpoczyna 30-dniowy proces usuwania i logujesz się z powodu bezpieczeństwa. Jeśli nie zalogujesz się ponownie w tym okresie, twoje tworzenia, biblioteka, kolekcje, rekordy, interakcje oraz inne dane osobiste Voxnela zostaną na stałe usunięte; twoje konto logowania pozostaje dostępne.",
            "Ponowne zalogowanie przed 30 dniem automatycznie anuluje usuwanie danych. Ograniczone rekordy transakcji i bezpieczeństwa wymagane przez prawo mogą być przechowywane z ograniczeniem dostępu w okresie obowiązującym prawnie."
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "Nie pozostało żadnych kredytów zdjęciowych",
      "quotaFreeMessage": "Wykorzystałeś kredyt zdjęciowy w swoim darmowym koncie. Wybierz plan, aby kontynuować tworzenie.",
      "later": "Później",
      "currentCredit": "Aktualne kredyty: 0",
      "quotaProTitle": "Osiągnięto miesięczny limit Pro",
      "quotaProMessage": "Wykorzystałeś 100 kredytów obrazowych tego miesiąca. Zaktualizuj do Studio, aby kontynuować tworzenie.",
      "renewalDate": "Data odnowienia: {{date}}",
      "quotaStudioTitle": "Osiągnięto miesięczny limit studia",
      "quotaStudioMessage": "Twoje kredyty na obraz będą automatycznie odnawiane na {{date}}.",
      "done": "Zrobione",
      "membership": "Członkostwo Voxnela",
      "options": "Opcje członkostwa",
      "credits": "Kredyty",
      "currentMembership": "Obecne członkostwo",
      "yearlyDiscount": "17% zniżki",
      "loadingPrice": "Ładowanie ceny ze sklepu…",
      "loadingStorePrice": "Ładowanie cen z sklepu",
      "year": "rok",
      "month": "miesiąc",
      "renewDisclosure": "Odnawia się automatycznie za każdym razem, gdy {{period}}. Anuluj w dowolnym momencie.",
      "legal": "Informacje prawne",
      "terms": "Warunki",
      "alreadyMember": "Masz już {{plan}} {{period}}",
      "startPlan": "Zacznij plan {{plan}}",
      "upgradeStudio": "Przejdź na Studio",
      "yearlyAdvantage": "Przejdź na roczne oszczędności",
      "upgrade": "Ulepsz członkostwo",
      "signInRequired": "Zaloguj się na swoje konto Voxnela przed rozpoczęciem subskrypcji.",
      "catalogUnavailable": "Katalog płatności nie mógł zostać zweryfikowany dla tego planu. Spróbuj ponownie wkrótce.",
      "paymentUnavailable": "Ekran płatności nie mógł zostać otwarty. Spróbuj ponownie.",
      "benefits": [
        {
          "lead": "{{credits}} kredyty",
          "label": "Generacja obrazów o wysokiej rozdzielczości co miesiąc"
        },
        {
          "lead": "50+ stylów studio",
          "label": "Neo-minimalizm, kinowe i każdy charakterystyczny styl"
        },
        {
          "lead": "Zamykanie twarzy",
          "label": "Wirtualne próbki mody bez zmiany cech twarzy"
        },
        {
          "lead": "Lista priorytetowa",
          "label": "Ultra-szybkie przetwarzanie GPU bez czekania"
        },
        {
          "lead": "Rewizje czatu",
          "label": "Niezależne edycje szczegółowe wielokrotnych rund w języku naturalnym"
        },
        {
          "lead": "Pełne prawa komercyjne",
          "label": "Wysokiej rozdzielczości, bez znaków wodnych"
        }
      ],
      "restorePurchases": "Przywróć zakupy",
      "restoringPurchases": "Restoring zakupów...",
      "restoreSuccess": "Twoja członkostwo zostało przywrócone.",
      "restoreEmpty": "Nie znaleziono aktywnych subskrypcji dla tego konta App Store.",
      "membershipSyncPending": "Weryfikacja członkostwa i kredytów zdjęciowych...",
      "membershipSyncFailed": "Nie udało się zsynchronizować kredytów obrazów. Spróbuj ponownie.",
      "membershipUnavailable": "Nie udało się wczytać członkostwa.",
      "retry": "Spróbuj ponownie"
    },
    "video": {
      "revisionHook": "Spraw, aby pierwsze trzy sekundy były bardziej angażujące.",
      "revisionPace": "Zrównoważ tempo i skróć powolne sekcje.",
      "revisionEnding": "Zrób zakończenie bardziej zapadające w pamięć.",
      "revisionTransition": "Ułatw przejścia i spraw, aby były bardziej płynne i naturalne.",
      "revisionFraming": "Użyj bardziej zrównoważonego kadru dla ważnych szczegółów.",
      "revisionColor": "Zrób kolory bardziej zrównoważone i kinowe.",
      "revisionText": "Skróć tekst i ułatw jego czytanie.",
      "revisionAudio": "Skoncentruj muzykę bardziej na rytmie obrazów.",
      "revisionEmotion": "Spraw, aby historia brzmiała bardziej szczere i emocjonalne.",
      "revisionStructure": "Zbuduj jaśniejsze początek, środkowie i koniec.",
      "previewBack": "Powrót do przeglądania",
      "revisionWelcome": "Co chciałbyś zmienić?",
      "revisionFailed": "Nie mogłem zastosować tej zmiany. Czy mógłbyś ją ponownie opisać?",
      "finalQueued": "Ostateczne wideo jest w kolejce. Pojawi się pod kategorii Wideo, gdy będzie gotowe.",
      "watermarkUpgrade": "Wybierz plan, aby stworzyć nowy ostateczny wynik bez znaku wodnego Voxnela.",
      "finalFailed": "Ostateczne wideo nie mogło zostać uruchomione.",
      "projectDeleteFailed": "Projekt nie mógł zostać usunięty.",
      "videoDescriptionWithBrief": "Ten film został stworzony na podstawie „{{brief}}”. Voxnela wybrała najsilniejsze momenty i zbudowała rytm oraz kolejność scen wokół wybranego kierunku kreatywnego.",
      "videoDescriptionGeneric": "Voxnela oceniła materiały pod kątem treści, tempa i spójności narracji, podkreślając najważniejsze momenty dla zrównoważonego edycji.",
      "play": "Graj",
      "deletesOn": "usuwa na {{date}}",
      "projectsBelong": "Twoje projekty są powiązane z Twoim kontem.",
      "videosBelong": "Twoje filmy są powiązane z Twoim kontem.",
      "signInToSeeProjects": "Zaloguj się, aby zobaczyć swoje projekty i kontynuować na różnych urządzeniach.",
      "signInToSeeVideos": "Zaloguj się, aby zobaczyć swoje filmy i kontynuować na różnych urządzeniach.",
      "delete": "Usuń",
      "deleting": "Usuwanie…",
      "secondsVersion": "{{seconds}} sek · wersja {{version}}",
      "deleteProject": "Usuń projekt",
      "projectCoverUnavailable": "Tło projektu nie mogło zostać załadowane",
      "videoCoverPreparing": "Przygotowywanie tła wideo",
      "deleteVideo": "Usuń film",
      "signed": "Z marką Voxnela",
      "failed": "Nie mogło ukończyć",
      "tryAgain": "Możesz spróbować ponownie",
      "cancelled": "Anulowane",
      "noCreditUsed": "Brak użytego kredytu",
      "featuredStyles": "Polecane style wizualne",
      "previousImage": "Poprzednie zdjęcie",
      "nextImage": "Następne zdjęcie",
      "reviewStyle": "Odkryj ten styl",
      "featuredNavigation": "Promocjonalna nawigacja wizualna",
      "taskCategories": "Kategorie zadań",
      "projectOpening": "Projekt otwierający",
      "opening": "Otwarcie...",
      "projectNotFound": "Nie znaleziono projektu",
      "projectUnavailable": "Ten projekt nie jest już dostępny.",
      "backToProjects": "Wróć do projektów",
      "editVideo": "Edytuj wideo",
      "versionContext": "Wersja {{version}} · Voxnela zna Twój projekt i materiały",
      "livePreviewActions": "Akcje w czasie rzeczywistym w przegląd",
      "edit": "Edytuj",
      "preparing": "Przygotowywanie",
      "save": "Zapisz",
      "thinking": "Voxnela myśli",
      "revisionSuggestions": "Sugestie edycji",
      "describeChange": "Opisz zmianę, którą chcesz",
      "sendEdit": "Wyślij prośbę o edyc",
      "deleteProjectDescription": "Czy jesteś pewien, że chcesz usunąć „{{title}}” i wszystkie powiązane materiały? To nie można cofnąć.",
      "projects": "Projekty",
      "projectsPreparing": "Przygotowywanie swoich projektów",
      "noProjects": "Nie masz jeszcze projektu. Zacznij od opisu swojej pierwszej idei.",
      "createNew": "Utwórz nowy obraz",
      "thisProject": "Ten projekt",
      "videos": "Filmy",
      "videosPreparing": "Przygotowywanie swoich filmów",
      "noVideos": "Nie masz jeszcze ukończonego filmu. Zostanie on wyświetlony tutaj, gdy Twój pierwszy film będzie gotowy.",
      "videoPlayFailed": "Wideo nie mogło zostać wyświetlone.",
      "videoNotReady": "Plik wideo nie jest jeszcze gotowy do pobrania.",
      "videoDownloadFailed": "Wideo nie mogło zostać pobrane.",
      "videoDeleteFailed": "Wideo nie mogło zostać usunięte.",
      "videoLoading": "Ładowanie wideo...",
      "videoActions": "Akcje wideo",
      "showVideoDescription": "Pokaż opis wideo",
      "videoDownloading": "Pobieranie wideo",
      "downloadVideo": "Pobierz wideo",
      "thisVideo": "Ten film",
      "deleteVideoDescription": "Czy jesteś pewien, że chcesz usunąć wideo o nazwie „{{title}}”? To nie można cofnąć."
    },
    "studio": {
      "useStyle": "Użyj tego stylu",
      "galleryFilters": "Filtry galerii",
      "modeStyleTransfer": "Styly Voxnela",
      "modeVirtualTryOn": "Wirtualne Spróbowanie Na Rzecz",
      "modeMagazineCover": "Magazyn i okładka",
      "modePosterStudio": "Studio posterowe",
      "modeCommercial": "Pokaz produktów",
      "modeTimeWarp": "Przekluczenie czasu",
      "modeOutpaintRelight": "Rozszerz i odświeć",
      "modeInfographic": "Infografika i dane",
      "modePortraitRetouch": "Retusz portretowy",
      "modeArtisticCollage": "Artystyczny kolaż",
      "defaultStyle": "Styl Voxnela",
      "signInToCreate": "Zaloguj się, aby utworzyć obraz.",
      "signInToEdit": "Zaloguj się, aby edytować obraz.",
      "creationSuccess": "Twoje zdjęcie zostało pomyślnie utworzone. Powiedz mi bezpośrednio, jeśli chcesz zmienić oświetlenie, kolory, obiekty lub ramkę.",
      "imageReady": "Twoje zdjęcie jest gotowe. Powiedz mi, co ci się podoba lub co chcesz poprawić.",
      "revisionSuccess": "Ostateczna wersja jest gotowa. Możesz porównać ją z przełącznikiem „przed/po” lub poprosić o zmianę.",
      "versionReady": "Wersja {{version}} jest gotowa.",
      "projectNotFound": "Projekt nie znaleziony.",
      "styleApplied": "Zastosowano styl {{style}}",
      "imageCreation": "Tworzenie obrazów",
      "defaultPrompt": "Zdjęcie studio",
      "aspectSquare": "Kwadrat",
      "aspectSquareDetail": "Kanał Instagrama, Profil, Sztuka",
      "aspectVertical": "Wertykalny",
      "aspectVerticalDetail": "Story na Instagramie, Reelsy, TikTok",
      "aspectHorizontal": "Poziomowy",
      "aspectHorizontalDetail": "YouTube, Baner, Kinowe",
      "aspectPortrait": "Portret",
      "aspectPortraitDetail": "Portret Instagram, poster, prezentacja",
      "aspectPanoramic": "Panoramyczny",
      "aspectPanoramicDetail": "Ultra szeroki, kinowy krajobraz",
      "styles": "Style Voxnela",
      "fullScreenStyle": "Zobacz styl w pełnym ekranie",
      "closeDescription": "Opis stylu bloku",
      "moreWithVoxnela": "Robisz więcej z Voxnela",
      "quickStartBody": "Napisz poniżej, co chcesz, lub załącz plik.",
      "createImage": "Utwórz obraz",
      "createImageDetail": "Stwórz swoją pomysł od zera",
      "editImage": "Edytuj obraz",
      "editImageQuick": "Edytuj obraz",
      "editImageDetail": "Przeobraź załadowane zdjęcie",
      "transformStyle": "Transformacja stylu i sceny",
      "transformStyleDetail": "Przenieś swoje zdjęcie do innego świata",
      "visualizeDocument": "Wyobraź sobie dokument lub prezentację",
      "visualizeDocumentDetail": "Przekształć całą treść w projekt",
      "submittedImage": "Przesłane zdjęcie",
      "generating": "Voxnela tworzy obraz…",
      "viewImage": "Zobacz obraz",
      "removeStyle": "Usuń wybrany styl",
      "referenceImage": "Obraz referencyjny",
      "referenceNotice": "To zdjęcie zostanie zrefaktowane lub zastosowany zostanie nowy styl",
      "removeReference": "Usuń obraz referencyjny",
      "remove": "Usuń",
      "uploading": "Ładowanie",
      "addFile": "Dodaj plik lub obraz",
      "addFileTitle": "Dodaj do 4 obrazki lub dokument (PDF, Word, PPT, max 12 MB)",
      "aspectRatio": "Proporcje aspektowe",
      "selectAspectRatio": "Wybierz stosunek kątów",
      "aspectOptions": "Opcje proporcji aspektu",
      "revisePlaceholder": "Co chciałbyś zmienić na tym obrazku?",
      "styledPlaceholder": "Opisz obraz, który chcesz w tym stylu (opcjonalnie)…",
      "promptPlaceholder": "Opisz obraz lub napisz prośbę…",
      "reviseImage": "Opracuj obraz",
      "generateImage": "Generuj obraz",
      "generatedImage": "Generowane obraz",
      "done": "Gotowe",
      "fileLimitTitle": "Plik jest za duży",
      "fileLimitMessage": "„{{name}}” przekracza limit 12 MB ({{size}} MB). Wybierz mniejszy plik.",
      "imageLimitTitle": "Limit obrazu",
      "imageLimitMessage": "Możesz przesłać do 4 obrazów. Obrazy {{count}} są obecnie wybrane.",
      "uploadFailedTitle": "Wysyłka nie powiodła się",
      "uploadFailedMessage": "Wystąpił problem podczas przesyłania pliku.",
      "revisionFailed": "Wystąpił błąd podczas przeglądu lub limit został przekroczony.",
      "generationFailed": "Wystąpił błąd podczas generowania obrazu lub limit został przekroczony.",
      "imageDetails": "Szczegóły obrazu",
      "close": "Zamyknij",
      "download": "Pobierz",
      "downloadImage": "Pobierz obraz",
      "downloading": "Pobieranie",
      "versionImage": "Obraz",
      "exploreTitle": "Jakiego stylu szukasz?",
      "explorePlaceholder": "Na przykład: kinowe portret z ciemnymi tonami i głębokim perspektywą",
      "searchStyles": "Szukaj stylów wizualnych",
      "clearSearch": "Czyste wyszukiwanie",
      "exploreCategories": "Przeglądaj kategorie",
      "all": "Wszystkie",
      "styleCount": "Styly {{count}}",
      "noStyle": "Nie znaleziono pasującego stylu",
      "noStyleBody": "Spróbuj ponownie z krótszą opisem lub innymi słowami.",
      "libraryKicker": "Twoja osobista biblioteka obrazów",
      "myImages": "Moje obrazy",
      "imageWorks": "Zdjęcie {{count}} działa",
      "newImage": "Utwórz nowy obraz",
      "noImage": "Jeszcze nie utworzyłeś obrazu",
      "noCategoryImage": "Nie ma obrazów w tej kategorii",
      "emptyGalleryBody": "Stwórz swoje pierwsze zdjęcie za pomocą transferu stylu, wirtualnego próbkowania, okładki magazynu lub pokazu produktów.",
      "firstImage": "Stwórz swoje pierwsze zdjęcie",
      "imageWork": "Praca z obrazami"
    },
    "create": {
      "briefTitle": "Opisz swoją pomysł lub temat",
      "briefPlaceholder": "Jaki jest temat? Na przykład: przyszłość sztucznej inteligencji, podróż na Marsa lub wprowadzenie produktu…",
      "briefLabel": "Podsumowanie tworzenia",
      "contentType": "Typ treści",
      "media": "Zdjęcia i media",
      "added": "{{count}} dodane",
      "optional": "Opcjonalne",
      "addMedia": "Dodaj zdjęcie lub wideo, jeśli chcesz",
      "addMediaBody": "Prześlij własne materiały lub zostaw je puste i pozwól AI je znaleźć",
      "attachedMedia": "Załączone media",
      "add": "Dodaj",
      "mediaFallback": "Media",
      "aiCompletes": "Pozwól AI ukończyć wizualizacje",
      "noMedia": "Nie przesłano żadnych obrazów; sztuczna inteligencja wypełni sceny.",
      "productionFormat": "Format produkcji",
      "style": "Styl",
      "customVisualWorld": "Opisz swój świat wizualny",
      "colorsAtmosphere": "Kolory, atmosfera, kamera, rytm",
      "customStyleShort": "Opisz świat wizualny, który masz na myśli (na przykład: pastelowe odcienie i spokojna kamera, albo neonowy cyberpunk…)",
      "customStyleLong": "Opisz świat wizualny, kolory, atmosferę i rytm, o których myślisz.",
      "voiceover": "Lektor",
      "ownVoiceover": "Twój tekst z podkładem głosu",
      "voiceoverPlaceholder": "Napisz tutaj swój tekst. Jeśli zostanie puste, Voxnela przygotuje go.",
      "duration": "Czas trwania",
      "seconds": "{{count}} sek",
      "freeLimit": "Najdłuższy wideo końcowe w ramach darmowego planu trwa 60 sekund.",
      "addSound": "Dodaj dźwięk lub muzykę",
      "notAdded": "Nie dodane",
      "files": "Pliki {{count}}",
      "readySounds": "Używaj gotowych dźwięków",
      "musicLibrary": "Biblioteka muzyki",
      "uploadOwn": "Prześlij swój własny",
      "captions": "Napisy",
      "back": "Wstecz",
      "create": "Utwórz",
      "next": "Dalej",
      "researchingTopic": "Badanie tematu…",
      "analyzingMaterials": "Analizowanie materiałów...",
      "researchBody": "Weryfikacja źródeł i przygotowywanie scenariusza oraz planu wizualnego.",
      "analyzeBody": "Oceniając silne kadry, emocje, rytm i krótką całość razem.",
      "creativeDirection": "Kreatywne kierowanie {{count}}",
      "recommended": "Polecane",
      "generationFailed": "Tworzenie nie mogło zostać zakończone",
      "retry": "Zaprojektuj ponownie",
      "backDirections": "Wrót do kierunków kreatywnych",
      "preparingVideo": "Przygotowywanie filmu",
      "voiceoverText": "Tekst z podpowiedzią głosową",
      "describeStyle": "Opisz swój własny styl",
      "topicDirection": "Temat i kierunek",
      "styleEditorSubtitle": "Opisz świat wizualny, kolory i atmosferę",
      "editorSubtitle": "Napisz tekst i wstaw go do arkusza tworzenia",
      "voiceoverEditorPlaceholder": "Napisz tekst do użycia do podpowiedzi głosowej.",
      "topicEditorPlaceholder": "Napisz temat i sposób, w jaki chcesz, aby go opowiedziano.",
      "insertText": "Wprowadź tekst",
      "bestFor": "Najlepiej dla:",
      "useStyle": "Użyj tego stylu",
      "musicSubtitle": "Prawdziwe utwory zostały zatwierdzone do użytku komerc",
      "adding": "Dodawanie...",
      "musicLicense": "Utwory są udostępniane na podstawie CC0 1.0; użycie komercyjne jest dozwolone i nie jest wymagane przypisanie autorstwa.",
      "yes": "Tak",
      "no": "Nie",
      "newCreation": "Nowa kreatycja",
      "reviewing": "Voxnela przegląda",
      "chooseDirection": "Wybierz jeden z trzech podejść edycji",
      "ideaSubtitle": "Opisz swoją pomysł; załaduj obrazy lub pozwól Voxnela je stworzyć",
      "projectOpenFailed": "Pakiet projektu nie mógł zostać otworzony.",
      "tooManyAssets": "Możesz dodać do projektu do 50 zasobów.",
      "uploadSizeLimit": "Całkowite załadowanie projektu przekracza limit 2 GB.",
      "filesAddFailed": "Pliki nie mogły zostać dodane.",
      "musicPreviewFailed": "Prewiew muzyki nie mógł zostać otwarty.",
      "musicFetchFailed": "Plik muzyczny nie mógł zostać pobrany.",
      "musicAddFailed": "Muzyka nie mogła zostać dodana.",
      "topicRequired": "Wprowadź temat i opisz, o czym będzie Twój film.",
      "briefTooShort": "Opisz, co chcesz powiedzieć co najmniej kilkoma słowami.",
      "mediaRequired": "Prześlij obraz lub włącz wizualizacje generowane przez sztuczną inteligencję.",
      "proposalIntro": "Przejrzałem zdjęcia i filmy oraz przygotowałem trzy kierunki edycji, które pasują do twojego stylu, formatu i wyboru dźwięku.",
      "removeMaterial": "Usuń {{name}}",
      "aiVisualNotice": "Otwarcie licencjonowane rzeczywiste obrazy i ilustracje AI są automatycznie znajdziane.",
      "stepProgress": "Krok {{current}} z {{total}}",
      "styleSampleAlt": "Przykładowe pokazanie stylu wideo {{style}}",
      "reviewStyle": "Przejrzyj styl {{style}}",
      "selectedDirectionPrompt": "Wybór kierunku: {{title}}. {{summary}} Kierunek wizualny: {{visual}}. Podejście przekształcania: {{transitions}}. Podejście muzyczne: {{music}}.",
      "letVoxnelaChoose": "Pozwól Voxnela wybrać",
      "feminineVoice": "Kobieta",
      "masculineVoice": "Męski",
      "narrationStyle": "Styl narracji",
      "voiceEstimate": "O {{seconds}} sek · słowa {{words}}.",
      "voiceShort": "Jeśli jest to skrót dla {{duration}} sekund, Voxnela je wypełni, zachowując znaczenie.",
      "voiceNatural": "Voxnela dostosowuje tylko gramatykę, sformułowanie i naturalny płyn.",
      "removeFile": "Usuń plik {{name}}",
      "musicStop": "Zakończ {{title}}",
      "musicListen": "Słuchaj {{title}}",
      "automatic": "Samochód",
      "all": "Wszystko",
      "cinematic": "Kinematyczny",
      "social": "Społeczny i dynamiczny",
      "designTypography": "Projektowanie i typografia",
      "retroExperimental": "Retro i eksperymentalne",
      "productionStage1": "Wybieranie najsilniejszych kadr i scen.",
      "productionStage2": "Budowanie historii, ruchu i przejść.",
      "productionStage3": "Połączenie muzyki, głosu i napisów.",
      "productionStage4": "Przeprowadzamy końcowe sprawdzenia na żywym przeglądzie.",
      "genericCreationError": "Wystąpił problem podczas przygotowywania planu wideo. Twoje materiały i wybory zostały zachowane; możesz spróbować ponownie.",
      "newVideo": "Nowe wideo",
      "topicNews": "Wiadomości",
      "topicDocumentary": "Dokumentalny",
      "topicExplainer": "Wyjaśniacz",
      "topicStory": "Opowieść",
      "topicScience": "Nauka",
      "topicPhilosophy": "Filozofia",
      "topicMagazine": "Magazyn",
      "topicEntertainment": "Rozrywka",
      "topicList": "Lista",
      "toneCalm": "Spokojny",
      "toneEmotional": "Emocjonalny",
      "toneEnergetic": "Energetyczny",
      "toneStorytelling": "Opowiadanie historii",
      "toneCheerful": "Śmiechliwy",
      "toneMysterious": "Mroczny",
      "toneNews": "Wiadomości",
      "styleCinematic": "Kinematyczny",
      "styleDarkCinematic": "Mroczny kinowy",
      "styleDocumentary": "Dokumentalny",
      "styleModernDocumentary": "Nowoczesne dokumenty",
      "stylePovImmersive": "Immersyjna perspektywa",
      "styleUgcAuthentic": "Autentyczne UGC",
      "styleMiniVlog": "Mini vlog",
      "styleSocialViral": "Wirus społeczny",
      "styleHyperEdit": "Hyper Edytuj",
      "styleSportsHype": "Hype sportowe",
      "styleVelocityEdit": "Edycja prędkości",
      "styleMusicBeatEdit": "Edycja beatów muzycznych",
      "styleKineticTypography": "Kinetyczna typografia",
      "styleMinimalClean": "Minimalistyczny i czysty",
      "styleLuxuryMinimal": "Luksus Minimalistyczny",
      "styleCommercialProduct": "Produkt komercyjny",
      "styleEditorialFashion": "Moda redakcyjna",
      "styleCollageZine": "Zinę kolażową",
      "styleTechFuturistic": "Technologia futurystyczna",
      "styleRetroFuturism": "Retrofuturizm",
      "styleY2kDigital": "Cyfrowe Y2K",
      "styleVhsCamcorder": "Kameryrek VHS",
      "styleAnalogFilm": "Film analogowy",
      "styleGlitchCyber": "Błąd Cyber",
      "musicUpbeatMood": "Energetyczny · jasny",
      "musicUpbeatDetail": "Prawdziwe nagrania instrumentalne do energicznego treści społecznościowych, chwil podróży i energicznych edycji.",
      "musicElectronicMood": "Nowoczesny · rytmiczny",
      "musicElectronicDetail": "Prawdziwa muzyka elektroniczna dla miast, technologii, produktów i szybkich edycji.",
      "musicRomanceMood": "Emocjonalny · ciepły",
      "musicRomanceDetail": "Muzyka instrumentalna z delikatną emocjonalną linią dla rodziny, portretów, wyjątkowych dni i wspomnień.",
      "musicScoringMood": "Narracyjna · kinematyczna",
      "musicScoringDetail": "Muzyka tła kinowa wspierająca historie, promocje i dramatyczne przejścia.",
      "musicEpicMood": "Silny · rosnący",
      "musicEpicDetail": "Warstwowa muzyka instrumentalna, która buduje się na wielkich otwartaniach, podróżach i mocnych finałach.",
      "proposalBalancedTitle": "Zrównoważona narracja",
      "proposalBalancedSummary": "Edycja, która zachowuje płynność materiału i podkreśla najsilniejsze kadry.",
      "proposalBalancedVisual": "Silna hierarchia i spójny system wizualny",
      "proposalBalancedTransitions": "Gładkie cięcia i zmierzone wstawki",
      "proposalBalancedMusic": "Muzyka, która przesuwa się od emocji do rytmu",
      "proposalQuietTitle": "Cicha historia",
      "proposalQuietSummary": "Spokojna podejście, które daje ramom więcej czasu i podkreśla detale oraz naturalne emocje.",
      "proposalQuietVisual": "Delikatne tony i dłuższe ujęcia",
      "proposalQuietTransitions": "Rozpuszcza się krzyżowo i wolne patelnie",
      "proposalQuietMusic": "Prosta i emocjonalna muzyka",
      "proposalRhythmicTitle": "Edycja rytmiczna",
      "proposalRhythmicSummary": "Edycja z silnym wprowadzeniem, które przyspiesza w środku i wyraźnie ustala się na końcu.",
      "proposalRhythmicVisual": "Silniejszy kontrast i dynamiczne ujęcie",
      "proposalRhythmicTransitions": "Częste cięcia beatów i kontrolowane przejścia z bęb",
      "proposalRhythmicMusic": "Energetyczna, rosnąca muzyka",
      "underVoiceover": "miękki pod wokalem",
      "withShortVoiceover": "z krótkim, mocnym głosem w tle"
    },
    "information": {
      "home": "Strona główna",
      "documentInfo": "Informacje o dokumencie",
      "version": "Wersja",
      "effective": "Obowiązuje od",
      "updated": "Ostatnia aktualizacja",
      "contents": "Spis treści",
      "officialReferences": "Oficjalne odniesienia",
      "referenceTitle": "Źródła prawa i władzy",
      "referenceBody": "Te linki są udostępniane wyłącznie w celu informacyjnego. Zgodnie z obowiązującymi przepisami prawa i aktualnymi przepisami właściwych władz obowiązują obowiązkowe przepisy prawne.",
      "supportKicker": "Obsługa Sponelabs",
      "contactTitle": "Skontaktuj się z nami",
      "contactLead": "Skontaktuj się z zespołem obsługi Voxnela w sprawie swojego konta, członkostwa, płatności, tworzenia, raportów o treściach, prywatności lub problemów technicznych.",
      "supportEmail": "E-mail pomocy",
      "emailBody": "Przycisk poniżej otworzy Twój domyślny aplikację e-mail z gotowym do użycia szablonem wsparcia, abyśmy mogli szybciej zbadać problem.",
      "openEmail": "Otwórz aplikację pocztową",
      "includeTitle": "Dodaj do wiadomości",
      "includeItems": [
        "Niezależnie od tego, czy korzystasz z Weba, iOS czy Maca;",
        "Wersja urządzenia i systemu operacyjnego;",
        "Kroki do odtworzenia problemu;",
        "Powiązany link projektu, szczegóły transakcji lub zrzut ekranu, jeśli są dostępne."
      ],
      "sensitiveTitle": "Nie wysyłaj poufnych danych",
      "sensitiveBody": "Nie podawaj kodów weryfikacyjnych, haseł, pełnych danych karty płatniczej, dokumentów tożsamości, danych zdrowotnych ani innych wrażliwych informacji, które nie są wymagane do rozwiązania problemu.",
      "securityTitle": "Bezpieczeństwo i zgłoszenia treści",
      "securityBody": "Użyj „Bezpieczeństwo” dla luk, „Prośba o prywatność” dla żądania danych lub „Raport treści” dla szkodliwych lub naruszających prawa treści. Skontaktuj się z lokalnymi służbami ratunkowymi w przypadku natychmiastowego zagrożenia fizycznego.",
      "mailSubject": "Prośba o wsparcie Voxnela",
      "mailGreeting": "Dzień dobry Zespół Obsługi Voxnela,",
      "mailTopic": "Temat wsparcia:",
      "mailPlatform": "Platforma (Web / iOS / Mac):",
      "mailDevice": "Urządzenie i system operacyjny:",
      "mailProject": "Identyfikator projektu (jeśli dostępny):",
      "mailDescription": "Opis problemu lub żądania:",
      "mailThanks": "Dziękuję.",
      "termsEyebrow": "Warunki świadczenia usług Voxnela",
      "termsTitle": "Warunki użytkowania",
      "termsLead": "Niniejsze warunki dotyczą korzystania z usług tworzenia i edycji obrazów AI w serwisie Voxnela oraz aplikacjach na iOS.",
      "privacyEyebrow": "Użycie danych Voxnela",
      "privacyTitle": "Polityka prywatności",
      "privacyLead": "Niniejsza polityka wyjaśnia, w jaki sposób dane konta, obrazu, projektu, członkostwa oraz danych technicznych są przetwarzane w serwisie tworzenia obrazów Voxnela.",
      "officialTurkishNotice": "Ten przekład jest dostarczony w celu wygody. Turkijski tekst prawny reguluje, jeśli znaczenia się różnią."
    }
  },
  "th": {
    "ui": {
      "home": "หน้าหลัก",
      "homeTitle": "บ้าน",
      "explore": "สำรวจ",
      "gallery": "แกลเลอรี",
      "myImages": "รูปภาพของฉัน",
      "settings": "การตั้งค่า",
      "createImage": "สร้างภาพ",
      "back": "ย้อนกลับ",
      "search": "ค้นหา",
      "account": "บัญชี",
      "login": "เข้าสู่ระบบ",
      "logout": "ออกจากระบบ",
      "profile": "โปรไฟล์",
      "profileSettings": "โปรไฟล์และการตั้งค่า",
      "plans": "แพ็กเกจและการใช้งาน",
      "plansSubtitle": "เครดิตภาพและค่าธรรมเนียมการเรียกเก็บ",
      "contact": "ติดต่อ",
      "contactSubtitle": "ความช่วยเหลือและข้อเสนอแนะ",
      "discoverVoxnela": "ค้นพบ Voxnela",
      "discoverVoxnelaSubtitle": "ทบทวนประสบการณ์สตูดิโอภาพ",
      "privacy": "ความเป็นส่วนตัว",
      "privacySubtitle": "ข้อมูลของคุณได้รับการคุ้มครองอย่างไร",
      "terms": "ข้อกำหนดการใช้งาน",
      "termsSubtitle": "ข้อกำหนดการให้บริการของ Voxnela",
      "preferencesSubtitle": "บัญชีของคุณและความชอบของ Voxnela",
      "accountSubtitle": "รายละเอียดบัญชีและการเป็นสมาชิก",
      "voxAccount": "บัญชี Voxnela",
      "accessEverywhere": "เข้าถึงรูปภาพของคุณบนอุปกรณ์ทุกเครื่อง",
      "imageRights": "เครดิตภาพ {{count}}",
      "availableCredits": "เครดิตที่มีอยู่",
      "renewalDate": "วันที่ต่ออายุ",
      "membershipStart": "การสมัครสมาชิกเริ่มต้นแล้ว",
      "registrationDate": "วันที่ลงทะเบียน",
      "monthly": "รายเดือน",
      "renewalOff": "การต่ออายุปิด",
      "user": "ผู้ใช้ Voxnela",
      "language": "ภาษา",
      "languageSubtitle": "เลือกภาษาของแอป",
      "supportBody": "เขียนถึงเราหากคุณมีปัญหาหรือต้องการแบ่งปันแนวคิด รวมถึงรหัสโครงการช่วยให้เราตอบกลับได้เร็วขึ้น",
      "studioTitle": "สตูดิโอภาพ Voxnela",
      "studioSubtitle": "สร้างสไตล์ของคุณ",
      "searchSubtitle": "รูปภาพและโครงการของคุณ",
      "searchPlaceholder": "ค้นหาภาพหรือโครงการ",
      "noSearchResults": "ไม่มีอะไรตรงกับการค้นหาครั้งนี้",
      "project": "โครงการ",
      "image": "ภาพ",
      "completed": "เสร็จสิ้นแล้ว",
      "currentPlan": "แผนปัจจุบัน",
      "notSignedIn": "ยังไม่ได้ลงชื่อเข้าใช้",
      "signInIntro": "ลงชื่อเข้าใช้เพื่อเริ่มใช้งาน Voxnela",
      "creditsAvailable": "เครดิตภาพสตูดิโอ {{count}} มีให้ใช้งานแล้ว",
      "noCredits": "คุณไม่มีเครดิตรูปภาพเหลืออยู่ในช่วงนี้",
      "membershipInfo": "เครดิตแผนรายปีจะต่ออายุทุกเดือนและไม่โอนย้าย การซื้อที่ฟื้นฟูจะยังคงได้รับการคุ้มครองผ่านบัญชีของคุณ",
      "signedOutMembershipInfo": "หลังจากลงชื่อเข้าใช้แล้ว เครดิตภาพและข้อมูลแผนที่พร้อมใช้งานของคุณจะปรากฏที่นี่",
      "reviewPlans": "ดูแผนการ",
      "versionUpdated": "เวอร์ชัน {{version}} · อัปเดตล่าสุด {{date}}",
      "onboardingWelcome": "ยินดีต้อนรับสู่ Voxnela",
      "skipIntro": "ข้ามคำแนะนำ",
      "continue": "ดำเนินการต่อ",
      "startCreating": "เริ่มสร้าง",
      "close": "ปิด",
      "dragToClose": "เลื่อนลงเพื่อปิดแผ่นงาน",
      "loading": "กำลังโหลด...",
      "sheetExpand": "ขยายแผ่นงาน",
      "sheetCollapse": "กลับแผ่นกลับสู่ความสูงปกติ",
      "cannotClose": "ไม่สามารถปิดได้ขณะที่การดำเนินการกำลังดำเนินอยู่",
      "stylePreview": "การดูตัวอย่างสไตล์",
      "stylePreviewSubtitle": "สไตล์และเทรนด์ที่เป็นเอกลักษณ์",
      "categories": "หมวดหมู่",
      "useThisStyle": "ใช้สไตล์นี้",
      "videoControls": "การควบคุมวิดีโอ",
      "play": "เล่น",
      "pause": "หยุดพัก",
      "mute": "ปิดเสียง",
      "unmute": "ปิดเสียง",
      "minimize": "ลดลง",
      "expandVideo": "ขยายในแอป",
      "videoProgress": "ความคืบหน้าของวิดีโอ",
      "toggleVideoControls": "แสดงหรือซ่อนการควบคุมวิดีโอ",
      "expandedVideo": "{{title}} การดูวิดีโอแบบขยายขนาด",
      "goToImage": "ไปที่ภาพ {{title}}",
      "categoryVisualStyles": "สไตล์ภาพ {{category}}",
      "onboarding1Eyebrow": "สร้างภาพ",
      "onboarding1Title": "สร้างภาพของคุณ",
      "onboarding1Body": "เปลี่ยนไอเดียของคุณให้กลายเป็นเฟรมภาพยนตร์ด้วยฟิล์ม 35 มม., การตัดต่อ, ผลิตภัณฑ์, โปสเตอร์ และสไตล์ภาพอีกมากมาย",
      "onboarding2Eyebrow": "ลองชุดเสมือนจริง",
      "onboarding2Title": "ลองชุดใหม่",
      "onboarding2Body": "รักษาเอกลักษณ์ไว้ตลอดการผลิตและสร้างภาพลักษณ์การลองสวมใส่แฟชั่น เครื่องประดับ และผลิตภัณฑ์ที่สมจริง",
      "onboarding3Eyebrow": "แก้ไขภาพ",
      "onboarding3Title": "แก้ไขภาพของคุณ",
      "onboarding3Body": "ทบทวนองค์ประกอบ แสง สี และรายละเอียดแบบสนทนาโดยไม่ต้องเริ่มต้นใหม่",
      "onboarding4Eyebrow": "ภาพฟรี 3 ภาพ",
      "onboarding4Title": "เริ่มใช้ฟรี",
      "onboarding4Body": "เริ่มได้ทันทีด้วยสิทธิ์สร้างภาพ AI ฟรี 3 ครั้งแบบครั้งเดียว ไม่ต้องมีบัญชี",
      "onboardingFaceEyebrow": "วิเคราะห์ใบหน้าและสไตล์",
      "onboardingFaceTitle": "ค้นพบใบหน้าและสไตล์ของคุณ",
      "onboardingFaceBody": "สำรวจไอเดียทรงผม แว่นตา และเสื้อผ้าจากภาพบุคคลของคุณในคู่มือภาพเดียว",
      "onboardingHouseEyebrow": "เดินทางข้ามเวลา",
      "onboardingHouseTitle": "เดินทางข้ามเวลา",
      "onboardingHouseBody": "รวมภาพถ่ายและวันที่ของคุณเพื่อเห็นว่าบ้านเปลี่ยนไปอย่างไรตามกาลเวลา",
      "onboardingFestivalEyebrow": "วันเทศกาลของคุณ",
      "onboardingFestivalTitle": "วางแผนวันเทศกาลได้ในพริบตา",
      "onboardingFestivalBody": "เปลี่ยนกำหนดการ เวที และเวลาที่คุณให้ไว้เป็นเส้นทางภาพส่วนตัว",
      "onboardingStylesEyebrow": "สไตล์ Voxnela",
      "onboardingStylesTitle": "เลือกสไตล์ของคุณ",
      "onboardingStylesBody": "เปลี่ยนไอเดียของคุณให้กลายเป็นเฟรมภาพยนตร์ด้วยฟิล์ม 35 มม., การตัดต่อ, ผลิตภัณฑ์, โปสเตอร์ และสไตล์ภาพอีกมากมาย"
    },
    "auth": {
      "enterCode": "ป้อนรหัส",
      "membershipAndAccount": "รายละเอียดการเป็นสมาชิกและบัญชี",
      "noPeriodInfo": "ช่วงเวลาไม่พร้อมใช้งาน",
      "memberSince": "สมาชิกตั้งแต่",
      "planSince": "{{plan}} ตั้งแต่",
      "membershipRenewal": "วันที่ต่ออายุสมาชิก",
      "accountActions": "การดำเนินการบัญชี",
      "manageSubscriptionTitle": "สิ้นสุดการสมัครสมาชิก",
      "manageSubscriptionSubtitle": "จัดการการสมัครสมาชิกร้านค้าและต่ออายุอัตโนมัติของคุณ",
      "deleteAccountTitle": "ลบบัญชีของฉัน",
      "deleteAccountSubtitle": "กระบวนการลบแบบย้อนกลับ 15 วัน",
      "deleteDataTitle": "ลบข้อมูลของฉัน",
      "deleteDataSubtitle": "กระบวนการลบข้อมูลแบบย้อนกลับได้ 30 วัน",
      "signingOut": "กำลังออกจากระบบ…",
      "signOut": "ออกจากระบบ",
      "signingIn": "กำลังเข้าสู่ระบบ…",
      "continueApple": "ดำเนินการต่อด้วย Apple",
      "continueGoogle": "ดำเนินการต่อด้วย Google",
      "or": "หรือ",
      "email": "อีเมล",
      "emailPlaceholder": "you@example.com",
      "legalPrefix": "โดยการดำเนินการต่อกับ Voxnela คุณยอมรับ",
      "legalTerms": "ข้อกำหนดการใช้งาน",
      "legalJoin": "และยืนยันว่าคุณได้อ่านและเข้าใจ",
      "legalPrivacy": "ประกาศความเป็นส่วนตัว",
      "legalSuffix": ".",
      "sendingCode": "กำลังส่งรหัส…",
      "emailSignIn": "เข้าสู่ระบบด้วยอีเมล",
      "codeSent": "เราได้ส่งรหัสไปยัง {{email}} แล้ว",
      "change": "เปลี่ยน",
      "sixDigitCode": "รหัส 6 หลัก",
      "emailCode": "รหัสลงชื่อเข้าใช้อีเมล",
      "verifyingCode": "กำลังตรวจสอบรหัส…",
      "resendCode": "ส่งรหัสอีกครั้ง",
      "requestReceived": "คำขอได้รับแล้ว",
      "accountDeletionStarted": "กระบวนการลบบัญชีของคุณได้เริ่มต้นขึ้นแล้ว",
      "dataDeletionStarted": "กระบวนการลบข้อมูลของคุณได้เริ่มต้นขึ้นแล้ว",
      "accountAction": "การดำเนินการบัญชี",
      "accountDeletesAt": "บัญชีของคุณจะถูกลบอย่างถาวรบน {{date}}",
      "dataDeletesAt": "ข้อมูลส่วนตัวของคุณจาก Voxnela จะถูกลบอย่างถาวรบน {{date}}",
      "deletionUndo": "หากคุณลงชื่อเข้าใช้ด้วยบัญชีเดียวกันก่อนวันที่นี้ กระบวนการลบจะถูกยกเลิกโดยอัตโนมัติ เซสชันปัจจุบันของคุณถูกปิดเนื่องจากมีการสร้างคำขอ",
      "done": "เสร็จสิ้น",
      "cancel": "ยกเลิก",
      "preparing": "เตรียมตัว...",
      "invalidEmail": "ป้อนที่อยู่อีเมลที่ถูกต้อง",
      "enterSixDigitCode": "ป้อนรหัส 6 หลักที่ส่งไปยังอีเมลของคุณ",
      "signInFailed": "ไม่สามารถดำเนินการลงชื่อเข้าใช้ได้ โปรดลองอีกครั้ง",
      "codeSendFailed": "รหัสการเข้าสู่ระบบไม่สามารถส่งได้ กรุณาลองอีกครั้ง",
      "codeVerifyFailed": "รหัสไม่สามารถตรวจสอบได้ กรุณาลองอีกครั้ง",
      "operationFailed": "ไม่สามารถดำเนินการได้ในขณะนี้ กรุณาลองอีกครั้ง",
      "popupClosed": "หน้าต่างเข้าสู่ระบบถูกปิดแล้ว",
      "unauthorizedDomain": "โดเมนนี้ไม่ได้รับอนุญาตให้ลงชื่อเข้าใช้",
      "methodUnavailable": "วิธีการลงชื่อเข้าใช้นี้ยังไม่ได้เปิดใช้งาน",
      "tooManyCodes": "มีการร้องขอรหัสมากเกินไป ลองอีกครั้งในอีกไม่กี่นาทีข้างหน้า",
      "invalidCode": "รหัสไม่ถูกต้องหรือหมดอายุ กรุณาขอรหัสใหม่",
      "emailUnavailable": "การจัดส่งอีเมลไม่สามารถทำได้ในขณะนี้",
      "actions": {
        "subscription": {
          "eyebrow": "การดำเนินการสมัครสมาชิก",
          "title": "ยกเลิกการสมัครสมาชิกของคุณแล้วหรือยัง?",
          "confirm": "จัดการการสมัครสมาชิก",
          "paragraphs": [
            "การดำเนินการต่อจะเปิดหน้าจัดการการสมัครสมาชิก Apple App Store หรือ Google Play ซึ่งเป็นหน้าที่คุณซื้อการสมัครสมาชิก คุณต้องปิดการต่ออายุอัตโนมัติในร้านค้า",
            "หลังจากยกเลิก สิทธิประโยชน์สมาชิกที่มีอยู่ของคุณยังคงสามารถใช้งานได้จนถึงสิ้นสุดระยะเวลาการชำระเงิน การลบบัญชีหรือข้อมูลของคุณจะไม่ยกเลิกการสมัครสมาชิกร้านค้า"
          ]
        },
        "account": {
          "eyebrow": "การดำเนินการบัญชีถาวร",
          "title": "คุณแน่ใจหรือไม่ว่าต้องการลบบัญชีของคุณ?",
          "confirm": "เริ่มกระบวนการลบ 15 วัน",
          "paragraphs": [
            "การดำเนินการต่อจะเริ่มกระบวนการลบข้อมูลเป็นเวลา 15 วัน และจะล็อกอินคุณเพื่อความปลอดภัย หากคุณไม่เข้าสู่ระบบอีกครั้งในช่วงเวลานี้ บัญชี โปรไฟล์ การสร้างสรรค์ ห้องสมุด คอลเลกชัน และข้อมูล Voxnela ที่เกี่ยวข้องของคุณจะถูกลบอย่างถาวร",
            "การเข้าสู่ระบบด้วยบัญชีเดียวกันก่อน 15 วันจะยกเลิกการลบโดยอัตโนมัติ การลบบัญชีจะไม่ยกเลิกการสมัครสมาชิกร้านค้าที่ใช้งานอยู่; ยกเลิกแยกต่างหากในร้านค้า"
          ]
        },
        "data": {
          "eyebrow": "การดำเนินการข้อมูลถาวร",
          "title": "คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูลของคุณ?",
          "confirm": "เริ่มกระบวนการลบ 30 วัน",
          "paragraphs": [
            "การดำเนินการต่อจะเริ่มกระบวนการลบข้อมูลเป็นเวลา 30 วัน และจะล็อกอินคุณเพื่อความปลอดภัย หากคุณไม่เข้าสู่ระบบอีกในช่วงเวลานี้ ผลงานของคุณ ห้องสมุด คอลเลกชัน บันทึก การโต้ตอบ และข้อมูลส่วนบุคคลอื่นๆ ของ Voxnela จะถูกลบอย่างถาวร แต่บัญชีการเข้าสู่ระบบของคุณยังคงใช้งานได้",
            "การลงชื่อเข้าใช้ใหม่ก่อน 30 วันจะยกเลิกการลบข้อมูลโดยอัตโนมัติ อาจมีการเก็บรักษาธุรกรรมและบันทึกความปลอดภัยที่จำกัดตามกฎหมายไว้พร้อมกับการเข้าถึงที่จำกัดในช่วงเวลาทางกฎหมายที่เกี่ยวข้อง"
          ]
        }
      }
    },
    "paywall": {
      "quotaFreeTitle": "ไม่มีเครดิตภาพเหลืออยู่",
      "quotaFreeMessage": "คุณได้ใช้เครดิตภาพในบัญชีฟรีของคุณแล้ว เลือกแผนเพื่อดำเนินการสร้างต่อ",
      "later": "ภายหลัง",
      "currentCredit": "เครดิตปัจจุบัน: 0",
      "quotaProTitle": "ถึงโควต้า Pro รายเดือนแล้ว",
      "quotaProMessage": "คุณได้ใช้เครดิตภาพ 100 ภาพของเดือนนี้แล้ว อัปเกรดเป็น Studio เพื่อดำเนินการสร้างต่อ",
      "renewalDate": "วันที่ต่ออายุ: {{date}}",
      "quotaStudioTitle": "ถึงโควต้าสตูดิโอรายเดือนแล้ว",
      "quotaStudioMessage": "เครดิตภาพของคุณจะต่ออายุโดยอัตโนมัติบน {{date}}",
      "done": "เสร็จแล้ว",
      "membership": "สมาชิก Voxnela",
      "options": "ตัวเลือกสมาชิก",
      "credits": "เครดิต",
      "currentMembership": "สมาชิกปัจจุบัน",
      "yearlyDiscount": "ลด 17%",
      "loadingPrice": "กำลังโหลดราคาจากร้านค้า…",
      "loadingStorePrice": "การโหลดราคาจากร้านค้า",
      "year": "ปี",
      "month": "เดือน",
      "renewDisclosure": "ต่ออายุอัตโนมัติทุกครั้งที่ {{period}} ยกเลิกได้ทุกเมื่อ",
      "legal": "กฎหมาย",
      "terms": "ข้อกำหนด",
      "alreadyMember": "คุณมี {{plan}} และ {{period}} อยู่แล้ว",
      "startPlan": "เริ่มต้นแผน {{plan}}",
      "upgradeStudio": "อัปเกรดเป็น Studio",
      "yearlyAdvantage": "เปลี่ยนไปเป็นการประหยัดรายปี",
      "upgrade": "อัปเกรดสมาชิก",
      "signInRequired": "ลงชื่อเข้าใช้บัญชี Voxnela ของคุณก่อนเริ่มสมัครสมาชิก",
      "catalogUnavailable": "แคตตาล็อกการชำระเงินไม่สามารถตรวจสอบได้สำหรับแผนนี้ โปรดลองอีกครั้งในไม่ช้า",
      "paymentUnavailable": "หน้าจอการชำระเงินไม่สามารถเปิดได้ กรุณาลองอีกครั้ง",
      "benefits": [
        {
          "lead": "{{credits}} เครดิต",
          "label": "การสร้างภาพความละเอียดสูงทุกเดือน"
        },
        {
          "lead": "สไตล์สตูดิโอมากกว่า 50 สไตล์",
          "label": "นีโอ-มินิมอลลิสต์, ภาพยนตร์และทุกสไตล์ที่เป็นเอกลักษณ์"
        },
        {
          "lead": "ล็อกใบหน้า",
          "label": "ลองใส่แฟชั่นเสมือนจริงโดยไม่เปลี่ยนลักษณะใบหน้า"
        },
        {
          "lead": "คิวลำดับความสำคัญ",
          "label": "การประมวลผล GPU ความเร็วสูงพิเศษพร้อมไม่มีการรอคอย"
        },
        {
          "lead": "การแก้ไขการแชท",
          "label": "การแก้ไขรายละเอียดหลายรอบแบบไม่จำกัดในภาษาธรรมชาติ"
        },
        {
          "lead": "สิทธิ์การค้าเต็มรูปแบบ",
          "label": "ความละเอียดสูง, การใช้งานไม่มีโลโก้น้ำหนัก"
        }
      ],
      "restorePurchases": "ฟื้นฟูการซื้อ",
      "restoringPurchases": "การซื้อที่กำลังถูกกู้คืน...",
      "restoreSuccess": "การเป็นสมาชิกของคุณได้รับการฟื้นฟูแล้ว",
      "restoreEmpty": "ไม่พบการสมัครสมาชิกที่ใช้งานอยู่สำหรับบัญชี App Store นี้",
      "membershipSyncPending": "ตรวจสอบการเป็นสมาชิกและเครดิตภาพ...",
      "membershipSyncFailed": "ไม่สามารถซิงค์เครดิตรูปภาพได้ กรุณาลองอีกครั้ง",
      "membershipUnavailable": "ไม่สามารถโหลดข้อมูลสมาชิกได้",
      "retry": "ลองอีกครั้ง"
    },
    "video": {
      "revisionHook": "ทำให้สามวินาทีแรกน่าสนใจมากขึ้น",
      "revisionPace": "ปรับความเร็วให้สมดุลและทำให้ส่วนที่ช้าลงสั้นลง",
      "revisionEnding": "ทำให้ตอนจบน่าจดจำมากขึ้น",
      "revisionTransition": "ทำให้การเปลี่ยนผ่านราบรื่นและเป็นธรรมชาติมากขึ้น",
      "revisionFraming": "ใช้กรอบที่สมดุลมากขึ้นสำหรับรายละเอียดสำคัญ",
      "revisionColor": "ทำให้สีสันมีความสมดุลและภาพยนตร์มากขึ้น",
      "revisionText": "ทำให้ข้อความสั้นลงและอ่านง่ายขึ้น",
      "revisionAudio": "จับคู่ดนตรีให้ใกล้ชิดกับจังหวะของภาพมากขึ้น",
      "revisionEmotion": "ทำให้เรื่องราวมีความจริงใจและอารมณ์มากขึ้น",
      "revisionStructure": "สร้างจุดเริ่มต้น กลาง และจุดสิ้นสุดที่ชัดเจนยิ่งขึ้น",
      "previewBack": "กลับไปที่ตัวอย่าง",
      "revisionWelcome": "คุณต้องการเปลี่ยนอะไร?",
      "revisionFailed": "ฉันไม่สามารถนำการเปลี่ยนแปลงนั้นไปใช้ได้ คุณช่วยอธิบายให้ฉันอีกครั้งได้ไหม?",
      "finalQueued": "วิดีโอสุดท้ายกำลังอยู่ในคิว จะปรากฏภายใต้วิดีโอเมื่อพร้อม",
      "watermarkUpgrade": "เลือกแผนเพื่อสร้างผลลัพธ์สุดท้ายใหม่โดยไม่มีโลโก้ Voxnela",
      "finalFailed": "วิดีโอสุดท้ายไม่สามารถเริ่มต้นได้",
      "projectDeleteFailed": "โครงการนี้ไม่สามารถลบได้",
      "videoDescriptionWithBrief": "วิดีโอนี้สร้างขึ้นจาก “{{brief}}” Voxnela ได้เลือกช่วงเวลาที่ทรงพลังที่สุดและสร้างจังหวะและลำดับฉากรอบทิศทางสร้างสรรค์ที่เลือกไว้",
      "videoDescriptionGeneric": "Voxnela ประเมินเนื้อหาสำหรับความสมดุลของเนื้อหา ความเร็ว และความสอดคล้องของเรื่องราว โดยเน้นช่วงเวลาที่แข็งแกร่งที่สุดสำหรับการตัดต่อที่สมดุล",
      "play": "เล่น",
      "deletesOn": "ลบบน {{date}}",
      "projectsBelong": "โครงการของคุณเชื่อมโยงกับบัญชีของคุณ",
      "videosBelong": "วิดีโอของคุณเชื่อมโยงกับบัญชีของคุณ",
      "signInToSeeProjects": "ลงชื่อเข้าใช้เพื่อดูโปรเจกต์ของคุณและดำเนินการต่อจากอุปกรณ์ต่างๆ",
      "signInToSeeVideos": "ลงชื่อเข้าใช้เพื่อดูวิดีโอของคุณและดำเนินการต่อจากอุปกรณ์ต่างๆ",
      "delete": "ลบ",
      "deleting": "กำลังลบ…",
      "secondsVersion": "{{seconds}} sec · เวอร์ชัน {{version}}",
      "deleteProject": "ลบโปรเจกต์",
      "projectCoverUnavailable": "ไม่สามารถโหลดปกโครงการได้",
      "videoCoverPreparing": "เตรียมปกวิดีโอ",
      "deleteVideo": "ลบวิดีโอ",
      "signed": "แบรนด์ Voxnela",
      "failed": "ไม่สามารถทำให้เสร็จสมบูรณ์ได้",
      "tryAgain": "คุณสามารถลองอีกครั้งได้",
      "cancelled": "ยกเลิก",
      "noCreditUsed": "ไม่มีการใช้เครดิต",
      "featuredStyles": "สไตล์ภาพเด่น",
      "previousImage": "ภาพก่อนหน้า",
      "nextImage": "รูปภาพถัดไป",
      "reviewStyle": "สำรวจสไตล์นี้",
      "featuredNavigation": "การนำทางด้วยภาพที่โดดเด่น",
      "taskCategories": "หมวดหมู่งาน",
      "projectOpening": "โครงการเปิดตัว",
      "opening": "การเปิด...",
      "projectNotFound": "ไม่พบโปรเจกต์",
      "projectUnavailable": "โครงการนี้ไม่พร้อมใช้งานอีกต่อไป",
      "backToProjects": "กลับไปยังโปรเจกต์ของฉัน",
      "editVideo": "แก้ไขวิดีโอ",
      "versionContext": "เวอร์ชัน {{version}} · Voxnela รู้จักโครงการและวัสดุของคุณ",
      "livePreviewActions": "การดำเนินการตัวอย่างสด",
      "edit": "แก้ไข",
      "preparing": "กำลังเตรียม",
      "save": "บันทึก",
      "thinking": "Voxnela กำลังคิด",
      "revisionSuggestions": "ข้อเสนอแนะในการแก้ไข",
      "describeChange": "อธิบายการเปลี่ยนแปลงที่คุณต้องการ",
      "sendEdit": "ส่งคำขอแก้ไข",
      "deleteProjectDescription": "คุณแน่ใจหรือไม่ว่าต้องการลบ “{{title}}” และเอกสารที่เกี่ยวข้องทั้งหมด? ไม่สามารถย้อนกลับได้",
      "projects": "โปรเจกต์",
      "projectsPreparing": "เตรียมโครงการของคุณ",
      "noProjects": "คุณยังไม่มีโปรเจกต์ เริ่มต้นด้วยการอธิบายแนวคิดแรกของคุณ",
      "createNew": "สร้างภาพใหม่",
      "thisProject": "โครงการนี้",
      "videos": "วิดีโอ",
      "videosPreparing": "เตรียมวิดีโอของคุณ",
      "noVideos": "คุณยังไม่มีวิดีโอที่เสร็จสมบูรณ์ มันจะปรากฏที่นี่เมื่อวิดีโอแรกของคุณพร้อม",
      "videoPlayFailed": "วิดีโอไม่สามารถเล่นได้",
      "videoNotReady": "ไฟล์วิดีโอยังไม่พร้อมที่จะดาวน์โหลด",
      "videoDownloadFailed": "วิดีโอไม่สามารถดาวน์โหลดได้",
      "videoDeleteFailed": "วิดีโอไม่สามารถลบได้",
      "videoLoading": "กำลังโหลดวิดีโอ...",
      "videoActions": "การดำเนินการวิดีโอ",
      "showVideoDescription": "แสดงคำอธิบายวิดีโอ",
      "videoDownloading": "ดาวน์โหลดวิดีโอ",
      "downloadVideo": "ดาวน์โหลดวิดีโอ",
      "thisVideo": "วิดีโอนี้",
      "deleteVideoDescription": "คุณแน่ใจหรือไม่ว่าต้องการลบวิดีโอที่มีชื่อเรื่องว่า “{{title}}”? ไม่สามารถย้อนกลับได้"
    },
    "studio": {
      "useStyle": "ใช้สไตล์นี้",
      "galleryFilters": "ตัวกรองแกลเลอรี",
      "modeStyleTransfer": "สไตล์ Voxnela",
      "modeVirtualTryOn": "ลองใส่เสมือนจริง",
      "modeMagazineCover": "นิตยสารและปก",
      "modePosterStudio": "สตูดิโอโปสเตอร์",
      "modeCommercial": "การนำเสนอผลิตภัณฑ์",
      "modeTimeWarp": "การเดินทางข้ามเวลา",
      "modeOutpaintRelight": "ขยายและรีไฟรท์",
      "modeInfographic": "อินโฟกราฟิกและข้อมูล",
      "modePortraitRetouch": "การรีทัชภาพถ่ายบุคคล",
      "modeArtisticCollage": "ภาพรวมศิลปะ",
      "defaultStyle": "สไตล์ Voxnela",
      "signInToCreate": "ลงชื่อเข้าใช้เพื่อสร้างภาพ",
      "signInToEdit": "ลงชื่อเข้าใช้เพื่อแก้ไขรูปภาพ",
      "creationSuccess": "รูปภาพของคุณถูกสร้างสำเร็จแล้ว แจ้งฉันโดยตรงหากคุณต้องการเปลี่ยนแสง สี วัตถุ หรือกรอบภาพ",
      "imageReady": "รูปภาพของคุณพร้อมแล้ว บอกฉันว่าคุณชอบอะไรหรือต้องการแก้ไขอะไร",
      "revisionSuccess": "การแก้ไขเสร็จสมบูรณ์แล้ว คุณสามารถเปรียบเทียบกับสไลเดอร์ก่อน/หลัง หรือขอการเปลี่ยนแปลงอื่นได้",
      "versionReady": "เวอร์ชัน {{version}} พร้อมแล้ว",
      "projectNotFound": "โครงการไม่พบ",
      "styleApplied": "สไตล์ {{style}} ถูกนำมาใช้",
      "imageCreation": "การสร้างภาพ",
      "defaultPrompt": "ภาพสตูดิโอ",
      "aspectSquare": "สี่เหลี่ยม",
      "aspectSquareDetail": "ฟีดอินสตาแกรม โปรไฟล์ ศิลปะ",
      "aspectVertical": "แนวตั้ง",
      "aspectVerticalDetail": "เรื่องราวบน Instagram, รีลส์, TikTok",
      "aspectHorizontal": "แนวนอน",
      "aspectHorizontalDetail": "YouTube, แบนเนอร์, โรงภาพยนตร์",
      "aspectPortrait": "ภาพเหมือน",
      "aspectPortraitDetail": "ภาพพอร์ตเทรต Instagram, โปสเตอร์, แกลเลอรี",
      "aspectPanoramic": "พาโนรามา",
      "aspectPanoramicDetail": "ทิวทัศน์ภาพยนตร์แบบกว้างสุดขอบฟ้า",
      "styles": "สไตล์ Voxnela",
      "fullScreenStyle": "ดูสไตล์เต็มหน้าจอ",
      "closeDescription": "คำอธิบายสไตล์ที่ใกล้ชิด",
      "moreWithVoxnela": "ทำอะไรมากขึ้นกับ Voxnela",
      "quickStartBody": "เขียนสิ่งที่คุณต้องการด้านล่างหรือแนบไฟล์",
      "createImage": "สร้างภาพ",
      "createImageDetail": "สร้างไอเดียของคุณจากศูนย์",
      "editImage": "แก้ไขภาพ",
      "editImageQuick": "แก้ไขรูปภาพ",
      "editImageDetail": "จินตนาการภาพที่อัปโหลดใหม่",
      "transformStyle": "เปลี่ยนสไตล์และฉาก",
      "transformStyleDetail": "ย้ายภาพของคุณไปยังโลกอีกใบหนึ่ง",
      "visualizeDocument": "จินตนาการเอกสารหรือการนำเสนอ",
      "visualizeDocumentDetail": "เปลี่ยนเนื้อหาทั้งหมดให้เป็นดีไซน์",
      "submittedImage": "รูปภาพที่ส่งมา",
      "generating": "Voxnela กำลังสร้างภาพ…",
      "viewImage": "ดูภาพ",
      "removeStyle": "ลบสไตล์ที่เลือก",
      "referenceImage": "รูปอ้างอิง",
      "referenceNotice": "รูปภาพนี้จะได้รับการแก้ไขหรือมีการนำสไตล์ใหม่มาใช้",
      "removeReference": "ลบรูปอ้างอิง",
      "remove": "ลบออก",
      "uploading": "อัปโหลด",
      "addFile": "เพิ่มไฟล์หรือรูปภาพ",
      "addFileTitle": "เพิ่มภาพได้สูงสุด 4 ภาพหรือเอกสาร (PDF, Word, PPT, สูงสุด 12 MB)",
      "aspectRatio": "อัตราส่วนเอสเปกต์",
      "selectAspectRatio": "เลือกอัตราส่วนเอียง",
      "aspectOptions": "ตัวเลือกอัตราส่วนเอสเปกต์",
      "revisePlaceholder": "คุณต้องการเปลี่ยนแปลงอะไรในภาพนี้?",
      "styledPlaceholder": "อธิบายภาพที่คุณต้องการในสไตล์นี้ (ทางเลือก)...",
      "promptPlaceholder": "อธิบายภาพหรือเขียนคำสั่ง...",
      "reviseImage": "ทบทวนภาพ",
      "generateImage": "สร้างภาพ",
      "generatedImage": "ภาพที่สร้างขึ้น",
      "done": "เสร็จสิ้น",
      "fileLimitTitle": "ไฟล์ใหญ่เกินไป",
      "fileLimitMessage": "“{{name}}” เกินขีดจำกัด 12 MB ({{size}} MB) เลือกไฟล์ขนาดเล็กกว่านี้",
      "imageLimitTitle": "ขีดจำกัดของภาพ",
      "imageLimitMessage": "คุณสามารถอัปโหลดภาพได้สูงสุด 4 ภาพ ภาพ {{count}} กำลังถูกเลือกอยู่",
      "uploadFailedTitle": "อัปโหลดล้มเหลว",
      "uploadFailedMessage": "เกิดปัญหาขณะอัปโหลดไฟล์",
      "revisionFailed": "เกิดข้อผิดพลาดระหว่างการแก้ไขหรือขีดจำกัดถูกเกิน",
      "generationFailed": "เกิดข้อผิดพลาดระหว่างการสร้างภาพหรือขีดจำกัดถูกเกิน",
      "imageDetails": "รายละเอียดภาพ",
      "close": "ปิด",
      "download": "ดาวน์โหลด",
      "downloadImage": "ดาวน์โหลดรูปภาพ",
      "downloading": "กำลังดาวน์โหลด",
      "versionImage": "ภาพ",
      "exploreTitle": "คุณกำลังมองหาสไตล์แบบใด?",
      "explorePlaceholder": "ตัวอย่างเช่น: ภาพบุคคลแนวภาพยนตร์ที่มีโทนสีเข้มและมุมมองที่ลึกซึ้ง",
      "searchStyles": "ค้นหาสไตล์ภาพ",
      "clearSearch": "ค้นหาอย่างชัดเจน",
      "exploreCategories": "สำรวจหมวดหมู่",
      "all": "ทั้งหมด",
      "styleCount": "สไตล์ {{count}}",
      "noStyle": "ไม่พบสไตล์ที่ตรงกัน",
      "noStyleBody": "ลองอีกครั้งด้วยคำอธิบายที่สั้นกว่าหรือคำที่แตกต่างกัน",
      "libraryKicker": "ห้องสมุดภาพส่วนตัวของคุณ",
      "myImages": "ภาพของฉัน",
      "imageWorks": "ภาพ {{count}} ทำงานได้",
      "newImage": "สร้างภาพใหม่",
      "noImage": "คุณยังไม่ได้สร้างภาพ",
      "noCategoryImage": "ไม่มีรูปภาพในหมวดหมู่นี้",
      "emptyGalleryBody": "สร้างภาพแรกของคุณด้วยการถ่ายโอนสไตล์ การลองสวมใส่เสมือนจริง ปกนิตยสาร หรือการนำเสนอผลิตภัณฑ์",
      "firstImage": "สร้างภาพแรกของคุณ",
      "imageWork": "งานภาพ"
    },
    "create": {
      "briefTitle": "อธิบายแนวคิดหรือหัวข้อของคุณ",
      "briefPlaceholder": "หัวข้อคืออะไร? ตัวอย่างเช่น: อนาคตของปัญญาประดิษฐ์ การเดินทางสู่ดาวอังคาร หรือการเปิดตัวผลิตภัณฑ์…",
      "briefLabel": "สรุปการสร้างสรรค์",
      "contentType": "ประเภทเนื้อหา",
      "media": "รูปภาพและสื่อ",
      "added": "{{count}} เพิ่มเข้ามา",
      "optional": "ไม่บังคับ",
      "addMedia": "เพิ่มรูปภาพหรือวิดีโอถ้าคุณต้องการ",
      "addMediaBody": "อัปโหลดสื่อของคุณเองหรือปล่อยให้ว่างเปล่าและให้ AI ค้นหา",
      "attachedMedia": "สื่อที่แนบมา",
      "add": "เพิ่ม",
      "mediaFallback": "สื่อ",
      "aiCompletes": "ปล่อยให้ AI ทำให้ภาพเสร็จสมบูรณ์",
      "noMedia": "ไม่มีการอัปโหลดรูปภาพ; AI จะทำให้ฉากต่างๆ เสร็จสมบูรณ์",
      "productionFormat": "รูปแบบการผลิต",
      "style": "สไตล์",
      "customVisualWorld": "อธิบายโลกทัศน์ของคุณ",
      "colorsAtmosphere": "สี, บรรยากาศ, กล้อง, จังหวะ",
      "customStyleShort": "อธิบายโลกภาพที่คุณนึกถึง (ตัวอย่างเช่น สีพาสเทลและกล้องที่เงียบสงบ หรือนีออนไซเบอร์พังก์…)",
      "customStyleLong": "อธิบายโลกภาพ สีสัน บรรยากาศ และจังหวะที่คุณนึกถึง",
      "voiceover": "เสียงบรรยาย",
      "ownVoiceover": "ข้อความเสียงบรรยายของคุณ",
      "voiceoverPlaceholder": "เขียนข้อความของคุณที่นี่ หากว่าง Voxnela จะเตรียมให้",
      "duration": "ระยะเวลา",
      "seconds": "{{count}} วินาที",
      "freeLimit": "วิดีโอสุดท้ายที่ยาวที่สุดในแพ็กเกจฟรีคือ 60 วินาที",
      "addSound": "เพิ่มเสียงหรือเพลง",
      "notAdded": "ไม่ได้เพิ่ม",
      "files": "ไฟล์ {{count}}",
      "readySounds": "ใช้เสียงที่เตรียมไว้ล่วงหน้า",
      "musicLibrary": "คลังเพลง",
      "uploadOwn": "อัปโหลดของคุณเอง",
      "captions": "คำบรรยาย",
      "back": "ย้อนกลับ",
      "create": "สร้าง",
      "next": "ถัดไป",
      "researchingTopic": "ทำการวิจัยในหัวข้อนี้...",
      "analyzingMaterials": "วิเคราะห์วัสดุ...",
      "researchBody": "ตรวจสอบแหล่งข้อมูลและเตรียมสคริปต์และแผนภาพ",
      "analyzeBody": "ประเมินกรอบที่แข็งแกร่ง อารมณ์ จังหวะ และความสั้นเข้าด้วยกัน",
      "creativeDirection": "ทิศทางความคิดสร้างสรรค์ {{count}}",
      "recommended": "แนะนำ",
      "generationFailed": "การสร้างไม่สามารถเสร็จสิ้นได้",
      "retry": "เตรียมอีกครั้ง",
      "backDirections": "กลับสู่แนวทางสร้างสรรค์",
      "preparingVideo": "กำลังเตรียมวิดีโอ",
      "voiceoverText": "ข้อความเสียงบรรยาย",
      "describeStyle": "อธิบายสไตล์ของคุณเอง",
      "topicDirection": "หัวข้อและทิศทาง",
      "styleEditorSubtitle": "อธิบายโลกทางสายตา สีสันและบรรยากาศ",
      "editorSubtitle": "เขียนข้อความและแทรกเข้าไปในแผ่นงานสร้างสรรค์",
      "voiceoverEditorPlaceholder": "เขียนข้อความที่จะใช้สำหรับการบรรยายเสียง",
      "topicEditorPlaceholder": "เขียนหัวข้อและวิธีที่คุณต้องการให้บอก",
      "insertText": "แทรกข้อความ",
      "bestFor": "เหมาะสำหรับ:",
      "useStyle": "ใช้สไตล์นี้",
      "musicSubtitle": "แทร็กจริงได้รับการอนุมัติสำหรับการใช้งานเชิงพาณิชย์แล้ว",
      "adding": "เพิ่ม...",
      "musicLicense": "แทร็กต่างๆ ได้รับการจัดเตรียมภายใต้ CC0 1.0; การใช้งานเชิงพาณิชย์ได้รับอนุญาตและไม่จำเป็นต้องระบุแหล่งที่มา",
      "yes": "ใช่",
      "no": "ไม่",
      "newCreation": "การสร้างสรรค์ใหม่",
      "reviewing": "Voxnela กำลังตรวจสอบ",
      "chooseDirection": "เลือกหนึ่งในสามวิธีการแก้ไข",
      "ideaSubtitle": "อธิบายแนวคิดของคุณ; อัปโหลดภาพหรืออนุญาตให้ Voxnela สร้างภาพเหล่านั้น",
      "projectOpenFailed": "แพ็กเกจโครงการไม่สามารถเปิดได้",
      "tooManyAssets": "คุณสามารถเพิ่มสินทรัพย์ได้สูงสุด 50 รายการลงในโปรเจกต์ได้",
      "uploadSizeLimit": "การอัปโหลดโครงการทั้งหมดเกินขีดจำกัด 2 GB",
      "filesAddFailed": "ไฟล์ไม่สามารถเพิ่มได้",
      "musicPreviewFailed": "ไม่สามารถเปิดการแสดงตัวอย่างเพลงได้",
      "musicFetchFailed": "ไม่สามารถดึงไฟล์เพลงได้",
      "musicAddFailed": "เพลงไม่สามารถเพิ่มได้",
      "topicRequired": "ป้อนหัวข้อและอธิบายว่าวิดีโอของคุณจะเกี่ยวกับอะไร",
      "briefTooShort": "อธิบายสิ่งที่คุณต้องการจะบอกอย่างน้อยไม่กี่คำ",
      "mediaRequired": "อัปโหลดภาพหรือเปิดใช้งานภาพที่สร้างโดย AI",
      "proposalIntro": "ฉันได้ตรวจสอบรูปภาพและวิดีโอและเตรียมคำแนะนำการแก้ไขสามข้อที่เหมาะกับสไตล์ รูปแบบ และตัวเลือกเสียงของคุณ",
      "removeMaterial": "ลบ {{name}}",
      "aiVisualNotice": "ภาพจริงและภาพประกอบ AI ที่ได้รับอนุญาตอย่างเปิดเผยจะถูกค้นพบโดยอัตโนมัติ",
      "stepProgress": "ขั้นตอน {{current}} ของ {{total}}",
      "styleSampleAlt": "ตัวอย่างที่แสดงสไตล์วิดีโอ {{style}}",
      "reviewStyle": "ตรวจสอบสไตล์ {{style}}",
      "selectedDirectionPrompt": "ทิศทางที่เลือก: {{title}}. {{summary}} ทิศทางภาพ: {{visual}}. วิธีการเปลี่ยนผ่าน: {{transitions}}. วิธีการดนตรี: {{music}}.",
      "letVoxnelaChoose": "ให้ Voxnela เลือก",
      "feminineVoice": "ผู้หญิง",
      "masculineVoice": "ความเป็นผู้ชาย",
      "narrationStyle": "สไตล์การบรรยาย",
      "voiceEstimate": "เกี่ยวกับ {{seconds}} sec · คำ {{words}}",
      "voiceShort": "หากเป็นคำย่อของ {{duration}} วินาที Voxnela จะทำให้เสร็จโดยยังคงความหมายไว้",
      "voiceNatural": "Voxnela ปรับแต่งไวยากรณ์ วลี และการไหลลื่นที่เป็นธรรมชาติเท่านั้น",
      "removeFile": "ลบไฟล์ {{name}}",
      "musicStop": "หยุด {{title}}",
      "musicListen": "ฟัง {{title}}",
      "automatic": "รถยนต์",
      "all": "ทั้งหมด",
      "cinematic": "ภาพยนตร์",
      "social": "สังคมและมีไดนามิก",
      "designTypography": "การออกแบบและตัวอักษร",
      "retroExperimental": "ย้อนยุคและทดลอง",
      "productionStage1": "การเลือกกรอบและฉากที่แข็งแกร่งที่สุด",
      "productionStage2": "การสร้างเรื่องราว การเคลื่อนไหว และการเปลี่ยนฉาก",
      "productionStage3": "การสร้างสมดุลระหว่างดนตรี เสียง และคำบรรยาย",
      "productionStage4": "กำลังดำเนินการตรวจสอบขั้นสุดท้ายบนการแสดงตัวอย่างสด",
      "genericCreationError": "เกิดปัญหาขณะเตรียมแผนวิดีโอ วัสดุและตัวเลือกของคุณได้รับการเก็บรักษาไว้แล้ว คุณสามารถลองอีกครั้งได้",
      "newVideo": "วิดีโอใหม่",
      "topicNews": "ข่าวสาร",
      "topicDocumentary": "สารคดี",
      "topicExplainer": "คำอธิบาย",
      "topicStory": "เรื่องราว",
      "topicScience": "วิทยาศาสตร์",
      "topicPhilosophy": "ปรัชญา",
      "topicMagazine": "นิตยสาร",
      "topicEntertainment": "ความบันเทิง",
      "topicList": "รายการ",
      "toneCalm": "สงบ",
      "toneEmotional": "อารมณ์",
      "toneEnergetic": "มีพลังงาน",
      "toneStorytelling": "การเล่าเรื่อง",
      "toneCheerful": "ร่าเริง",
      "toneMysterious": "ลึกลับ",
      "toneNews": "ข่าวสาร",
      "styleCinematic": "ภาพยนตร์",
      "styleDarkCinematic": "ภาพยนตร์ไซไฟมืดมิด",
      "styleDocumentary": "สารคดี",
      "styleModernDocumentary": "สารคดีสมัยใหม่",
      "stylePovImmersive": "มุมมองแบบดื่มด่ำ",
      "styleUgcAuthentic": "UGC ที่แท้จริง",
      "styleMiniVlog": "มินิวิดีโอ",
      "styleSocialViral": "ไวรัลทางสังคม",
      "styleHyperEdit": "แก้ไขแบบไฮเปอร์เอ็ด",
      "styleSportsHype": "ความฮือฮาในวงการกีฬา",
      "styleVelocityEdit": "แก้ไขความเร็ว",
      "styleMusicBeatEdit": "แก้ไขจังหวะดนตรี",
      "styleKineticTypography": "การพิมพ์แบบเคมี",
      "styleMinimalClean": "มินิมอลและสะอาดตา",
      "styleLuxuryMinimal": "มินิมอลหรูหรา",
      "styleCommercialProduct": "ผลิตภัณฑ์เชิงพาณิชย์",
      "styleEditorialFashion": "แฟชั่นบรรณาธิการ",
      "styleCollageZine": "ซีนคอลลาจ",
      "styleTechFuturistic": "เทคโนโลยีแห่งอนาคต",
      "styleRetroFuturism": "เรโทรฟิวเจอร์นิซึม",
      "styleY2kDigital": "ดิจิทัล Y2K",
      "styleVhsCamcorder": "กล้องวิดีโอ VHS",
      "styleAnalogFilm": "ฟิล์มอนาล็อก",
      "styleGlitchCyber": "กลิตช์ไซเบอร์",
      "musicUpbeatMood": "มีพลังงาน · สว่างไสว",
      "musicUpbeatDetail": "การบันทึกดนตรีบรรเลงจริงสำหรับเนื้อหาสังคมที่สนุกสนาน ช่วงเวลาการเดินทาง และการแก้ไขที่สดใส",
      "musicElectronicMood": "สมัยใหม่ · จังหวะ",
      "musicElectronicDetail": "ดนตรีอิเล็กทรอนิกส์จริงสำหรับเมือง เทคโนโลยี ผลิตภัณฑ์ และการแก้ไขที่รวดเร็ว",
      "musicRomanceMood": "อารมณ์ · อบอุ่น",
      "musicRomanceDetail": "ดนตรีบรรเลงที่มีอารมณ์อ่อนโยนสำหรับครอบครัว ภาพถ่ายบุคคล วันพิเศษ และความทรงจำ",
      "musicScoringMood": "การเล่าเรื่อง · ภาพยนตร์",
      "musicScoringDetail": "ดนตรีพื้นหลังภาพยนตร์ที่สนับสนุนเรื่องราว โปรโมชั่น และการเปลี่ยนฉากอย่างน่าตื่นเต้น",
      "musicEpicMood": "ทรงพลัง · กำลังเพิ่มขึ้น",
      "musicEpicDetail": "ดนตรีบรรเลงหลายชั้นที่สร้างขึ้นสำหรับการเปิดตัวครั้งใหญ่ การเดินทาง และช่วงจบที่ทรงพลัง",
      "proposalBalancedTitle": "เรื่องราวที่สมดุล",
      "proposalBalancedSummary": "การแก้ไขที่รักษาการไหลของเนื้อหาและเน้นเฟรมที่แข็งแกร่งที่สุด",
      "proposalBalancedVisual": "ลำดับชั้นที่เข้มแข็งและระบบภาพที่สอดคล้องกัน",
      "proposalBalancedTransitions": "การตัดที่เรียบเนียนและการดันเข้าที่ที่วัดขนาดได้",
      "proposalBalancedMusic": "ดนตรีที่เปลี่ยนจากอารมณ์ไปเป็นจังหวะ",
      "proposalQuietTitle": "เรื่องราวเงียบสงบ",
      "proposalQuietSummary": "วิธีการที่สงบซึ่งให้กรอบเวลามากขึ้นและเน้นรายละเอียดและอารมณ์ธรรมชาติ",
      "proposalQuietVisual": "โทนสีอ่อนและช็อตที่ยาวขึ้น",
      "proposalQuietTransitions": "การละลายแบบข้ามและการทอดแบบช้า",
      "proposalQuietMusic": "ดนตรีที่เรียบง่ายและเต็มไปด้วยอาร",
      "proposalRhythmicTitle": "การแก้ไขจังหวะ",
      "proposalRhythmicSummary": "การแก้ไขที่มีจุดเริ่มต้นที่แข็งแกร่งซึ่งเร่งความเร็วในตอนกลางและลงตัวอย่างชัดเจนในตอนท้าย",
      "proposalRhythmicVisual": "ความคมชัดที่มากขึ้นและการจัดกรอบแบบไดนามิก",
      "proposalRhythmicTransitions": "การตัดจังหวะและเทคนิคการเปลี่ยนฉากด้วยการกระโดด",
      "proposalRhythmicMusic": "ดนตรีที่มีพลังงานและกำลังเพิ่มขึ้น",
      "underVoiceover": "เบาๆ ใต้เสียงบรรยาย",
      "withShortVoiceover": "ด้วยเสียงบรรยายสั้นๆ ที่ทรงพลัง"
    },
    "information": {
      "home": "หน้าหลัก",
      "documentInfo": "ข้อมูลเอกสาร",
      "version": "เวอร์ชัน",
      "effective": "มีผลตั้งแต่",
      "updated": "อัปเดตล่าสุด",
      "contents": "สารบัญ",
      "officialReferences": "อ้างอิงอย่างเป็นทางการ",
      "referenceTitle": "แหล่งข้อมูลกฎหมายและอำนาจ",
      "referenceBody": "ลิงก์เหล่านี้จัดทำขึ้นเพื่อเป็นข้อมูลทั่วไป กฎหมายบังคับใช้และกฎระเบียบปัจจุบันจากหน่วยงานที่เกี่ยวข้องมีผลเหนือกว่า",
      "supportKicker": "การสนับสนุนจาก Sponelabs",
      "contactTitle": "ติดต่อเรา",
      "contactLead": "ติดต่อทีมสนับสนุน Voxnela เกี่ยวกับบัญชีของคุณ การเป็นสมาชิก การชำระเงิน การสร้างเนื้อหา รายงานเนื้อหา ความเป็นส่วนตัว หรือปัญหาทางเทคนิค",
      "supportEmail": "อีเมลฝ่ายสนับสนุน",
      "emailBody": "ปุ่มด้านล่างจะเปิดแอปอีเมลเริ่มต้นของคุณพร้อมเทมเพลตสนับสนุนที่พร้อมใช้งานเพื่อให้เราสามารถตรวจสอบได้เร็วขึ้น",
      "openEmail": "เปิดแอปอีเมล",
      "includeTitle": "ระบุในข้อความ",
      "includeItems": [
        "ไม่ว่าคุณจะใช้เว็บ iOS หรือ Mac;",
        "เวอร์ชันของอุปกรณ์และระบบปฏิบัติการของคุณ;",
        "ขั้นตอนในการจำลองปัญหา;",
        "ลิงก์โครงการที่เกี่ยวข้อง รายละเอียดการทำธุรกรรม หรือสกรีนช็อต หากมี"
      ],
      "sensitiveTitle": "อย่าส่งข้อมูลที่ละเอียดอ่อน",
      "sensitiveBody": "อย่ารวมรหัสการยืนยัน รหัสผ่าน รายละเอียดบัตรชำระเงินเต็มรูปแบบ เอกสารประจำตัว ข้อมูลสุขภาพ หรือข้อมูลที่ละเอียดอ่อนอื่น ๆ ที่ไม่จำเป็นต้องใช้ในการแก้ไขปัญหา",
      "securityTitle": "ความปลอดภัยและการรายงานเนื้อหา",
      "securityBody": "ใช้ “ความปลอดภัย” สำหรับช่องโหว่, “คำขอความเป็นส่วนตัว” สำหรับคำขอข้อมูล, หรือ “รายงานเนื้อหา” สำหรับเนื้อหาที่เป็นอันตรายหรือละเมิดกฎหมาย ติดต่อหน่วยบริการฉุกเฉินในท้องถิ่นในกรณีที่มีอันตรายทางกายภาพทันที",
      "mailSubject": "คำขอการสนับสนุน Voxnela",
      "mailGreeting": "สวัสดีทีมสนับสนุน Voxnela,",
      "mailTopic": "หัวข้อสนับสนุน:",
      "mailPlatform": "แพลตฟอร์ม (เว็บ / iOS / Mac):",
      "mailDevice": "อุปกรณ์และระบบปฏิบัติการ:",
      "mailProject": "รหัสโครงการ (หากมี):",
      "mailDescription": "คำอธิบายของปัญหาหรือคำขอ:",
      "mailThanks": "ขอบคุณค่ะ",
      "termsEyebrow": "ข้อกำหนดการให้บริการของ Voxnela",
      "termsTitle": "ข้อกำหนดการใช้งาน",
      "termsLead": "ข้อกำหนดเหล่านี้ควบคุมการใช้บริการสร้างและแก้ไขภาพ AI ในเว็บไซต์ Voxnela และแอป iOS",
      "privacyEyebrow": "การใช้ข้อมูล Voxnela",
      "privacyTitle": "นโยบายความเป็นส่วนตัว",
      "privacyLead": "นโยบายนี้อธิบายวิธีการประมวลผลบัญชี รูปภาพ โครงการ สมาชิก และข้อมูลทางเทคนิคในบริการสร้างภาพ Voxnela",
      "officialTurkishNotice": "การแปลนี้จัดทำขึ้นเพื่อความสะดวก ข้อความทางกฎหมายภาษาตุรกีเป็นผู้กำหนดหากความหมายแตกต่างกัน"
    }
  }
}
